import {Loc} from 'landing.loc';

export const FontAwesome6_3 = {
	id: 'fontawesome6_3',
	name: 'Fontawesome 3',
	active: true,
	categories: [
		{
			id: 'household',
			name: Loc.getMessage('LANDING_ICONS_SECTION_HOUSEHOLD'),
			items: [
				{
					className: 'far fa-air-conditioner',
					options: [
						'fat fa-air-conditioner', 'fal fa-air-conditioner', 'far fa-air-conditioner', 'fas fa-air-conditioner',
					],
					defaultOption: 'far fa-air-conditioner',
					keywords: 'ac cool heat heat pump hvac mini split temperature unit air-conditioner',
				},
				{
					className: 'far fa-bath',
					options: [
						'fat fa-bath', 'fal fa-bath', 'far fa-bath', 'fas fa-bath',
					],
					defaultOption: 'far fa-bath',
					keywords: 'bath bathtub clean shower tub wash bath',
				},
				{
					className: 'far fa-bed',
					options: [
						'fat fa-bed', 'fal fa-bed', 'far fa-bed', 'fas fa-bed',
					],
					defaultOption: 'far fa-bed',
					keywords: 'hotel lodging mattress person in bed rest sleep travel bed',
				},
				{
					className: 'far fa-bed-bunk',
					options: [
						'fat fa-bed-bunk', 'fal fa-bed-bunk', 'far fa-bed-bunk', 'fas fa-bed-bunk',
					],
					defaultOption: 'far fa-bed-bunk',
					keywords: 'lodging mattress rest siblings sleep sleepover travel bed bunk',
				},
				{
					className: 'far fa-bed-empty',
					options: [
						'fat fa-bed-empty', 'fal fa-bed-empty', 'far fa-bed-empty', 'fas fa-bed-empty',
					],
					defaultOption: 'far fa-bed-empty',
					keywords: 'bed hotel lodging mattress rest sleep travel bed empty',
				},
				{
					className: 'far fa-bed-front',
					options: [
						'fat fa-bed-front', 'fal fa-bed-front', 'far fa-bed-front', 'fas fa-bed-front',
					],
					defaultOption: 'far fa-bed-front',
					keywords: 'double king lodging mattress pillows queen rest sleep travel bed front',
				},
				{
					className: 'far fa-bell',
					options: [
						'fat fa-bell', 'fal fa-bell', 'far fa-bell', 'fas fa-bell',
					],
					defaultOption: 'far fa-bell',
					keywords: 'alarm alert bel bell chime notification reminder bell',
				},
				{
					className: 'far fa-bell-on',
					options: [
						'fat fa-bell-on', 'fal fa-bell-on', 'far fa-bell-on', 'fas fa-bell-on',
					],
					defaultOption: 'far fa-bell-on',
					keywords: 'ringing bell alarm alert chime notification reminder bell on',
				},
				{
					className: 'far fa-blanket',
					options: [
						'fat fa-blanket', 'fal fa-blanket', 'far fa-blanket', 'fas fa-blanket',
					],
					defaultOption: 'far fa-blanket',
					keywords: 'bed cover cozy sleep warm blanket',
				},
				{
					className: 'far fa-blanket-fire',
					options: [
						'fat fa-blanket-fire', 'fal fa-blanket-fire', 'far fa-blanket-fire', 'fas fa-blanket-fire',
					],
					defaultOption: 'far fa-blanket-fire',
					keywords: 'fire flammable safety blanket fire',
				},
				{
					className: 'far fa-blender',
					options: [
						'fat fa-blender', 'fal fa-blender', 'far fa-blender', 'fas fa-blender',
					],
					defaultOption: 'far fa-blender',
					keywords: 'cocktail milkshake mixer puree smoothie blender',
				},
				{
					className: 'far fa-blinds',
					options: [
						'fat fa-blinds', 'fal fa-blinds', 'far fa-blinds', 'fas fa-blinds',
					],
					defaultOption: 'far fa-blinds',
					keywords: 'privacy shutter window blinds',
				},
				{
					className: 'far fa-blinds-open',
					options: [
						'fat fa-blinds-open', 'fal fa-blinds-open', 'far fa-blinds-open', 'fas fa-blinds-open',
					],
					defaultOption: 'far fa-blinds-open',
					keywords: 'privacy shutter window blinds open',
				},
				{
					className: 'far fa-blinds-raised',
					options: [
						'fat fa-blinds-raised', 'fal fa-blinds-raised', 'far fa-blinds-raised', 'fas fa-blinds-raised',
					],
					defaultOption: 'far fa-blinds-raised',
					keywords: 'privacy shutter window blinds raised',
				},
				{
					className: 'far fa-block-brick',
					options: [
						'fat fa-block-brick', 'fal fa-block-brick', 'far fa-block-brick', 'fas fa-block-brick',
					],
					defaultOption: 'far fa-block-brick',
					keywords: 'block brick mortar super mario wall block brick',
				},
				{
					className: 'far fa-block-brick-fire',
					options: [
						'fat fa-block-brick-fire', 'fal fa-block-brick-fire', 'far fa-block-brick-fire', 'fas fa-block-brick-fire',
					],
					defaultOption: 'far fa-block-brick-fire',
					keywords: 'brick fire firewall network wall block brick-fire',
				},
				{
					className: 'far fa-books',
					options: [
						'fat fa-books', 'fal fa-books', 'far fa-books', 'fas fa-books',
					],
					defaultOption: 'far fa-books',
					keywords: 'book books diary documentation journal library read research books',
				},
				{
					className: 'far fa-bowl-spoon',
					options: [
						'fat fa-bowl-spoon', 'fal fa-bowl-spoon', 'far fa-bowl-spoon', 'fas fa-bowl-spoon',
					],
					defaultOption: 'far fa-bowl-spoon',
					keywords: 'breakfast cereal congee oatmeal porridge bowl spoon',
				},
				{
					className: 'far fa-box-tissue',
					options: [
						'fat fa-box-tissue', 'fal fa-box-tissue', 'far fa-box-tissue', 'fas fa-box-tissue',
					],
					defaultOption: 'far fa-box-tissue',
					keywords: 'cough covid 19 kleenex mucus nose sneeze snot box-tissue',
				},
				{
					className: 'far fa-camera-cctv',
					options: [
						'fat fa-camera-cctv', 'fal fa-camera-cctv', 'far fa-camera-cctv', 'fas fa-camera-cctv',
					],
					defaultOption: 'far fa-camera-cctv',
					keywords: '1984 big brother george orwell camera security surveillance video camera cctv',
				},
				{
					className: 'far fa-camera-security',
					options: [
						'fat fa-camera-security', 'fal fa-camera-security', 'far fa-camera-security', 'fas fa-camera-security',
					],
					defaultOption: 'far fa-camera-security',
					keywords: 'chat conference call facetime podcast security video videoconferencing youtube camera security',
				},
				{
					className: 'far fa-camera-web',
					options: [
						'fat fa-camera-web', 'fal fa-camera-web', 'far fa-camera-web', 'fas fa-camera-web',
					],
					defaultOption: 'far fa-camera-web',
					keywords: 'chat conference call facetime podcast video videoconferencing youtube camera web',
				},
				{
					className: 'far fa-chair',
					options: [
						'fat fa-chair', 'fal fa-chair', 'far fa-chair', 'fas fa-chair',
					],
					defaultOption: 'far fa-chair',
					keywords: 'chair furniture seat sit chair',
				},
				{
					className: 'far fa-chair-office',
					options: [
						'fat fa-chair-office', 'fal fa-chair-office', 'far fa-chair-office', 'fas fa-chair-office',
					],
					defaultOption: 'far fa-chair-office',
					keywords: 'ergonomic furniture seat chair office',
				},
				{
					className: 'far fa-chopsticks',
					options: [
						'fat fa-chopsticks', 'fal fa-chopsticks', 'far fa-chopsticks', 'fas fa-chopsticks',
					],
					defaultOption: 'far fa-chopsticks',
					keywords: 'bamboo chopsticks utensils chopsticks',
				},
				{
					className: 'far fa-circle-sort',
					options: [
						'fat fa-circle-sort', 'fal fa-circle-sort', 'far fa-circle-sort', 'fas fa-circle-sort',
					],
					defaultOption: 'far fa-circle-sort',
					keywords: 'down elevator lower raise temperature thermostat up circle sort',
				},
				{
					className: 'far fa-circle-sort-down',
					options: [
						'fat fa-circle-sort-down', 'fal fa-circle-sort-down', 'far fa-circle-sort-down', 'fas fa-circle-sort-down',
					],
					defaultOption: 'far fa-circle-sort-down',
					keywords: 'down elevator lower raise temperature thermostat up circle sort-down',
				},
				{
					className: 'far fa-circle-sort-up',
					options: [
						'fat fa-circle-sort-up', 'fal fa-circle-sort-up', 'far fa-circle-sort-up', 'fas fa-circle-sort-up',
					],
					defaultOption: 'far fa-circle-sort-up',
					keywords: 'down elevator lower raise temperature thermostat up circle sort-up',
				},
				{
					className: 'far fa-clock-desk',
					options: [
						'fat fa-clock-desk', 'fal fa-clock-desk', 'far fa-clock-desk', 'fas fa-clock-desk',
					],
					defaultOption: 'far fa-clock-desk',
					keywords: 'alarm clock mantelpiece clock timer clock desk',
				},
				{
					className: 'far fa-clothes-hanger',
					options: [
						'fat fa-clothes-hanger', 'fal fa-clothes-hanger', 'far fa-clothes-hanger', 'fas fa-clothes-hanger',
					],
					defaultOption: 'far fa-clothes-hanger',
					keywords: 'clothing dry cleaner hang wire clothes hanger',
				},
				{
					className: 'far fa-coffee-pot',
					options: [
						'fat fa-coffee-pot', 'fal fa-coffee-pot', 'far fa-coffee-pot', 'fas fa-coffee-pot',
					],
					defaultOption: 'far fa-coffee-pot',
					keywords: 'beverage breakfast brew cafe carafe drink morning coffee pot',
				},
				{
					className: 'far fa-couch',
					options: [
						'fat fa-couch', 'fal fa-couch', 'far fa-couch', 'fas fa-couch',
					],
					defaultOption: 'far fa-couch',
					keywords: 'chair cushion furniture relax sofa couch',
				},
				{
					className: 'far fa-door-closed',
					options: [
						'fat fa-door-closed', 'fal fa-door-closed', 'far fa-door-closed', 'fas fa-door-closed',
					],
					defaultOption: 'far fa-door-closed',
					keywords: 'doo door enter exit locked door closed',
				},
				{
					className: 'far fa-door-open',
					options: [
						'fat fa-door-open', 'fal fa-door-open', 'far fa-door-open', 'fas fa-door-open',
					],
					defaultOption: 'far fa-door-open',
					keywords: 'enter exit welcome door open',
				},
				{
					className: 'far fa-dryer',
					options: [
						'fat fa-dryer', 'fal fa-dryer', 'far fa-dryer', 'fas fa-dryer',
					],
					defaultOption: 'far fa-dryer',
					keywords: 'clean clothes laundromat laundry washing machine dryer',
				},
				{
					className: 'far fa-dryer-heat',
					options: [
						'fat fa-dryer-heat', 'fal fa-dryer-heat', 'far fa-dryer-heat', 'fas fa-dryer-heat',
					],
					defaultOption: 'far fa-dryer-heat',
					keywords: 'clean clothes laundromat laundry washing machine dryer heat',
				},
				{
					className: 'far fa-dungeon',
					options: [
						'fat fa-dungeon', 'fal fa-dungeon', 'far fa-dungeon', 'fas fa-dungeon',
					],
					defaultOption: 'far fa-dungeon',
					keywords: 'dungeons & dragons building d&d dnd door entrance fantasy gate dungeon',
				},
				{
					className: 'far fa-fan',
					options: [
						'fat fa-fan', 'fal fa-fan', 'far fa-fan', 'fas fa-fan',
					],
					defaultOption: 'far fa-fan',
					keywords: 'ac air conditioning blade blower cool hot fan',
				},
				{
					className: 'far fa-fan-table',
					options: [
						'fat fa-fan-table', 'fal fa-fan-table', 'far fa-fan-table', 'fas fa-fan-table',
					],
					defaultOption: 'far fa-fan-table',
					keywords: 'ac air conditioning blade blower cool hot oscillate fan table',
				},
				{
					className: 'far fa-faucet',
					options: [
						'fat fa-faucet', 'fal fa-faucet', 'far fa-faucet', 'fas fa-faucet',
					],
					defaultOption: 'far fa-faucet',
					keywords: 'covid 19 drip house hygiene kitchen sink water faucet',
				},
				{
					className: 'far fa-faucet-drip',
					options: [
						'fat fa-faucet-drip', 'fal fa-faucet-drip', 'far fa-faucet-drip', 'fas fa-faucet-drip',
					],
					defaultOption: 'far fa-faucet-drip',
					keywords: 'drinking drip house kitchen potable potable water sink water faucet drip',
				},
				{
					className: 'far fa-fire-hydrant',
					options: [
						'fat fa-fire-hydrant', 'fal fa-fire-hydrant', 'far fa-fire-hydrant', 'fas fa-fire-hydrant',
					],
					defaultOption: 'far fa-fire-hydrant',
					keywords: 'fire irrigate water fire hydrant',
				},
				{
					className: 'far fa-fireplace',
					options: [
						'fat fa-fireplace', 'fal fa-fireplace', 'far fa-fireplace', 'fas fa-fireplace',
					],
					defaultOption: 'far fa-fireplace',
					keywords: 'caliente flame hearth heat holiday mantle toasty warmth fireplace',
				},
				{
					className: 'far fa-flashlight',
					options: [
						'fat fa-flashlight', 'fal fa-flashlight', 'far fa-flashlight', 'fas fa-flashlight',
					],
					defaultOption: 'far fa-flashlight',
					keywords: 'camping electric flashlight hide and seek lamp light tool torch flashlight',
				},
				{
					className: 'far fa-fork',
					options: [
						'fat fa-fork', 'fal fa-fork', 'far fa-fork', 'fas fa-fork',
					],
					defaultOption: 'far fa-fork',
					keywords: 'cutlery dining food fork silverware fork',
				},
				{
					className: 'far fa-fork-knife',
					options: [
						'fat fa-fork-knife', 'fal fa-fork-knife', 'far fa-fork-knife', 'fas fa-fork-knife',
					],
					defaultOption: 'far fa-fork-knife',
					keywords: 'cutlery dining dinner eat food fork knife restaurant fork knife',
				},
				{
					className: 'far fa-garage',
					options: [
						'fat fa-garage', 'fal fa-garage', 'far fa-garage', 'fas fa-garage',
					],
					defaultOption: 'far fa-garage',
					keywords: 'auto car door storage structure warehouse garage',
				},
				{
					className: 'far fa-garage-car',
					options: [
						'fat fa-garage-car', 'fal fa-garage-car', 'far fa-garage-car', 'fas fa-garage-car',
					],
					defaultOption: 'far fa-garage-car',
					keywords: 'auto car door storage structure warehouse garage car',
				},
				{
					className: 'far fa-garage-open',
					options: [
						'fat fa-garage-open', 'fal fa-garage-open', 'far fa-garage-open', 'fas fa-garage-open',
					],
					defaultOption: 'far fa-garage-open',
					keywords: 'auto car door storage structure warehouse garage open',
				},
				{
					className: 'far fa-heat',
					options: [
						'fat fa-heat', 'fal fa-heat', 'far fa-heat', 'fas fa-heat',
					],
					defaultOption: 'far fa-heat',
					keywords: 'ac air conditioner boiler heating hot sauna spa summer temperature heat',
				},
				{
					className: 'far fa-hose',
					options: [
						'fat fa-hose', 'fal fa-hose', 'far fa-hose', 'fas fa-hose',
					],
					defaultOption: 'far fa-hose',
					keywords: 'fire irrigation water hose',
				},
				{
					className: 'far fa-hose-reel',
					options: [
						'fat fa-hose-reel', 'fal fa-hose-reel', 'far fa-hose-reel', 'fas fa-hose-reel',
					],
					defaultOption: 'far fa-hose-reel',
					keywords: 'fire irrigation water hose reel',
				},
				{
					className: 'far fa-house-chimney-heart',
					options: [
						'fat fa-house-chimney-heart', 'fal fa-house-chimney-heart', 'far fa-house-chimney-heart', 'fas fa-house-chimney-heart',
					],
					defaultOption: 'far fa-house-chimney-heart',
					keywords: 'care home love house chimney-heart',
				},
				{
					className: 'far fa-house-chimney-user',
					options: [
						'fat fa-house-chimney-user', 'fal fa-house-chimney-user', 'far fa-house-chimney-user', 'fas fa-house-chimney-user',
					],
					defaultOption: 'far fa-house-chimney-user',
					keywords: 'covid 19 home isolation quarantine house-chimney-user',
				},
				{
					className: 'far fa-house-chimney-window',
					options: [
						'fat fa-house-chimney-window', 'fal fa-house-chimney-window', 'far fa-house-chimney-window', 'fas fa-house-chimney-window',
					],
					defaultOption: 'far fa-house-chimney-window',
					keywords: 'abode building family home residence house chimney-window',
				},
				{
					className: 'far fa-house-day',
					options: [
						'fat fa-house-day', 'fal fa-house-day', 'far fa-house-day', 'fas fa-house-day',
					],
					defaultOption: 'far fa-house-day',
					keywords: 'abode building family home residence solar sun house day',
				},
				{
					className: 'far fa-house-heart',
					options: [
						'fat fa-house-heart', 'fal fa-house-heart', 'far fa-house-heart', 'fas fa-house-heart',
					],
					defaultOption: 'far fa-house-heart',
					keywords: 'abode building charity house main house heart',
				},
				{
					className: 'far fa-house-laptop',
					options: [
						'fat fa-house-laptop', 'fal fa-house-laptop', 'far fa-house-laptop', 'fas fa-house-laptop',
					],
					defaultOption: 'far fa-house-laptop',
					keywords: 'computer covid 19 device office remote work from home house-laptop',
				},
				{
					className: 'far fa-house-night',
					options: [
						'fat fa-house-night', 'fal fa-house-night', 'far fa-house-night', 'fas fa-house-night',
					],
					defaultOption: 'far fa-house-night',
					keywords: 'abode building family home moon residence stars house night',
				},
				{
					className: 'far fa-house-person-leave',
					options: [
						'fat fa-house-person-leave', 'fal fa-house-person-leave', 'far fa-house-person-leave', 'fas fa-house-person-leave',
					],
					defaultOption: 'far fa-house-person-leave',
					keywords: 'away home house person-leave',
				},
				{
					className: 'far fa-house-person-return',
					options: [
						'fat fa-house-person-return', 'fal fa-house-person-return', 'far fa-house-person-return', 'fas fa-house-person-return',
					],
					defaultOption: 'far fa-house-person-return',
					keywords: 'home remote house person-return',
				},
				{
					className: 'far fa-house-signal',
					options: [
						'fat fa-house-signal', 'fal fa-house-signal', 'far fa-house-signal', 'fas fa-house-signal',
					],
					defaultOption: 'far fa-house-signal',
					keywords: 'abode building connect family home residence smart home wifi house signal',
				},
				{
					className: 'far fa-house-user',
					options: [
						'fat fa-house-user', 'fal fa-house-user', 'far fa-house-user', 'fas fa-house-user',
					],
					defaultOption: 'far fa-house-user',
					keywords: 'house house user',
				},
				{
					className: 'far fa-lamp',
					options: [
						'fat fa-lamp', 'fal fa-lamp', 'far fa-lamp', 'fas fa-lamp',
					],
					defaultOption: 'far fa-lamp',
					keywords: 'bright furniture light lamp',
				},
				{
					className: 'far fa-lamp-desk',
					options: [
						'fat fa-lamp-desk', 'fal fa-lamp-desk', 'far fa-lamp-desk', 'fas fa-lamp-desk',
					],
					defaultOption: 'far fa-lamp-desk',
					keywords: 'bright furniture light lamp desk',
				},
				{
					className: 'far fa-lamp-floor',
					options: [
						'fat fa-lamp-floor', 'fal fa-lamp-floor', 'far fa-lamp-floor', 'fas fa-lamp-floor',
					],
					defaultOption: 'far fa-lamp-floor',
					keywords: 'bright furniture light lamp floor',
				},
				{
					className: 'far fa-light-ceiling',
					options: [
						'fat fa-light-ceiling', 'fal fa-light-ceiling', 'far fa-light-ceiling', 'fas fa-light-ceiling',
					],
					defaultOption: 'far fa-light-ceiling',
					keywords: 'bright furniture light overhead light ceiling',
				},
				{
					className: 'far fa-light-switch',
					options: [
						'fat fa-light-switch', 'fal fa-light-switch', 'far fa-light-switch', 'fas fa-light-switch',
					],
					defaultOption: 'far fa-light-switch',
					keywords: 'light off on light switch',
				},
				{
					className: 'far fa-light-switch-off',
					options: [
						'fat fa-light-switch-off', 'fal fa-light-switch-off', 'far fa-light-switch-off', 'fas fa-light-switch-off',
					],
					defaultOption: 'far fa-light-switch-off',
					keywords: 'light off on light switch-off',
				},
				{
					className: 'far fa-light-switch-on',
					options: [
						'fat fa-light-switch-on', 'fal fa-light-switch-on', 'far fa-light-switch-on', 'fas fa-light-switch-on',
					],
					defaultOption: 'far fa-light-switch-on',
					keywords: 'light off on light switch-on',
				},
				{
					className: 'far fa-lightbulb',
					options: [
						'fat fa-lightbulb', 'fal fa-lightbulb', 'far fa-lightbulb', 'fas fa-lightbulb',
					],
					defaultOption: 'far fa-lightbulb',
					keywords: 'bulb comic electric energy idea inspiration light light bulb lightbulb',
				},
				{
					className: 'far fa-lightbulb-on',
					options: [
						'fat fa-lightbulb-on', 'fal fa-lightbulb-on', 'far fa-lightbulb-on', 'fas fa-lightbulb-on',
					],
					defaultOption: 'far fa-lightbulb-on',
					keywords: 'energy idea inspiration light shine lightbulb on',
				},
				{
					className: 'far fa-loveseat',
					options: [
						'fat fa-loveseat', 'fal fa-loveseat', 'far fa-loveseat', 'fas fa-loveseat',
					],
					defaultOption: 'far fa-loveseat',
					keywords: 'chair couch cushion furniture relax sofa loveseat',
				},
				{
					className: 'far fa-mailbox',
					options: [
						'fat fa-mailbox', 'fal fa-mailbox', 'far fa-mailbox', 'fas fa-mailbox',
					],
					defaultOption: 'far fa-mailbox',
					keywords: 'archive closed closed mailbox with lowered flag envelope letter lowered mail mailbox post office postal postbox postcard send stamp usps mailbox',
				},
				{
					className: 'far fa-microwave',
					options: [
						'fat fa-microwave', 'fal fa-microwave', 'far fa-microwave', 'fas fa-microwave',
					],
					defaultOption: 'far fa-microwave',
					keywords: 'chef cook kitchen nuke microwave',
				},
				{
					className: 'far fa-mug-saucer',
					options: [
						'fat fa-mug-saucer', 'fal fa-mug-saucer', 'far fa-mug-saucer', 'fas fa-mug-saucer',
					],
					defaultOption: 'far fa-mug-saucer',
					keywords: 'beverage breakfast cafe drink fall morning mug seasonal tea mug saucer',
				},
				{
					className: 'far fa-outlet',
					options: [
						'fat fa-outlet', 'fal fa-outlet', 'far fa-outlet', 'fas fa-outlet',
					],
					defaultOption: 'far fa-outlet',
					keywords: 'electricity energy plug outlet',
				},
				{
					className: 'far fa-oven',
					options: [
						'fat fa-oven', 'fal fa-oven', 'far fa-oven', 'fas fa-oven',
					],
					defaultOption: 'far fa-oven',
					keywords: 'bake broiler convection cook kitchen stove oven',
				},
				{
					className: 'far fa-pan-frying',
					options: [
						'fat fa-pan-frying', 'fal fa-pan-frying', 'far fa-pan-frying', 'fas fa-pan-frying',
					],
					defaultOption: 'far fa-pan-frying',
					keywords: 'breakfast cook egg fry pan frying',
				},
				{
					className: 'far fa-person-to-door',
					options: [
						'fat fa-person-to-door', 'fal fa-person-to-door', 'far fa-person-to-door', 'fas fa-person-to-door',
					],
					defaultOption: 'far fa-person-to-door',
					keywords: 'door exit leave person to-door',
				},
				{
					className: 'far fa-phone-intercom',
					options: [
						'fat fa-phone-intercom', 'fal fa-phone-intercom', 'far fa-phone-intercom', 'fas fa-phone-intercom',
					],
					defaultOption: 'far fa-phone-intercom',
					keywords: 'call phone warning phone intercom',
				},
				{
					className: 'far fa-plate-utensils',
					options: [
						'fat fa-plate-utensils', 'fal fa-plate-utensils', 'far fa-plate-utensils', 'fas fa-plate-utensils',
					],
					defaultOption: 'far fa-plate-utensils',
					keywords: 'dinner food fork knife plate plate utensils',
				},
				{
					className: 'far fa-plug',
					options: [
						'fat fa-plug', 'fal fa-plug', 'far fa-plug', 'fas fa-plug',
					],
					defaultOption: 'far fa-plug',
					keywords: 'connect electric electric plug electricity online plug power plug',
				},
				{
					className: 'far fa-pump',
					options: [
						'fat fa-pump', 'fal fa-pump', 'far fa-pump', 'fas fa-pump',
					],
					defaultOption: 'far fa-pump',
					keywords: 'drain flood pump sump water pump',
				},
				{
					className: 'far fa-pump-soap',
					options: [
						'fat fa-pump-soap', 'fal fa-pump-soap', 'far fa-pump-soap', 'fas fa-pump-soap',
					],
					defaultOption: 'far fa-pump-soap',
					keywords: 'anti bacterial clean covid-19 disinfect hygiene sanitizer soap pump-soap',
				},
				{
					className: 'far fa-refrigerator',
					options: [
						'fat fa-refrigerator', 'fal fa-refrigerator', 'far fa-refrigerator', 'fas fa-refrigerator',
					],
					defaultOption: 'far fa-refrigerator',
					keywords: 'cold cool freezer fridge icebox kitchen refrigerator',
				},
				{
					className: 'far fa-sensor',
					options: [
						'fat fa-sensor', 'fal fa-sensor', 'far fa-sensor', 'fas fa-sensor',
					],
					defaultOption: 'far fa-sensor',
					keywords: 'alarm alert carbon monoxide detector fire smoke sensor',
				},
				{
					className: 'far fa-sensor-cloud',
					options: [
						'fat fa-sensor-cloud', 'fal fa-sensor-cloud', 'far fa-sensor-cloud', 'fas fa-sensor-cloud',
					],
					defaultOption: 'far fa-sensor-cloud',
					keywords: 'alarm alert carbon monoxide detector fire smoke sensor cloud',
				},
				{
					className: 'far fa-sensor-fire',
					options: [
						'fat fa-sensor-fire', 'fal fa-sensor-fire', 'far fa-sensor-fire', 'fas fa-sensor-fire',
					],
					defaultOption: 'far fa-sensor-fire',
					keywords: 'alarm alert carbon monoxide detector fire smoke sensor fire',
				},
				{
					className: 'far fa-sensor-on',
					options: [
						'fat fa-sensor-on', 'fal fa-sensor-on', 'far fa-sensor-on', 'fas fa-sensor-on',
					],
					defaultOption: 'far fa-sensor-on',
					keywords: 'alarm alert carbon monoxide detector fire smoke sensor on',
				},
				{
					className: 'far fa-sensor-triangle-exclamation',
					options: [
						'fat fa-sensor-triangle-exclamation', 'fal fa-sensor-triangle-exclamation', 'far fa-sensor-triangle-exclamation', 'fas fa-sensor-triangle-exclamation',
					],
					defaultOption: 'far fa-sensor-triangle-exclamation',
					keywords: 'alarm alert carbon monoxide detector fire smoke sensor triangle-exclamation',
				},
				{
					className: 'far fa-shower',
					options: [
						'fat fa-shower', 'fal fa-shower', 'far fa-shower', 'fas fa-shower',
					],
					defaultOption: 'far fa-shower',
					keywords: 'bath clean faucet shower water shower',
				},
				{
					className: 'far fa-shower-down',
					options: [
						'fat fa-shower-down', 'fal fa-shower-down', 'far fa-shower-down', 'fas fa-shower-down',
					],
					defaultOption: 'far fa-shower-down',
					keywords: 'bath drip hygiene water shower down',
				},
				{
					className: 'far fa-shutters',
					options: [
						'fat fa-shutters', 'fal fa-shutters', 'far fa-shutters', 'fas fa-shutters',
					],
					defaultOption: 'far fa-shutters',
					keywords: 'damper fire shades window shutters',
				},
				{
					className: 'far fa-signal-stream',
					options: [
						'fat fa-signal-stream', 'fal fa-signal-stream', 'far fa-signal-stream', 'fas fa-signal-stream',
					],
					defaultOption: 'far fa-signal-stream',
					keywords: 'podcast radio sisngal streaming wave wifi wireless signal stream',
				},
				{
					className: 'far fa-sink',
					options: [
						'fat fa-sink', 'fal fa-sink', 'far fa-sink', 'fas fa-sink',
					],
					defaultOption: 'far fa-sink',
					keywords: 'bathroom covid 19 faucet kitchen wash sink',
				},
				{
					className: 'far fa-siren',
					options: [
						'fat fa-siren', 'fal fa-siren', 'far fa-siren', 'fas fa-siren',
					],
					defaultOption: 'far fa-siren',
					keywords: 'alarm alert ambulance loud police warning siren',
				},
				{
					className: 'far fa-siren-on',
					options: [
						'fat fa-siren-on', 'fal fa-siren-on', 'far fa-siren-on', 'fas fa-siren-on',
					],
					defaultOption: 'far fa-siren-on',
					keywords: 'alarm alert ambulance loud police warning siren on',
				},
				{
					className: 'far fa-snowflake',
					options: [
						'fat fa-snowflake', 'fal fa-snowflake', 'far fa-snowflake', 'fas fa-snowflake',
					],
					defaultOption: 'far fa-snowflake',
					keywords: 'heavy chevron snowflake cold precipitation rain snow snowflake winter snowflake',
				},
				{
					className: 'far fa-soap',
					options: [
						'fat fa-soap', 'fal fa-soap', 'far fa-soap', 'fas fa-soap',
					],
					defaultOption: 'far fa-soap',
					keywords: 'bar bathing bubbles clean cleaning covid 19 hygiene lather soap soapdish wash soap',
				},
				{
					className: 'far fa-speaker',
					options: [
						'fat fa-speaker', 'fal fa-speaker', 'far fa-speaker', 'fas fa-speaker',
					],
					defaultOption: 'far fa-speaker',
					keywords: 'audio device music sound subwoofer transducer tweeter speaker',
				},
				{
					className: 'far fa-speakers',
					options: [
						'fat fa-speakers', 'fal fa-speakers', 'far fa-speakers', 'fas fa-speakers',
					],
					defaultOption: 'far fa-speakers',
					keywords: 'audio device group music sound subwoofer transducer tweeter speakers',
				},
				{
					className: 'far fa-spoon',
					options: [
						'fat fa-spoon', 'fal fa-spoon', 'far fa-spoon', 'fas fa-spoon',
					],
					defaultOption: 'far fa-spoon',
					keywords: 'cutlery dining scoop silverware spoon tableware spoon',
				},
				{
					className: 'far fa-sprinkler',
					options: [
						'fat fa-sprinkler', 'fal fa-sprinkler', 'far fa-sprinkler', 'fas fa-sprinkler',
					],
					defaultOption: 'far fa-sprinkler',
					keywords: 'grass lawn shower spray water sprinkler',
				},
				{
					className: 'far fa-sprinkler-ceiling',
					options: [
						'fat fa-sprinkler-ceiling', 'fal fa-sprinkler-ceiling', 'far fa-sprinkler-ceiling', 'fas fa-sprinkler-ceiling',
					],
					defaultOption: 'far fa-sprinkler-ceiling',
					keywords: 'emergency fire water sprinkler ceiling',
				},
				{
					className: 'far fa-square-ring',
					options: [
						'fat fa-square-ring', 'fal fa-square-ring', 'far fa-square-ring', 'fas fa-square-ring',
					],
					defaultOption: 'far fa-square-ring',
					keywords: 'pipe service square ring',
				},
				{
					className: 'far fa-stairs',
					options: [
						'fat fa-stairs', 'fal fa-stairs', 'far fa-stairs', 'fas fa-stairs',
					],
					defaultOption: 'far fa-stairs',
					keywords: 'exit steps up stairs',
				},
				{
					className: 'far fa-tank-water',
					options: [
						'fat fa-tank-water', 'fal fa-tank-water', 'far fa-tank-water', 'fas fa-tank-water',
					],
					defaultOption: 'far fa-tank-water',
					keywords: 'hydration storage water tank water',
				},
				{
					className: 'far fa-temperature-arrow-down',
					options: [
						'fat fa-temperature-arrow-down', 'fal fa-temperature-arrow-down', 'far fa-temperature-arrow-down', 'fas fa-temperature-arrow-down',
					],
					defaultOption: 'far fa-temperature-arrow-down',
					keywords: 'air conditioner cold heater mercury thermometer winter temperature arrow-down',
				},
				{
					className: 'far fa-temperature-arrow-up',
					options: [
						'fat fa-temperature-arrow-up', 'fal fa-temperature-arrow-up', 'far fa-temperature-arrow-up', 'fas fa-temperature-arrow-up',
					],
					defaultOption: 'far fa-temperature-arrow-up',
					keywords: 'air conditioner cold heater mercury thermometer winter temperature arrow-up',
				},
				{
					className: 'far fa-toilet',
					options: [
						'fat fa-toilet', 'fal fa-toilet', 'far fa-toilet', 'fas fa-toilet',
					],
					defaultOption: 'far fa-toilet',
					keywords: 'bathroom flush john loo pee plumbing poop porcelain potty restroom throne toile toilet washroom waste wc toilet',
				},
				{
					className: 'far fa-toilet-paper',
					options: [
						'fat fa-toilet-paper', 'fal fa-toilet-paper', 'far fa-toilet-paper', 'fas fa-toilet-paper',
					],
					defaultOption: 'far fa-toilet-paper',
					keywords: 'bathroom covid 19 halloween holiday lavatory paper towels prank privy restroom roll roll of paper toilet toilet paper wipe toilet-paper',
				},
				{
					className: 'far fa-toilet-paper-blank',
					options: [
						'fat fa-toilet-paper-blank', 'fal fa-toilet-paper-blank', 'far fa-toilet-paper-blank', 'fas fa-toilet-paper-blank',
					],
					defaultOption: 'far fa-toilet-paper-blank',
					keywords: 'bathroom halloween lavatory prank privy restroom roll toilet wipe toilet paper-blank',
				},
				{
					className: 'far fa-toilet-paper-blank-under',
					options: [
						'fat fa-toilet-paper-blank-under', 'fal fa-toilet-paper-blank-under', 'far fa-toilet-paper-blank-under', 'fas fa-toilet-paper-blank-under',
					],
					defaultOption: 'far fa-toilet-paper-blank-under',
					keywords: 'bathroom lavatory privy restroom roll toilet wipe toilet paper-blank-under',
				},
				{
					className: 'far fa-toilet-paper-slash',
					options: [
						'fat fa-toilet-paper-slash', 'fal fa-toilet-paper-slash', 'far fa-toilet-paper-slash', 'fas fa-toilet-paper-slash',
					],
					defaultOption: 'far fa-toilet-paper-slash',
					keywords: 'bathroom covid 19 halloween holiday lavatory leaves prank privy restroom roll toilet trouble ut oh wipe toilet-paper-slash',
				},
				{
					className: 'far fa-toilet-paper-under',
					options: [
						'fat fa-toilet-paper-under', 'fal fa-toilet-paper-under', 'far fa-toilet-paper-under', 'fas fa-toilet-paper-under',
					],
					defaultOption: 'far fa-toilet-paper-under',
					keywords: 'bathroom lavatory privy restroom roll toilet wipe toilet paper-under',
				},
				{
					className: 'far fa-toilet-paper-under-slash',
					options: [
						'fat fa-toilet-paper-under-slash', 'fal fa-toilet-paper-under-slash', 'far fa-toilet-paper-under-slash', 'fas fa-toilet-paper-under-slash',
					],
					defaultOption: 'far fa-toilet-paper-under-slash',
					keywords: 'bathroom lavatory privy restroom roll toilet wipe toilet paper-under-slash',
				},
				{
					className: 'far fa-tv',
					options: [
						'fat fa-tv', 'fal fa-tv', 'far fa-tv', 'fas fa-tv',
					],
					defaultOption: 'far fa-tv',
					keywords: 'computer display monitor television tv',
				},
				{
					className: 'far fa-tv-retro',
					options: [
						'fat fa-tv-retro', 'fal fa-tv-retro', 'far fa-tv-retro', 'fas fa-tv-retro',
					],
					defaultOption: 'far fa-tv-retro',
					keywords: 'computer display monitor television tv video tv retro',
				},
				{
					className: 'far fa-utensils',
					options: [
						'fat fa-utensils', 'fal fa-utensils', 'far fa-utensils', 'fas fa-utensils',
					],
					defaultOption: 'far fa-utensils',
					keywords: 'cooking cutlery dining dinner eat food fork fork and knife knife restaurant utensils',
				},
				{
					className: 'far fa-utensils-slash',
					options: [
						'fat fa-utensils-slash', 'fal fa-utensils-slash', 'far fa-utensils-slash', 'fas fa-utensils-slash',
					],
					defaultOption: 'far fa-utensils-slash',
					keywords: 'cooking cutlery dining dinner eat food fork fork and knife knife restaurant utensils slash',
				},
				{
					className: 'far fa-vacuum',
					options: [
						'fat fa-vacuum', 'fal fa-vacuum', 'far fa-vacuum', 'fas fa-vacuum',
					],
					defaultOption: 'far fa-vacuum',
					keywords: 'cleaning dyson floor suck suction vacuum',
				},
				{
					className: 'far fa-vacuum-robot',
					options: [
						'fat fa-vacuum-robot', 'fal fa-vacuum-robot', 'far fa-vacuum-robot', 'fas fa-vacuum-robot',
					],
					defaultOption: 'far fa-vacuum-robot',
					keywords: 'cleaning floor roomba suck suction vacuum robot',
				},
				{
					className: 'far fa-vent-damper',
					options: [
						'fat fa-vent-damper', 'fal fa-vent-damper', 'far fa-vent-damper', 'fas fa-vent-damper',
					],
					defaultOption: 'far fa-vent-damper',
					keywords: 'air fire hvac ventilate vent damper',
				},
				{
					className: 'far fa-washing-machine',
					options: [
						'fat fa-washing-machine', 'fal fa-washing-machine', 'far fa-washing-machine', 'fas fa-washing-machine',
					],
					defaultOption: 'far fa-washing-machine',
					keywords: 'clean clothes laundromat laundry washing machine washing machine',
				},
				{
					className: 'far fa-window-frame',
					options: [
						'fat fa-window-frame', 'fal fa-window-frame', 'far fa-window-frame', 'fas fa-window-frame',
					],
					defaultOption: 'far fa-window-frame',
					keywords: 'door frame fresh air glass opening pane transparent view window window frame',
				},
				{
					className: 'far fa-window-frame-open',
					options: [
						'fat fa-window-frame-open', 'fal fa-window-frame-open', 'far fa-window-frame-open', 'fas fa-window-frame-open',
					],
					defaultOption: 'far fa-window-frame-open',
					keywords: 'door glass pane view window window frame-open',
				},
			],
		},
		{
			id: 'logistics',
			name: Loc.getMessage('LANDING_ICONS_SECTION_LOGISTICS'),
			items: [
				{
					className: 'far fa-barcode-read',
					options: [
						'fat fa-barcode-read', 'fal fa-barcode-read', 'far fa-barcode-read', 'fas fa-barcode-read',
					],
					defaultOption: 'far fa-barcode-read',
					keywords: 'info laser price scan upc barcode read',
				},
				{
					className: 'far fa-barcode-scan',
					options: [
						'fat fa-barcode-scan', 'fal fa-barcode-scan', 'far fa-barcode-scan', 'fas fa-barcode-scan',
					],
					defaultOption: 'far fa-barcode-scan',
					keywords: 'info laser price scan upc barcode scan',
				},
				{
					className: 'far fa-box',
					options: [
						'fat fa-box', 'fal fa-box', 'far fa-box', 'fas fa-box',
					],
					defaultOption: 'far fa-box',
					keywords: 'archive box container package parcel storage box',
				},
				{
					className: 'far fa-box-check',
					options: [
						'fat fa-box-check', 'fal fa-box-check', 'far fa-box-check', 'fas fa-box-check',
					],
					defaultOption: 'far fa-box-check',
					keywords: 'accept agree confirm correct done ok package select success tick todo yes box check',
				},
				{
					className: 'far fa-box-circle-check',
					options: [
						'fat fa-box-circle-check', 'fal fa-box-circle-check', 'far fa-box-circle-check', 'fas fa-box-circle-check',
					],
					defaultOption: 'far fa-box-circle-check',
					keywords: 'confirm inventory package box circle-check',
				},
				{
					className: 'far fa-boxes-stacked',
					options: [
						'fat fa-boxes-stacked', 'fal fa-boxes-stacked', 'far fa-boxes-stacked', 'fas fa-boxes-stacked',
					],
					defaultOption: 'far fa-boxes-stacked',
					keywords: 'archives inventory storage warehouse boxes stacked',
				},
				{
					className: 'far fa-cart-flatbed',
					options: [
						'fat fa-cart-flatbed', 'fal fa-cart-flatbed', 'far fa-cart-flatbed', 'fas fa-cart-flatbed',
					],
					defaultOption: 'far fa-cart-flatbed',
					keywords: 'carry inventory shipping transport cart flatbed',
				},
				{
					className: 'far fa-cart-flatbed-boxes',
					options: [
						'fat fa-cart-flatbed-boxes', 'fal fa-cart-flatbed-boxes', 'far fa-cart-flatbed-boxes', 'fas fa-cart-flatbed-boxes',
					],
					defaultOption: 'far fa-cart-flatbed-boxes',
					keywords: 'carry inventory shipping transport cart flatbed-boxes',
				},
				{
					className: 'far fa-cart-flatbed-empty',
					options: [
						'fat fa-cart-flatbed-empty', 'fal fa-cart-flatbed-empty', 'far fa-cart-flatbed-empty', 'fas fa-cart-flatbed-empty',
					],
					defaultOption: 'far fa-cart-flatbed-empty',
					keywords: 'carry inventory shipping transport cart flatbed-empty',
				},
				{
					className: 'far fa-clipboard-check',
					options: [
						'fat fa-clipboard-check', 'fal fa-clipboard-check', 'far fa-clipboard-check', 'fas fa-clipboard-check',
					],
					defaultOption: 'far fa-clipboard-check',
					keywords: 'accept agree confirm done ok select success tick todo yes clipboard check',
				},
				{
					className: 'far fa-clipboard-list',
					options: [
						'fat fa-clipboard-list', 'fal fa-clipboard-list', 'far fa-clipboard-list', 'fas fa-clipboard-list',
					],
					defaultOption: 'far fa-clipboard-list',
					keywords: 'checklist completed done finished intinerary ol schedule tick todo ul clipboard list',
				},
				{
					className: 'far fa-conveyor-belt',
					options: [
						'fat fa-conveyor-belt', 'fal fa-conveyor-belt', 'far fa-conveyor-belt', 'fas fa-conveyor-belt',
					],
					defaultOption: 'far fa-conveyor-belt',
					keywords: 'carousel inventory manufacture packaging shipping conveyor belt',
				},
				{
					className: 'far fa-conveyor-belt-boxes',
					options: [
						'fat fa-conveyor-belt-boxes', 'fal fa-conveyor-belt-boxes', 'far fa-conveyor-belt-boxes', 'fas fa-conveyor-belt-boxes',
					],
					defaultOption: 'far fa-conveyor-belt-boxes',
					keywords: 'carousel inventory manufacture packaging shipping conveyor belt-boxes',
				},
				{
					className: 'far fa-conveyor-belt-empty',
					options: [
						'fat fa-conveyor-belt-empty', 'fal fa-conveyor-belt-empty', 'far fa-conveyor-belt-empty', 'fas fa-conveyor-belt-empty',
					],
					defaultOption: 'far fa-conveyor-belt-empty',
					keywords: 'inventory shipping conveyor belt-empty',
				},
				{
					className: 'far fa-crate-empty',
					options: [
						'fat fa-crate-empty', 'fal fa-crate-empty', 'far fa-crate-empty', 'fas fa-crate-empty',
					],
					defaultOption: 'far fa-crate-empty',
					keywords: 'box crate crate empty',
				},
				{
					className: 'far fa-dolly',
					options: [
						'fat fa-dolly', 'fal fa-dolly', 'far fa-dolly', 'fas fa-dolly',
					],
					defaultOption: 'far fa-dolly',
					keywords: 'carry shipping transport dolly',
				},
				{
					className: 'far fa-dolly-empty',
					options: [
						'fat fa-dolly-empty', 'fal fa-dolly-empty', 'far fa-dolly-empty', 'fas fa-dolly-empty',
					],
					defaultOption: 'far fa-dolly-empty',
					keywords: 'carry inventory shipping transport dolly empty',
				},
				{
					className: 'far fa-forklift',
					options: [
						'fat fa-forklift', 'fal fa-forklift', 'far fa-forklift', 'fas fa-forklift',
					],
					defaultOption: 'far fa-forklift',
					keywords: 'archive inventory lorry pallet shipping tractor warehouse forklift',
				},
				{
					className: 'far fa-gears',
					options: [
						'fat fa-gears', 'fal fa-gears', 'far fa-gears', 'fas fa-gears',
					],
					defaultOption: 'far fa-gears',
					keywords: 'gears mechanical settings sprocket wheel gears',
				},
				{
					className: 'far fa-hand-holding-box',
					options: [
						'fat fa-hand-holding-box', 'fal fa-hand-holding-box', 'far fa-hand-holding-box', 'fas fa-hand-holding-box',
					],
					defaultOption: 'far fa-hand-holding-box',
					keywords: 'carry gift handling lift package hand holding-box',
				},
				{
					className: 'far fa-hands-holding-diamond',
					options: [
						'fat fa-hands-holding-diamond', 'fal fa-hands-holding-diamond', 'far fa-hands-holding-diamond', 'fas fa-hands-holding-diamond',
					],
					defaultOption: 'far fa-hands-holding-diamond',
					keywords: 'carry gift handling package shipping hands holding-diamond',
				},
				{
					className: 'far fa-helmet-safety',
					options: [
						'fat fa-helmet-safety', 'fal fa-helmet-safety', 'far fa-helmet-safety', 'fas fa-helmet-safety',
					],
					defaultOption: 'far fa-helmet-safety',
					keywords: 'construction hardhat helmet safety helmet safety',
				},
				{
					className: 'far fa-pallet',
					options: [
						'fat fa-pallet', 'fal fa-pallet', 'far fa-pallet', 'fas fa-pallet',
					],
					defaultOption: 'far fa-pallet',
					keywords: 'archive box inventory shipping warehouse pallet',
				},
				{
					className: 'far fa-pallet-box',
					options: [
						'fat fa-pallet-box', 'fal fa-pallet-box', 'far fa-pallet-box', 'fas fa-pallet-box',
					],
					defaultOption: 'far fa-pallet-box',
					keywords: 'inventory package shipping pallet box',
				},
				{
					className: 'far fa-pallet-boxes',
					options: [
						'fat fa-pallet-boxes', 'fal fa-pallet-boxes', 'far fa-pallet-boxes', 'fas fa-pallet-boxes',
					],
					defaultOption: 'far fa-pallet-boxes',
					keywords: 'archive box inventory shipping warehouse pallet boxes',
				},
				{
					className: 'far fa-person-carry-box',
					options: [
						'fat fa-person-carry-box', 'fal fa-person-carry-box', 'far fa-person-carry-box', 'fas fa-person-carry-box',
					],
					defaultOption: 'far fa-person-carry-box',
					keywords: 'deliver lift person carry-box',
				},
				{
					className: 'far fa-person-dolly',
					options: [
						'fat fa-person-dolly', 'fal fa-person-dolly', 'far fa-person-dolly', 'fas fa-person-dolly',
					],
					defaultOption: 'far fa-person-dolly',
					keywords: 'carry deliver transport person dolly',
				},
				{
					className: 'far fa-person-dolly-empty',
					options: [
						'fat fa-person-dolly-empty', 'fal fa-person-dolly-empty', 'far fa-person-dolly-empty', 'fas fa-person-dolly-empty',
					],
					defaultOption: 'far fa-person-dolly-empty',
					keywords: 'carry deliver transport person dolly-empty',
				},
				{
					className: 'far fa-rectangle-barcode',
					options: [
						'fat fa-rectangle-barcode', 'fal fa-rectangle-barcode', 'far fa-rectangle-barcode', 'fas fa-rectangle-barcode',
					],
					defaultOption: 'far fa-rectangle-barcode',
					keywords: 'info laser price scan upc rectangle barcode',
				},
				{
					className: 'far fa-reel',
					options: [
						'fat fa-reel', 'fal fa-reel', 'far fa-reel', 'fas fa-reel',
					],
					defaultOption: 'far fa-reel',
					keywords: 'needle sewing spool string thread wire reel',
				},
				{
					className: 'far fa-scanner-gun',
					options: [
						'fat fa-scanner-gun', 'fal fa-scanner-gun', 'far fa-scanner-gun', 'fas fa-scanner-gun',
					],
					defaultOption: 'far fa-scanner-gun',
					keywords: 'barcode checkout gun inventory price upc warehouse scanner gun',
				},
				{
					className: 'far fa-scanner-keyboard',
					options: [
						'fat fa-scanner-keyboard', 'fal fa-scanner-keyboard', 'far fa-scanner-keyboard', 'fas fa-scanner-keyboard',
					],
					defaultOption: 'far fa-scanner-keyboard',
					keywords: 'barcode checkout gun inventory price upc warehouse scanner keyboard',
				},
				{
					className: 'far fa-scanner-touchscreen',
					options: [
						'fat fa-scanner-touchscreen', 'fal fa-scanner-touchscreen', 'far fa-scanner-touchscreen', 'fas fa-scanner-touchscreen',
					],
					defaultOption: 'far fa-scanner-touchscreen',
					keywords: 'barcode checkout gun inventory price upc warehouse scanner touchscreen',
				},
				{
					className: 'far fa-shelves',
					options: [
						'fat fa-shelves', 'fal fa-shelves', 'far fa-shelves', 'fas fa-shelves',
					],
					defaultOption: 'far fa-shelves',
					keywords: 'archive box shipping warehouse shelves',
				},
				{
					className: 'far fa-shelves-empty',
					options: [
						'fat fa-shelves-empty', 'fal fa-shelves-empty', 'far fa-shelves-empty', 'fas fa-shelves-empty',
					],
					defaultOption: 'far fa-shelves-empty',
					keywords: 'bookshelf inventory stock shelves empty',
				},
				{
					className: 'far fa-tablet-rugged',
					options: [
						'fat fa-tablet-rugged', 'fal fa-tablet-rugged', 'far fa-tablet-rugged', 'fas fa-tablet-rugged',
					],
					defaultOption: 'far fa-tablet-rugged',
					keywords: 'device durable protection screen tough tablet rugged',
				},
				{
					className: 'far fa-truck',
					options: [
						'fat fa-truck', 'fal fa-truck', 'far fa-truck', 'fas fa-truck',
					],
					defaultOption: 'far fa-truck',
					keywords: 'black truck cargo delivery delivery truck shipping truck vehicle truck',
				},
				{
					className: 'far fa-truck-clock',
					options: [
						'fat fa-truck-clock', 'fal fa-truck-clock', 'far fa-truck-clock', 'fas fa-truck-clock',
					],
					defaultOption: 'far fa-truck-clock',
					keywords: 'express fedex mail overnight package ups truck clock',
				},
				{
					className: 'far fa-truck-container-empty',
					options: [
						'fat fa-truck-container-empty', 'fal fa-truck-container-empty', 'far fa-truck-container-empty', 'fas fa-truck-container-empty',
					],
					defaultOption: 'far fa-truck-container-empty',
					keywords: 'container flatbed shipping truck container-empty',
				},
				{
					className: 'far fa-truck-fast',
					options: [
						'fat fa-truck-fast', 'fal fa-truck-fast', 'far fa-truck-fast', 'fas fa-truck-fast',
					],
					defaultOption: 'far fa-truck-fast',
					keywords: 'express fedex mail overnight package ups truck fast',
				},
				{
					className: 'far fa-truck-flatbed',
					options: [
						'fat fa-truck-flatbed', 'fal fa-truck-flatbed', 'far fa-truck-flatbed', 'fas fa-truck-flatbed',
					],
					defaultOption: 'far fa-truck-flatbed',
					keywords: 'container flatbed shipping truck flatbed',
				},
				{
					className: 'far fa-truck-front',
					options: [
						'fat fa-truck-front', 'fal fa-truck-front', 'far fa-truck-front', 'fas fa-truck-front',
					],
					defaultOption: 'far fa-truck-front',
					keywords: 'shuttle truck van truck front',
				},
				{
					className: 'far fa-user-helmet-safety',
					options: [
						'fat fa-user-helmet-safety', 'fal fa-user-helmet-safety', 'far fa-user-helmet-safety', 'fas fa-user-helmet-safety',
					],
					defaultOption: 'far fa-user-helmet-safety',
					keywords: 'construction construction worker hardhat hat helmet safety worker user helmet-safety',
				},
				{
					className: 'far fa-warehouse',
					options: [
						'fat fa-warehouse', 'fal fa-warehouse', 'far fa-warehouse', 'fas fa-warehouse',
					],
					defaultOption: 'far fa-warehouse',
					keywords: 'building capacity garage inventory storage warehouse',
				},
				{
					className: 'far fa-warehouse-full',
					options: [
						'fat fa-warehouse-full', 'fal fa-warehouse-full', 'far fa-warehouse-full', 'fas fa-warehouse-full',
					],
					defaultOption: 'far fa-warehouse-full',
					keywords: 'building capacity garage inventory storage warehouse full',
				},
			],
		},
		{
			id: 'maps',
			name: Loc.getMessage('LANDING_ICONS_SECTION_MAPS'),
			items: [
				{
					className: 'far fa-anchor',
					options: [
						'fat fa-anchor', 'fal fa-anchor', 'far fa-anchor', 'fas fa-anchor',
					],
					defaultOption: 'far fa-anchor',
					keywords: 'anchor berth boat dock embed link maritime moor secure ship tool anchor',
				},
				{
					className: 'far fa-bag-shopping',
					options: [
						'fat fa-bag-shopping', 'fal fa-bag-shopping', 'far fa-bag-shopping', 'fas fa-bag-shopping',
					],
					defaultOption: 'far fa-bag-shopping',
					keywords: 'buy checkout grocery payment purchase bag shopping',
				},
				{
					className: 'far fa-bags-shopping',
					options: [
						'fat fa-bags-shopping', 'fal fa-bags-shopping', 'far fa-bags-shopping', 'fas fa-bags-shopping',
					],
					defaultOption: 'far fa-bags-shopping',
					keywords: 'bag buy checkout hotel order shopping shopping bags store bags shopping',
				},
				{
					className: 'far fa-ban-parking',
					options: [
						'fat fa-ban-parking', 'fal fa-ban-parking', 'far fa-ban-parking', 'fas fa-ban-parking',
					],
					defaultOption: 'far fa-ban-parking',
					keywords: 'auto car garage meter ban parking',
				},
				{
					className: 'far fa-bank',
					options: [
						'fat fa-bank', 'fal fa-bank', 'far fa-bank', 'fas fa-bank',
					],
					defaultOption: 'far fa-bank',
					keywords: 'bank building college higher education       students institution bank',
				},
				{
					className: 'far fa-basket-shopping',
					options: [
						'fat fa-basket-shopping', 'fal fa-basket-shopping', 'far fa-basket-shopping', 'fas fa-basket-shopping',
					],
					defaultOption: 'far fa-basket-shopping',
					keywords: 'buy checkout grocery payment purchase basket shopping',
				},
				{
					className: 'far fa-bath',
					options: [
						'fat fa-bath', 'fal fa-bath', 'far fa-bath', 'fas fa-bath',
					],
					defaultOption: 'far fa-bath',
					keywords: 'bath bathtub clean shower tub wash bath',
				},
				{
					className: 'far fa-bed',
					options: [
						'fat fa-bed', 'fal fa-bed', 'far fa-bed', 'fas fa-bed',
					],
					defaultOption: 'far fa-bed',
					keywords: 'hotel lodging mattress person in bed rest sleep travel bed',
				},
				{
					className: 'far fa-beer-mug-empty',
					options: [
						'fat fa-beer-mug-empty', 'fal fa-beer-mug-empty', 'far fa-beer-mug-empty', 'fas fa-beer-mug-empty',
					],
					defaultOption: 'far fa-beer-mug-empty',
					keywords: 'alcohol ale bar beverage brew brewery drink foam lager liquor mug stein beer mug-empty',
				},
				{
					className: 'far fa-bell',
					options: [
						'fat fa-bell', 'fal fa-bell', 'far fa-bell', 'fas fa-bell',
					],
					defaultOption: 'far fa-bell',
					keywords: 'alarm alert bel bell chime notification reminder bell',
				},
				{
					className: 'far fa-bell-slash',
					options: [
						'fat fa-bell-slash', 'fal fa-bell-slash', 'far fa-bell-slash', 'fas fa-bell-slash',
					],
					defaultOption: 'far fa-bell-slash',
					keywords: 'alert bell bell with slash cancel disabled forbidden mute notification off quiet reminder silent bell slash',
				},
				{
					className: 'far fa-bicycle',
					options: [
						'fat fa-bicycle', 'fal fa-bicycle', 'far fa-bicycle', 'fas fa-bicycle',
					],
					defaultOption: 'far fa-bicycle',
					keywords: 'bicycle bike gears pedal transportation vehicle bicycle',
				},
				{
					className: 'far fa-binoculars',
					options: [
						'fat fa-binoculars', 'fal fa-binoculars', 'far fa-binoculars', 'fas fa-binoculars',
					],
					defaultOption: 'far fa-binoculars',
					keywords: 'glasses magnify scenic spyglass view binoculars',
				},
				{
					className: 'far fa-bomb',
					options: [
						'fat fa-bomb', 'fal fa-bomb', 'far fa-bomb', 'fas fa-bomb',
					],
					defaultOption: 'far fa-bomb',
					keywords: 'bomb comic error explode fuse grenade warning bomb',
				},
				{
					className: 'far fa-book',
					options: [
						'fat fa-book', 'fal fa-book', 'far fa-book', 'fas fa-book',
					],
					defaultOption: 'far fa-book',
					keywords: 'book cover decorated diary documentation journal library notebook notebook with decorative cover read research book',
				},
				{
					className: 'far fa-book-atlas',
					options: [
						'fat fa-book-atlas', 'fal fa-book-atlas', 'far fa-book-atlas', 'fas fa-book-atlas',
					],
					defaultOption: 'far fa-book-atlas',
					keywords: 'book directions geography globe library map research travel wayfinding book atlas',
				},
				{
					className: 'far fa-bookmark',
					options: [
						'fat fa-bookmark', 'fal fa-bookmark', 'far fa-bookmark', 'fas fa-bookmark',
					],
					defaultOption: 'far fa-bookmark',
					keywords: 'bookmark favorite library mark marker read remember research save bookmark',
				},
				{
					className: 'far fa-briefcase',
					options: [
						'fat fa-briefcase', 'fal fa-briefcase', 'far fa-briefcase', 'fas fa-briefcase',
					],
					defaultOption: 'far fa-briefcase',
					keywords: 'bag briefcas briefcase business luggage office work briefcase',
				},
				{
					className: 'far fa-building',
					options: [
						'fat fa-building', 'fal fa-building', 'far fa-building', 'fas fa-building',
					],
					defaultOption: 'far fa-building',
					keywords: 'apartment building business city company office office building work building',
				},
				{
					className: 'far fa-cake-candles',
					options: [
						'fat fa-cake-candles', 'fal fa-cake-candles', 'far fa-cake-candles', 'fas fa-cake-candles',
					],
					defaultOption: 'far fa-cake-candles',
					keywords: 'anniversary bakery birthday birthday cake cake candles celebration dessert frosting holiday party pastry sweet cake candles',
				},
				{
					className: 'far fa-camera-cctv',
					options: [
						'fat fa-camera-cctv', 'fal fa-camera-cctv', 'far fa-camera-cctv', 'fas fa-camera-cctv',
					],
					defaultOption: 'far fa-camera-cctv',
					keywords: '1984 big brother george orwell camera security surveillance video camera cctv',
				},
				{
					className: 'far fa-car',
					options: [
						'fat fa-car', 'fal fa-car', 'far fa-car', 'fas fa-car',
					],
					defaultOption: 'far fa-car',
					keywords: 'auto automobile car oncoming oncoming automobile sedan transportation travel vehicle car',
				},
				{
					className: 'far fa-cart-shopping',
					options: [
						'fat fa-cart-shopping', 'fal fa-cart-shopping', 'far fa-cart-shopping', 'fas fa-cart-shopping',
					],
					defaultOption: 'far fa-cart-shopping',
					keywords: 'buy cart checkout grocery payment purchase shopping shopping cart trolley cart shopping',
				},
				{
					className: 'far fa-circle-dollar',
					options: [
						'fat fa-circle-dollar', 'fal fa-circle-dollar', 'far fa-circle-dollar', 'fas fa-circle-dollar',
					],
					defaultOption: 'far fa-circle-dollar',
					keywords: '$ currency dollar sign money price usd circle-dollar',
				},
				{
					className: 'far fa-circle-info',
					options: [
						'fat fa-circle-info', 'fal fa-circle-info', 'far fa-circle-info', 'fas fa-circle-info',
					],
					defaultOption: 'far fa-circle-info',
					keywords: 'details help information more support circle info',
				},
				{
					className: 'far fa-circle-location-arrow',
					options: [
						'fat fa-circle-location-arrow', 'fal fa-circle-location-arrow', 'far fa-circle-location-arrow', 'fas fa-circle-location-arrow',
					],
					defaultOption: 'far fa-circle-location-arrow',
					keywords: 'address compass coordinate direction gps map navigation place circle location-arrow',
				},
				{
					className: 'far fa-circle-parking',
					options: [
						'fat fa-circle-parking', 'fal fa-circle-parking', 'far fa-circle-parking', 'fas fa-circle-parking',
					],
					defaultOption: 'far fa-circle-parking',
					keywords: 'auto car garage meter circle parking',
				},
				{
					className: 'far fa-compass-slash',
					options: [
						'fat fa-compass-slash', 'fal fa-compass-slash', 'far fa-compass-slash', 'fas fa-compass-slash',
					],
					defaultOption: 'far fa-compass-slash',
					keywords: 'directions directory location lost menu navigation safari travel compass slash',
				},
				{
					className: 'far fa-crosshairs',
					options: [
						'fat fa-crosshairs', 'fal fa-crosshairs', 'far fa-crosshairs', 'fas fa-crosshairs',
					],
					defaultOption: 'far fa-crosshairs',
					keywords: 'aim bullseye gpd picker position crosshairs',
				},
				{
					className: 'far fa-diamond-turn-right',
					options: [
						'fat fa-diamond-turn-right', 'fal fa-diamond-turn-right', 'far fa-diamond-turn-right', 'fas fa-diamond-turn-right',
					],
					defaultOption: 'far fa-diamond-turn-right',
					keywords: 'map navigation sign turn diamond turn-right',
				},
				{
					className: 'far fa-do-not-enter',
					options: [
						'fat fa-do-not-enter', 'fal fa-do-not-enter', 'far fa-do-not-enter', 'fas fa-do-not-enter',
					],
					defaultOption: 'far fa-do-not-enter',
					keywords: 'closed traffic warning do not-enter',
				},
				{
					className: 'far fa-dollar-sign',
					options: [
						'fat fa-dollar-sign', 'fal fa-dollar-sign', 'far fa-dollar-sign', 'fas fa-dollar-sign',
					],
					defaultOption: 'far fa-dollar-sign',
					keywords: 'dollar sign currency dollar heavy dollar sign money dollar sign',
				},
				{
					className: 'far fa-draw-circle',
					options: [
						'fat fa-draw-circle', 'fal fa-draw-circle', 'far fa-draw-circle', 'fas fa-draw-circle',
					],
					defaultOption: 'far fa-draw-circle',
					keywords: 'anchors lines object render shape draw circle',
				},
				{
					className: 'far fa-draw-polygon',
					options: [
						'fat fa-draw-polygon', 'fal fa-draw-polygon', 'far fa-draw-polygon', 'fas fa-draw-polygon',
					],
					defaultOption: 'far fa-draw-polygon',
					keywords: 'anchors lines object render shape draw polygon',
				},
				{
					className: 'far fa-draw-square',
					options: [
						'fat fa-draw-square', 'fal fa-draw-square', 'far fa-draw-square', 'fas fa-draw-square',
					],
					defaultOption: 'far fa-draw-square',
					keywords: 'anchors lines object render shape draw square',
				},
				{
					className: 'far fa-droplet',
					options: [
						'fat fa-droplet', 'fal fa-droplet', 'far fa-droplet', 'fas fa-droplet',
					],
					defaultOption: 'far fa-droplet',
					keywords: 'cold color comic drop droplet raindrop sweat waterdrop droplet',
				},
				{
					className: 'far fa-eye',
					options: [
						'fat fa-eye', 'fal fa-eye', 'far fa-eye', 'fas fa-eye',
					],
					defaultOption: 'far fa-eye',
					keywords: 'body eye look optic see seen show sight views visible eye',
				},
				{
					className: 'far fa-eye-low-vision',
					options: [
						'fat fa-eye-low-vision', 'fal fa-eye-low-vision', 'far fa-eye-low-vision', 'fas fa-eye-low-vision',
					],
					defaultOption: 'far fa-eye-low-vision',
					keywords: 'blind eye sight eye low-vision',
				},
				{
					className: 'far fa-eye-slash',
					options: [
						'fat fa-eye-slash', 'fal fa-eye-slash', 'far fa-eye-slash', 'fas fa-eye-slash',
					],
					defaultOption: 'far fa-eye-slash',
					keywords: 'blind hide show toggle unseen views visible visiblity eye slash',
				},
				{
					className: 'far fa-fire',
					options: [
						'fat fa-fire', 'fal fa-fire', 'far fa-fire', 'fas fa-fire',
					],
					defaultOption: 'far fa-fire',
					keywords: 'burn caliente fire flame heat hot popular tool fire',
				},
				{
					className: 'far fa-fire-extinguisher',
					options: [
						'fat fa-fire-extinguisher', 'fal fa-fire-extinguisher', 'far fa-fire-extinguisher', 'fas fa-fire-extinguisher',
					],
					defaultOption: 'far fa-fire-extinguisher',
					keywords: 'burn caliente extinguish fire fire extinguisher fire fighter flame heat hot quench rescue fire extinguisher',
				},
				{
					className: 'far fa-fire-flame-curved',
					options: [
						'fat fa-fire-flame-curved', 'fal fa-fire-flame-curved', 'far fa-fire-flame-curved', 'fas fa-fire-flame-curved',
					],
					defaultOption: 'far fa-fire-flame-curved',
					keywords: 'burn caliente flame heat hot popular fire flame-curved',
				},
				{
					className: 'far fa-flag',
					options: [
						'fat fa-flag', 'fal fa-flag', 'far fa-flag', 'fas fa-flag',
					],
					defaultOption: 'far fa-flag',
					keywords: 'black flag country notice notification notify pole report symbol waving flag',
				},
				{
					className: 'far fa-flag-checkered',
					options: [
						'fat fa-flag-checkered', 'fal fa-flag-checkered', 'far fa-flag-checkered', 'fas fa-flag-checkered',
					],
					defaultOption: 'far fa-flag-checkered',
					keywords: 'checkered chequered chequered flag notice notification notify pole racing report symbol flag checkered',
				},
				{
					className: 'far fa-flask',
					options: [
						'fat fa-flask', 'fal fa-flask', 'far fa-flask', 'fas fa-flask',
					],
					defaultOption: 'far fa-flask',
					keywords: 'beaker experimental labs science flask',
				},
				{
					className: 'far fa-fork',
					options: [
						'fat fa-fork', 'fal fa-fork', 'far fa-fork', 'fas fa-fork',
					],
					defaultOption: 'far fa-fork',
					keywords: 'cutlery dining food fork silverware fork',
				},
				{
					className: 'far fa-fork-knife',
					options: [
						'fat fa-fork-knife', 'fal fa-fork-knife', 'far fa-fork-knife', 'fas fa-fork-knife',
					],
					defaultOption: 'far fa-fork-knife',
					keywords: 'cutlery dining dinner eat food fork knife restaurant fork knife',
				},
				{
					className: 'far fa-gamepad',
					options: [
						'fat fa-gamepad', 'fal fa-gamepad', 'far fa-gamepad', 'fas fa-gamepad',
					],
					defaultOption: 'far fa-gamepad',
					keywords: 'arcade controller d pad joystick video video game gamepad',
				},
				{
					className: 'far fa-gavel',
					options: [
						'fat fa-gavel', 'fal fa-gavel', 'far fa-gavel', 'fas fa-gavel',
					],
					defaultOption: 'far fa-gavel',
					keywords: 'hammer judge law lawyer opinion gavel',
				},
				{
					className: 'far fa-gift',
					options: [
						'fat fa-gift', 'fal fa-gift', 'far fa-gift', 'fas fa-gift',
					],
					defaultOption: 'far fa-gift',
					keywords: 'box celebration christmas generosity gift giving holiday party present wrapped wrapped gift xmas gift',
				},
				{
					className: 'far fa-globe',
					options: [
						'fat fa-globe', 'fal fa-globe', 'far fa-globe', 'fas fa-globe',
					],
					defaultOption: 'far fa-globe',
					keywords: 'all coordinates country earth global globe globe with meridians gps language localize location map meridians network online place planet translate travel world globe',
				},
				{
					className: 'far fa-graduation-cap',
					options: [
						'fat fa-graduation-cap', 'fal fa-graduation-cap', 'far fa-graduation-cap', 'fas fa-graduation-cap',
					],
					defaultOption: 'far fa-graduation-cap',
					keywords: 'cap celebration ceremony clothing college graduate graduation graduation cap hat learning school student graduation cap',
				},
				{
					className: 'far fa-heart',
					options: [
						'fat fa-heart', 'fal fa-heart', 'far fa-heart', 'fas fa-heart',
					],
					defaultOption: 'far fa-heart',
					keywords: 'black black heart blue blue heart brown brown heart card evil favorite game green green heart heart heart suit like love orange orange heart purple purple heart red heart relationship valentine white white heart wicked yellow yellow heart heart',
				},
				{
					className: 'far fa-heart-pulse',
					options: [
						'fat fa-heart-pulse', 'fal fa-heart-pulse', 'far fa-heart-pulse', 'fas fa-heart-pulse',
					],
					defaultOption: 'far fa-heart-pulse',
					keywords: 'ekg electrocardiogram health lifeline vital signs heart pulse',
				},
				{
					className: 'far fa-helicopter',
					options: [
						'fat fa-helicopter', 'fal fa-helicopter', 'far fa-helicopter', 'fas fa-helicopter',
					],
					defaultOption: 'far fa-helicopter',
					keywords: 'airwolf apache chopper flight fly helicopter travel vehicle helicopter',
				},
				{
					className: 'far fa-hospital',
					options: [
						'fat fa-hospital', 'fal fa-hospital', 'far fa-hospital', 'fas fa-hospital',
					],
					defaultOption: 'far fa-hospital',
					keywords: 'building covid 19 doctor emergency room hospital medical center medicine hospital',
				},
				{
					className: 'far fa-house',
					options: [
						'fat fa-house', 'fal fa-house', 'far fa-house', 'fas fa-house',
					],
					defaultOption: 'far fa-house',
					keywords: 'abode building home house main residence house',
				},
				{
					className: 'far fa-image',
					options: [
						'fat fa-image', 'fal fa-image', 'far fa-image', 'fas fa-image',
					],
					defaultOption: 'far fa-image',
					keywords: 'album landscape photo picture image',
				},
				{
					className: 'far fa-images',
					options: [
						'fat fa-images', 'fal fa-images', 'far fa-images', 'fas fa-images',
					],
					defaultOption: 'far fa-images',
					keywords: 'album landscape photo picture images',
				},
				{
					className: 'far fa-industry',
					options: [
						'fat fa-industry', 'fal fa-industry', 'far fa-industry', 'fas fa-industry',
					],
					defaultOption: 'far fa-industry',
					keywords: 'building factory industrial manufacturing mill warehouse industry',
				},
				{
					className: 'far fa-industry-windows',
					options: [
						'fat fa-industry-windows', 'fal fa-industry-windows', 'far fa-industry-windows', 'fas fa-industry-windows',
					],
					defaultOption: 'far fa-industry-windows',
					keywords: 'building factory industrial manufacturing mill warehouse industry windows',
				},
				{
					className: 'far fa-info',
					options: [
						'fat fa-info', 'fal fa-info', 'far fa-info', 'fas fa-info',
					],
					defaultOption: 'far fa-info',
					keywords: 'details help information more support info',
				},
				{
					className: 'far fa-jet-fighter',
					options: [
						'fat fa-jet-fighter', 'fal fa-jet-fighter', 'far fa-jet-fighter', 'fas fa-jet-fighter',
					],
					defaultOption: 'far fa-jet-fighter',
					keywords: 'airplane fast fly goose maverick plane quick top gun transportation travel jet fighter',
				},
				{
					className: 'far fa-key',
					options: [
						'fat fa-key', 'fal fa-key', 'far fa-key', 'fas fa-key',
					],
					defaultOption: 'far fa-key',
					keywords: 'key lock password private secret unlock key',
				},
				{
					className: 'far fa-knife',
					options: [
						'fat fa-knife', 'fal fa-knife', 'far fa-knife', 'fas fa-knife',
					],
					defaultOption: 'far fa-knife',
					keywords: 'cut cutlery dining silverware tool knife',
				},
				{
					className: 'far fa-landmark',
					options: [
						'fat fa-landmark', 'fal fa-landmark', 'far fa-landmark', 'fas fa-landmark',
					],
					defaultOption: 'far fa-landmark',
					keywords: 'building classical classical building historic memorable monument politics landmark',
				},
				{
					className: 'far fa-layer-group',
					options: [
						'fat fa-layer-group', 'fal fa-layer-group', 'far fa-layer-group', 'fas fa-layer-group',
					],
					defaultOption: 'far fa-layer-group',
					keywords: 'arrange develop layers map stack layer group',
				},
				{
					className: 'far fa-layer-minus',
					options: [
						'fat fa-layer-minus', 'fal fa-layer-minus', 'far fa-layer-minus', 'fas fa-layer-minus',
					],
					defaultOption: 'far fa-layer-minus',
					keywords: 'arrange delete layers negative remove stack layer minus',
				},
				{
					className: 'far fa-layer-plus',
					options: [
						'fat fa-layer-plus', 'fal fa-layer-plus', 'far fa-layer-plus', 'fas fa-layer-plus',
					],
					defaultOption: 'far fa-layer-plus',
					keywords: 'add arrange create layers new positive stack layer plus',
				},
				{
					className: 'far fa-leaf',
					options: [
						'fat fa-leaf', 'fal fa-leaf', 'far fa-leaf', 'fas fa-leaf',
					],
					defaultOption: 'far fa-leaf',
					keywords: 'eco flora nature plant vegan leaf',
				},
				{
					className: 'far fa-lemon',
					options: [
						'fat fa-lemon', 'fal fa-lemon', 'far fa-lemon', 'fas fa-lemon',
					],
					defaultOption: 'far fa-lemon',
					keywords: 'citrus fruit lemon lemonade lime tart lemon',
				},
				{
					className: 'far fa-life-ring',
					options: [
						'fat fa-life-ring', 'fal fa-life-ring', 'far fa-life-ring', 'fas fa-life-ring',
					],
					defaultOption: 'far fa-life-ring',
					keywords: 'coast guard help overboard save support life ring',
				},
				{
					className: 'far fa-lightbulb',
					options: [
						'fat fa-lightbulb', 'fal fa-lightbulb', 'far fa-lightbulb', 'fas fa-lightbulb',
					],
					defaultOption: 'far fa-lightbulb',
					keywords: 'bulb comic electric energy idea inspiration light light bulb lightbulb',
				},
				{
					className: 'far fa-location-arrow',
					options: [
						'fat fa-location-arrow', 'fal fa-location-arrow', 'far fa-location-arrow', 'fas fa-location-arrow',
					],
					defaultOption: 'far fa-location-arrow',
					keywords: 'address compass coordinate direction gps map navigation place location arrow',
				},
				{
					className: 'far fa-location-check',
					options: [
						'fat fa-location-check', 'fal fa-location-check', 'far fa-location-check', 'fas fa-location-check',
					],
					defaultOption: 'far fa-location-check',
					keywords: 'agree coordinates destination location map navigation pin place select success tick todo location check',
				},
				{
					className: 'far fa-location-crosshairs',
					options: [
						'fat fa-location-crosshairs', 'fal fa-location-crosshairs', 'far fa-location-crosshairs', 'fas fa-location-crosshairs',
					],
					defaultOption: 'far fa-location-crosshairs',
					keywords: 'address coordinate direction gps location map navigation place where location crosshairs',
				},
				{
					className: 'far fa-location-crosshairs-slash',
					options: [
						'fat fa-location-crosshairs-slash', 'fal fa-location-crosshairs-slash', 'far fa-location-crosshairs-slash', 'fas fa-location-crosshairs-slash',
					],
					defaultOption: 'far fa-location-crosshairs-slash',
					keywords: 'address coordinate direction gps map navigation place where location crosshairs-slash',
				},
				{
					className: 'far fa-location-dot',
					options: [
						'fat fa-location-dot', 'fal fa-location-dot', 'far fa-location-dot', 'fas fa-location-dot',
					],
					defaultOption: 'far fa-location-dot',
					keywords: 'address coordinates destination gps localize location map navigation paper pin place point of interest position route travel location dot',
				},
				{
					className: 'far fa-location-dot-slash',
					options: [
						'fat fa-location-dot-slash', 'fal fa-location-dot-slash', 'far fa-location-dot-slash', 'fas fa-location-dot-slash',
					],
					defaultOption: 'far fa-location-dot-slash',
					keywords: 'address coordinates destination gps localize location map navigation paper pin place point of interest position route travel location dot-slash',
				},
				{
					className: 'far fa-location-exclamation',
					options: [
						'fat fa-location-exclamation', 'fal fa-location-exclamation', 'far fa-location-exclamation', 'fas fa-location-exclamation',
					],
					defaultOption: 'far fa-location-exclamation',
					keywords: 'agree alert coordinates destination important location map navigation pin place location exclamation',
				},
				{
					className: 'far fa-location-minus',
					options: [
						'fat fa-location-minus', 'fal fa-location-minus', 'far fa-location-minus', 'fas fa-location-minus',
					],
					defaultOption: 'far fa-location-minus',
					keywords: 'agree coordinates delete destination location map navigation negative pin place remove location minus',
				},
				{
					className: 'far fa-location-pen',
					options: [
						'fat fa-location-pen', 'fal fa-location-pen', 'far fa-location-pen', 'fas fa-location-pen',
					],
					defaultOption: 'far fa-location-pen',
					keywords: 'agree coordinates destination edit location map navigation pen pencil pin place update write location pen',
				},
				{
					className: 'far fa-location-pin',
					options: [
						'fat fa-location-pin', 'fal fa-location-pin', 'far fa-location-pin', 'fas fa-location-pin',
					],
					defaultOption: 'far fa-location-pin',
					keywords: 'address coordinates destination gps localize location map navigation paper pin place point of interest position route travel location pin',
				},
				{
					className: 'far fa-location-pin-slash',
					options: [
						'fat fa-location-pin-slash', 'fal fa-location-pin-slash', 'far fa-location-pin-slash', 'fas fa-location-pin-slash',
					],
					defaultOption: 'far fa-location-pin-slash',
					keywords: 'agree cancel coordinates destination location map missing navigation pin place location pin-slash',
				},
				{
					className: 'far fa-location-plus',
					options: [
						'fat fa-location-plus', 'fal fa-location-plus', 'far fa-location-plus', 'fas fa-location-plus',
					],
					defaultOption: 'far fa-location-plus',
					keywords: 'add agree coordinates create destination location map navigation new pin place positive location plus',
				},
				{
					className: 'far fa-location-question',
					options: [
						'fat fa-location-question', 'fal fa-location-question', 'far fa-location-question', 'fas fa-location-question',
					],
					defaultOption: 'far fa-location-question',
					keywords: 'agree coordinates destination help info location map navigation pin place support location question',
				},
				{
					className: 'far fa-location-smile',
					options: [
						'fat fa-location-smile', 'fal fa-location-smile', 'far fa-location-smile', 'fas fa-location-smile',
					],
					defaultOption: 'far fa-location-smile',
					keywords: 'agree coordinates destination emoji happy location map navigation pin place success location smile',
				},
				{
					className: 'far fa-location-xmark',
					options: [
						'fat fa-location-xmark', 'fal fa-location-xmark', 'far fa-location-xmark', 'fas fa-location-xmark',
					],
					defaultOption: 'far fa-location-xmark',
					keywords: 'agree archive coordinates delete destination location map navigation pin place remove x location xmark',
				},
				{
					className: 'far fa-magnet',
					options: [
						'fat fa-magnet', 'fal fa-magnet', 'far fa-magnet', 'fas fa-magnet',
					],
					defaultOption: 'far fa-magnet',
					keywords: 'attract attraction horseshoe lodestone magnet magnetic tool magnet',
				},
				{
					className: 'far fa-magnifying-glass',
					options: [
						'fat fa-magnifying-glass', 'fal fa-magnifying-glass', 'far fa-magnifying-glass', 'fas fa-magnifying-glass',
					],
					defaultOption: 'far fa-magnifying-glass',
					keywords: 'bigger enlarge find glass magnify magnifying magnifying glass tilted left preview search tool zoom magnifying glass',
				},
				{
					className: 'far fa-magnifying-glass-minus',
					options: [
						'fat fa-magnifying-glass-minus', 'fal fa-magnifying-glass-minus', 'far fa-magnifying-glass-minus', 'fas fa-magnifying-glass-minus',
					],
					defaultOption: 'far fa-magnifying-glass-minus',
					keywords: 'minify negative smaller zoom zoom out magnifying glass-minus',
				},
				{
					className: 'far fa-magnifying-glass-plus',
					options: [
						'fat fa-magnifying-glass-plus', 'fal fa-magnifying-glass-plus', 'far fa-magnifying-glass-plus', 'fas fa-magnifying-glass-plus',
					],
					defaultOption: 'far fa-magnifying-glass-plus',
					keywords: 'bigger enlarge magnify positive zoom zoom in magnifying glass-plus',
				},
				{
					className: 'far fa-map',
					options: [
						'fat fa-map', 'fal fa-map', 'far fa-map', 'fas fa-map',
					],
					defaultOption: 'far fa-map',
					keywords: 'address coordinates destination gps localize location map navigation paper pin place point of interest position route travel world world map map',
				},
				{
					className: 'far fa-map-pin',
					options: [
						'fat fa-map-pin', 'fal fa-map-pin', 'far fa-map-pin', 'fas fa-map-pin',
					],
					defaultOption: 'far fa-map-pin',
					keywords: 'address agree coordinates destination gps localize location map marker navigation pin place position pushpin round pushpin travel map pin',
				},
				{
					className: 'far fa-martini-glass-empty',
					options: [
						'fat fa-martini-glass-empty', 'fal fa-martini-glass-empty', 'far fa-martini-glass-empty', 'fas fa-martini-glass-empty',
					],
					defaultOption: 'far fa-martini-glass-empty',
					keywords: 'alcohol bar beverage drink liquor martini glass-empty',
				},
				{
					className: 'far fa-money-bill',
					options: [
						'fat fa-money-bill', 'fal fa-money-bill', 'far fa-money-bill', 'fas fa-money-bill',
					],
					defaultOption: 'far fa-money-bill',
					keywords: 'buy cash checkout money payment price purchase money bill',
				},
				{
					className: 'far fa-money-bill-1',
					options: [
						'fat fa-money-bill-1', 'fal fa-money-bill-1', 'far fa-money-bill-1', 'fas fa-money-bill-1',
					],
					defaultOption: 'far fa-money-bill-1',
					keywords: 'buy cash checkout money payment price purchase money bill-1',
				},
				{
					className: 'far fa-motorcycle',
					options: [
						'fat fa-motorcycle', 'fal fa-motorcycle', 'far fa-motorcycle', 'fas fa-motorcycle',
					],
					defaultOption: 'far fa-motorcycle',
					keywords: 'bike machine motorcycle racing transportation vehicle motorcycle',
				},
				{
					className: 'far fa-mug-saucer',
					options: [
						'fat fa-mug-saucer', 'fal fa-mug-saucer', 'far fa-mug-saucer', 'fas fa-mug-saucer',
					],
					defaultOption: 'far fa-mug-saucer',
					keywords: 'beverage breakfast cafe drink fall morning mug seasonal tea mug saucer',
				},
				{
					className: 'far fa-music',
					options: [
						'fat fa-music', 'fal fa-music', 'far fa-music', 'fas fa-music',
					],
					defaultOption: 'far fa-music',
					keywords: 'lyrics melody music musical note note sing sound music',
				},
				{
					className: 'far fa-newspaper',
					options: [
						'fat fa-newspaper', 'fal fa-newspaper', 'far fa-newspaper', 'fas fa-newspaper',
					],
					defaultOption: 'far fa-newspaper',
					keywords: 'article editorial headline journal journalism news newspaper paper press newspaper',
				},
				{
					className: 'far fa-paw',
					options: [
						'fat fa-paw', 'fal fa-paw', 'far fa-paw', 'fas fa-paw',
					],
					defaultOption: 'far fa-paw',
					keywords: 'animal cat dog pet print paw',
				},
				{
					className: 'far fa-person',
					options: [
						'fat fa-person', 'fal fa-person', 'far fa-person', 'fas fa-person',
					],
					defaultOption: 'far fa-person',
					keywords: 'man person standing stand standing woman person',
				},
				{
					className: 'far fa-person-walking-with-cane',
					options: [
						'fat fa-person-walking-with-cane', 'fal fa-person-walking-with-cane', 'far fa-person-walking-with-cane', 'fas fa-person-walking-with-cane',
					],
					defaultOption: 'far fa-person-walking-with-cane',
					keywords: 'blind cane person walking-with-cane',
				},
				{
					className: 'far fa-phone',
					options: [
						'fat fa-phone', 'fal fa-phone', 'far fa-phone', 'fas fa-phone',
					],
					defaultOption: 'far fa-phone',
					keywords: 'left hand telephone receiver call earphone number phone receiver support telephone telephone receiver voice phone',
				},
				{
					className: 'far fa-phone-flip',
					options: [
						'fat fa-phone-flip', 'fal fa-phone-flip', 'far fa-phone-flip', 'fas fa-phone-flip',
					],
					defaultOption: 'far fa-phone-flip',
					keywords: 'right hand telephone receiver call earphone number support telephone voice phone flip',
				},
				{
					className: 'far fa-phone-volume',
					options: [
						'fat fa-phone-volume', 'fal fa-phone-volume', 'far fa-phone-volume', 'fas fa-phone-volume',
					],
					defaultOption: 'far fa-phone-volume',
					keywords: 'call earphone number sound support telephone voice volume control-phone phone-volume',
				},
				{
					className: 'far fa-plane',
					options: [
						'fat fa-plane', 'fal fa-plane', 'far fa-plane', 'fas fa-plane',
					],
					defaultOption: 'far fa-plane',
					keywords: 'airplane airport destination fly location mode travel trip plane',
				},
				{
					className: 'far fa-plane-engines',
					options: [
						'fat fa-plane-engines', 'fal fa-plane-engines', 'far fa-plane-engines', 'fas fa-plane-engines',
					],
					defaultOption: 'far fa-plane-engines',
					keywords: 'aeroplane airplane airport destination fly location mode travel trip plane engines',
				},
				{
					className: 'far fa-plug',
					options: [
						'fat fa-plug', 'fal fa-plug', 'far fa-plug', 'fas fa-plug',
					],
					defaultOption: 'far fa-plug',
					keywords: 'connect electric electric plug electricity online plug power plug',
				},
				{
					className: 'far fa-plus',
					options: [
						'fat fa-plus', 'fal fa-plus', 'far fa-plus', 'fas fa-plus',
					],
					defaultOption: 'far fa-plus',
					keywords: '0 plus sign add create expand math new plus positive shape sign plus',
				},
				{
					className: 'far fa-print',
					options: [
						'fat fa-print', 'fal fa-print', 'far fa-print', 'fas fa-print',
					],
					defaultOption: 'far fa-print',
					keywords: 'print screen symbol printer icon business computer copy document office paper printer print',
				},
				{
					className: 'far fa-recycle',
					options: [
						'fat fa-recycle', 'fal fa-recycle', 'far fa-recycle', 'fas fa-recycle',
					],
					defaultOption: 'far fa-recycle',
					keywords: 'recycling symbol for generic materials universal recycling symbol waste compost garbage recycle recycling symbol reuse trash recycle',
				},
				{
					className: 'far fa-restroom',
					options: [
						'fat fa-restroom', 'fal fa-restroom', 'far fa-restroom', 'fas fa-restroom',
					],
					defaultOption: 'far fa-restroom',
					keywords: 'bathroom toilet water closet wc restroom',
				},
				{
					className: 'far fa-road',
					options: [
						'fat fa-road', 'fal fa-road', 'far fa-road', 'fas fa-road',
					],
					defaultOption: 'far fa-road',
					keywords: 'highway map motorway pavement road route street travel road',
				},
				{
					className: 'far fa-rocket',
					options: [
						'fat fa-rocket', 'fal fa-rocket', 'far fa-rocket', 'fas fa-rocket',
					],
					defaultOption: 'far fa-rocket',
					keywords: 'aircraft app jet launch nasa space rocket',
				},
				{
					className: 'far fa-route',
					options: [
						'fat fa-route', 'fal fa-route', 'far fa-route', 'fas fa-route',
					],
					defaultOption: 'far fa-route',
					keywords: 'directions navigation travel route',
				},
				{
					className: 'far fa-route-highway',
					options: [
						'fat fa-route-highway', 'fal fa-route-highway', 'far fa-route-highway', 'fas fa-route-highway',
					],
					defaultOption: 'far fa-route-highway',
					keywords: 'directions highway interstate navigation sign travel route highway',
				},
				{
					className: 'far fa-route-interstate',
					options: [
						'fat fa-route-interstate', 'fal fa-route-interstate', 'far fa-route-interstate', 'fas fa-route-interstate',
					],
					defaultOption: 'far fa-route-interstate',
					keywords: 'directions highway interstate navigation sign travel route interstate',
				},
				{
					className: 'far fa-scale-balanced',
					options: [
						'fat fa-scale-balanced', 'fal fa-scale-balanced', 'far fa-scale-balanced', 'fas fa-scale-balanced',
					],
					defaultOption: 'far fa-scale-balanced',
					keywords: 'libra balance balance scale balanced justice legal measure scale weight zodiac scale balanced',
				},
				{
					className: 'far fa-scale-unbalanced',
					options: [
						'fat fa-scale-unbalanced', 'fal fa-scale-unbalanced', 'far fa-scale-unbalanced', 'fas fa-scale-unbalanced',
					],
					defaultOption: 'far fa-scale-unbalanced',
					keywords: 'justice legal measure unbalanced weight scale unbalanced',
				},
				{
					className: 'far fa-scale-unbalanced-flip',
					options: [
						'fat fa-scale-unbalanced-flip', 'fal fa-scale-unbalanced-flip', 'far fa-scale-unbalanced-flip', 'fas fa-scale-unbalanced-flip',
					],
					defaultOption: 'far fa-scale-unbalanced-flip',
					keywords: 'justice legal measure unbalanced weight scale unbalanced-flip',
				},
				{
					className: 'far fa-ship',
					options: [
						'fat fa-ship', 'fal fa-ship', 'far fa-ship', 'fas fa-ship',
					],
					defaultOption: 'far fa-ship',
					keywords: 'boat passenger sea ship water ship',
				},
				{
					className: 'far fa-shoe-prints',
					options: [
						'fat fa-shoe-prints', 'fal fa-shoe-prints', 'far fa-shoe-prints', 'fas fa-shoe-prints',
					],
					defaultOption: 'far fa-shoe-prints',
					keywords: 'feet footprints steps walk shoe prints',
				},
				{
					className: 'far fa-shower',
					options: [
						'fat fa-shower', 'fal fa-shower', 'far fa-shower', 'fas fa-shower',
					],
					defaultOption: 'far fa-shower',
					keywords: 'bath clean faucet shower water shower',
				},
				{
					className: 'far fa-signs-post',
					options: [
						'fat fa-signs-post', 'fal fa-signs-post', 'far fa-signs-post', 'fas fa-signs-post',
					],
					defaultOption: 'far fa-signs-post',
					keywords: 'directions directory map signage wayfinding signs post',
				},
				{
					className: 'far fa-skull-cow',
					options: [
						'fat fa-skull-cow', 'fal fa-skull-cow', 'far fa-skull-cow', 'fas fa-skull-cow',
					],
					defaultOption: 'far fa-skull-cow',
					keywords: 'barren cowboy dead desert horns old west skeleton western skull cow',
				},
				{
					className: 'far fa-snowplow',
					options: [
						'fat fa-snowplow', 'fal fa-snowplow', 'far fa-snowplow', 'fas fa-snowplow',
					],
					defaultOption: 'far fa-snowplow',
					keywords: 'clean up cold road storm winter snowplow',
				},
				{
					className: 'far fa-spoon',
					options: [
						'fat fa-spoon', 'fal fa-spoon', 'far fa-spoon', 'fas fa-spoon',
					],
					defaultOption: 'far fa-spoon',
					keywords: 'cutlery dining scoop silverware spoon tableware spoon',
				},
				{
					className: 'far fa-square-dollar',
					options: [
						'fat fa-square-dollar', 'fal fa-square-dollar', 'far fa-square-dollar', 'fas fa-square-dollar',
					],
					defaultOption: 'far fa-square-dollar',
					keywords: '$ dollar sign money price usd square-dollar',
				},
				{
					className: 'far fa-square-h',
					options: [
						'fat fa-square-h', 'fal fa-square-h', 'far fa-square-h', 'fas fa-square-h',
					],
					defaultOption: 'far fa-square-h',
					keywords: 'directions emergency hospital hotel letter map square h',
				},
				{
					className: 'far fa-square-info',
					options: [
						'fat fa-square-info', 'fal fa-square-info', 'far fa-square-info', 'fas fa-square-info',
					],
					defaultOption: 'far fa-square-info',
					keywords: 'details help information more support square info',
				},
				{
					className: 'far fa-square-parking',
					options: [
						'fat fa-square-parking', 'fal fa-square-parking', 'far fa-square-parking', 'fas fa-square-parking',
					],
					defaultOption: 'far fa-square-parking',
					keywords: 'auto car garage meter parking square parking',
				},
				{
					className: 'far fa-square-parking-slash',
					options: [
						'fat fa-square-parking-slash', 'fal fa-square-parking-slash', 'far fa-square-parking-slash', 'fas fa-square-parking-slash',
					],
					defaultOption: 'far fa-square-parking-slash',
					keywords: 'auto car garage meter square parking-slash',
				},
				{
					className: 'far fa-square-phone',
					options: [
						'fat fa-square-phone', 'fal fa-square-phone', 'far fa-square-phone', 'fas fa-square-phone',
					],
					defaultOption: 'far fa-square-phone',
					keywords: 'call earphone number support telephone voice square phone',
				},
				{
					className: 'far fa-square-phone-flip',
					options: [
						'fat fa-square-phone-flip', 'fal fa-square-phone-flip', 'far fa-square-phone-flip', 'fas fa-square-phone-flip',
					],
					defaultOption: 'far fa-square-phone-flip',
					keywords: 'call earphone number support telephone voice square phone-flip',
				},
				{
					className: 'far fa-square-plus',
					options: [
						'fat fa-square-plus', 'fal fa-square-plus', 'far fa-square-plus', 'fas fa-square-plus',
					],
					defaultOption: 'far fa-square-plus',
					keywords: 'add create expand new positive shape square plus',
				},
				{
					className: 'far fa-street-view',
					options: [
						'fat fa-street-view', 'fal fa-street-view', 'far fa-street-view', 'fas fa-street-view',
					],
					defaultOption: 'far fa-street-view',
					keywords: 'directions location map navigation street view',
				},
				{
					className: 'far fa-suitcase',
					options: [
						'fat fa-suitcase', 'fal fa-suitcase', 'far fa-suitcase', 'fas fa-suitcase',
					],
					defaultOption: 'far fa-suitcase',
					keywords: 'baggage luggage move packing suitcase travel trip suitcase',
				},
				{
					className: 'far fa-suitcase-medical',
					options: [
						'fat fa-suitcase-medical', 'fal fa-suitcase-medical', 'far fa-suitcase-medical', 'fas fa-suitcase-medical',
					],
					defaultOption: 'far fa-suitcase-medical',
					keywords: 'first aid firstaid health help support suitcase medical',
				},
				{
					className: 'far fa-tag',
					options: [
						'fat fa-tag', 'fal fa-tag', 'far fa-tag', 'fas fa-tag',
					],
					defaultOption: 'far fa-tag',
					keywords: 'discount labe label price shopping tag',
				},
				{
					className: 'far fa-tags',
					options: [
						'fat fa-tags', 'fal fa-tags', 'far fa-tags', 'fas fa-tags',
					],
					defaultOption: 'far fa-tags',
					keywords: 'discount label price shopping tags',
				},
				{
					className: 'far fa-taxi',
					options: [
						'fat fa-taxi', 'fal fa-taxi', 'far fa-taxi', 'fas fa-taxi',
					],
					defaultOption: 'far fa-taxi',
					keywords: 'cab cabbie car car service lyft machine oncoming oncoming taxi taxi transportation travel uber vehicle taxi',
				},
				{
					className: 'far fa-thumbtack',
					options: [
						'fat fa-thumbtack', 'fal fa-thumbtack', 'far fa-thumbtack', 'fas fa-thumbtack',
					],
					defaultOption: 'far fa-thumbtack',
					keywords: 'black pushpin coordinates location marker pin pushpin thumb tack thumbtack',
				},
				{
					className: 'far fa-ticket',
					options: [
						'fat fa-ticket', 'fal fa-ticket', 'far fa-ticket', 'fas fa-ticket',
					],
					defaultOption: 'far fa-ticket',
					keywords: 'admission admission tickets movie pass support ticket ticket',
				},
				{
					className: 'far fa-ticket-simple',
					options: [
						'fat fa-ticket-simple', 'fal fa-ticket-simple', 'far fa-ticket-simple', 'fas fa-ticket-simple',
					],
					defaultOption: 'far fa-ticket-simple',
					keywords: 'movie pass support ticket ticket simple',
				},
				{
					className: 'far fa-traffic-cone',
					options: [
						'fat fa-traffic-cone', 'fal fa-traffic-cone', 'far fa-traffic-cone', 'fas fa-traffic-cone',
					],
					defaultOption: 'far fa-traffic-cone',
					keywords: 'alert construction road traffic cone',
				},
				{
					className: 'far fa-traffic-light',
					options: [
						'fat fa-traffic-light', 'fal fa-traffic-light', 'far fa-traffic-light', 'fas fa-traffic-light',
					],
					defaultOption: 'far fa-traffic-light',
					keywords: 'direction light road signal traffic travel vertical traffic light traffic light',
				},
				{
					className: 'far fa-traffic-light-go',
					options: [
						'fat fa-traffic-light-go', 'fal fa-traffic-light-go', 'far fa-traffic-light-go', 'fas fa-traffic-light-go',
					],
					defaultOption: 'far fa-traffic-light-go',
					keywords: 'direction green road signal travel traffic light-go',
				},
				{
					className: 'far fa-traffic-light-slow',
					options: [
						'fat fa-traffic-light-slow', 'fal fa-traffic-light-slow', 'far fa-traffic-light-slow', 'fas fa-traffic-light-slow',
					],
					defaultOption: 'far fa-traffic-light-slow',
					keywords: 'direction road signal travel yellow traffic light-slow',
				},
				{
					className: 'far fa-traffic-light-stop',
					options: [
						'fat fa-traffic-light-stop', 'fal fa-traffic-light-stop', 'far fa-traffic-light-stop', 'fas fa-traffic-light-stop',
					],
					defaultOption: 'far fa-traffic-light-stop',
					keywords: 'direction red road signal travel traffic light-stop',
				},
				{
					className: 'far fa-train',
					options: [
						'fat fa-train', 'fal fa-train', 'far fa-train', 'fas fa-train',
					],
					defaultOption: 'far fa-train',
					keywords: 'bullet commute locomotive railway subway train train',
				},
				{
					className: 'far fa-train-subway',
					options: [
						'fat fa-train-subway', 'fal fa-train-subway', 'far fa-train-subway', 'fas fa-train-subway',
					],
					defaultOption: 'far fa-train-subway',
					keywords: 'machine railway train transportation vehicle train subway',
				},
				{
					className: 'far fa-train-track',
					options: [
						'fat fa-train-track', 'fal fa-train-track', 'far fa-train-track', 'fas fa-train-track',
					],
					defaultOption: 'far fa-train-track',
					keywords: 'rail railroad tracks train train track',
				},
				{
					className: 'far fa-train-tram',
					options: [
						'fat fa-train-tram', 'fal fa-train-tram', 'far fa-train-tram', 'fas fa-train-tram',
					],
					defaultOption: 'far fa-train-tram',
					keywords: 'crossing machine mountains seasonal tram transportation trolleybus train tram',
				},
				{
					className: 'far fa-tree',
					options: [
						'fat fa-tree', 'fal fa-tree', 'far fa-tree', 'fas fa-tree',
					],
					defaultOption: 'far fa-tree',
					keywords: 'bark evergreen tree fall flora forest nature plant seasonal tree tree',
				},
				{
					className: 'far fa-tree-deciduous',
					options: [
						'fat fa-tree-deciduous', 'fal fa-tree-deciduous', 'far fa-tree-deciduous', 'fas fa-tree-deciduous',
					],
					defaultOption: 'far fa-tree-deciduous',
					keywords: 'bark deciduous deciduous tree fall flora forest nature plant seasonal shedding tree tree deciduous',
				},
				{
					className: 'far fa-trophy',
					options: [
						'fat fa-trophy', 'fal fa-trophy', 'far fa-trophy', 'fas fa-trophy',
					],
					defaultOption: 'far fa-trophy',
					keywords: 'achievement award cup game prize trophy winner trophy',
				},
				{
					className: 'far fa-trophy-star',
					options: [
						'fat fa-trophy-star', 'fal fa-trophy-star', 'far fa-trophy-star', 'fas fa-trophy-star',
					],
					defaultOption: 'far fa-trophy-star',
					keywords: 'achievement award cup game star winner trophy star',
				},
				{
					className: 'far fa-truck',
					options: [
						'fat fa-truck', 'fal fa-truck', 'far fa-truck', 'fas fa-truck',
					],
					defaultOption: 'far fa-truck',
					keywords: 'black truck cargo delivery delivery truck shipping truck vehicle truck',
				},
				{
					className: 'far fa-truck-medical',
					options: [
						'fat fa-truck-medical', 'fal fa-truck-medical', 'far fa-truck-medical', 'fas fa-truck-medical',
					],
					defaultOption: 'far fa-truck-medical',
					keywords: 'ambulance covid 19 emergency emt er help hospital support vehicle truck-medical',
				},
				{
					className: 'far fa-truck-plow',
					options: [
						'fat fa-truck-plow', 'fal fa-truck-plow', 'far fa-truck-plow', 'fas fa-truck-plow',
					],
					defaultOption: 'far fa-truck-plow',
					keywords: 'clean up cold seasonal snow winter truck plow',
				},
				{
					className: 'far fa-tty',
					options: [
						'fat fa-tty', 'fal fa-tty', 'far fa-tty', 'fas fa-tty',
					],
					defaultOption: 'far fa-tty',
					keywords: 'communication deaf telephone teletypewriter text tty',
				},
				{
					className: 'far fa-umbrella',
					options: [
						'fat fa-umbrella', 'fal fa-umbrella', 'far fa-umbrella', 'fas fa-umbrella',
					],
					defaultOption: 'far fa-umbrella',
					keywords: 'protection rain storm wet umbrella',
				},
				{
					className: 'far fa-utensils',
					options: [
						'fat fa-utensils', 'fal fa-utensils', 'far fa-utensils', 'fas fa-utensils',
					],
					defaultOption: 'far fa-utensils',
					keywords: 'cooking cutlery dining dinner eat food fork fork and knife knife restaurant utensils',
				},
				{
					className: 'far fa-vest',
					options: [
						'fat fa-vest', 'fal fa-vest', 'far fa-vest', 'fas fa-vest',
					],
					defaultOption: 'far fa-vest',
					keywords: 'biker fashion style vest',
				},
				{
					className: 'far fa-vest-patches',
					options: [
						'fat fa-vest-patches', 'fal fa-vest-patches', 'far fa-vest-patches', 'fas fa-vest-patches',
					],
					defaultOption: 'far fa-vest-patches',
					keywords: 'biker fashion style vest patches',
				},
				{
					className: 'far fa-wheelchair',
					options: [
						'fat fa-wheelchair', 'fal fa-wheelchair', 'far fa-wheelchair', 'fas fa-wheelchair',
					],
					defaultOption: 'far fa-wheelchair',
					keywords: 'users people wheelchair',
				},
				{
					className: 'far fa-wheelchair-move',
					options: [
						'fat fa-wheelchair-move', 'fal fa-wheelchair-move', 'far fa-wheelchair-move', 'fas fa-wheelchair-move',
					],
					defaultOption: 'far fa-wheelchair-move',
					keywords: 'access users people wheelchair symbol wheelchair-move',
				},
				{
					className: 'far fa-wifi',
					options: [
						'fat fa-wifi', 'fal fa-wifi', 'far fa-wifi', 'fas fa-wifi',
					],
					defaultOption: 'far fa-wifi',
					keywords: 'connection hotspot internet network wireless wifi',
				},
				{
					className: 'far fa-wine-glass',
					options: [
						'fat fa-wine-glass', 'fal fa-wine-glass', 'far fa-wine-glass', 'fas fa-wine-glass',
					],
					defaultOption: 'far fa-wine-glass',
					keywords: 'alcohol bar beverage cabernet drink glass grapes merlot sauvignon wine wine glass wine glass',
				},
				{
					className: 'far fa-wrench',
					options: [
						'fat fa-wrench', 'fal fa-wrench', 'far fa-wrench', 'fas fa-wrench',
					],
					defaultOption: 'far fa-wrench',
					keywords: 'construction fix mechanic plumbing settings spanner tool update wrench wrench',
				},
			],
		},
		{
			id: 'maritime',
			name: Loc.getMessage('LANDING_ICONS_SECTION_MARITIME'),
			items: [
				{
					className: 'far fa-anchor',
					options: [
						'fat fa-anchor', 'fal fa-anchor', 'far fa-anchor', 'fas fa-anchor',
					],
					defaultOption: 'far fa-anchor',
					keywords: 'anchor berth boat dock embed link maritime moor secure ship tool anchor',
				},
				{
					className: 'far fa-crab',
					options: [
						'fat fa-crab', 'fal fa-crab', 'far fa-crab', 'fas fa-crab',
					],
					defaultOption: 'far fa-crab',
					keywords: 'cancer claws crabmeat crustacean seafood shellfish zodiac crab',
				},
				{
					className: 'far fa-dolphin',
					options: [
						'fat fa-dolphin', 'fal fa-dolphin', 'far fa-dolphin', 'fas fa-dolphin',
					],
					defaultOption: 'far fa-dolphin',
					keywords: 'aquarium dolphin fish flipper mammal marine maritime porpoise dolphin',
				},
				{
					className: 'far fa-duck',
					options: [
						'fat fa-duck', 'fal fa-duck', 'far fa-duck', 'fas fa-duck',
					],
					defaultOption: 'far fa-duck',
					keywords: 'bath bird duck fauna quack rubber duck',
				},
				{
					className: 'far fa-fish',
					options: [
						'fat fa-fish', 'fal fa-fish', 'far fa-fish', 'fas fa-fish',
					],
					defaultOption: 'far fa-fish',
					keywords: 'pisces fauna fish gold seafood swimming zodiac fish',
				},
				{
					className: 'far fa-fish-bones',
					options: [
						'fat fa-fish-bones', 'fal fa-fish-bones', 'far fa-fish-bones', 'fas fa-fish-bones',
					],
					defaultOption: 'far fa-fish-bones',
					keywords: 'dead fish skeleton fish bones',
				},
				{
					className: 'far fa-fish-cooked',
					options: [
						'fat fa-fish-cooked', 'fal fa-fish-cooked', 'far fa-fish-cooked', 'fas fa-fish-cooked',
					],
					defaultOption: 'far fa-fish-cooked',
					keywords: 'grilled health salmon seafood tuna fish cooked',
				},
				{
					className: 'far fa-fishing-rod',
					options: [
						'fat fa-fishing-rod', 'fal fa-fishing-rod', 'far fa-fishing-rod', 'fas fa-fishing-rod',
					],
					defaultOption: 'far fa-fishing-rod',
					keywords: 'bait cast fish fishing pole pole fishing rod',
				},
				{
					className: 'far fa-lobster',
					options: [
						'fat fa-lobster', 'fal fa-lobster', 'far fa-lobster', 'fas fa-lobster',
					],
					defaultOption: 'far fa-lobster',
					keywords: 'bisque claes crustacean lobster seafood shellfish lobster',
				},
				{
					className: 'far fa-narwhal',
					options: [
						'fat fa-narwhal', 'fal fa-narwhal', 'far fa-narwhal', 'fas fa-narwhal',
					],
					defaultOption: 'far fa-narwhal',
					keywords: 'animal fauna holiday ivory mammal tusk unicorn whale narwhal',
				},
				{
					className: 'far fa-person-swimming',
					options: [
						'fat fa-person-swimming', 'fal fa-person-swimming', 'far fa-person-swimming', 'fas fa-person-swimming',
					],
					defaultOption: 'far fa-person-swimming',
					keywords: 'ocean person swimming pool sea swim water person swimming',
				},
				{
					className: 'far fa-sailboat',
					options: [
						'fat fa-sailboat', 'fal fa-sailboat', 'far fa-sailboat', 'fas fa-sailboat',
					],
					defaultOption: 'far fa-sailboat',
					keywords: 'dinghy mast sailboat sailing yacht sailboat',
				},
				{
					className: 'far fa-ship',
					options: [
						'fat fa-ship', 'fal fa-ship', 'far fa-ship', 'fas fa-ship',
					],
					defaultOption: 'far fa-ship',
					keywords: 'boat passenger sea ship water ship',
				},
				{
					className: 'far fa-squid',
					options: [
						'fat fa-squid', 'fal fa-squid', 'far fa-squid', 'fas fa-squid',
					],
					defaultOption: 'far fa-squid',
					keywords: 'calamari ink marine ocean squid squid',
				},
				{
					className: 'far fa-water',
					options: [
						'fat fa-water', 'fal fa-water', 'far fa-water', 'fas fa-water',
					],
					defaultOption: 'far fa-water',
					keywords: 'lake liquid ocean sea swim wet water',
				},
				{
					className: 'far fa-water-arrow-down',
					options: [
						'fat fa-water-arrow-down', 'fal fa-water-arrow-down', 'far fa-water-arrow-down', 'fas fa-water-arrow-down',
					],
					defaultOption: 'far fa-water-arrow-down',
					keywords: 'flood lake liquid ocean recede sea swim wet water arrow-down',
				},
				{
					className: 'far fa-water-arrow-up',
					options: [
						'fat fa-water-arrow-up', 'fal fa-water-arrow-up', 'far fa-water-arrow-up', 'fas fa-water-arrow-up',
					],
					defaultOption: 'far fa-water-arrow-up',
					keywords: 'flood lake liquid ocean sea swim wet water arrow-up',
				},
				{
					className: 'far fa-whale',
					options: [
						'fat fa-whale', 'fal fa-whale', 'far fa-whale', 'fas fa-whale',
					],
					defaultOption: 'far fa-whale',
					keywords: 'fauna mammal swimming whal whale whale',
				},
			],
		},
		{
			id: 'marketing',
			name: Loc.getMessage('LANDING_ICONS_SECTION_MARKETING'),
			items: [
				{
					className: 'far fa-badge',
					options: [
						'fat fa-badge', 'fal fa-badge', 'far fa-badge', 'fas fa-badge',
					],
					defaultOption: 'far fa-badge',
					keywords: 'discount meatball verified verify badge',
				},
				{
					className: 'far fa-badge-check',
					options: [
						'fat fa-badge-check', 'fal fa-badge-check', 'far fa-badge-check', 'fas fa-badge-check',
					],
					defaultOption: 'far fa-badge-check',
					keywords: 'accept achievement agree award confirm correct done ok security select success verified verify winner yes badge check',
				},
				{
					className: 'far fa-badge-dollar',
					options: [
						'fat fa-badge-dollar', 'fal fa-badge-dollar', 'far fa-badge-dollar', 'fas fa-badge-dollar',
					],
					defaultOption: 'far fa-badge-dollar',
					keywords: 'deal discount money save usd badge dollar',
				},
				{
					className: 'far fa-badge-percent',
					options: [
						'fat fa-badge-percent', 'fal fa-badge-percent', 'far fa-badge-percent', 'fas fa-badge-percent',
					],
					defaultOption: 'far fa-badge-percent',
					keywords: 'deal discount money save usd badge percent',
				},
				{
					className: 'far fa-block-question',
					options: [
						'fat fa-block-question', 'fal fa-block-question', 'far fa-block-question', 'fas fa-block-question',
					],
					defaultOption: 'far fa-block-question',
					keywords: 'block brick mystery prize question super mario block question',
				},
				{
					className: 'far fa-bullhorn',
					options: [
						'fat fa-bullhorn', 'fal fa-bullhorn', 'far fa-bullhorn', 'fas fa-bullhorn',
					],
					defaultOption: 'far fa-bullhorn',
					keywords: 'bullhorn announcement broadcast loud louder loudspeaker megaphone public address share bullhorn',
				},
				{
					className: 'far fa-bullseye',
					options: [
						'fat fa-bullseye', 'fal fa-bullseye', 'far fa-bullseye', 'fas fa-bullseye',
					],
					defaultOption: 'far fa-bullseye',
					keywords: 'archery goal objective target bullseye',
				},
				{
					className: 'far fa-bullseye-arrow',
					options: [
						'fat fa-bullseye-arrow', 'fal fa-bullseye-arrow', 'far fa-bullseye-arrow', 'fas fa-bullseye-arrow',
					],
					defaultOption: 'far fa-bullseye-arrow',
					keywords: 'archery arrow bullseye dart direct hit game goal hit objective robin hood target bullseye arrow',
				},
				{
					className: 'far fa-bullseye-pointer',
					options: [
						'fat fa-bullseye-pointer', 'fal fa-bullseye-pointer', 'far fa-bullseye-pointer', 'fas fa-bullseye-pointer',
					],
					defaultOption: 'far fa-bullseye-pointer',
					keywords: 'archery goal objective target bullseye pointer',
				},
				{
					className: 'far fa-chart-mixed',
					options: [
						'fat fa-chart-mixed', 'fal fa-chart-mixed', 'far fa-chart-mixed', 'fas fa-chart-mixed',
					],
					defaultOption: 'far fa-chart-mixed',
					keywords: 'chart measure roi tracking trend chart mixed',
				},
				{
					className: 'far fa-comment-dollar',
					options: [
						'fat fa-comment-dollar', 'fal fa-comment-dollar', 'far fa-comment-dollar', 'fas fa-comment-dollar',
					],
					defaultOption: 'far fa-comment-dollar',
					keywords: 'bubble chat commenting conversation feedback message money note notification pay sms speech spend texting transfer comment dollar',
				},
				{
					className: 'far fa-comments-dollar',
					options: [
						'fat fa-comments-dollar', 'fal fa-comments-dollar', 'far fa-comments-dollar', 'fas fa-comments-dollar',
					],
					defaultOption: 'far fa-comments-dollar',
					keywords: 'bubble chat commenting conversation feedback message money note notification pay sms speech spend texting transfer comments dollar',
				},
				{
					className: 'far fa-envelope-open-dollar',
					options: [
						'fat fa-envelope-open-dollar', 'fal fa-envelope-open-dollar', 'far fa-envelope-open-dollar', 'fas fa-envelope-open-dollar',
					],
					defaultOption: 'far fa-envelope-open-dollar',
					keywords: 'e mail email letter mail message money notification pay transfer envelope-open-dollar',
				},
				{
					className: 'far fa-envelope-open-text',
					options: [
						'fat fa-envelope-open-text', 'fal fa-envelope-open-text', 'far fa-envelope-open-text', 'fas fa-envelope-open-text',
					],
					defaultOption: 'far fa-envelope-open-text',
					keywords: 'e mail email letter mail message notification support envelope-open-text',
				},
				{
					className: 'far fa-envelopes-bulk',
					options: [
						'fat fa-envelopes-bulk', 'fal fa-envelopes-bulk', 'far fa-envelopes-bulk', 'fas fa-envelopes-bulk',
					],
					defaultOption: 'far fa-envelopes-bulk',
					keywords: 'archive envelope letter post office postal postcard send stamp usps envelopes bulk',
				},
				{
					className: 'far fa-filter-circle-dollar',
					options: [
						'fat fa-filter-circle-dollar', 'fal fa-filter-circle-dollar', 'far fa-filter-circle-dollar', 'fas fa-filter-circle-dollar',
					],
					defaultOption: 'far fa-filter-circle-dollar',
					keywords: 'filter money options separate sort filter circle-dollar',
				},
				{
					className: 'far fa-gift-card',
					options: [
						'fat fa-gift-card', 'fal fa-gift-card', 'far fa-gift-card', 'fas fa-gift-card',
					],
					defaultOption: 'far fa-gift-card',
					keywords: 'christmas generosity giving holiday money party present wrapped xmas gift card',
				},
				{
					className: 'far fa-hundred-points',
					options: [
						'fat fa-hundred-points', 'fal fa-hundred-points', 'far fa-hundred-points', 'fas fa-hundred-points',
					],
					defaultOption: 'far fa-hundred-points',
					keywords: '100 agree one hundred percent perfect score win hundred points',
				},
				{
					className: 'far fa-lightbulb',
					options: [
						'fat fa-lightbulb', 'fal fa-lightbulb', 'far fa-lightbulb', 'fas fa-lightbulb',
					],
					defaultOption: 'far fa-lightbulb',
					keywords: 'bulb comic electric energy idea inspiration light light bulb lightbulb',
				},
				{
					className: 'far fa-lightbulb-dollar',
					options: [
						'fat fa-lightbulb-dollar', 'fal fa-lightbulb-dollar', 'far fa-lightbulb-dollar', 'fas fa-lightbulb-dollar',
					],
					defaultOption: 'far fa-lightbulb-dollar',
					keywords: 'energy idea inspiration light money lightbulb dollar',
				},
				{
					className: 'far fa-lightbulb-exclamation',
					options: [
						'fat fa-lightbulb-exclamation', 'fal fa-lightbulb-exclamation', 'far fa-lightbulb-exclamation', 'fas fa-lightbulb-exclamation',
					],
					defaultOption: 'far fa-lightbulb-exclamation',
					keywords: 'alert energy idea inspiration light lightbulb exclamation',
				},
				{
					className: 'far fa-lightbulb-on',
					options: [
						'fat fa-lightbulb-on', 'fal fa-lightbulb-on', 'far fa-lightbulb-on', 'fas fa-lightbulb-on',
					],
					defaultOption: 'far fa-lightbulb-on',
					keywords: 'energy idea inspiration light shine lightbulb on',
				},
				{
					className: 'far fa-lightbulb-slash',
					options: [
						'fat fa-lightbulb-slash', 'fal fa-lightbulb-slash', 'far fa-lightbulb-slash', 'fas fa-lightbulb-slash',
					],
					defaultOption: 'far fa-lightbulb-slash',
					keywords: 'dark light off lightbulb slash',
				},
				{
					className: 'far fa-magnifying-glass-dollar',
					options: [
						'fat fa-magnifying-glass-dollar', 'fal fa-magnifying-glass-dollar', 'far fa-magnifying-glass-dollar', 'fas fa-magnifying-glass-dollar',
					],
					defaultOption: 'far fa-magnifying-glass-dollar',
					keywords: 'bigger enlarge find magnify money preview zoom magnifying glass-dollar',
				},
				{
					className: 'far fa-magnifying-glass-location',
					options: [
						'fat fa-magnifying-glass-location', 'fal fa-magnifying-glass-location', 'far fa-magnifying-glass-location', 'fas fa-magnifying-glass-location',
					],
					defaultOption: 'far fa-magnifying-glass-location',
					keywords: 'bigger enlarge find magnify preview zoom magnifying glass-location',
				},
				{
					className: 'far fa-megaphone',
					options: [
						'fat fa-megaphone', 'fal fa-megaphone', 'far fa-megaphone', 'fas fa-megaphone',
					],
					defaultOption: 'far fa-megaphone',
					keywords: 'announcement broadcast bullhorn cheering louder megaphone share megaphone',
				},
				{
					className: 'far fa-message-dollar',
					options: [
						'fat fa-message-dollar', 'fal fa-message-dollar', 'far fa-message-dollar', 'fas fa-message-dollar',
					],
					defaultOption: 'far fa-message-dollar',
					keywords: 'bubble chat commenting conversation feedback message money note notification pay sms speech spend texting transfer message dollar',
				},
				{
					className: 'far fa-messages-dollar',
					options: [
						'fat fa-messages-dollar', 'fal fa-messages-dollar', 'far fa-messages-dollar', 'fas fa-messages-dollar',
					],
					defaultOption: 'far fa-messages-dollar',
					keywords: 'bubble chat commenting conversation feedback message money note notification pay sms speech spend texting transfer messages dollar',
				},
				{
					className: 'far fa-rectangle-ad',
					options: [
						'fat fa-rectangle-ad', 'fal fa-rectangle-ad', 'far fa-rectangle-ad', 'fas fa-rectangle-ad',
					],
					defaultOption: 'far fa-rectangle-ad',
					keywords: 'advertisement media newspaper promotion publicity rectangle ad',
				},
				{
					className: 'far fa-rectangle-pro',
					options: [
						'fat fa-rectangle-pro', 'fal fa-rectangle-pro', 'far fa-rectangle-pro', 'fas fa-rectangle-pro',
					],
					defaultOption: 'far fa-rectangle-pro',
					keywords: 'professional rectangle pro',
				},
				{
					className: 'far fa-signal-stream',
					options: [
						'fat fa-signal-stream', 'fal fa-signal-stream', 'far fa-signal-stream', 'fas fa-signal-stream',
					],
					defaultOption: 'far fa-signal-stream',
					keywords: 'podcast radio sisngal streaming wave wifi wireless signal stream',
				},
				{
					className: 'far fa-signal-stream-slash',
					options: [
						'fat fa-signal-stream-slash', 'fal fa-signal-stream-slash', 'far fa-signal-stream-slash', 'fas fa-signal-stream-slash',
					],
					defaultOption: 'far fa-signal-stream-slash',
					keywords: 'podcast radio sisngal streaming wave wifi wireless signal stream-slash',
				},
				{
					className: 'far fa-sparkles',
					options: [
						'fat fa-sparkles', 'fal fa-sparkles', 'far fa-sparkles', 'fas fa-sparkles',
					],
					defaultOption: 'far fa-sparkles',
					keywords: '* glitter magic new sparkle sparkles special star twinkle sparkles',
				},
				{
					className: 'far fa-square-poll-horizontal',
					options: [
						'fat fa-square-poll-horizontal', 'fal fa-square-poll-horizontal', 'far fa-square-poll-horizontal', 'fas fa-square-poll-horizontal',
					],
					defaultOption: 'far fa-square-poll-horizontal',
					keywords: 'chart graph results survey trend vote voting square poll-horizontal',
				},
				{
					className: 'far fa-square-poll-vertical',
					options: [
						'fat fa-square-poll-vertical', 'fal fa-square-poll-vertical', 'far fa-square-poll-vertical', 'fas fa-square-poll-vertical',
					],
					defaultOption: 'far fa-square-poll-vertical',
					keywords: 'chart graph results survey trend vote voting square poll-vertical',
				},
				{
					className: 'far fa-timeline',
					options: [
						'fat fa-timeline', 'fal fa-timeline', 'far fa-timeline', 'fas fa-timeline',
					],
					defaultOption: 'far fa-timeline',
					keywords: 'chronological deadline history linear timeline',
				},
				{
					className: 'far fa-timeline-arrow',
					options: [
						'fat fa-timeline-arrow', 'fal fa-timeline-arrow', 'far fa-timeline-arrow', 'fas fa-timeline-arrow',
					],
					defaultOption: 'far fa-timeline-arrow',
					keywords: 'chronological deadline history linear timeline arrow',
				},
				{
					className: 'far fa-user-crown',
					options: [
						'fat fa-user-crown', 'fal fa-user-crown', 'far fa-user-crown', 'fas fa-user-crown',
					],
					defaultOption: 'far fa-user-crown',
					keywords: 'users people user-crown',
				},
				{
					className: 'far fa-user-group-crown',
					options: [
						'fat fa-user-group-crown', 'fal fa-user-group-crown', 'far fa-user-group-crown', 'fas fa-user-group-crown',
					],
					defaultOption: 'far fa-user-group-crown',
					keywords: 'users people user-group-crown',
				},
			],
		},
		{
			id: 'mathematics',
			name: Loc.getMessage('LANDING_ICONS_SECTION_MATHEMATICS'),
			items: [
				{
					className: 'far fa-abacus',
					options: [
						'fat fa-abacus', 'fal fa-abacus', 'far fa-abacus', 'fas fa-abacus',
					],
					defaultOption: 'far fa-abacus',
					keywords: 'abacus addition ancient arithmetic calculation calculator counting hexadecimal math subtraction abacus',
				},
				{
					className: 'far fa-calculator',
					options: [
						'fat fa-calculator', 'fal fa-calculator', 'far fa-calculator', 'fas fa-calculator',
					],
					defaultOption: 'far fa-calculator',
					keywords: 'pocket calculator abacus addition arithmetic counting math multiplication subtraction calculator',
				},
				{
					className: 'far fa-calculator-simple',
					options: [
						'fat fa-calculator-simple', 'fal fa-calculator-simple', 'far fa-calculator-simple', 'fas fa-calculator-simple',
					],
					defaultOption: 'far fa-calculator-simple',
					keywords: 'abacus addition arithmetic counting math multiplication subtraction calculator simple',
				},
				{
					className: 'far fa-circle-divide',
					options: [
						'fat fa-circle-divide', 'fal fa-circle-divide', 'far fa-circle-divide', 'fas fa-circle-divide',
					],
					defaultOption: 'far fa-circle-divide',
					keywords: 'algebra arithmetic division circle divide',
				},
				{
					className: 'far fa-circle-minus',
					options: [
						'fat fa-circle-minus', 'fal fa-circle-minus', 'far fa-circle-minus', 'fas fa-circle-minus',
					],
					defaultOption: 'far fa-circle-minus',
					keywords: 'delete hide negative remove shape trash circle minus',
				},
				{
					className: 'far fa-circle-plus',
					options: [
						'fat fa-circle-plus', 'fal fa-circle-plus', 'far fa-circle-plus', 'fas fa-circle-plus',
					],
					defaultOption: 'far fa-circle-plus',
					keywords: 'add create expand new positive shape circle plus',
				},
				{
					className: 'far fa-circle-xmark',
					options: [
						'fat fa-circle-xmark', 'fal fa-circle-xmark', 'far fa-circle-xmark', 'fas fa-circle-xmark',
					],
					defaultOption: 'far fa-circle-xmark',
					keywords: 'close cross exit incorrect notice notification notify problem wrong x circle xmark',
				},
				{
					className: 'far fa-divide',
					options: [
						'fat fa-divide', 'fal fa-divide', 'far fa-divide', 'fas fa-divide',
					],
					defaultOption: 'far fa-divide',
					keywords: 'division sign arithmetic calculus divide division math sign ? divide',
				},
				{
					className: 'far fa-empty-set',
					options: [
						'fat fa-empty-set', 'fal fa-empty-set', 'far fa-empty-set', 'fas fa-empty-set',
					],
					defaultOption: 'far fa-empty-set',
					keywords: 'empty set latin capital letter o with stroke math theory empty set',
				},
				{
					className: 'far fa-equals',
					options: [
						'fat fa-equals', 'fal fa-equals', 'far fa-equals', 'fas fa-equals',
					],
					defaultOption: 'far fa-equals',
					keywords: 'equals sign arithmetic even match math equals',
				},
				{
					className: 'far fa-function',
					options: [
						'fat fa-function', 'fal fa-function', 'far fa-function', 'fas fa-function',
					],
					defaultOption: 'far fa-function',
					keywords: 'math mathematics function',
				},
				{
					className: 'far fa-greater-than',
					options: [
						'fat fa-greater-than', 'fal fa-greater-than', 'far fa-greater-than', 'fas fa-greater-than',
					],
					defaultOption: 'far fa-greater-than',
					keywords: 'greater than sign arithmetic compare math greater-than',
				},
				{
					className: 'far fa-greater-than-equal',
					options: [
						'fat fa-greater-than-equal', 'fal fa-greater-than-equal', 'far fa-greater-than-equal', 'fas fa-greater-than-equal',
					],
					defaultOption: 'far fa-greater-than-equal',
					keywords: 'arithmetic compare math greater than-equal',
				},
				{
					className: 'far fa-hexagon-divide',
					options: [
						'fat fa-hexagon-divide', 'fal fa-hexagon-divide', 'far fa-hexagon-divide', 'fas fa-hexagon-divide',
					],
					defaultOption: 'far fa-hexagon-divide',
					keywords: 'algebra arithmetic division hexagon divide',
				},
				{
					className: 'far fa-hexagon-minus',
					options: [
						'fat fa-hexagon-minus', 'fal fa-hexagon-minus', 'far fa-hexagon-minus', 'fas fa-hexagon-minus',
					],
					defaultOption: 'far fa-hexagon-minus',
					keywords: 'delete hide negative remove shape trash hexagon minus',
				},
				{
					className: 'far fa-hexagon-plus',
					options: [
						'fat fa-hexagon-plus', 'fal fa-hexagon-plus', 'far fa-hexagon-plus', 'fas fa-hexagon-plus',
					],
					defaultOption: 'far fa-hexagon-plus',
					keywords: 'add create expand new positive shape hexagon plus',
				},
				{
					className: 'far fa-hexagon-xmark',
					options: [
						'fat fa-hexagon-xmark', 'fal fa-hexagon-xmark', 'far fa-hexagon-xmark', 'fas fa-hexagon-xmark',
					],
					defaultOption: 'far fa-hexagon-xmark',
					keywords: 'close cross exit incorrect notice notification notify problem wrong x hexagon xmark',
				},
				{
					className: 'far fa-infinity',
					options: [
						'fat fa-infinity', 'fal fa-infinity', 'far fa-infinity', 'fas fa-infinity',
					],
					defaultOption: 'far fa-infinity',
					keywords: 'infinity eternity forever infinity math unbounded universal infinity',
				},
				{
					className: 'far fa-integral',
					options: [
						'fat fa-integral', 'fal fa-integral', 'far fa-integral', 'fas fa-integral',
					],
					defaultOption: 'far fa-integral',
					keywords: 'calculus equation function math integral',
				},
				{
					className: 'far fa-intersection',
					options: [
						'fat fa-intersection', 'fal fa-intersection', 'far fa-intersection', 'fas fa-intersection',
					],
					defaultOption: 'far fa-intersection',
					keywords: 'n ary intersection calculus equation function math intersection',
				},
				{
					className: 'far fa-lambda',
					options: [
						'fat fa-lambda', 'fal fa-lambda', 'far fa-lambda', 'fas fa-lambda',
					],
					defaultOption: 'far fa-lambda',
					keywords: 'calculus equation function math lambda',
				},
				{
					className: 'far fa-less-than',
					options: [
						'fat fa-less-than', 'fal fa-less-than', 'far fa-less-than', 'fas fa-less-than',
					],
					defaultOption: 'far fa-less-than',
					keywords: 'less than sign arithmetic compare math less-than',
				},
				{
					className: 'far fa-less-than-equal',
					options: [
						'fat fa-less-than-equal', 'fal fa-less-than-equal', 'far fa-less-than-equal', 'fas fa-less-than-equal',
					],
					defaultOption: 'far fa-less-than-equal',
					keywords: 'arithmetic compare math less than-equal',
				},
				{
					className: 'far fa-minus',
					options: [
						'fat fa-minus', 'fal fa-minus', 'far fa-minus', 'fas fa-minus',
					],
					defaultOption: 'far fa-minus',
					keywords: 'en dash minus sign collapse delete hide math minify minus negative remove sign trash ? minus',
				},
				{
					className: 'far fa-not-equal',
					options: [
						'fat fa-not-equal', 'fal fa-not-equal', 'far fa-not-equal', 'fas fa-not-equal',
					],
					defaultOption: 'far fa-not-equal',
					keywords: 'arithmetic compare math not equal',
				},
				{
					className: 'far fa-octagon-divide',
					options: [
						'fat fa-octagon-divide', 'fal fa-octagon-divide', 'far fa-octagon-divide', 'fas fa-octagon-divide',
					],
					defaultOption: 'far fa-octagon-divide',
					keywords: 'algebra arithmetic division octagon divide',
				},
				{
					className: 'far fa-octagon-minus',
					options: [
						'fat fa-octagon-minus', 'fal fa-octagon-minus', 'far fa-octagon-minus', 'fas fa-octagon-minus',
					],
					defaultOption: 'far fa-octagon-minus',
					keywords: 'delete hide negative remove shape trash octagon minus',
				},
				{
					className: 'far fa-octagon-plus',
					options: [
						'fat fa-octagon-plus', 'fal fa-octagon-plus', 'far fa-octagon-plus', 'fas fa-octagon-plus',
					],
					defaultOption: 'far fa-octagon-plus',
					keywords: 'add create expand new positive shape octagon plus',
				},
				{
					className: 'far fa-octagon-xmark',
					options: [
						'fat fa-octagon-xmark', 'fal fa-octagon-xmark', 'far fa-octagon-xmark', 'fas fa-octagon-xmark',
					],
					defaultOption: 'far fa-octagon-xmark',
					keywords: 'close cross exit incorrect notice notification notify problem wrong x octagon xmark',
				},
				{
					className: 'far fa-omega',
					options: [
						'fat fa-omega', 'fal fa-omega', 'far fa-omega', 'fas fa-omega',
					],
					defaultOption: 'far fa-omega',
					keywords: 'alphabet greek math omega',
				},
				{
					className: 'far fa-percent',
					options: [
						'fat fa-percent', 'fal fa-percent', 'far fa-percent', 'fas fa-percent',
					],
					defaultOption: 'far fa-percent',
					keywords: 'percent sign discount fraction proportion rate ratio percent',
				},
				{
					className: 'far fa-pi',
					options: [
						'fat fa-pi', 'fal fa-pi', 'far fa-pi', 'fas fa-pi',
					],
					defaultOption: 'far fa-pi',
					keywords: 'alphabet circumference diameter greek math mathematics pi',
				},
				{
					className: 'far fa-plus',
					options: [
						'fat fa-plus', 'fal fa-plus', 'far fa-plus', 'fas fa-plus',
					],
					defaultOption: 'far fa-plus',
					keywords: '0 plus sign add create expand math new plus positive shape sign plus',
				},
				{
					className: 'far fa-plus-minus',
					options: [
						'fat fa-plus-minus', 'fal fa-plus-minus', 'far fa-plus-minus', 'fas fa-plus-minus',
					],
					defaultOption: 'far fa-plus-minus',
					keywords: 'plus minus sign add math subtract plus-minus',
				},
				{
					className: 'far fa-sigma',
					options: [
						'fat fa-sigma', 'fal fa-sigma', 'far fa-sigma', 'fas fa-sigma',
					],
					defaultOption: 'far fa-sigma',
					keywords: 'n ary summation alphabet greek math summation sigma',
				},
				{
					className: 'far fa-square-divide',
					options: [
						'fat fa-square-divide', 'fal fa-square-divide', 'far fa-square-divide', 'fas fa-square-divide',
					],
					defaultOption: 'far fa-square-divide',
					keywords: 'algebra arithmetic division square divide',
				},
				{
					className: 'far fa-square-minus',
					options: [
						'fat fa-square-minus', 'fal fa-square-minus', 'far fa-square-minus', 'fas fa-square-minus',
					],
					defaultOption: 'far fa-square-minus',
					keywords: 'collapse delete hide minify negative remove shape trash square minus',
				},
				{
					className: 'far fa-square-root',
					options: [
						'fat fa-square-root', 'fal fa-square-root', 'far fa-square-root', 'fas fa-square-root',
					],
					defaultOption: 'far fa-square-root',
					keywords: 'square root arithmetic calculus division math square root',
				},
				{
					className: 'far fa-square-root-variable',
					options: [
						'fat fa-square-root-variable', 'fal fa-square-root-variable', 'far fa-square-root-variable', 'fas fa-square-root-variable',
					],
					defaultOption: 'far fa-square-root-variable',
					keywords: 'arithmetic calculus division math square root-variable',
				},
				{
					className: 'far fa-square-xmark',
					options: [
						'fat fa-square-xmark', 'fal fa-square-xmark', 'far fa-square-xmark', 'fas fa-square-xmark',
					],
					defaultOption: 'far fa-square-xmark',
					keywords: 'close cross cross mark button incorrect mark notice notification notify problem square window wrong x ? square xmark',
				},
				{
					className: 'far fa-subscript',
					options: [
						'fat fa-subscript', 'fal fa-subscript', 'far fa-subscript', 'fas fa-subscript',
					],
					defaultOption: 'far fa-subscript',
					keywords: 'edit font format text type subscript',
				},
				{
					className: 'far fa-superscript',
					options: [
						'fat fa-superscript', 'fal fa-superscript', 'far fa-superscript', 'fas fa-superscript',
					],
					defaultOption: 'far fa-superscript',
					keywords: 'edit exponential font format text type superscript',
				},
				{
					className: 'far fa-tally',
					options: [
						'fat fa-tally', 'fal fa-tally', 'far fa-tally', 'fas fa-tally',
					],
					defaultOption: 'far fa-tally',
					keywords: 'count hash numbers tally',
				},
				{
					className: 'far fa-tally-1',
					options: [
						'fat fa-tally-1', 'fal fa-tally-1', 'far fa-tally-1', 'fas fa-tally-1',
					],
					defaultOption: 'far fa-tally-1',
					keywords: 'calculate count hash number tally 1',
				},
				{
					className: 'far fa-tally-2',
					options: [
						'fat fa-tally-2', 'fal fa-tally-2', 'far fa-tally-2', 'fas fa-tally-2',
					],
					defaultOption: 'far fa-tally-2',
					keywords: 'calculate count hash number tally 2',
				},
				{
					className: 'far fa-tally-3',
					options: [
						'fat fa-tally-3', 'fal fa-tally-3', 'far fa-tally-3', 'fas fa-tally-3',
					],
					defaultOption: 'far fa-tally-3',
					keywords: 'calculate count hash number tally 3',
				},
				{
					className: 'far fa-tally-4',
					options: [
						'fat fa-tally-4', 'fal fa-tally-4', 'far fa-tally-4', 'fas fa-tally-4',
					],
					defaultOption: 'far fa-tally-4',
					keywords: 'calculate count hash number tally 4',
				},
				{
					className: 'far fa-theta',
					options: [
						'fat fa-theta', 'fal fa-theta', 'far fa-theta', 'fas fa-theta',
					],
					defaultOption: 'far fa-theta',
					keywords: 'alphabet greek math theta',
				},
				{
					className: 'far fa-tilde',
					options: [
						'fat fa-tilde', 'fal fa-tilde', 'far fa-tilde', 'fas fa-tilde',
					],
					defaultOption: 'far fa-tilde',
					keywords: 'tilde accent symbol text type tilde',
				},
				{
					className: 'far fa-union',
					options: [
						'fat fa-union', 'fal fa-union', 'far fa-union', 'fas fa-union',
					],
					defaultOption: 'far fa-union',
					keywords: 'n ary union calculus equation function math union',
				},
				{
					className: 'far fa-value-absolute',
					options: [
						'fat fa-value-absolute', 'fal fa-value-absolute', 'far fa-value-absolute', 'fas fa-value-absolute',
					],
					defaultOption: 'far fa-value-absolute',
					keywords: 'math value absolute',
				},
				{
					className: 'far fa-watch-calculator',
					options: [
						'fat fa-watch-calculator', 'fal fa-watch-calculator', 'far fa-watch-calculator', 'fas fa-watch-calculator',
					],
					defaultOption: 'far fa-watch-calculator',
					keywords: 'casio digital math time watch calculator',
				},
				{
					className: 'far fa-wave-sine',
					options: [
						'fat fa-wave-sine', 'fal fa-wave-sine', 'far fa-wave-sine', 'fas fa-wave-sine',
					],
					defaultOption: 'far fa-wave-sine',
					keywords: 'sine wave frequency pulse signal wave sine',
				},
				{
					className: 'far fa-wave-square',
					options: [
						'fat fa-wave-square', 'fal fa-wave-square', 'far fa-wave-square', 'fas fa-wave-square',
					],
					defaultOption: 'far fa-wave-square',
					keywords: 'frequency pulse signal wave square',
				},
				{
					className: 'far fa-wave-triangle',
					options: [
						'fat fa-wave-triangle', 'fal fa-wave-triangle', 'far fa-wave-triangle', 'fas fa-wave-triangle',
					],
					defaultOption: 'far fa-wave-triangle',
					keywords: 'frequency pulse signal wave triangle',
				},
				{
					className: 'far fa-xmark',
					options: [
						'fat fa-xmark', 'fal fa-xmark', 'far fa-xmark', 'fas fa-xmark',
					],
					defaultOption: 'far fa-xmark',
					keywords: 'cancellation x multiplication sign multiplication x cancel close cross cross mark error exit incorrect mark multiplication multiply notice notification notify problem sign wrong x ? xmark',
				},
			],
		},
		{
			id: 'media-playback',
			name: Loc.getMessage('LANDING_ICONS_SECTION_MEDIA_PLAYBACK'),
			items: [
				{
					className: 'far fa-arrow-rotate-left',
					options: [
						'fat fa-arrow-rotate-left', 'fal fa-arrow-rotate-left', 'far fa-arrow-rotate-left', 'fas fa-arrow-rotate-left',
					],
					defaultOption: 'far fa-arrow-rotate-left',
					keywords: 'anticlockwise open circle arrow back control z exchange oops return rotate swap arrow rotate left',
				},
				{
					className: 'far fa-arrow-rotate-right',
					options: [
						'fat fa-arrow-rotate-right', 'fal fa-arrow-rotate-right', 'far fa-arrow-rotate-right', 'fas fa-arrow-rotate-right',
					],
					defaultOption: 'far fa-arrow-rotate-right',
					keywords: 'clockwise open circle arrow forward refresh reload repeat arrow rotate right',
				},
				{
					className: 'far fa-arrows-maximize',
					options: [
						'fat fa-arrows-maximize', 'fal fa-arrows-maximize', 'far fa-arrows-maximize', 'fas fa-arrows-maximize',
					],
					defaultOption: 'far fa-arrows-maximize',
					keywords: 'bigger enlarge fullscreen move resize arrows maximize',
				},
				{
					className: 'far fa-arrows-repeat',
					options: [
						'fat fa-arrows-repeat', 'fal fa-arrows-repeat', 'far fa-arrows-repeat', 'fas fa-arrows-repeat',
					],
					defaultOption: 'far fa-arrows-repeat',
					keywords: 'flip reload rewind switch arrows repeat',
				},
				{
					className: 'far fa-arrows-repeat-1',
					options: [
						'fat fa-arrows-repeat-1', 'fal fa-arrows-repeat-1', 'far fa-arrows-repeat-1', 'fas fa-arrows-repeat-1',
					],
					defaultOption: 'far fa-arrows-repeat-1',
					keywords: 'flip reload rewind switch arrows repeat 1',
				},
				{
					className: 'far fa-arrows-rotate',
					options: [
						'fat fa-arrows-rotate', 'fal fa-arrows-rotate', 'far fa-arrows-rotate', 'fas fa-arrows-rotate',
					],
					defaultOption: 'far fa-arrows-rotate',
					keywords: 'clockwise right and left semicircle arrows exchange refresh reload rotate swap arrows rotate',
				},
				{
					className: 'far fa-backward',
					options: [
						'fat fa-backward', 'fal fa-backward', 'far fa-backward', 'fas fa-backward',
					],
					defaultOption: 'far fa-backward',
					keywords: 'arrow double fast reverse button previous rewind backward',
				},
				{
					className: 'far fa-backward-fast',
					options: [
						'fat fa-backward-fast', 'fal fa-backward-fast', 'far fa-backward-fast', 'fas fa-backward-fast',
					],
					defaultOption: 'far fa-backward-fast',
					keywords: 'arrow beginning first last track button previous previous scene previous track rewind start triangle backward fast',
				},
				{
					className: 'far fa-backward-step',
					options: [
						'fat fa-backward-step', 'fal fa-backward-step', 'far fa-backward-step', 'fas fa-backward-step',
					],
					defaultOption: 'far fa-backward-step',
					keywords: 'beginning first previous rewind start backward step',
				},
				{
					className: 'far fa-circle-pause',
					options: [
						'fat fa-circle-pause', 'fal fa-circle-pause', 'far fa-circle-pause', 'fas fa-circle-pause',
					],
					defaultOption: 'far fa-circle-pause',
					keywords: 'hold wait circle pause',
				},
				{
					className: 'far fa-circle-play',
					options: [
						'fat fa-circle-play', 'fal fa-circle-play', 'far fa-circle-play', 'fas fa-circle-play',
					],
					defaultOption: 'far fa-circle-play',
					keywords: 'audio music playing sound start video circle play',
				},
				{
					className: 'far fa-circle-stop',
					options: [
						'fat fa-circle-stop', 'fal fa-circle-stop', 'far fa-circle-stop', 'fas fa-circle-stop',
					],
					defaultOption: 'far fa-circle-stop',
					keywords: 'block box circle square circle stop',
				},
				{
					className: 'far fa-compress',
					options: [
						'fat fa-compress', 'fal fa-compress', 'far fa-compress', 'fas fa-compress',
					],
					defaultOption: 'far fa-compress',
					keywords: 'collapse fullscreen minimize move resize shrink smaller compress',
				},
				{
					className: 'far fa-compress-wide',
					options: [
						'fat fa-compress-wide', 'fal fa-compress-wide', 'far fa-compress-wide', 'fas fa-compress-wide',
					],
					defaultOption: 'far fa-compress-wide',
					keywords: 'collapse fullscreen minimize move resize shrink smaller compress wide',
				},
				{
					className: 'far fa-down-left-and-up-right-to-center',
					options: [
						'fat fa-down-left-and-up-right-to-center', 'fal fa-down-left-and-up-right-to-center', 'far fa-down-left-and-up-right-to-center', 'fas fa-down-left-and-up-right-to-center',
					],
					defaultOption: 'far fa-down-left-and-up-right-to-center',
					keywords: 'collapse fullscreen minimize move resize shrink smaller down left and up right to center',
				},
				{
					className: 'far fa-eject',
					options: [
						'fat fa-eject', 'fal fa-eject', 'far fa-eject', 'fas fa-eject',
					],
					defaultOption: 'far fa-eject',
					keywords: 'abort cancel cd discharge eject eject button eject',
				},
				{
					className: 'far fa-expand',
					options: [
						'fat fa-expand', 'fal fa-expand', 'far fa-expand', 'fas fa-expand',
					],
					defaultOption: 'far fa-expand',
					keywords: 'bigger enlarge fullscreen resize expand',
				},
				{
					className: 'far fa-expand-wide',
					options: [
						'fat fa-expand-wide', 'fal fa-expand-wide', 'far fa-expand-wide', 'fas fa-expand-wide',
					],
					defaultOption: 'far fa-expand-wide',
					keywords: 'bigger enlarge fullscreen resize expand wide',
				},
				{
					className: 'far fa-forward',
					options: [
						'fat fa-forward', 'fal fa-forward', 'far fa-forward', 'fas fa-forward',
					],
					defaultOption: 'far fa-forward',
					keywords: 'arrow double fast fast forward button forward next skip forward',
				},
				{
					className: 'far fa-forward-fast',
					options: [
						'fat fa-forward-fast', 'fal fa-forward-fast', 'far fa-forward-fast', 'fas fa-forward-fast',
					],
					defaultOption: 'far fa-forward-fast',
					keywords: 'arrow end last next next scene next track next track button triangle forward fast',
				},
				{
					className: 'far fa-forward-step',
					options: [
						'fat fa-forward-step', 'fal fa-forward-step', 'far fa-forward-step', 'fas fa-forward-step',
					],
					defaultOption: 'far fa-forward-step',
					keywords: 'end last next forward step',
				},
				{
					className: 'far fa-hand',
					options: [
						'fat fa-hand', 'fal fa-hand', 'far fa-hand', 'fas fa-hand',
					],
					defaultOption: 'far fa-hand',
					keywords: 'raised hand backhand game halt palm raised raised back of hand roshambo stop hand',
				},
				{
					className: 'far fa-maximize',
					options: [
						'fat fa-maximize', 'fal fa-maximize', 'far fa-maximize', 'fas fa-maximize',
					],
					defaultOption: 'far fa-maximize',
					keywords: 'bigger enlarge fullscreen move resize maximize',
				},
				{
					className: 'far fa-minimize',
					options: [
						'fat fa-minimize', 'fal fa-minimize', 'far fa-minimize', 'fas fa-minimize',
					],
					defaultOption: 'far fa-minimize',
					keywords: 'collapse fullscreen minimize move resize shrink smaller minimize',
				},
				{
					className: 'far fa-music',
					options: [
						'fat fa-music', 'fal fa-music', 'far fa-music', 'fas fa-music',
					],
					defaultOption: 'far fa-music',
					keywords: 'lyrics melody music musical note note sing sound music',
				},
				{
					className: 'far fa-pause',
					options: [
						'fat fa-pause', 'fal fa-pause', 'far fa-pause', 'fas fa-pause',
					],
					defaultOption: 'far fa-pause',
					keywords: 'bar double hold pause pause button vertical wait pause',
				},
				{
					className: 'far fa-phone-volume',
					options: [
						'fat fa-phone-volume', 'fal fa-phone-volume', 'far fa-phone-volume', 'fas fa-phone-volume',
					],
					defaultOption: 'far fa-phone-volume',
					keywords: 'call earphone number sound support telephone voice volume control phone phone volume',
				},
				{
					className: 'far fa-play',
					options: [
						'fat fa-play', 'fal fa-play', 'far fa-play', 'fas fa-play',
					],
					defaultOption: 'far fa-play',
					keywords: 'arrow audio music play play button playing right sound start triangle video play',
				},
				{
					className: 'far fa-play-pause',
					options: [
						'fat fa-play-pause', 'fal fa-play-pause', 'far fa-play-pause', 'fas fa-play-pause',
					],
					defaultOption: 'far fa-play-pause',
					keywords: 'arrow pause play play or pause button right stop triangle play pause',
				},
				{
					className: 'far fa-plus-minus',
					options: [
						'fat fa-plus-minus', 'fal fa-plus-minus', 'far fa-plus-minus', 'fas fa-plus-minus',
					],
					defaultOption: 'far fa-plus-minus',
					keywords: 'plus minus sign add math subtract plus minus',
				},
				{
					className: 'far fa-repeat',
					options: [
						'fat fa-repeat', 'fal fa-repeat', 'far fa-repeat', 'fas fa-repeat',
					],
					defaultOption: 'far fa-repeat',
					keywords: 'arrow clockwise flip reload repeat repeat button rewind switch repeat',
				},
				{
					className: 'far fa-repeat-1',
					options: [
						'fat fa-repeat-1', 'fal fa-repeat-1', 'far fa-repeat-1', 'fas fa-repeat-1',
					],
					defaultOption: 'far fa-repeat-1',
					keywords: 'arrow clockwise flip once reload repeat single button rewind switch repeat 1',
				},
				{
					className: 'far fa-rotate',
					options: [
						'fat fa-rotate', 'fal fa-rotate', 'far fa-rotate', 'fas fa-rotate',
					],
					defaultOption: 'far fa-rotate',
					keywords: 'anticlockwise arrow counterclockwise counterclockwise arrows button exchange refresh reload rotate swap withershins rotate',
				},
				{
					className: 'far fa-rotate-left',
					options: [
						'fat fa-rotate-left', 'fal fa-rotate-left', 'far fa-rotate-left', 'fas fa-rotate-left',
					],
					defaultOption: 'far fa-rotate-left',
					keywords: 'back control z exchange oops return swap rotate left',
				},
				{
					className: 'far fa-rotate-right',
					options: [
						'fat fa-rotate-right', 'fal fa-rotate-right', 'far fa-rotate-right', 'fas fa-rotate-right',
					],
					defaultOption: 'far fa-rotate-right',
					keywords: 'forward refresh reload repeat rotate right',
				},
				{
					className: 'far fa-rss',
					options: [
						'fat fa-rss', 'fal fa-rss', 'far fa-rss', 'fas fa-rss',
					],
					defaultOption: 'far fa-rss',
					keywords: 'blog feed journal news writing rss',
				},
				{
					className: 'far fa-scrubber',
					options: [
						'fat fa-scrubber', 'fal fa-scrubber', 'far fa-scrubber', 'fas fa-scrubber',
					],
					defaultOption: 'far fa-scrubber',
					keywords: 'circle dot toggle scrubber',
				},
				{
					className: 'far fa-shuffle',
					options: [
						'fat fa-shuffle', 'fal fa-shuffle', 'far fa-shuffle', 'fas fa-shuffle',
					],
					defaultOption: 'far fa-shuffle',
					keywords: 'arrow arrows crossed shuffle shuffle tracks button sort swap switch transfer shuffle',
				},
				{
					className: 'far fa-sliders',
					options: [
						'fat fa-sliders', 'fal fa-sliders', 'far fa-sliders', 'fas fa-sliders',
					],
					defaultOption: 'far fa-sliders',
					keywords: 'adjust settings sliders toggle sliders',
				},
				{
					className: 'far fa-sliders-up',
					options: [
						'fat fa-sliders-up', 'fal fa-sliders-up', 'far fa-sliders-up', 'fas fa-sliders-up',
					],
					defaultOption: 'far fa-sliders-up',
					keywords: 'adjust settings sliders toggle sliders up',
				},
				{
					className: 'far fa-stop',
					options: [
						'fat fa-stop', 'fal fa-stop', 'far fa-stop', 'fas fa-stop',
					],
					defaultOption: 'far fa-stop',
					keywords: 'block box square stop stop button stop',
				},
				{
					className: 'far fa-up-right-and-down-left-from-center',
					options: [
						'fat fa-up-right-and-down-left-from-center', 'fal fa-up-right-and-down-left-from-center', 'far fa-up-right-and-down-left-from-center', 'fas fa-up-right-and-down-left-from-center',
					],
					defaultOption: 'far fa-up-right-and-down-left-from-center',
					keywords: 'arrows bigger enlarge fullscreen resize up right and down left from center',
				},
				{
					className: 'far fa-volume',
					options: [
						'fat fa-volume', 'fal fa-volume', 'far fa-volume', 'fas fa-volume',
					],
					defaultOption: 'far fa-volume',
					keywords: 'audio control medium music sound speaker speaker medium volume volume',
				},
				{
					className: 'far fa-volume-high',
					options: [
						'fat fa-volume-high', 'fal fa-volume-high', 'far fa-volume-high', 'fas fa-volume-high',
					],
					defaultOption: 'far fa-volume-high',
					keywords: 'audio higher loud louder music sound speaker speaker high volume volume high',
				},
				{
					className: 'far fa-volume-low',
					options: [
						'fat fa-volume-low', 'fal fa-volume-low', 'far fa-volume-low', 'fas fa-volume-low',
					],
					defaultOption: 'far fa-volume-low',
					keywords: 'audio lower music quieter soft sound speaker speaker low volume volume low',
				},
				{
					className: 'far fa-volume-off',
					options: [
						'fat fa-volume-off', 'fal fa-volume-off', 'far fa-volume-off', 'fas fa-volume-off',
					],
					defaultOption: 'far fa-volume-off',
					keywords: 'audio ban music mute quiet silent sound volume off',
				},
				{
					className: 'far fa-volume-slash',
					options: [
						'fat fa-volume-slash', 'fal fa-volume-slash', 'far fa-volume-slash', 'fas fa-volume-slash',
					],
					defaultOption: 'far fa-volume-slash',
					keywords: 'audio ban music mute muted speaker quiet silent sound speaker volume slash',
				},
				{
					className: 'far fa-volume-xmark',
					options: [
						'fat fa-volume-xmark', 'fal fa-volume-xmark', 'far fa-volume-xmark', 'fas fa-volume-xmark',
					],
					defaultOption: 'far fa-volume-xmark',
					keywords: 'audio music quiet sound speaker volume xmark',
				},
			],
		},
		{
			id: 'medical-health',
			name: Loc.getMessage('LANDING_ICONS_SECTION_MEDICAL_HEALTH'),
			items: [
				{
					className: 'far fa-bacteria',
					options: [
						'fat fa-bacteria', 'fal fa-bacteria', 'far fa-bacteria', 'fas fa-bacteria',
					],
					defaultOption: 'far fa-bacteria',
					keywords: 'antibiotic antibody covid 19 health organism sick bacteria',
				},
				{
					className: 'far fa-bacterium',
					options: [
						'fat fa-bacterium', 'fal fa-bacterium', 'far fa-bacterium', 'fas fa-bacterium',
					],
					defaultOption: 'far fa-bacterium',
					keywords: 'antibiotic antibody covid 19 health organism sick bacterium',
				},
				{
					className: 'far fa-ban-smoking',
					options: [
						'fat fa-ban-smoking', 'fal fa-ban-smoking', 'far fa-ban-smoking', 'fas fa-ban-smoking',
					],
					defaultOption: 'far fa-ban-smoking',
					keywords: 'ban cancel forbidden no no smoking non smoking not prohibited smoking ban-smoking',
				},
				{
					className: 'far fa-bandage',
					options: [
						'fat fa-bandage', 'fal fa-bandage', 'far fa-bandage', 'fas fa-bandage',
					],
					defaultOption: 'far fa-bandage',
					keywords: 'adhesive bandage bandage boo boo first aid ouch bandage',
				},
				{
					className: 'far fa-bed-pulse',
					options: [
						'fat fa-bed-pulse', 'fal fa-bed-pulse', 'far fa-bed-pulse', 'fas fa-bed-pulse',
					],
					defaultOption: 'far fa-bed-pulse',
					keywords: 'ekg bed electrocardiogram health hospital life patient vital bed pulse',
				},
				{
					className: 'far fa-biohazard',
					options: [
						'fat fa-biohazard', 'fal fa-biohazard', 'far fa-biohazard', 'fas fa-biohazard',
					],
					defaultOption: 'far fa-biohazard',
					keywords: 'biohazard covid 19 danger dangerous hazmat medical radioactive sign toxic waste zombie biohazard',
				},
				{
					className: 'far fa-bone',
					options: [
						'fat fa-bone', 'fal fa-bone', 'far fa-bone', 'fas fa-bone',
					],
					defaultOption: 'far fa-bone',
					keywords: 'bone calcium dog skeletal skeleton tibia bone',
				},
				{
					className: 'far fa-bone-break',
					options: [
						'fat fa-bone-break', 'fal fa-bone-break', 'far fa-bone-break', 'fas fa-bone-break',
					],
					defaultOption: 'far fa-bone-break',
					keywords: 'broken calcium dog fracture skeletal skeleton tibia bone break',
				},
				{
					className: 'far fa-bong',
					options: [
						'fat fa-bong', 'fal fa-bong', 'far fa-bong', 'fas fa-bong',
					],
					defaultOption: 'far fa-bong',
					keywords: 'aparatus cannabis marijuana pipe smoke smoking bong',
				},
				{
					className: 'far fa-book-medical',
					options: [
						'fat fa-book-medical', 'fal fa-book-medical', 'far fa-book-medical', 'fas fa-book-medical',
					],
					defaultOption: 'far fa-book-medical',
					keywords: 'diary documentation health history journal library read record research book medical',
				},
				{
					className: 'far fa-book-user',
					options: [
						'fat fa-book-user', 'fal fa-book-user', 'far fa-book-user', 'fas fa-book-user',
					],
					defaultOption: 'far fa-book-user',
					keywords: 'address biography diary documentation journal library read research book user',
				},
				{
					className: 'far fa-books-medical',
					options: [
						'fat fa-books-medical', 'fal fa-books-medical', 'far fa-books-medical', 'fas fa-books-medical',
					],
					defaultOption: 'far fa-books-medical',
					keywords: 'add diary documentation health journal library read records research books medical',
				},
				{
					className: 'far fa-brain',
					options: [
						'fat fa-brain', 'fal fa-brain', 'far fa-brain', 'fas fa-brain',
					],
					defaultOption: 'far fa-brain',
					keywords: 'brain cerebellum gray matter intellect intelligent medulla oblongata mind noodle wit brain',
				},
				{
					className: 'far fa-briefcase-medical',
					options: [
						'fat fa-briefcase-medical', 'fal fa-briefcase-medical', 'far fa-briefcase-medical', 'fas fa-briefcase-medical',
					],
					defaultOption: 'far fa-briefcase-medical',
					keywords: 'doctor emt first aid health briefcase medical',
				},
				{
					className: 'far fa-cannabis',
					options: [
						'fat fa-cannabis', 'fal fa-cannabis', 'far fa-cannabis', 'fas fa-cannabis',
					],
					defaultOption: 'far fa-cannabis',
					keywords: 'bud chronic drugs endica endo ganja marijuana mary jane pot reefer sativa spliff weed whacky tabacky cannabis',
				},
				{
					className: 'far fa-capsules',
					options: [
						'fat fa-capsules', 'fal fa-capsules', 'far fa-capsules', 'fas fa-capsules',
					],
					defaultOption: 'far fa-capsules',
					keywords: 'drugs medicine pills prescription capsules',
				},
				{
					className: 'far fa-cauldron',
					options: [
						'fat fa-cauldron', 'fal fa-cauldron', 'far fa-cauldron', 'fas fa-cauldron',
					],
					defaultOption: 'far fa-cauldron',
					keywords: 'boil bubble cooking halloween holiday magic pot sorcery toil trouble witch wizard cauldron',
				},
				{
					className: 'far fa-circle-h',
					options: [
						'fat fa-circle-h', 'fal fa-circle-h', 'far fa-circle-h', 'fas fa-circle-h',
					],
					defaultOption: 'far fa-circle-h',
					keywords: 'circled latin capital letter h clinic covid 19 emergency letter map circle-h',
				},
				{
					className: 'far fa-circle-radiation',
					options: [
						'fat fa-circle-radiation', 'fal fa-circle-radiation', 'far fa-circle-radiation', 'fas fa-circle-radiation',
					],
					defaultOption: 'far fa-circle-radiation',
					keywords: 'danger dangerous deadly hazard nuclear radioactive sign warning circle radiation',
				},
				{
					className: 'far fa-clipboard-medical',
					options: [
						'fat fa-clipboard-medical', 'fal fa-clipboard-medical', 'far fa-clipboard-medical', 'fas fa-clipboard-medical',
					],
					defaultOption: 'far fa-clipboard-medical',
					keywords: 'copy paste patient records clipboard medical',
				},
				{
					className: 'far fa-clipboard-prescription',
					options: [
						'fat fa-clipboard-prescription', 'fal fa-clipboard-prescription', 'far fa-clipboard-prescription', 'fas fa-clipboard-prescription',
					],
					defaultOption: 'far fa-clipboard-prescription',
					keywords: 'copy history medical notes paste record clipboard prescription',
				},
				{
					className: 'far fa-clipboard-user',
					options: [
						'fat fa-clipboard-user', 'fal fa-clipboard-user', 'far fa-clipboard-user', 'fas fa-clipboard-user',
					],
					defaultOption: 'far fa-clipboard-user',
					keywords: 'attendance record roster staff clipboard user',
				},
				{
					className: 'far fa-clock-rotate-left',
					options: [
						'fat fa-clock-rotate-left', 'fal fa-clock-rotate-left', 'far fa-clock-rotate-left', 'fas fa-clock-rotate-left',
					],
					defaultOption: 'far fa-clock-rotate-left',
					keywords: 'rewind clock reverse time time machine time travel clock rotate-left',
				},
				{
					className: 'far fa-comment-medical',
					options: [
						'fat fa-comment-medical', 'fal fa-comment-medical', 'far fa-comment-medical', 'fas fa-comment-medical',
					],
					defaultOption: 'far fa-comment-medical',
					keywords: 'advice bubble chat commenting conversation diagnose feedback message note notification prescription sms speech texting comment medical',
				},
				{
					className: 'far fa-crutch',
					options: [
						'fat fa-crutch', 'fal fa-crutch', 'far fa-crutch', 'fas fa-crutch',
					],
					defaultOption: 'far fa-crutch',
					keywords: 'cane injury mobility wheelchair crutch',
				},
				{
					className: 'far fa-crutches',
					options: [
						'fat fa-crutches', 'fal fa-crutches', 'far fa-crutches', 'fas fa-crutches',
					],
					defaultOption: 'far fa-crutches',
					keywords: 'cane injury mobility wheelchair crutches',
				},
				{
					className: 'far fa-disease',
					options: [
						'fat fa-disease', 'fal fa-disease', 'far fa-disease', 'fas fa-disease',
					],
					defaultOption: 'far fa-disease',
					keywords: 'bacteria cancer covid 19 illness infection sickness virus disease',
				},
				{
					className: 'far fa-display-medical',
					options: [
						'fat fa-display-medical', 'fal fa-display-medical', 'far fa-display-medical', 'fas fa-display-medical',
					],
					defaultOption: 'far fa-display-medical',
					keywords: 'computer desktop records display medical',
				},
				{
					className: 'far fa-dna',
					options: [
						'fat fa-dna', 'fal fa-dna', 'far fa-dna', 'fas fa-dna',
					],
					defaultOption: 'far fa-dna',
					keywords: 'biologist dna double helix evolution gene genetic genetics helix life molecule protein dna',
				},
				{
					className: 'far fa-ear',
					options: [
						'fat fa-ear', 'fal fa-ear', 'far fa-ear', 'fas fa-ear',
					],
					defaultOption: 'far fa-ear',
					keywords: 'body ear head hearing listen lobe ear',
				},
				{
					className: 'far fa-eye',
					options: [
						'fat fa-eye', 'fal fa-eye', 'far fa-eye', 'fas fa-eye',
					],
					defaultOption: 'far fa-eye',
					keywords: 'body eye look optic see seen show sight views visible eye',
				},
				{
					className: 'far fa-eye-dropper',
					options: [
						'fat fa-eye-dropper', 'fal fa-eye-dropper', 'far fa-eye-dropper', 'fas fa-eye-dropper',
					],
					defaultOption: 'far fa-eye-dropper',
					keywords: 'beaker clone color copy eyedropper pipette eye dropper',
				},
				{
					className: 'far fa-eyes',
					options: [
						'fat fa-eyes', 'fal fa-eyes', 'far fa-eyes', 'fas fa-eyes',
					],
					defaultOption: 'far fa-eyes',
					keywords: 'eye idea look see eyes',
				},
				{
					className: 'far fa-face-head-bandage',
					options: [
						'fat fa-face-head-bandage', 'fal fa-face-head-bandage', 'far fa-face-head-bandage', 'fas fa-face-head-bandage',
					],
					defaultOption: 'far fa-face-head-bandage',
					keywords: 'bandage clumsy face face with head bandage hurt ill injury face-head-bandage',
				},
				{
					className: 'far fa-face-mask',
					options: [
						'fat fa-face-mask', 'fal fa-face-mask', 'far fa-face-mask', 'fas fa-face-mask',
					],
					defaultOption: 'far fa-face-mask',
					keywords: 'cold coronavirus covid covid 19 doctor face face with medical mask mask medical sick surgical face-mask',
				},
				{
					className: 'far fa-face-thermometer',
					options: [
						'fat fa-face-thermometer', 'fal fa-face-thermometer', 'far fa-face-thermometer', 'fas fa-face-thermometer',
					],
					defaultOption: 'far fa-face-thermometer',
					keywords: 'cold coronavirus covid covid 19 face face with thermometer fever flu ill sick thermometer face-thermometer',
				},
				{
					className: 'far fa-face-vomit',
					options: [
						'fat fa-face-vomit', 'fal fa-face-vomit', 'far fa-face-vomit', 'fas fa-face-vomit',
					],
					defaultOption: 'far fa-face-vomit',
					keywords: 'face vomiting flu poison sick spew throw up vomit face vomit',
				},
				{
					className: 'far fa-file-medical',
					options: [
						'fat fa-file-medical', 'fal fa-file-medical', 'far fa-file-medical', 'fas fa-file-medical',
					],
					defaultOption: 'far fa-file-medical',
					keywords: 'document health history prescription record file medical',
				},
				{
					className: 'far fa-file-prescription',
					options: [
						'fat fa-file-prescription', 'fal fa-file-prescription', 'far fa-file-prescription', 'fas fa-file-prescription',
					],
					defaultOption: 'far fa-file-prescription',
					keywords: 'document drugs medical medicine rx file prescription',
				},
				{
					className: 'far fa-file-waveform',
					options: [
						'fat fa-file-waveform', 'fal fa-file-waveform', 'far fa-file-waveform', 'fas fa-file-waveform',
					],
					defaultOption: 'far fa-file-waveform',
					keywords: 'document health history prescription record file waveform',
				},
				{
					className: 'far fa-files-medical',
					options: [
						'fat fa-files-medical', 'fal fa-files-medical', 'far fa-files-medical', 'fas fa-files-medical',
					],
					defaultOption: 'far fa-files-medical',
					keywords: 'document health history prescription record files medical',
				},
				{
					className: 'far fa-fire-flame-simple',
					options: [
						'fat fa-fire-flame-simple', 'fal fa-fire-flame-simple', 'far fa-fire-flame-simple', 'fas fa-fire-flame-simple',
					],
					defaultOption: 'far fa-fire-flame-simple',
					keywords: 'caliente energy fire flame gas heat hot fire flame-simple',
				},
				{
					className: 'far fa-flask',
					options: [
						'fat fa-flask', 'fal fa-flask', 'far fa-flask', 'fas fa-flask',
					],
					defaultOption: 'far fa-flask',
					keywords: 'beaker experimental labs science flask',
				},
				{
					className: 'far fa-flask-round-potion',
					options: [
						'fat fa-flask-round-potion', 'fal fa-flask-round-potion', 'far fa-flask-round-potion', 'fas fa-flask-round-potion',
					],
					defaultOption: 'far fa-flask-round-potion',
					keywords: 'dungeons & dragons alert beaker beverage container d&d danger dangerous deadly death dnd drink fantasy halloween heal health holiday magic mana science flask round-potion',
				},
				{
					className: 'far fa-folder-medical',
					options: [
						'fat fa-folder-medical', 'fal fa-folder-medical', 'far fa-folder-medical', 'fas fa-folder-medical',
					],
					defaultOption: 'far fa-folder-medical',
					keywords: 'health patient record folder medical',
				},
				{
					className: 'far fa-hand-dots',
					options: [
						'fat fa-hand-dots', 'fal fa-hand-dots', 'far fa-hand-dots', 'fas fa-hand-dots',
					],
					defaultOption: 'far fa-hand-dots',
					keywords: 'allergy freckles hand hives palm pox skin spots hand dots',
				},
				{
					className: 'far fa-hand-holding-medical',
					options: [
						'fat fa-hand-holding-medical', 'fal fa-hand-holding-medical', 'far fa-hand-holding-medical', 'fas fa-hand-holding-medical',
					],
					defaultOption: 'far fa-hand-holding-medical',
					keywords: 'care covid 19 donate help hand-holding-medical',
				},
				{
					className: 'far fa-head-side-brain',
					options: [
						'fat fa-head-side-brain', 'fal fa-head-side-brain', 'far fa-head-side-brain', 'fas fa-head-side-brain',
					],
					defaultOption: 'far fa-head-side-brain',
					keywords: 'diagnosis face mental health profile psychiatric psychiatry head side-brain',
				},
				{
					className: 'far fa-head-side-cough',
					options: [
						'fat fa-head-side-cough', 'fal fa-head-side-cough', 'far fa-head-side-cough', 'fas fa-head-side-cough',
					],
					defaultOption: 'far fa-head-side-cough',
					keywords: 'cough covid 19 germs lungs respiratory sick head-side-cough',
				},
				{
					className: 'far fa-head-side-cough-slash',
					options: [
						'fat fa-head-side-cough-slash', 'fal fa-head-side-cough-slash', 'far fa-head-side-cough-slash', 'fas fa-head-side-cough-slash',
					],
					defaultOption: 'far fa-head-side-cough-slash',
					keywords: 'cough covid 19 germs lungs respiratory sick head-side-cough-slash',
				},
				{
					className: 'far fa-head-side-mask',
					options: [
						'fat fa-head-side-mask', 'fal fa-head-side-mask', 'far fa-head-side-mask', 'fas fa-head-side-mask',
					],
					defaultOption: 'far fa-head-side-mask',
					keywords: 'breath covid 19 filter respirator virus head-side-mask',
				},
				{
					className: 'far fa-head-side-medical',
					options: [
						'fat fa-head-side-medical', 'fal fa-head-side-medical', 'far fa-head-side-medical', 'fas fa-head-side-medical',
					],
					defaultOption: 'far fa-head-side-medical',
					keywords: 'diagnosis face mental health profile psychiatric psychiatry head side-medical',
				},
				{
					className: 'far fa-head-side-virus',
					options: [
						'fat fa-head-side-virus', 'fal fa-head-side-virus', 'far fa-head-side-virus', 'fas fa-head-side-virus',
					],
					defaultOption: 'far fa-head-side-virus',
					keywords: 'cold covid 19 flu sick head-side-virus',
				},
				{
					className: 'far fa-heart',
					options: [
						'fat fa-heart', 'fal fa-heart', 'far fa-heart', 'fas fa-heart',
					],
					defaultOption: 'far fa-heart',
					keywords: 'black black heart blue blue heart brown brown heart card evil favorite game green green heart heart heart suit like love orange orange heart purple purple heart red heart relationship valentine white white heart wicked yellow yellow heart heart',
				},
				{
					className: 'far fa-heart-pulse',
					options: [
						'fat fa-heart-pulse', 'fal fa-heart-pulse', 'far fa-heart-pulse', 'fas fa-heart-pulse',
					],
					defaultOption: 'far fa-heart-pulse',
					keywords: 'ekg electrocardiogram health lifeline vital signs heart pulse',
				},
				{
					className: 'far fa-hospital',
					options: [
						'fat fa-hospital', 'fal fa-hospital', 'far fa-hospital', 'fas fa-hospital',
					],
					defaultOption: 'far fa-hospital',
					keywords: 'building covid 19 doctor emergency room hospital medical center medicine hospital',
				},
				{
					className: 'far fa-hospital-user',
					options: [
						'fat fa-hospital-user', 'fal fa-hospital-user', 'far fa-hospital-user', 'fas fa-hospital-user',
					],
					defaultOption: 'far fa-hospital-user',
					keywords: 'covid 19 doctor network patient primary care hospital-user',
				},
				{
					className: 'far fa-hospitals',
					options: [
						'fat fa-hospitals', 'fal fa-hospitals', 'far fa-hospitals', 'fas fa-hospitals',
					],
					defaultOption: 'far fa-hospitals',
					keywords: 'emergency insurance network hospitals',
				},
				{
					className: 'far fa-house-chimney-medical',
					options: [
						'fat fa-house-chimney-medical', 'fal fa-house-chimney-medical', 'far fa-house-chimney-medical', 'fas fa-house-chimney-medical',
					],
					defaultOption: 'far fa-house-chimney-medical',
					keywords: 'covid 19 doctor general practitioner hospital infirmary medicine office outpatient house-chimney-medical',
				},
				{
					className: 'far fa-house-medical',
					options: [
						'fat fa-house-medical', 'fal fa-house-medical', 'far fa-house-medical', 'fas fa-house-medical',
					],
					defaultOption: 'far fa-house-medical',
					keywords: 'covid 19 doctor general practitioner hospital infirmary medicine office outpatient house-medical',
				},
				{
					className: 'far fa-id-card-clip',
					options: [
						'fat fa-id-card-clip', 'fal fa-id-card-clip', 'far fa-id-card-clip', 'fas fa-id-card-clip',
					],
					defaultOption: 'far fa-id-card-clip',
					keywords: 'contact demographics document identification issued profile id card-clip',
				},
				{
					className: 'far fa-inhaler',
					options: [
						'fat fa-inhaler', 'fal fa-inhaler', 'far fa-inhaler', 'fas fa-inhaler',
					],
					defaultOption: 'far fa-inhaler',
					keywords: 'asthma cough lungs nebulizer vaporizer inhaler',
				},
				{
					className: 'far fa-joint',
					options: [
						'fat fa-joint', 'fal fa-joint', 'far fa-joint', 'fas fa-joint',
					],
					defaultOption: 'far fa-joint',
					keywords: 'blunt cannabis doobie drugs marijuana roach smoke smoking spliff joint',
				},
				{
					className: 'far fa-kidneys',
					options: [
						'fat fa-kidneys', 'fal fa-kidneys', 'far fa-kidneys', 'fas fa-kidneys',
					],
					defaultOption: 'far fa-kidneys',
					keywords: 'blood body organ surgery urine kidneys',
				},
				{
					className: 'far fa-kit-medical',
					options: [
						'fat fa-kit-medical', 'fal fa-kit-medical', 'far fa-kit-medical', 'fas fa-kit-medical',
					],
					defaultOption: 'far fa-kit-medical',
					keywords: 'emergency emt health medical rescue kit medical',
				},
				{
					className: 'far fa-laptop-medical',
					options: [
						'fat fa-laptop-medical', 'fal fa-laptop-medical', 'far fa-laptop-medical', 'fas fa-laptop-medical',
					],
					defaultOption: 'far fa-laptop-medical',
					keywords: 'computer device ehr electronic health records history laptop medical',
				},
				{
					className: 'far fa-lips',
					options: [
						'fat fa-lips', 'fal fa-lips', 'far fa-lips', 'fas fa-lips',
					],
					defaultOption: 'far fa-lips',
					keywords: 'lips fashion kiss lips lipstick mouth smile lips',
				},
				{
					className: 'far fa-lungs',
					options: [
						'fat fa-lungs', 'fal fa-lungs', 'far fa-lungs', 'fas fa-lungs',
					],
					defaultOption: 'far fa-lungs',
					keywords: 'air breath covid 19 exhalation inhalation lungs organ respiration respiratory lungs',
				},
				{
					className: 'far fa-lungs-virus',
					options: [
						'fat fa-lungs-virus', 'fal fa-lungs-virus', 'far fa-lungs-virus', 'fas fa-lungs-virus',
					],
					defaultOption: 'far fa-lungs-virus',
					keywords: 'breath covid 19 respiratory sick lungs-virus',
				},
				{
					className: 'far fa-mask-face',
					options: [
						'fat fa-mask-face', 'fal fa-mask-face', 'far fa-mask-face', 'fas fa-mask-face',
					],
					defaultOption: 'far fa-mask-face',
					keywords: 'breath covid 19 filter respirator virus mask-face',
				},
				{
					className: 'far fa-message-medical',
					options: [
						'fat fa-message-medical', 'fal fa-message-medical', 'far fa-message-medical', 'fas fa-message-medical',
					],
					defaultOption: 'far fa-message-medical',
					keywords: 'advice bubble chat commenting conversation diagnose feedback message note notification prescription sms speech texting message medical',
				},
				{
					className: 'far fa-microscope',
					options: [
						'fat fa-microscope', 'fal fa-microscope', 'far fa-microscope', 'fas fa-microscope',
					],
					defaultOption: 'far fa-microscope',
					keywords: 'covid 19 electron lens microscope optics science shrink tool microscope',
				},
				{
					className: 'far fa-monitor-waveform',
					options: [
						'fat fa-monitor-waveform', 'fal fa-monitor-waveform', 'far fa-monitor-waveform', 'fas fa-monitor-waveform',
					],
					defaultOption: 'far fa-monitor-waveform',
					keywords: 'ekg electrocardiogram health life vital monitor waveform',
				},
				{
					className: 'far fa-mortar-pestle',
					options: [
						'fat fa-mortar-pestle', 'fal fa-mortar-pestle', 'far fa-mortar-pestle', 'fas fa-mortar-pestle',
					],
					defaultOption: 'far fa-mortar-pestle',
					keywords: 'crush culinary grind medical mix pharmacy prescription spices mortar pestle',
				},
				{
					className: 'far fa-note-medical',
					options: [
						'fat fa-note-medical', 'fal fa-note-medical', 'far fa-note-medical', 'fas fa-note-medical',
					],
					defaultOption: 'far fa-note-medical',
					keywords: 'memo sticky note note medical',
				},
				{
					className: 'far fa-notes-medical',
					options: [
						'fat fa-notes-medical', 'fal fa-notes-medical', 'far fa-notes-medical', 'fas fa-notes-medical',
					],
					defaultOption: 'far fa-notes-medical',
					keywords: 'clipboard doctor ehr health history records notes medical',
				},
				{
					className: 'far fa-pager',
					options: [
						'fat fa-pager', 'fal fa-pager', 'far fa-pager', 'fas fa-pager',
					],
					defaultOption: 'far fa-pager',
					keywords: 'beeper cell phone communication page pager pager',
				},
				{
					className: 'far fa-person-dots-from-line',
					options: [
						'fat fa-person-dots-from-line', 'fal fa-person-dots-from-line', 'far fa-person-dots-from-line', 'fas fa-person-dots-from-line',
					],
					defaultOption: 'far fa-person-dots-from-line',
					keywords: 'allergy diagnosis person dots-from-line',
				},
				{
					className: 'far fa-pills',
					options: [
						'fat fa-pills', 'fal fa-pills', 'far fa-pills', 'fas fa-pills',
					],
					defaultOption: 'far fa-pills',
					keywords: 'drugs medicine prescription tablets pills',
				},
				{
					className: 'far fa-plus',
					options: [
						'fat fa-plus', 'fal fa-plus', 'far fa-plus', 'fas fa-plus',
					],
					defaultOption: 'far fa-plus',
					keywords: '0 plus sign add create expand math new plus positive shape sign plus',
				},
				{
					className: 'far fa-poop',
					options: [
						'fat fa-poop', 'fal fa-poop', 'far fa-poop', 'fas fa-poop',
					],
					defaultOption: 'far fa-poop',
					keywords: 'crap poop shit smile turd poop',
				},
				{
					className: 'far fa-prescription',
					options: [
						'fat fa-prescription', 'fal fa-prescription', 'far fa-prescription', 'fas fa-prescription',
					],
					defaultOption: 'far fa-prescription',
					keywords: 'drugs medical medicine pharmacy rx prescription',
				},
				{
					className: 'far fa-prescription-bottle',
					options: [
						'fat fa-prescription-bottle', 'fal fa-prescription-bottle', 'far fa-prescription-bottle', 'fas fa-prescription-bottle',
					],
					defaultOption: 'far fa-prescription-bottle',
					keywords: 'drugs medical medicine pharmacy rx prescription bottle',
				},
				{
					className: 'far fa-prescription-bottle-medical',
					options: [
						'fat fa-prescription-bottle-medical', 'fal fa-prescription-bottle-medical', 'far fa-prescription-bottle-medical', 'fas fa-prescription-bottle-medical',
					],
					defaultOption: 'far fa-prescription-bottle-medical',
					keywords: 'drugs medical medicine pharmacy rx prescription bottle-medical',
				},
				{
					className: 'far fa-pump-medical',
					options: [
						'fat fa-pump-medical', 'fal fa-pump-medical', 'far fa-pump-medical', 'fas fa-pump-medical',
					],
					defaultOption: 'far fa-pump-medical',
					keywords: 'anti bacterial clean covid-19 disinfect hygiene medical grade sanitizer soap pump-medical',
				},
				{
					className: 'far fa-radiation',
					options: [
						'fat fa-radiation', 'fal fa-radiation', 'far fa-radiation', 'fas fa-radiation',
					],
					defaultOption: 'far fa-radiation',
					keywords: 'danger dangerous deadly hazard nuclear radioactive warning radiation',
				},
				{
					className: 'far fa-receipt',
					options: [
						'fat fa-receipt', 'fal fa-receipt', 'far fa-receipt', 'fas fa-receipt',
					],
					defaultOption: 'far fa-receipt',
					keywords: 'accounting bookkeeping check evidence invoice money pay proof receipt table receipt',
				},
				{
					className: 'far fa-scalpel',
					options: [
						'fat fa-scalpel', 'fal fa-scalpel', 'far fa-scalpel', 'fas fa-scalpel',
					],
					defaultOption: 'far fa-scalpel',
					keywords: 'blade cut doctor knife surgeon surgery scalpel',
				},
				{
					className: 'far fa-scalpel-line-dashed',
					options: [
						'fat fa-scalpel-line-dashed', 'fal fa-scalpel-line-dashed', 'far fa-scalpel-line-dashed', 'fas fa-scalpel-line-dashed',
					],
					defaultOption: 'far fa-scalpel-line-dashed',
					keywords: 'blade cut doctor knife surgeon surgery scalpel line-dashed',
				},
				{
					className: 'far fa-shield-virus',
					options: [
						'fat fa-shield-virus', 'fal fa-shield-virus', 'far fa-shield-virus', 'fas fa-shield-virus',
					],
					defaultOption: 'far fa-shield-virus',
					keywords: 'antibodies barrier covid 19 health protect shield-virus',
				},
				{
					className: 'far fa-skeleton',
					options: [
						'fat fa-skeleton', 'fal fa-skeleton', 'far fa-skeleton', 'fas fa-skeleton',
					],
					defaultOption: 'far fa-skeleton',
					keywords: 'bones skeletal vertebrate x ray skeleton',
				},
				{
					className: 'far fa-skull',
					options: [
						'fat fa-skull', 'fal fa-skull', 'far fa-skull', 'fas fa-skull',
					],
					defaultOption: 'far fa-skull',
					keywords: 'bones death face fairy tale monster skeleton skull x ray yorick skull',
				},
				{
					className: 'far fa-skull-crossbones',
					options: [
						'fat fa-skull-crossbones', 'fal fa-skull-crossbones', 'far fa-skull-crossbones', 'fas fa-skull-crossbones',
					],
					defaultOption: 'far fa-skull-crossbones',
					keywords: 'black skull and crossbones dungeons & dragons alert bones crossbones d&d danger dead deadly death dnd face fantasy halloween holiday jolly roger monster pirate poison skeleton skull skull and crossbones warning skull-crossbones',
				},
				{
					className: 'far fa-smoking',
					options: [
						'fat fa-smoking', 'fal fa-smoking', 'far fa-smoking', 'fas fa-smoking',
					],
					defaultOption: 'far fa-smoking',
					keywords: 'cancer cigarette nicotine smoking smoking status tobacco smoking',
				},
				{
					className: 'far fa-square-h',
					options: [
						'fat fa-square-h', 'fal fa-square-h', 'far fa-square-h', 'fas fa-square-h',
					],
					defaultOption: 'far fa-square-h',
					keywords: 'directions emergency hospital hotel letter map square h',
				},
				{
					className: 'far fa-square-plus',
					options: [
						'fat fa-square-plus', 'fal fa-square-plus', 'far fa-square-plus', 'fas fa-square-plus',
					],
					defaultOption: 'far fa-square-plus',
					keywords: 'add create expand new positive shape square plus',
				},
				{
					className: 'far fa-star-of-life',
					options: [
						'fat fa-star-of-life', 'fal fa-star-of-life', 'far fa-star-of-life', 'fas fa-star-of-life',
					],
					defaultOption: 'far fa-star-of-life',
					keywords: 'doctor emt first aid health medical star of-life',
				},
				{
					className: 'far fa-stethoscope',
					options: [
						'fat fa-stethoscope', 'fal fa-stethoscope', 'far fa-stethoscope', 'fas fa-stethoscope',
					],
					defaultOption: 'far fa-stethoscope',
					keywords: 'covid 19 diagnosis doctor general practitioner heart hospital infirmary medicine office outpatient stethoscope stethoscope',
				},
				{
					className: 'far fa-stomach',
					options: [
						'fat fa-stomach', 'fal fa-stomach', 'far fa-stomach', 'fas fa-stomach',
					],
					defaultOption: 'far fa-stomach',
					keywords: 'abdomen belly food gut hungry intestine organ tummy stomach',
				},
				{
					className: 'far fa-stretcher',
					options: [
						'fat fa-stretcher', 'fal fa-stretcher', 'far fa-stretcher', 'fas fa-stretcher',
					],
					defaultOption: 'far fa-stretcher',
					keywords: 'ambulance bed emergency er patient stretcher',
				},
				{
					className: 'far fa-suitcase-medical',
					options: [
						'fat fa-suitcase-medical', 'fal fa-suitcase-medical', 'far fa-suitcase-medical', 'fas fa-suitcase-medical',
					],
					defaultOption: 'far fa-suitcase-medical',
					keywords: 'first aid firstaid health help support suitcase medical',
				},
				{
					className: 'far fa-syringe',
					options: [
						'fat fa-syringe', 'fal fa-syringe', 'far fa-syringe', 'fas fa-syringe',
					],
					defaultOption: 'far fa-syringe',
					keywords: 'covid 19 doctor immunizations medical medicine needle shot sick syringe syringe',
				},
				{
					className: 'far fa-tablets',
					options: [
						'fat fa-tablets', 'fal fa-tablets', 'far fa-tablets', 'fas fa-tablets',
					],
					defaultOption: 'far fa-tablets',
					keywords: 'drugs medicine pills prescription tablets',
				},
				{
					className: 'far fa-teeth',
					options: [
						'fat fa-teeth', 'fal fa-teeth', 'far fa-teeth', 'fas fa-teeth',
					],
					defaultOption: 'far fa-teeth',
					keywords: 'bite dental dentist gums mouth smile tooth teeth',
				},
				{
					className: 'far fa-teeth-open',
					options: [
						'fat fa-teeth-open', 'fal fa-teeth-open', 'far fa-teeth-open', 'fas fa-teeth-open',
					],
					defaultOption: 'far fa-teeth-open',
					keywords: 'dental dentist gums bite mouth smile tooth teeth open',
				},
				{
					className: 'far fa-thermometer',
					options: [
						'fat fa-thermometer', 'fal fa-thermometer', 'far fa-thermometer', 'fas fa-thermometer',
					],
					defaultOption: 'far fa-thermometer',
					keywords: 'covid 19 mercury status temperature thermometer',
				},
				{
					className: 'far fa-tooth',
					options: [
						'fat fa-tooth', 'fal fa-tooth', 'far fa-tooth', 'fas fa-tooth',
					],
					defaultOption: 'far fa-tooth',
					keywords: 'bicuspid dental dentist molar mouth teeth tooth tooth',
				},
				{
					className: 'far fa-toothbrush',
					options: [
						'fat fa-toothbrush', 'fal fa-toothbrush', 'far fa-toothbrush', 'fas fa-toothbrush',
					],
					defaultOption: 'far fa-toothbrush',
					keywords: 'bathroom bicuspid brush clean dental dentist hygiene molar mouth teeth toothbrush toothbrush',
				},
				{
					className: 'far fa-truck-medical',
					options: [
						'fat fa-truck-medical', 'fal fa-truck-medical', 'far fa-truck-medical', 'fas fa-truck-medical',
					],
					defaultOption: 'far fa-truck-medical',
					keywords: 'ambulance covid 19 emergency emt er help hospital support vehicle truck-medical',
				},
				{
					className: 'far fa-user-doctor',
					options: [
						'fat fa-user-doctor', 'fal fa-user-doctor', 'far fa-user-doctor', 'fas fa-user-doctor',
					],
					defaultOption: 'far fa-user-doctor',
					keywords: 'covid 19 job medical nurse occupation physician profile surgeon user-doctor',
				},
				{
					className: 'far fa-user-doctor-hair',
					options: [
						'fat fa-user-doctor-hair', 'fal fa-user-doctor-hair', 'far fa-user-doctor-hair', 'fas fa-user-doctor-hair',
					],
					defaultOption: 'far fa-user-doctor-hair',
					keywords: 'covid 19 job medical nurse occupation physician profile surgeon user-doctor-hair',
				},
				{
					className: 'far fa-user-doctor-hair-long',
					options: [
						'fat fa-user-doctor-hair-long', 'fal fa-user-doctor-hair-long', 'far fa-user-doctor-hair-long', 'fas fa-user-doctor-hair-long',
					],
					defaultOption: 'far fa-user-doctor-hair-long',
					keywords: 'covid 19 job medical nurse occupation physician profile surgeon user-doctor-hair-long',
				},
				{
					className: 'far fa-user-doctor-message',
					options: [
						'fat fa-user-doctor-message', 'fal fa-user-doctor-message', 'far fa-user-doctor-message', 'fas fa-user-doctor-message',
					],
					defaultOption: 'far fa-user-doctor-message',
					keywords: 'advice comment diagnosis opinion prescription user doctor-message',
				},
				{
					className: 'far fa-user-nurse',
					options: [
						'fat fa-user-nurse', 'fal fa-user-nurse', 'far fa-user-nurse', 'fas fa-user-nurse',
					],
					defaultOption: 'far fa-user-nurse',
					keywords: 'covid 19 doctor md medico midwife physician practitioner surgeon user-nurse',
				},
				{
					className: 'far fa-user-nurse-hair',
					options: [
						'fat fa-user-nurse-hair', 'fal fa-user-nurse-hair', 'far fa-user-nurse-hair', 'fas fa-user-nurse-hair',
					],
					defaultOption: 'far fa-user-nurse-hair',
					keywords: 'doctor md midwife physician practitioner surgeon user nurse-hair',
				},
				{
					className: 'far fa-user-nurse-hair-long',
					options: [
						'fat fa-user-nurse-hair-long', 'fal fa-user-nurse-hair-long', 'far fa-user-nurse-hair-long', 'fas fa-user-nurse-hair-long',
					],
					defaultOption: 'far fa-user-nurse-hair-long',
					keywords: 'doctor md midwife physician practitioner surgeon user nurse-hair-long',
				},
				{
					className: 'far fa-users-medical',
					options: [
						'fat fa-users-medical', 'fal fa-users-medical', 'far fa-users-medical', 'fas fa-users-medical',
					],
					defaultOption: 'far fa-users-medical',
					keywords: 'group patients physician team users medical',
				},
				{
					className: 'far fa-vial',
					options: [
						'fat fa-vial', 'fal fa-vial', 'far fa-vial', 'fas fa-vial',
					],
					defaultOption: 'far fa-vial',
					keywords: 'chemist chemistry experiment lab sample science test test tube vial',
				},
				{
					className: 'far fa-vials',
					options: [
						'fat fa-vials', 'fal fa-vials', 'far fa-vials', 'fas fa-vials',
					],
					defaultOption: 'far fa-vials',
					keywords: 'experiment lab sample science test test tube vials',
				},
				{
					className: 'far fa-virus',
					options: [
						'fat fa-virus', 'fal fa-virus', 'far fa-virus', 'fas fa-virus',
					],
					defaultOption: 'far fa-virus',
					keywords: 'bug covid 19 flu health sick viral virus',
				},
				{
					className: 'far fa-virus-slash',
					options: [
						'fat fa-virus-slash', 'fal fa-virus-slash', 'far fa-virus-slash', 'fas fa-virus-slash',
					],
					defaultOption: 'far fa-virus-slash',
					keywords: 'bug covid 19 cure eliminate flu health sick viral virus-slash',
				},
				{
					className: 'far fa-viruses',
					options: [
						'fat fa-viruses', 'fal fa-viruses', 'far fa-viruses', 'fas fa-viruses',
					],
					defaultOption: 'far fa-viruses',
					keywords: 'bugs covid 19 flu health multiply sick spread viral viruses',
				},
				{
					className: 'far fa-walker',
					options: [
						'fat fa-walker', 'fal fa-walker', 'far fa-walker', 'fas fa-walker',
					],
					defaultOption: 'far fa-walker',
					keywords: 'accessibility assistance wheelchair walker',
				},
				{
					className: 'far fa-watch-fitness',
					options: [
						'fat fa-watch-fitness', 'fal fa-watch-fitness', 'far fa-watch-fitness', 'fas fa-watch-fitness',
					],
					defaultOption: 'far fa-watch-fitness',
					keywords: 'fitbit alert apple watch clock pedometer time wristwatch watch fitness',
				},
				{
					className: 'far fa-wave-pulse',
					options: [
						'fat fa-wave-pulse', 'fal fa-wave-pulse', 'far fa-wave-pulse', 'fas fa-wave-pulse',
					],
					defaultOption: 'far fa-wave-pulse',
					keywords: 'ekg activity electrocardiogram health life vital wave pulse',
				},
				{
					className: 'far fa-weight-scale',
					options: [
						'fat fa-weight-scale', 'fal fa-weight-scale', 'far fa-weight-scale', 'fas fa-weight-scale',
					],
					defaultOption: 'far fa-weight-scale',
					keywords: 'health measurement scale weight weight scale',
				},
				{
					className: 'far fa-wheelchair',
					options: [
						'fat fa-wheelchair', 'fal fa-wheelchair', 'far fa-wheelchair', 'fas fa-wheelchair',
					],
					defaultOption: 'far fa-wheelchair',
					keywords: 'users people wheelchair',
				},
				{
					className: 'far fa-wheelchair-move',
					options: [
						'fat fa-wheelchair-move', 'fal fa-wheelchair-move', 'far fa-wheelchair-move', 'fas fa-wheelchair-move',
					],
					defaultOption: 'far fa-wheelchair-move',
					keywords: 'access users people wheelchair symbol wheelchair-move',
				},
				{
					className: 'far fa-x-ray',
					options: [
						'fat fa-x-ray', 'fal fa-x-ray', 'far fa-x-ray', 'fas fa-x-ray',
					],
					defaultOption: 'far fa-x-ray',
					keywords: 'health medical radiological images radiology skeleton x ray',
				},
			],
		},
		{
			id: 'money',
			name: Loc.getMessage('LANDING_ICONS_SECTION_MONEY'),
			items: [
				{
					className: 'far fa-austral-sign',
					options: [
						'fat fa-austral-sign', 'fal fa-austral-sign', 'far fa-austral-sign', 'fas fa-austral-sign',
					],
					defaultOption: 'far fa-austral-sign',
					keywords: 'austral sign currency austral sign',
				},
				{
					className: 'far fa-badge-dollar',
					options: [
						'fat fa-badge-dollar', 'fal fa-badge-dollar', 'far fa-badge-dollar', 'fas fa-badge-dollar',
					],
					defaultOption: 'far fa-badge-dollar',
					keywords: 'deal discount money save usd badge dollar',
				},
				{
					className: 'far fa-badge-percent',
					options: [
						'fat fa-badge-percent', 'fal fa-badge-percent', 'far fa-badge-percent', 'fas fa-badge-percent',
					],
					defaultOption: 'far fa-badge-percent',
					keywords: 'deal discount money save usd badge percent',
				},
				{
					className: 'far fa-baht-sign',
					options: [
						'fat fa-baht-sign', 'fal fa-baht-sign', 'far fa-baht-sign', 'fas fa-baht-sign',
					],
					defaultOption: 'far fa-baht-sign',
					keywords: 'currency baht sign',
				},
				{
					className: 'far fa-bangladeshi-taka-sign',
					options: [
						'fat fa-bangladeshi-taka-sign', 'fal fa-bangladeshi-taka-sign', 'far fa-bangladeshi-taka-sign', 'fas fa-bangladeshi-taka-sign',
					],
					defaultOption: 'far fa-bangladeshi-taka-sign',
					keywords: 'bdt currency tk bangladeshi taka-sign',
				},
				{
					className: 'far fa-bitcoin-sign',
					options: [
						'fat fa-bitcoin-sign', 'fal fa-bitcoin-sign', 'far fa-bitcoin-sign', 'fas fa-bitcoin-sign',
					],
					defaultOption: 'far fa-bitcoin-sign',
					keywords: 'bitcoin sign currency bitcoin sign',
				},
				{
					className: 'far fa-cash-register',
					options: [
						'fat fa-cash-register', 'fal fa-cash-register', 'far fa-cash-register', 'fas fa-cash-register',
					],
					defaultOption: 'far fa-cash-register',
					keywords: 'buy cha ching change checkout commerce leaerboard machine pay payment purchase store cash-register',
				},
				{
					className: 'far fa-cedi-sign',
					options: [
						'fat fa-cedi-sign', 'fal fa-cedi-sign', 'far fa-cedi-sign', 'fas fa-cedi-sign',
					],
					defaultOption: 'far fa-cedi-sign',
					keywords: 'cedi sign currency cedi sign',
				},
				{
					className: 'far fa-cent-sign',
					options: [
						'fat fa-cent-sign', 'fal fa-cent-sign', 'far fa-cent-sign', 'fas fa-cent-sign',
					],
					defaultOption: 'far fa-cent-sign',
					keywords: 'cent sign currency cent sign',
				},
				{
					className: 'far fa-chart-line',
					options: [
						'fat fa-chart-line', 'fal fa-chart-line', 'far fa-chart-line', 'fas fa-chart-line',
					],
					defaultOption: 'far fa-chart-line',
					keywords: 'activity analytics chart dashboard gain graph increase line chart line',
				},
				{
					className: 'far fa-chart-line-down',
					options: [
						'fat fa-chart-line-down', 'fal fa-chart-line-down', 'far fa-chart-line-down', 'fas fa-chart-line-down',
					],
					defaultOption: 'far fa-chart-line-down',
					keywords: 'analytics chart chart decreasing dashboard decline down graph line loss trend chart line-down',
				},
				{
					className: 'far fa-chart-mixed',
					options: [
						'fat fa-chart-mixed', 'fal fa-chart-mixed', 'far fa-chart-mixed', 'fas fa-chart-mixed',
					],
					defaultOption: 'far fa-chart-mixed',
					keywords: 'chart measure roi tracking trend chart mixed',
				},
				{
					className: 'far fa-chart-pie',
					options: [
						'fat fa-chart-pie', 'fal fa-chart-pie', 'far fa-chart-pie', 'fas fa-chart-pie',
					],
					defaultOption: 'far fa-chart-pie',
					keywords: 'analytics chart diagram graph pie chart pie',
				},
				{
					className: 'far fa-chart-pie-simple',
					options: [
						'fat fa-chart-pie-simple', 'fal fa-chart-pie-simple', 'far fa-chart-pie-simple', 'fas fa-chart-pie-simple',
					],
					defaultOption: 'far fa-chart-pie-simple',
					keywords: 'analytics chart diagram graph pie chart pie-simple',
				},
				{
					className: 'far fa-circle-dollar',
					options: [
						'fat fa-circle-dollar', 'fal fa-circle-dollar', 'far fa-circle-dollar', 'fas fa-circle-dollar',
					],
					defaultOption: 'far fa-circle-dollar',
					keywords: '$ currency dollar sign money price usd circle-dollar',
				},
				{
					className: 'far fa-circle-dollar-to-slot',
					options: [
						'fat fa-circle-dollar-to-slot', 'fal fa-circle-dollar-to-slot', 'far fa-circle-dollar-to-slot', 'fas fa-circle-dollar-to-slot',
					],
					defaultOption: 'far fa-circle-dollar-to-slot',
					keywords: 'contribute generosity gift give circle dollar-to-slot',
				},
				{
					className: 'far fa-coin',
					options: [
						'fat fa-coin', 'fal fa-coin', 'far fa-coin', 'fas fa-coin',
					],
					defaultOption: 'far fa-coin',
					keywords: 'coin dime gold metal money nickel penny quarter silver treasure coin',
				},
				{
					className: 'far fa-coin-blank',
					options: [
						'fat fa-coin-blank', 'fal fa-coin-blank', 'far fa-coin-blank', 'fas fa-coin-blank',
					],
					defaultOption: 'far fa-coin-blank',
					keywords: 'coin dime gold metal money nickel penny quarter silver treasure coin blank',
				},
				{
					className: 'far fa-coin-front',
					options: [
						'fat fa-coin-front', 'fal fa-coin-front', 'far fa-coin-front', 'fas fa-coin-front',
					],
					defaultOption: 'far fa-coin-front',
					keywords: 'coin dime gold metal money nickel penny quarter silver super mario treasure coin front',
				},
				{
					className: 'far fa-coin-vertical',
					options: [
						'fat fa-coin-vertical', 'fal fa-coin-vertical', 'far fa-coin-vertical', 'fas fa-coin-vertical',
					],
					defaultOption: 'far fa-coin-vertical',
					keywords: 'coin dime gold metal money nickel penny quarter silver super mario treasure coin vertical',
				},
				{
					className: 'far fa-coins',
					options: [
						'fat fa-coins', 'fal fa-coins', 'far fa-coins', 'fas fa-coins',
					],
					defaultOption: 'far fa-coins',
					keywords: 'currency dime financial gold money penny coins',
				},
				{
					className: 'far fa-colon-sign',
					options: [
						'fat fa-colon-sign', 'fal fa-colon-sign', 'far fa-colon-sign', 'fas fa-colon-sign',
					],
					defaultOption: 'far fa-colon-sign',
					keywords: 'colon sign currency colon sign',
				},
				{
					className: 'far fa-comment-dollar',
					options: [
						'fat fa-comment-dollar', 'fal fa-comment-dollar', 'far fa-comment-dollar', 'fas fa-comment-dollar',
					],
					defaultOption: 'far fa-comment-dollar',
					keywords: 'bubble chat commenting conversation feedback message money note notification pay sms speech spend texting transfer comment dollar',
				},
				{
					className: 'far fa-comments-dollar',
					options: [
						'fat fa-comments-dollar', 'fal fa-comments-dollar', 'far fa-comments-dollar', 'fas fa-comments-dollar',
					],
					defaultOption: 'far fa-comments-dollar',
					keywords: 'bubble chat commenting conversation feedback message money note notification pay sms speech spend texting transfer comments dollar',
				},
				{
					className: 'far fa-credit-card',
					options: [
						'fat fa-credit-card', 'fal fa-credit-card', 'far fa-credit-card', 'fas fa-credit-card',
					],
					defaultOption: 'far fa-credit-card',
					keywords: 'buy card checkout credit credit card credit card-alt debit money payment purchase credit-card',
				},
				{
					className: 'far fa-credit-card-blank',
					options: [
						'fat fa-credit-card-blank', 'fal fa-credit-card-blank', 'far fa-credit-card-blank', 'fas fa-credit-card-blank',
					],
					defaultOption: 'far fa-credit-card-blank',
					keywords: 'buy checkout debit money payment purchase credit card-blank',
				},
				{
					className: 'far fa-credit-card-front',
					options: [
						'fat fa-credit-card-front', 'fal fa-credit-card-front', 'far fa-credit-card-front', 'fas fa-credit-card-front',
					],
					defaultOption: 'far fa-credit-card-front',
					keywords: 'buy checkout chip debit money payment purchase credit card-front',
				},
				{
					className: 'far fa-cruzeiro-sign',
					options: [
						'fat fa-cruzeiro-sign', 'fal fa-cruzeiro-sign', 'far fa-cruzeiro-sign', 'fas fa-cruzeiro-sign',
					],
					defaultOption: 'far fa-cruzeiro-sign',
					keywords: 'cruzeiro sign currency cruzeiro sign',
				},
				{
					className: 'far fa-dollar-sign',
					options: [
						'fat fa-dollar-sign', 'fal fa-dollar-sign', 'far fa-dollar-sign', 'fas fa-dollar-sign',
					],
					defaultOption: 'far fa-dollar-sign',
					keywords: 'dollar sign currency dollar heavy dollar sign money dollar sign',
				},
				{
					className: 'far fa-dong-sign',
					options: [
						'fat fa-dong-sign', 'fal fa-dong-sign', 'far fa-dong-sign', 'fas fa-dong-sign',
					],
					defaultOption: 'far fa-dong-sign',
					keywords: 'dong sign currency dong sign',
				},
				{
					className: 'far fa-euro-sign',
					options: [
						'fat fa-euro-sign', 'fal fa-euro-sign', 'far fa-euro-sign', 'fas fa-euro-sign',
					],
					defaultOption: 'far fa-euro-sign',
					keywords: 'euro sign currency euro sign',
				},
				{
					className: 'far fa-file-chart-column',
					options: [
						'fat fa-file-chart-column', 'fal fa-file-chart-column', 'far fa-file-chart-column', 'fas fa-file-chart-column',
					],
					defaultOption: 'far fa-file-chart-column',
					keywords: 'analytics data document projection report file chart-column',
				},
				{
					className: 'far fa-file-chart-pie',
					options: [
						'fat fa-file-chart-pie', 'fal fa-file-chart-pie', 'far fa-file-chart-pie', 'fas fa-file-chart-pie',
					],
					defaultOption: 'far fa-file-chart-pie',
					keywords: 'analytics data document projection report file chart-pie',
				},
				{
					className: 'far fa-file-invoice',
					options: [
						'fat fa-file-invoice', 'fal fa-file-invoice', 'far fa-file-invoice', 'fas fa-file-invoice',
					],
					defaultOption: 'far fa-file-invoice',
					keywords: 'account bill charge document payment receipt file invoice',
				},
				{
					className: 'far fa-file-invoice-dollar',
					options: [
						'fat fa-file-invoice-dollar', 'fal fa-file-invoice-dollar', 'far fa-file-invoice-dollar', 'fas fa-file-invoice-dollar',
					],
					defaultOption: 'far fa-file-invoice-dollar',
					keywords: '$ account bill charge document dollar sign money payment receipt usd file-invoice-dollar',
				},
				{
					className: 'far fa-florin-sign',
					options: [
						'fat fa-florin-sign', 'fal fa-florin-sign', 'far fa-florin-sign', 'fas fa-florin-sign',
					],
					defaultOption: 'far fa-florin-sign',
					keywords: 'currency florin sign',
				},
				{
					className: 'far fa-franc-sign',
					options: [
						'fat fa-franc-sign', 'fal fa-franc-sign', 'far fa-franc-sign', 'fas fa-franc-sign',
					],
					defaultOption: 'far fa-franc-sign',
					keywords: 'french franc sign currency franc sign',
				},
				{
					className: 'far fa-guarani-sign',
					options: [
						'fat fa-guarani-sign', 'fal fa-guarani-sign', 'far fa-guarani-sign', 'fas fa-guarani-sign',
					],
					defaultOption: 'far fa-guarani-sign',
					keywords: 'guarani sign currency guarani sign',
				},
				{
					className: 'far fa-hand-holding-dollar',
					options: [
						'fat fa-hand-holding-dollar', 'fal fa-hand-holding-dollar', 'far fa-hand-holding-dollar', 'fas fa-hand-holding-dollar',
					],
					defaultOption: 'far fa-hand-holding-dollar',
					keywords: '$ carry dollar sign donation giving lift money price hand holding-dollar',
				},
				{
					className: 'far fa-hands-holding-dollar',
					options: [
						'fat fa-hands-holding-dollar', 'fal fa-hands-holding-dollar', 'far fa-hands-holding-dollar', 'fas fa-hands-holding-dollar',
					],
					defaultOption: 'far fa-hands-holding-dollar',
					keywords: '$ carry dollar sign donation giving hold money price usd hands holding-dollar',
				},
				{
					className: 'far fa-hryvnia-sign',
					options: [
						'fat fa-hryvnia-sign', 'fal fa-hryvnia-sign', 'far fa-hryvnia-sign', 'fas fa-hryvnia-sign',
					],
					defaultOption: 'far fa-hryvnia-sign',
					keywords: 'hryvnia sign currency hryvnia sign',
				},
				{
					className: 'far fa-indian-rupee-sign',
					options: [
						'fat fa-indian-rupee-sign', 'fal fa-indian-rupee-sign', 'far fa-indian-rupee-sign', 'fas fa-indian-rupee-sign',
					],
					defaultOption: 'far fa-indian-rupee-sign',
					keywords: 'indian rupee sign currency indian rupee-sign',
				},
				{
					className: 'far fa-kip-sign',
					options: [
						'fat fa-kip-sign', 'fal fa-kip-sign', 'far fa-kip-sign', 'fas fa-kip-sign',
					],
					defaultOption: 'far fa-kip-sign',
					keywords: 'kip sign currency kip sign',
				},
				{
					className: 'far fa-landmark',
					options: [
						'fat fa-landmark', 'fal fa-landmark', 'far fa-landmark', 'fas fa-landmark',
					],
					defaultOption: 'far fa-landmark',
					keywords: 'building classical classical building historic memorable monument politics landmark',
				},
				{
					className: 'far fa-lari-sign',
					options: [
						'fat fa-lari-sign', 'fal fa-lari-sign', 'far fa-lari-sign', 'fas fa-lari-sign',
					],
					defaultOption: 'far fa-lari-sign',
					keywords: 'lari sign currency lari sign',
				},
				{
					className: 'far fa-lira-sign',
					options: [
						'fat fa-lira-sign', 'fal fa-lira-sign', 'far fa-lira-sign', 'fas fa-lira-sign',
					],
					defaultOption: 'far fa-lira-sign',
					keywords: 'lira sign currency lira sign',
				},
				{
					className: 'far fa-litecoin-sign',
					options: [
						'fat fa-litecoin-sign', 'fal fa-litecoin-sign', 'far fa-litecoin-sign', 'fas fa-litecoin-sign',
					],
					defaultOption: 'far fa-litecoin-sign',
					keywords: 'currency litecoin sign',
				},
				{
					className: 'far fa-manat-sign',
					options: [
						'fat fa-manat-sign', 'fal fa-manat-sign', 'far fa-manat-sign', 'fas fa-manat-sign',
					],
					defaultOption: 'far fa-manat-sign',
					keywords: 'manat sign currency manat sign',
				},
				{
					className: 'far fa-message-dollar',
					options: [
						'fat fa-message-dollar', 'fal fa-message-dollar', 'far fa-message-dollar', 'fas fa-message-dollar',
					],
					defaultOption: 'far fa-message-dollar',
					keywords: 'bubble chat commenting conversation feedback message money note notification pay sms speech spend texting transfer message dollar',
				},
				{
					className: 'far fa-messages-dollar',
					options: [
						'fat fa-messages-dollar', 'fal fa-messages-dollar', 'far fa-messages-dollar', 'fas fa-messages-dollar',
					],
					defaultOption: 'far fa-messages-dollar',
					keywords: 'bubble chat commenting conversation feedback message money note notification pay sms speech spend texting transfer messages dollar',
				},
				{
					className: 'far fa-mill-sign',
					options: [
						'fat fa-mill-sign', 'fal fa-mill-sign', 'far fa-mill-sign', 'fas fa-mill-sign',
					],
					defaultOption: 'far fa-mill-sign',
					keywords: 'mill sign currency mill sign',
				},
				{
					className: 'far fa-money-bill',
					options: [
						'fat fa-money-bill', 'fal fa-money-bill', 'far fa-money-bill', 'fas fa-money-bill',
					],
					defaultOption: 'far fa-money-bill',
					keywords: 'buy cash checkout money payment price purchase money bill',
				},
				{
					className: 'far fa-money-bill-1',
					options: [
						'fat fa-money-bill-1', 'fal fa-money-bill-1', 'far fa-money-bill-1', 'fas fa-money-bill-1',
					],
					defaultOption: 'far fa-money-bill-1',
					keywords: 'buy cash checkout money payment price purchase money bill-1',
				},
				{
					className: 'far fa-money-bill-1-wave',
					options: [
						'fat fa-money-bill-1-wave', 'fal fa-money-bill-1-wave', 'far fa-money-bill-1-wave', 'fas fa-money-bill-1-wave',
					],
					defaultOption: 'far fa-money-bill-1-wave',
					keywords: 'buy cash checkout money payment price purchase money bill-1-wave',
				},
				{
					className: 'far fa-money-bill-simple',
					options: [
						'fat fa-money-bill-simple', 'fal fa-money-bill-simple', 'far fa-money-bill-simple', 'fas fa-money-bill-simple',
					],
					defaultOption: 'far fa-money-bill-simple',
					keywords: 'atm cash money moolah money bill-simple',
				},
				{
					className: 'far fa-money-bill-simple-wave',
					options: [
						'fat fa-money-bill-simple-wave', 'fal fa-money-bill-simple-wave', 'far fa-money-bill-simple-wave', 'fas fa-money-bill-simple-wave',
					],
					defaultOption: 'far fa-money-bill-simple-wave',
					keywords: 'atm cash money moolah money bill-simple-wave',
				},
				{
					className: 'far fa-money-bill-wave',
					options: [
						'fat fa-money-bill-wave', 'fal fa-money-bill-wave', 'far fa-money-bill-wave', 'fas fa-money-bill-wave',
					],
					defaultOption: 'far fa-money-bill-wave',
					keywords: 'buy cash checkout money payment price purchase money bill-wave',
				},
				{
					className: 'far fa-money-bills',
					options: [
						'fat fa-money-bills', 'fal fa-money-bills', 'far fa-money-bills', 'fas fa-money-bills',
					],
					defaultOption: 'far fa-money-bills',
					keywords: 'atm cash money moolah money bills',
				},
				{
					className: 'far fa-money-bills-simple',
					options: [
						'fat fa-money-bills-simple', 'fal fa-money-bills-simple', 'far fa-money-bills-simple', 'fas fa-money-bills-simple',
					],
					defaultOption: 'far fa-money-bills-simple',
					keywords: 'atm cash money moolah money bills-simple',
				},
				{
					className: 'far fa-money-check',
					options: [
						'fat fa-money-check', 'fal fa-money-check', 'far fa-money-check', 'fas fa-money-check',
					],
					defaultOption: 'far fa-money-check',
					keywords: 'bank check buy checkout cheque money payment price purchase money check',
				},
				{
					className: 'far fa-money-check-dollar',
					options: [
						'fat fa-money-check-dollar', 'fal fa-money-check-dollar', 'far fa-money-check-dollar', 'fas fa-money-check-dollar',
					],
					defaultOption: 'far fa-money-check-dollar',
					keywords: 'bank check buy checkout cheque money payment price purchase money check-dollar',
				},
				{
					className: 'far fa-money-from-bracket',
					options: [
						'fat fa-money-from-bracket', 'fal fa-money-from-bracket', 'far fa-money-from-bracket', 'fas fa-money-from-bracket',
					],
					defaultOption: 'far fa-money-from-bracket',
					keywords: 'atm automated cash deposit dispenser transaction withdrawl money from-bracket',
				},
				{
					className: 'far fa-money-simple-from-bracket',
					options: [
						'fat fa-money-simple-from-bracket', 'fal fa-money-simple-from-bracket', 'far fa-money-simple-from-bracket', 'fas fa-money-simple-from-bracket',
					],
					defaultOption: 'far fa-money-simple-from-bracket',
					keywords: 'atm automated cash deposit dispenser transaction withdrawl money simple-from-bracket',
				},
				{
					className: 'far fa-naira-sign',
					options: [
						'fat fa-naira-sign', 'fal fa-naira-sign', 'far fa-naira-sign', 'fas fa-naira-sign',
					],
					defaultOption: 'far fa-naira-sign',
					keywords: 'naira sign currency naira sign',
				},
				{
					className: 'far fa-percent',
					options: [
						'fat fa-percent', 'fal fa-percent', 'far fa-percent', 'fas fa-percent',
					],
					defaultOption: 'far fa-percent',
					keywords: 'percent sign discount fraction proportion rate ratio percent',
				},
				{
					className: 'far fa-peseta-sign',
					options: [
						'fat fa-peseta-sign', 'fal fa-peseta-sign', 'far fa-peseta-sign', 'fas fa-peseta-sign',
					],
					defaultOption: 'far fa-peseta-sign',
					keywords: 'peseta sign currency peseta sign',
				},
				{
					className: 'far fa-peso-sign',
					options: [
						'fat fa-peso-sign', 'fal fa-peso-sign', 'far fa-peso-sign', 'fas fa-peso-sign',
					],
					defaultOption: 'far fa-peso-sign',
					keywords: 'peso sign currency peso sign',
				},
				{
					className: 'far fa-piggy-bank',
					options: [
						'fat fa-piggy-bank', 'fal fa-piggy-bank', 'far fa-piggy-bank', 'fas fa-piggy-bank',
					],
					defaultOption: 'far fa-piggy-bank',
					keywords: 'bank save savings piggy bank',
				},
				{
					className: 'far fa-receipt',
					options: [
						'fat fa-receipt', 'fal fa-receipt', 'far fa-receipt', 'fas fa-receipt',
					],
					defaultOption: 'far fa-receipt',
					keywords: 'accounting bookkeeping check evidence invoice money pay proof receipt table receipt',
				},
				{
					className: 'far fa-ruble-sign',
					options: [
						'fat fa-ruble-sign', 'fal fa-ruble-sign', 'far fa-ruble-sign', 'fas fa-ruble-sign',
					],
					defaultOption: 'far fa-ruble-sign',
					keywords: 'ruble sign currency ruble sign',
				},
				{
					className: 'far fa-rupee-sign',
					options: [
						'fat fa-rupee-sign', 'fal fa-rupee-sign', 'far fa-rupee-sign', 'fas fa-rupee-sign',
					],
					defaultOption: 'far fa-rupee-sign',
					keywords: 'rupee sign currency rupee sign',
				},
				{
					className: 'far fa-rupiah-sign',
					options: [
						'fat fa-rupiah-sign', 'fal fa-rupiah-sign', 'far fa-rupiah-sign', 'fas fa-rupiah-sign',
					],
					defaultOption: 'far fa-rupiah-sign',
					keywords: 'currency rupiah sign',
				},
				{
					className: 'far fa-sack',
					options: [
						'fat fa-sack', 'fal fa-sack', 'far fa-sack', 'fas fa-sack',
					],
					defaultOption: 'far fa-sack',
					keywords: 'bag burlap money santa sack',
				},
				{
					className: 'far fa-sack-dollar',
					options: [
						'fat fa-sack-dollar', 'fal fa-sack-dollar', 'far fa-sack-dollar', 'fas fa-sack-dollar',
					],
					defaultOption: 'far fa-sack-dollar',
					keywords: 'bag burlap cash dollar money money bag moneybag robber santa usd sack dollar',
				},
				{
					className: 'far fa-scale-balanced',
					options: [
						'fat fa-scale-balanced', 'fal fa-scale-balanced', 'far fa-scale-balanced', 'fas fa-scale-balanced',
					],
					defaultOption: 'far fa-scale-balanced',
					keywords: 'libra balance balance scale balanced justice legal measure scale weight zodiac scale balanced',
				},
				{
					className: 'far fa-scale-unbalanced',
					options: [
						'fat fa-scale-unbalanced', 'fal fa-scale-unbalanced', 'far fa-scale-unbalanced', 'fas fa-scale-unbalanced',
					],
					defaultOption: 'far fa-scale-unbalanced',
					keywords: 'justice legal measure unbalanced weight scale unbalanced',
				},
				{
					className: 'far fa-scale-unbalanced-flip',
					options: [
						'fat fa-scale-unbalanced-flip', 'fal fa-scale-unbalanced-flip', 'far fa-scale-unbalanced-flip', 'fas fa-scale-unbalanced-flip',
					],
					defaultOption: 'far fa-scale-unbalanced-flip',
					keywords: 'justice legal measure unbalanced weight scale unbalanced-flip',
				},
				{
					className: 'far fa-shekel-sign',
					options: [
						'fat fa-shekel-sign', 'fal fa-shekel-sign', 'far fa-shekel-sign', 'fas fa-shekel-sign',
					],
					defaultOption: 'far fa-shekel-sign',
					keywords: 'new sheqel sign currency ils money shekel sign',
				},
				{
					className: 'far fa-square-dollar',
					options: [
						'fat fa-square-dollar', 'fal fa-square-dollar', 'far fa-square-dollar', 'fas fa-square-dollar',
					],
					defaultOption: 'far fa-square-dollar',
					keywords: '$ dollar sign money price usd square-dollar',
				},
				{
					className: 'far fa-stamp',
					options: [
						'fat fa-stamp', 'fal fa-stamp', 'far fa-stamp', 'fas fa-stamp',
					],
					defaultOption: 'far fa-stamp',
					keywords: 'art certificate imprint rubber seal stamp',
				},
				{
					className: 'far fa-sterling-sign',
					options: [
						'fat fa-sterling-sign', 'fal fa-sterling-sign', 'far fa-sterling-sign', 'fas fa-sterling-sign',
					],
					defaultOption: 'far fa-sterling-sign',
					keywords: 'pound sign currency sterling sign',
				},
				{
					className: 'far fa-tally',
					options: [
						'fat fa-tally', 'fal fa-tally', 'far fa-tally', 'fas fa-tally',
					],
					defaultOption: 'far fa-tally',
					keywords: 'count hash numbers tally',
				},
				{
					className: 'far fa-tenge-sign',
					options: [
						'fat fa-tenge-sign', 'fal fa-tenge-sign', 'far fa-tenge-sign', 'fas fa-tenge-sign',
					],
					defaultOption: 'far fa-tenge-sign',
					keywords: 'tenge sign currency tenge sign',
				},
				{
					className: 'far fa-treasure-chest',
					options: [
						'fat fa-treasure-chest', 'fal fa-treasure-chest', 'far fa-treasure-chest', 'fas fa-treasure-chest',
					],
					defaultOption: 'far fa-treasure-chest',
					keywords: 'dungeons & dragons booty d&d dnd fantasy gold hidden loot reward trap treasure chest',
				},
				{
					className: 'far fa-tugrik-sign',
					options: [
						'fat fa-tugrik-sign', 'fal fa-tugrik-sign', 'far fa-tugrik-sign', 'fas fa-tugrik-sign',
					],
					defaultOption: 'far fa-tugrik-sign',
					keywords: 'tugrik sign currency tugrik sign',
				},
				{
					className: 'far fa-turkish-lira-sign',
					options: [
						'fat fa-turkish-lira-sign', 'fal fa-turkish-lira-sign', 'far fa-turkish-lira-sign', 'fas fa-turkish-lira-sign',
					],
					defaultOption: 'far fa-turkish-lira-sign',
					keywords: 'turkish lira sign currency turkish lira-sign',
				},
				{
					className: 'far fa-vault',
					options: [
						'fat fa-vault', 'fal fa-vault', 'far fa-vault', 'fas fa-vault',
					],
					defaultOption: 'far fa-vault',
					keywords: 'bank important lock money safe vault',
				},
				{
					className: 'far fa-wallet',
					options: [
						'fat fa-wallet', 'fal fa-wallet', 'far fa-wallet', 'fas fa-wallet',
					],
					defaultOption: 'far fa-wallet',
					keywords: 'billfold cash currency money wallet',
				},
				{
					className: 'far fa-won-sign',
					options: [
						'fat fa-won-sign', 'fal fa-won-sign', 'far fa-won-sign', 'fas fa-won-sign',
					],
					defaultOption: 'far fa-won-sign',
					keywords: 'won sign currency won sign',
				},
				{
					className: 'far fa-yen-sign',
					options: [
						'fat fa-yen-sign', 'fal fa-yen-sign', 'far fa-yen-sign', 'fas fa-yen-sign',
					],
					defaultOption: 'far fa-yen-sign',
					keywords: 'yen sign currency yen sign',
				},
			],
		},
		{
			id: 'moving',
			name: Loc.getMessage('LANDING_ICONS_SECTION_MOVING'),
			items: [
				{
					className: 'far fa-blanket',
					options: [
						'fat fa-blanket', 'fal fa-blanket', 'far fa-blanket', 'fas fa-blanket',
					],
					defaultOption: 'far fa-blanket',
					keywords: 'bed cover cozy sleep warm blanket',
				},
				{
					className: 'far fa-box-archive',
					options: [
						'fat fa-box-archive', 'fal fa-box-archive', 'far fa-box-archive', 'fas fa-box-archive',
					],
					defaultOption: 'far fa-box-archive',
					keywords: 'box package save storage box archive',
				},
				{
					className: 'far fa-box-open',
					options: [
						'fat fa-box-open', 'fal fa-box-open', 'far fa-box-open', 'fas fa-box-open',
					],
					defaultOption: 'far fa-box-open',
					keywords: 'archive container package storage unpack box open',
				},
				{
					className: 'far fa-box-open-full',
					options: [
						'fat fa-box-open-full', 'fal fa-box-open-full', 'far fa-box-open-full', 'fas fa-box-open-full',
					],
					defaultOption: 'far fa-box-open-full',
					keywords: 'attic package packed storage box open-full',
				},
				{
					className: 'far fa-box-taped',
					options: [
						'fat fa-box-taped', 'fal fa-box-taped', 'far fa-box-taped', 'fas fa-box-taped',
					],
					defaultOption: 'far fa-box-taped',
					keywords: 'archive container package storage box taped',
				},
				{
					className: 'far fa-caravan',
					options: [
						'fat fa-caravan', 'fal fa-caravan', 'far fa-caravan', 'fas fa-caravan',
					],
					defaultOption: 'far fa-caravan',
					keywords: 'camper motor home rv trailer travel caravan',
				},
				{
					className: 'far fa-caravan-simple',
					options: [
						'fat fa-caravan-simple', 'fal fa-caravan-simple', 'far fa-caravan-simple', 'fas fa-caravan-simple',
					],
					defaultOption: 'far fa-caravan-simple',
					keywords: 'camper motor home rv trailer travel caravan simple',
				},
				{
					className: 'far fa-container-storage',
					options: [
						'fat fa-container-storage', 'fal fa-container-storage', 'far fa-container-storage', 'fas fa-container-storage',
					],
					defaultOption: 'far fa-container-storage',
					keywords: 'archive box inventory shipping warehouse container storage',
				},
				{
					className: 'far fa-couch',
					options: [
						'fat fa-couch', 'fal fa-couch', 'far fa-couch', 'fas fa-couch',
					],
					defaultOption: 'far fa-couch',
					keywords: 'chair cushion furniture relax sofa couch',
				},
				{
					className: 'far fa-dolly',
					options: [
						'fat fa-dolly', 'fal fa-dolly', 'far fa-dolly', 'fas fa-dolly',
					],
					defaultOption: 'far fa-dolly',
					keywords: 'carry shipping transport dolly',
				},
				{
					className: 'far fa-dolly-empty',
					options: [
						'fat fa-dolly-empty', 'fal fa-dolly-empty', 'far fa-dolly-empty', 'fas fa-dolly-empty',
					],
					defaultOption: 'far fa-dolly-empty',
					keywords: 'carry inventory shipping transport dolly empty',
				},
				{
					className: 'far fa-house-chimney',
					options: [
						'fat fa-house-chimney', 'fal fa-house-chimney', 'far fa-house-chimney', 'fas fa-house-chimney',
					],
					defaultOption: 'far fa-house-chimney',
					keywords: 'abode building chimney house main residence smokestack house chimney',
				},
				{
					className: 'far fa-house-person-leave',
					options: [
						'fat fa-house-person-leave', 'fal fa-house-person-leave', 'far fa-house-person-leave', 'fas fa-house-person-leave',
					],
					defaultOption: 'far fa-house-person-leave',
					keywords: 'away home house person-leave',
				},
				{
					className: 'far fa-house-person-return',
					options: [
						'fat fa-house-person-return', 'fal fa-house-person-return', 'far fa-house-person-return', 'fas fa-house-person-return',
					],
					defaultOption: 'far fa-house-person-return',
					keywords: 'home remote house person-return',
				},
				{
					className: 'far fa-lamp',
					options: [
						'fat fa-lamp', 'fal fa-lamp', 'far fa-lamp', 'fas fa-lamp',
					],
					defaultOption: 'far fa-lamp',
					keywords: 'bright furniture light lamp',
				},
				{
					className: 'far fa-loveseat',
					options: [
						'fat fa-loveseat', 'fal fa-loveseat', 'far fa-loveseat', 'fas fa-loveseat',
					],
					defaultOption: 'far fa-loveseat',
					keywords: 'chair couch cushion furniture relax sofa loveseat',
				},
				{
					className: 'far fa-people-carry-box',
					options: [
						'fat fa-people-carry-box', 'fal fa-people-carry-box', 'far fa-people-carry-box', 'fas fa-people-carry-box',
					],
					defaultOption: 'far fa-people-carry-box',
					keywords: 'users people people-carry-box',
				},
				{
					className: 'far fa-person-carry-box',
					options: [
						'fat fa-person-carry-box', 'fal fa-person-carry-box', 'far fa-person-carry-box', 'fas fa-person-carry-box',
					],
					defaultOption: 'far fa-person-carry-box',
					keywords: 'deliver lift person carry-box',
				},
				{
					className: 'far fa-person-dolly',
					options: [
						'fat fa-person-dolly', 'fal fa-person-dolly', 'far fa-person-dolly', 'fas fa-person-dolly',
					],
					defaultOption: 'far fa-person-dolly',
					keywords: 'carry deliver transport person dolly',
				},
				{
					className: 'far fa-person-dolly-empty',
					options: [
						'fat fa-person-dolly-empty', 'fal fa-person-dolly-empty', 'far fa-person-dolly-empty', 'fas fa-person-dolly-empty',
					],
					defaultOption: 'far fa-person-dolly-empty',
					keywords: 'carry deliver transport person dolly-empty',
				},
				{
					className: 'far fa-ramp-loading',
					options: [
						'fat fa-ramp-loading', 'fal fa-ramp-loading', 'far fa-ramp-loading', 'fas fa-ramp-loading',
					],
					defaultOption: 'far fa-ramp-loading',
					keywords: 'inventory moving shipping storage warehouse ramp loading',
				},
				{
					className: 'far fa-route',
					options: [
						'fat fa-route', 'fal fa-route', 'far fa-route', 'fas fa-route',
					],
					defaultOption: 'far fa-route',
					keywords: 'directions navigation travel route',
				},
				{
					className: 'far fa-sign-hanging',
					options: [
						'fat fa-sign-hanging', 'fal fa-sign-hanging', 'far fa-sign-hanging', 'fas fa-sign-hanging',
					],
					defaultOption: 'far fa-sign-hanging',
					keywords: 'directions real estate signage wayfinding sign hanging',
				},
				{
					className: 'far fa-square-fragile',
					options: [
						'fat fa-square-fragile', 'fal fa-square-fragile', 'far fa-square-fragile', 'fas fa-square-fragile',
					],
					defaultOption: 'far fa-square-fragile',
					keywords: 'broken careful glass package square fragile',
				},
				{
					className: 'far fa-square-this-way-up',
					options: [
						'fat fa-square-this-way-up', 'fal fa-square-this-way-up', 'far fa-square-this-way-up', 'fas fa-square-this-way-up',
					],
					defaultOption: 'far fa-square-this-way-up',
					keywords: 'archive container package shipping storage square this-way-up',
				},
				{
					className: 'far fa-suitcase',
					options: [
						'fat fa-suitcase', 'fal fa-suitcase', 'far fa-suitcase', 'fas fa-suitcase',
					],
					defaultOption: 'far fa-suitcase',
					keywords: 'baggage luggage move packing suitcase travel trip suitcase',
				},
				{
					className: 'far fa-tape',
					options: [
						'fat fa-tape', 'fal fa-tape', 'far fa-tape', 'fas fa-tape',
					],
					defaultOption: 'far fa-tape',
					keywords: 'design package sticky tape',
				},
				{
					className: 'far fa-trailer',
					options: [
						'fat fa-trailer', 'fal fa-trailer', 'far fa-trailer', 'fas fa-trailer',
					],
					defaultOption: 'far fa-trailer',
					keywords: 'carry haul moving travel trailer',
				},
				{
					className: 'far fa-truck-container',
					options: [
						'fat fa-truck-container', 'fal fa-truck-container', 'far fa-truck-container', 'fas fa-truck-container',
					],
					defaultOption: 'far fa-truck-container',
					keywords: 'cargo delivery shipping vehicle truck container',
				},
				{
					className: 'far fa-truck-moving',
					options: [
						'fat fa-truck-moving', 'fal fa-truck-moving', 'far fa-truck-moving', 'fas fa-truck-moving',
					],
					defaultOption: 'far fa-truck-moving',
					keywords: 'cargo inventory rental vehicle truck moving',
				},
				{
					className: 'far fa-truck-ramp',
					options: [
						'fat fa-truck-ramp', 'fal fa-truck-ramp', 'far fa-truck-ramp', 'fas fa-truck-ramp',
					],
					defaultOption: 'far fa-truck-ramp',
					keywords: 'box cargo delivery inventory moving rental vehicle truck ramp',
				},
				{
					className: 'far fa-truck-ramp-box',
					options: [
						'fat fa-truck-ramp-box', 'fal fa-truck-ramp-box', 'far fa-truck-ramp-box', 'fas fa-truck-ramp-box',
					],
					defaultOption: 'far fa-truck-ramp-box',
					keywords: 'box cargo delivery inventory moving rental vehicle truck ramp-box',
				},
				{
					className: 'far fa-truck-ramp-couch',
					options: [
						'fat fa-truck-ramp-couch', 'fal fa-truck-ramp-couch', 'far fa-truck-ramp-couch', 'fas fa-truck-ramp-couch',
					],
					defaultOption: 'far fa-truck-ramp-couch',
					keywords: 'cargo delivery moving rental shipping vehicle truck ramp-couch',
				},
				{
					className: 'far fa-vacuum',
					options: [
						'fat fa-vacuum', 'fal fa-vacuum', 'far fa-vacuum', 'fas fa-vacuum',
					],
					defaultOption: 'far fa-vacuum',
					keywords: 'cleaning dyson floor suck suction vacuum',
				},
				{
					className: 'far fa-wine-glass',
					options: [
						'fat fa-wine-glass', 'fal fa-wine-glass', 'far fa-wine-glass', 'fas fa-wine-glass',
					],
					defaultOption: 'far fa-wine-glass',
					keywords: 'alcohol bar beverage cabernet drink glass grapes merlot sauvignon wine wine glass wine glass',
				},
				{
					className: 'far fa-wine-glass-crack',
					options: [
						'fat fa-wine-glass-crack', 'fal fa-wine-glass-crack', 'far fa-wine-glass-crack', 'fas fa-wine-glass-crack',
					],
					defaultOption: 'far fa-wine-glass-crack',
					keywords: 'break broken delicate glass wine glass-crack',
				},
			],
		},
		{
			id: 'music-audio',
			name: Loc.getMessage('LANDING_ICONS_SECTION_MUSIC_AUDIO'),
			items: [
				{
					className: 'far fa-airplay',
					options: [
						'fat fa-airplay', 'fal fa-airplay', 'far fa-airplay', 'fas fa-airplay',
					],
					defaultOption: 'far fa-airplay',
					keywords: 'apple share stream airplay',
				},
				{
					className: 'far fa-album',
					options: [
						'fat fa-album', 'fal fa-album', 'far fa-album', 'fas fa-album',
					],
					defaultOption: 'far fa-album',
					keywords: 'computer computer disk disk library minidisk music optical record song vinyl album',
				},
				{
					className: 'far fa-album-collection',
					options: [
						'fat fa-album-collection', 'fal fa-album-collection', 'far fa-album-collection', 'fas fa-album-collection',
					],
					defaultOption: 'far fa-album-collection',
					keywords: 'catalog library music record song vinyl album collection',
				},
				{
					className: 'far fa-amp-guitar',
					options: [
						'fat fa-amp-guitar', 'fal fa-amp-guitar', 'far fa-amp-guitar', 'fas fa-amp-guitar',
					],
					defaultOption: 'far fa-amp-guitar',
					keywords: 'audio guitar loudspeaker music pa volume amp guitar',
				},
				{
					className: 'far fa-banjo',
					options: [
						'fat fa-banjo', 'fal fa-banjo', 'far fa-banjo', 'fas fa-banjo',
					],
					defaultOption: 'far fa-banjo',
					keywords: 'banjo bluegrass folk guitar instrument jazz music stringed banjo',
				},
				{
					className: 'far fa-bells',
					options: [
						'fat fa-bells', 'fal fa-bells', 'far fa-bells', 'fas fa-bells',
					],
					defaultOption: 'far fa-bells',
					keywords: 'alert christmas holiday notification reminder xmas bells',
				},
				{
					className: 'far fa-boombox',
					options: [
						'fat fa-boombox', 'fal fa-boombox', 'far fa-boombox', 'fas fa-boombox',
					],
					defaultOption: 'far fa-boombox',
					keywords: 'portable stereo cassette jambox john cusack music radio say anything boombox',
				},
				{
					className: 'far fa-cassette-tape',
					options: [
						'fat fa-cassette-tape', 'fal fa-cassette-tape', 'far fa-cassette-tape', 'fas fa-cassette-tape',
					],
					defaultOption: 'far fa-cassette-tape',
					keywords: 'tape cartridge mixtape music play recording walkman cassette tape',
				},
				{
					className: 'far fa-circle-microphone',
					options: [
						'fat fa-circle-microphone', 'fal fa-circle-microphone', 'far fa-circle-microphone', 'fas fa-circle-microphone',
					],
					defaultOption: 'far fa-circle-microphone',
					keywords: 'listen podcast record circle microphone',
				},
				{
					className: 'far fa-circle-microphone-lines',
					options: [
						'fat fa-circle-microphone-lines', 'fal fa-circle-microphone-lines', 'far fa-circle-microphone-lines', 'fas fa-circle-microphone-lines',
					],
					defaultOption: 'far fa-circle-microphone-lines',
					keywords: 'listen podcast record circle microphone-lines',
				},
				{
					className: 'far fa-clarinet',
					options: [
						'fat fa-clarinet', 'fal fa-clarinet', 'far fa-clarinet', 'fas fa-clarinet',
					],
					defaultOption: 'far fa-clarinet',
					keywords: 'instrument jazz music woodwind clarinet',
				},
				{
					className: 'far fa-cloud-music',
					options: [
						'fat fa-cloud-music', 'fal fa-cloud-music', 'far fa-cloud-music', 'fas fa-cloud-music',
					],
					defaultOption: 'far fa-cloud-music',
					keywords: 'download music spotify streaming cloud music',
				},
				{
					className: 'far fa-comment-music',
					options: [
						'fat fa-comment-music', 'fal fa-comment-music', 'far fa-comment-music', 'fas fa-comment-music',
					],
					defaultOption: 'far fa-comment-music',
					keywords: 'chat commenting conversation create message music note notification sing sms song texting comment music',
				},
				{
					className: 'far fa-compact-disc',
					options: [
						'fat fa-compact-disc', 'fal fa-compact-disc', 'far fa-compact-disc', 'fas fa-compact-disc',
					],
					defaultOption: 'far fa-compact-disc',
					keywords: 'optical disc icon album blu ray bluray cd computer disc disk dvd media movie music optical optical disk record video vinyl compact-disc',
				},
				{
					className: 'far fa-computer-speaker',
					options: [
						'fat fa-computer-speaker', 'fal fa-computer-speaker', 'far fa-computer-speaker', 'fas fa-computer-speaker',
					],
					defaultOption: 'far fa-computer-speaker',
					keywords: 'airplay bluetooth devices music output pair sound sync computer speaker',
				},
				{
					className: 'far fa-cowbell',
					options: [
						'fat fa-cowbell', 'fal fa-cowbell', 'far fa-cowbell', 'fas fa-cowbell',
					],
					defaultOption: 'far fa-cowbell',
					keywords: 'blue ?yster cult christopher walken snl the bruce dickinson will ferrell music cowbell',
				},
				{
					className: 'far fa-cowbell-circle-plus',
					options: [
						'fat fa-cowbell-circle-plus', 'fal fa-cowbell-circle-plus', 'far fa-cowbell-circle-plus', 'fas fa-cowbell-circle-plus',
					],
					defaultOption: 'far fa-cowbell-circle-plus',
					keywords: 'blue ?yster cult christopher walken snl the bruce dickinson will ferrell music cowbell circle-plus',
				},
				{
					className: 'far fa-dial',
					options: [
						'fat fa-dial', 'fal fa-dial', 'far fa-dial', 'fas fa-dial',
					],
					defaultOption: 'far fa-dial',
					keywords: 'dial level dial',
				},
				{
					className: 'far fa-dial-high',
					options: [
						'fat fa-dial-high', 'fal fa-dial-high', 'far fa-dial-high', 'fas fa-dial-high',
					],
					defaultOption: 'far fa-dial-high',
					keywords: 'dial level dial high',
				},
				{
					className: 'far fa-dial-low',
					options: [
						'fat fa-dial-low', 'fal fa-dial-low', 'far fa-dial-low', 'fas fa-dial-low',
					],
					defaultOption: 'far fa-dial-low',
					keywords: 'dial level dial low',
				},
				{
					className: 'far fa-dial-max',
					options: [
						'fat fa-dial-max', 'fal fa-dial-max', 'far fa-dial-max', 'fas fa-dial-max',
					],
					defaultOption: 'far fa-dial-max',
					keywords: 'dial level dial max',
				},
				{
					className: 'far fa-dial-med',
					options: [
						'fat fa-dial-med', 'fal fa-dial-med', 'far fa-dial-med', 'fas fa-dial-med',
					],
					defaultOption: 'far fa-dial-med',
					keywords: 'dial level dial med',
				},
				{
					className: 'far fa-dial-med-low',
					options: [
						'fat fa-dial-med-low', 'fal fa-dial-med-low', 'far fa-dial-med-low', 'fas fa-dial-med-low',
					],
					defaultOption: 'far fa-dial-med-low',
					keywords: 'dial level dial med-low',
				},
				{
					className: 'far fa-dial-min',
					options: [
						'fat fa-dial-min', 'fal fa-dial-min', 'far fa-dial-min', 'fas fa-dial-min',
					],
					defaultOption: 'far fa-dial-min',
					keywords: 'dial level dial min',
				},
				{
					className: 'far fa-dial-off',
					options: [
						'fat fa-dial-off', 'fal fa-dial-off', 'far fa-dial-off', 'fas fa-dial-off',
					],
					defaultOption: 'far fa-dial-off',
					keywords: 'dial level dial off',
				},
				{
					className: 'far fa-disc-drive',
					options: [
						'fat fa-disc-drive', 'fal fa-disc-drive', 'far fa-disc-drive', 'fas fa-disc-drive',
					],
					defaultOption: 'far fa-disc-drive',
					keywords: 'blu ray cd cd-rom computer dvd load music optical drive peripheral tray video disc-drive',
				},
				{
					className: 'far fa-drum',
					options: [
						'fat fa-drum', 'fal fa-drum', 'far fa-drum', 'fas fa-drum',
					],
					defaultOption: 'far fa-drum',
					keywords: 'drum drumsticks instrument music percussion snare sound drum',
				},
				{
					className: 'far fa-drum-steelpan',
					options: [
						'fat fa-drum-steelpan', 'fal fa-drum-steelpan', 'far fa-drum-steelpan', 'fas fa-drum-steelpan',
					],
					defaultOption: 'far fa-drum-steelpan',
					keywords: 'calypso instrument music percussion reggae snare sound steel tropical drum steelpan',
				},
				{
					className: 'far fa-ear',
					options: [
						'fat fa-ear', 'fal fa-ear', 'far fa-ear', 'fas fa-ear',
					],
					defaultOption: 'far fa-ear',
					keywords: 'body ear head hearing listen lobe ear',
				},
				{
					className: 'far fa-file-audio',
					options: [
						'fat fa-file-audio', 'fal fa-file-audio', 'far fa-file-audio', 'fas fa-file-audio',
					],
					defaultOption: 'far fa-file-audio',
					keywords: 'document mp3 music page play sound file audio',
				},
				{
					className: 'far fa-file-music',
					options: [
						'fat fa-file-music', 'fal fa-file-music', 'far fa-file-music', 'fas fa-file-music',
					],
					defaultOption: 'far fa-file-music',
					keywords: 'aac aif audio midi mp3 ogg sheet music wav wma file music',
				},
				{
					className: 'far fa-flute',
					options: [
						'fat fa-flute', 'fal fa-flute', 'far fa-flute', 'fas fa-flute',
					],
					defaultOption: 'far fa-flute',
					keywords: 'aerophone instrument music pied piper woodwind flute',
				},
				{
					className: 'far fa-folder-music',
					options: [
						'fat fa-folder-music', 'fal fa-folder-music', 'far fa-folder-music', 'fas fa-folder-music',
					],
					defaultOption: 'far fa-folder-music',
					keywords: 'audio mp3 folder music',
				},
				{
					className: 'far fa-gramophone',
					options: [
						'fat fa-gramophone', 'fal fa-gramophone', 'far fa-gramophone', 'fas fa-gramophone',
					],
					defaultOption: 'far fa-gramophone',
					keywords: 'award grammy music phonograph record turntable victrola gramophone',
				},
				{
					className: 'far fa-guitar',
					options: [
						'fat fa-guitar', 'fal fa-guitar', 'far fa-guitar', 'fas fa-guitar',
					],
					defaultOption: 'far fa-guitar',
					keywords: 'acoustic instrument music rock rock and roll song strings guitar',
				},
				{
					className: 'far fa-guitar-electric',
					options: [
						'fat fa-guitar-electric', 'fal fa-guitar-electric', 'far fa-guitar-electric', 'fas fa-guitar-electric',
					],
					defaultOption: 'far fa-guitar-electric',
					keywords: 'axe guitar instrument music rock rock and roll song strings guitar electric',
				},
				{
					className: 'far fa-guitars',
					options: [
						'fat fa-guitars', 'fal fa-guitars', 'far fa-guitars', 'fas fa-guitars',
					],
					defaultOption: 'far fa-guitars',
					keywords: 'acoustic axes electric instrument music rock rock and roll song strings guitars',
				},
				{
					className: 'far fa-head-side-headphones',
					options: [
						'fat fa-head-side-headphones', 'fal fa-head-side-headphones', 'far fa-head-side-headphones', 'fas fa-head-side-headphones',
					],
					defaultOption: 'far fa-head-side-headphones',
					keywords: 'amplifier bluetooth earphone headset listen microphone music head side-headphones',
				},
				{
					className: 'far fa-headphones',
					options: [
						'fat fa-headphones', 'fal fa-headphones', 'far fa-headphones', 'fas fa-headphones',
					],
					defaultOption: 'far fa-headphones',
					keywords: 'audio earbud headphone listen music sound speaker headphones',
				},
				{
					className: 'far fa-headphones-simple',
					options: [
						'fat fa-headphones-simple', 'fal fa-headphones-simple', 'far fa-headphones-simple', 'fas fa-headphones-simple',
					],
					defaultOption: 'far fa-headphones-simple',
					keywords: 'audio listen music sound speaker headphones simple',
				},
				{
					className: 'far fa-kazoo',
					options: [
						'fat fa-kazoo', 'fal fa-kazoo', 'far fa-kazoo', 'fas fa-kazoo',
					],
					defaultOption: 'far fa-kazoo',
					keywords: 'buzz instrument membranophone mirliton music kazoo',
				},
				{
					className: 'far fa-list-music',
					options: [
						'fat fa-list-music', 'fal fa-list-music', 'far fa-list-music', 'fas fa-list-music',
					],
					defaultOption: 'far fa-list-music',
					keywords: 'album itunes music playlist podcast soundtrack list music',
				},
				{
					className: 'far fa-mandolin',
					options: [
						'fat fa-mandolin', 'fal fa-mandolin', 'far fa-mandolin', 'fas fa-mandolin',
					],
					defaultOption: 'far fa-mandolin',
					keywords: 'dungeons & dragons bard d&d dnd fantasy guitar instrument lute music song strings mandolin',
				},
				{
					className: 'far fa-message-music',
					options: [
						'fat fa-message-music', 'fal fa-message-music', 'far fa-message-music', 'fas fa-message-music',
					],
					defaultOption: 'far fa-message-music',
					keywords: 'chat commenting conversation create message music note notification sing sms song texting message music',
				},
				{
					className: 'far fa-microphone',
					options: [
						'fat fa-microphone', 'fal fa-microphone', 'far fa-microphone', 'fas fa-microphone',
					],
					defaultOption: 'far fa-microphone',
					keywords: 'audio podcast record sing sound voice microphone',
				},
				{
					className: 'far fa-microphone-lines',
					options: [
						'fat fa-microphone-lines', 'fal fa-microphone-lines', 'far fa-microphone-lines', 'fas fa-microphone-lines',
					],
					defaultOption: 'far fa-microphone-lines',
					keywords: 'audio mic microphone music podcast record sing sound studio studio microphone voice microphone lines',
				},
				{
					className: 'far fa-microphone-lines-slash',
					options: [
						'fat fa-microphone-lines-slash', 'fal fa-microphone-lines-slash', 'far fa-microphone-lines-slash', 'fas fa-microphone-lines-slash',
					],
					defaultOption: 'far fa-microphone-lines-slash',
					keywords: 'audio disable mute podcast record sing sound voice microphone lines-slash',
				},
				{
					className: 'far fa-microphone-slash',
					options: [
						'fat fa-microphone-slash', 'fal fa-microphone-slash', 'far fa-microphone-slash', 'fas fa-microphone-slash',
					],
					defaultOption: 'far fa-microphone-slash',
					keywords: 'audio disable mute podcast record sing sound voice microphone slash',
				},
				{
					className: 'far fa-microphone-stand',
					options: [
						'fat fa-microphone-stand', 'fal fa-microphone-stand', 'far fa-microphone-stand', 'fas fa-microphone-stand',
					],
					defaultOption: 'far fa-microphone-stand',
					keywords: 'audio karaoke mic microphone podcast record sing sound voice microphone stand',
				},
				{
					className: 'far fa-mp3-player',
					options: [
						'fat fa-mp3-player', 'fal fa-mp3-player', 'far fa-mp3-player', 'fas fa-mp3-player',
					],
					defaultOption: 'far fa-mp3-player',
					keywords: 'audio handheld ipod itunes music zune mp3 player',
				},
				{
					className: 'far fa-music',
					options: [
						'fat fa-music', 'fal fa-music', 'far fa-music', 'fas fa-music',
					],
					defaultOption: 'far fa-music',
					keywords: 'lyrics melody music musical note note sing sound music',
				},
				{
					className: 'far fa-music-note',
					options: [
						'fat fa-music-note', 'fal fa-music-note', 'far fa-music-note', 'fas fa-music-note',
					],
					defaultOption: 'far fa-music-note',
					keywords: 'lyrics melody note sing sound music note',
				},
				{
					className: 'far fa-music-note-slash',
					options: [
						'fat fa-music-note-slash', 'fal fa-music-note-slash', 'far fa-music-note-slash', 'fas fa-music-note-slash',
					],
					defaultOption: 'far fa-music-note-slash',
					keywords: 'cancel disabled lyrics melody mute note off sing sound music note-slash',
				},
				{
					className: 'far fa-music-slash',
					options: [
						'fat fa-music-slash', 'fal fa-music-slash', 'far fa-music-slash', 'fas fa-music-slash',
					],
					defaultOption: 'far fa-music-slash',
					keywords: 'cancel disabled lyrics melody mute note off sing sound music slash',
				},
				{
					className: 'far fa-photo-film-music',
					options: [
						'fat fa-photo-film-music', 'fal fa-photo-film-music', 'far fa-photo-film-music', 'fas fa-photo-film-music',
					],
					defaultOption: 'far fa-photo-film-music',
					keywords: 'media photo film-music',
				},
				{
					className: 'far fa-piano',
					options: [
						'fat fa-piano', 'fal fa-piano', 'far fa-piano', 'fas fa-piano',
					],
					defaultOption: 'far fa-piano',
					keywords: 'grand piano instrument keyboard keys midi music piano',
				},
				{
					className: 'far fa-piano-keyboard',
					options: [
						'fat fa-piano-keyboard', 'fal fa-piano-keyboard', 'far fa-piano-keyboard', 'fas fa-piano-keyboard',
					],
					defaultOption: 'far fa-piano-keyboard',
					keywords: 'instrument keyboard keys midi music musical keyboard piano piano keyboard',
				},
				{
					className: 'far fa-radio',
					options: [
						'fat fa-radio', 'fal fa-radio', 'far fa-radio', 'fas fa-radio',
					],
					defaultOption: 'far fa-radio',
					keywords: 'am broadcast fm frequency music news radio receiver transmitter tuner video radio',
				},
				{
					className: 'far fa-radio-tuner',
					options: [
						'fat fa-radio-tuner', 'fal fa-radio-tuner', 'far fa-radio-tuner', 'fas fa-radio-tuner',
					],
					defaultOption: 'far fa-radio-tuner',
					keywords: 'am broadcast fm frequency music news receiver transmitter tuner radio tuner',
				},
				{
					className: 'far fa-record-vinyl',
					options: [
						'fat fa-record-vinyl', 'fal fa-record-vinyl', 'far fa-record-vinyl', 'fas fa-record-vinyl',
					],
					defaultOption: 'far fa-record-vinyl',
					keywords: 'lp album analog music phonograph sound record vinyl',
				},
				{
					className: 'far fa-saxophone',
					options: [
						'fat fa-saxophone', 'fal fa-saxophone', 'far fa-saxophone', 'fas fa-saxophone',
					],
					defaultOption: 'far fa-saxophone',
					keywords: 'brass instrument jazz music sax saxophone woodwind saxophone',
				},
				{
					className: 'far fa-saxophone-fire',
					options: [
						'fat fa-saxophone-fire', 'fal fa-saxophone-fire', 'far fa-saxophone-fire', 'fas fa-saxophone-fire',
					],
					defaultOption: 'far fa-saxophone-fire',
					keywords: 'brass fire flame instrument jazz music saxophone woodwind saxophone fire',
				},
				{
					className: 'far fa-screencast',
					options: [
						'fat fa-screencast', 'fal fa-screencast', 'far fa-screencast', 'fas fa-screencast',
					],
					defaultOption: 'far fa-screencast',
					keywords: 'airplay share stream screencast',
				},
				{
					className: 'far fa-sliders',
					options: [
						'fat fa-sliders', 'fal fa-sliders', 'far fa-sliders', 'fas fa-sliders',
					],
					defaultOption: 'far fa-sliders',
					keywords: 'adjust settings sliders toggle sliders',
				},
				{
					className: 'far fa-sliders-up',
					options: [
						'fat fa-sliders-up', 'fal fa-sliders-up', 'far fa-sliders-up', 'fas fa-sliders-up',
					],
					defaultOption: 'far fa-sliders-up',
					keywords: 'adjust settings sliders toggle sliders up',
				},
				{
					className: 'far fa-speaker',
					options: [
						'fat fa-speaker', 'fal fa-speaker', 'far fa-speaker', 'fas fa-speaker',
					],
					defaultOption: 'far fa-speaker',
					keywords: 'audio device music sound subwoofer transducer tweeter speaker',
				},
				{
					className: 'far fa-speakers',
					options: [
						'fat fa-speakers', 'fal fa-speakers', 'far fa-speakers', 'fas fa-speakers',
					],
					defaultOption: 'far fa-speakers',
					keywords: 'audio device group music sound subwoofer transducer tweeter speakers',
				},
				{
					className: 'far fa-square-sliders',
					options: [
						'fat fa-square-sliders', 'fal fa-square-sliders', 'far fa-square-sliders', 'fas fa-square-sliders',
					],
					defaultOption: 'far fa-square-sliders',
					keywords: 'adjust settings sliders toggle square sliders',
				},
				{
					className: 'far fa-square-sliders-vertical',
					options: [
						'fat fa-square-sliders-vertical', 'fal fa-square-sliders-vertical', 'far fa-square-sliders-vertical', 'fas fa-square-sliders-vertical',
					],
					defaultOption: 'far fa-square-sliders-vertical',
					keywords: 'adjust settings sliders toggle square sliders-vertical',
				},
				{
					className: 'far fa-triangle-instrument',
					options: [
						'fat fa-triangle-instrument', 'fal fa-triangle-instrument', 'far fa-triangle-instrument', 'fas fa-triangle-instrument',
					],
					defaultOption: 'far fa-triangle-instrument',
					keywords: 'ding idiophone instrument music percussion triangle instrument',
				},
				{
					className: 'far fa-trumpet',
					options: [
						'fat fa-trumpet', 'fal fa-trumpet', 'far fa-trumpet', 'fas fa-trumpet',
					],
					defaultOption: 'far fa-trumpet',
					keywords: 'brass bugle classical cornet instrument jazz music orchestra trumpet trumpet',
				},
				{
					className: 'far fa-turntable',
					options: [
						'fat fa-turntable', 'fal fa-turntable', 'far fa-turntable', 'fas fa-turntable',
					],
					defaultOption: 'far fa-turntable',
					keywords: 'album music phonograph record record player vinyl turntable',
				},
				{
					className: 'far fa-tv-music',
					options: [
						'fat fa-tv-music', 'fal fa-tv-music', 'far fa-tv-music', 'fas fa-tv-music',
					],
					defaultOption: 'far fa-tv-music',
					keywords: 'audio mtv music music video sound television vh1 tv music',
				},
				{
					className: 'far fa-user-music',
					options: [
						'fat fa-user-music', 'fal fa-user-music', 'far fa-user-music', 'fas fa-user-music',
					],
					defaultOption: 'far fa-user-music',
					keywords: 'artist music musician singer user music',
				},
				{
					className: 'far fa-violin',
					options: [
						'fat fa-violin', 'fal fa-violin', 'far fa-violin', 'fas fa-violin',
					],
					defaultOption: 'far fa-violin',
					keywords: 'bow cello fiddle instrument music orchestra string violin violin',
				},
				{
					className: 'far fa-volume',
					options: [
						'fat fa-volume', 'fal fa-volume', 'far fa-volume', 'fas fa-volume',
					],
					defaultOption: 'far fa-volume',
					keywords: 'audio control medium music sound speaker speaker medium volume volume',
				},
				{
					className: 'far fa-volume-high',
					options: [
						'fat fa-volume-high', 'fal fa-volume-high', 'far fa-volume-high', 'fas fa-volume-high',
					],
					defaultOption: 'far fa-volume-high',
					keywords: 'audio higher loud louder music sound speaker speaker high volume volume high',
				},
				{
					className: 'far fa-volume-low',
					options: [
						'fat fa-volume-low', 'fal fa-volume-low', 'far fa-volume-low', 'fas fa-volume-low',
					],
					defaultOption: 'far fa-volume-low',
					keywords: 'audio lower music quieter soft sound speaker speaker low volume volume low',
				},
				{
					className: 'far fa-volume-off',
					options: [
						'fat fa-volume-off', 'fal fa-volume-off', 'far fa-volume-off', 'fas fa-volume-off',
					],
					defaultOption: 'far fa-volume-off',
					keywords: 'audio ban music mute quiet silent sound volume off',
				},
				{
					className: 'far fa-volume-slash',
					options: [
						'fat fa-volume-slash', 'fal fa-volume-slash', 'far fa-volume-slash', 'fas fa-volume-slash',
					],
					defaultOption: 'far fa-volume-slash',
					keywords: 'audio ban music mute muted speaker quiet silent sound speaker volume slash',
				},
				{
					className: 'far fa-volume-xmark',
					options: [
						'fat fa-volume-xmark', 'fal fa-volume-xmark', 'far fa-volume-xmark', 'fas fa-volume-xmark',
					],
					defaultOption: 'far fa-volume-xmark',
					keywords: 'audio music quiet sound speaker volume xmark',
				},
				{
					className: 'far fa-waveform',
					options: [
						'fat fa-waveform', 'fal fa-waveform', 'far fa-waveform', 'fas fa-waveform',
					],
					defaultOption: 'far fa-waveform',
					keywords: 'amplitude sound soundwave waveform',
				},
				{
					className: 'far fa-waveform-lines',
					options: [
						'fat fa-waveform-lines', 'fal fa-waveform-lines', 'far fa-waveform-lines', 'fas fa-waveform-lines',
					],
					defaultOption: 'far fa-waveform-lines',
					keywords: 'amplitude sound soundwave waveform lines',
				},
				{
					className: 'far fa-whistle',
					options: [
						'fat fa-whistle', 'fal fa-whistle', 'far fa-whistle', 'fas fa-whistle',
					],
					defaultOption: 'far fa-whistle',
					keywords: 'alert single sound toot whistle',
				},
			],
		},
		{
			id: 'nature',
			name: Loc.getMessage('LANDING_ICONS_SECTION_NATURE'),
			items: [
				{
					className: 'far fa-acorn',
					options: [
						'fat fa-acorn', 'fal fa-acorn', 'far fa-acorn', 'fas fa-acorn',
					],
					defaultOption: 'far fa-acorn',
					keywords: 'fall nature nut oak seasonal seed squirrel tree acorn',
				},
				{
					className: 'far fa-bench-tree',
					options: [
						'fat fa-bench-tree', 'fal fa-bench-tree', 'far fa-bench-tree', 'fas fa-bench-tree',
					],
					defaultOption: 'far fa-bench-tree',
					keywords: 'bench outside park picnic tree bench tree',
				},
				{
					className: 'far fa-binoculars',
					options: [
						'fat fa-binoculars', 'fal fa-binoculars', 'far fa-binoculars', 'fas fa-binoculars',
					],
					defaultOption: 'far fa-binoculars',
					keywords: 'glasses magnify scenic spyglass view binoculars',
				},
				{
					className: 'far fa-bug',
					options: [
						'fat fa-bug', 'fal fa-bug', 'far fa-bug', 'fas fa-bug',
					],
					defaultOption: 'far fa-bug',
					keywords: 'beetle error insect report bug',
				},
				{
					className: 'far fa-cannabis',
					options: [
						'fat fa-cannabis', 'fal fa-cannabis', 'far fa-cannabis', 'fas fa-cannabis',
					],
					defaultOption: 'far fa-cannabis',
					keywords: 'bud chronic drugs endica endo ganja marijuana mary jane pot reefer sativa spliff weed whacky tabacky cannabis',
				},
				{
					className: 'far fa-chestnut',
					options: [
						'fat fa-chestnut', 'fal fa-chestnut', 'far fa-chestnut', 'fas fa-chestnut',
					],
					defaultOption: 'far fa-chestnut',
					keywords: 'nut plant chestnut',
				},
				{
					className: 'far fa-cloud-sun',
					options: [
						'fat fa-cloud-sun', 'fal fa-cloud-sun', 'far fa-cloud-sun', 'fas fa-cloud-sun',
					],
					defaultOption: 'far fa-cloud-sun',
					keywords: 'clear cloud day daytime fall outdoors overcast partly cloudy sun sun behind cloud cloud sun',
				},
				{
					className: 'far fa-clover',
					options: [
						'fat fa-clover', 'fal fa-clover', 'far fa-clover', 'fas fa-clover',
					],
					defaultOption: 'far fa-clover',
					keywords: '4 charm clover four four leaf clover four leaf clover leaf leprechaun luck lucky clover',
				},
				{
					className: 'far fa-feather',
					options: [
						'fat fa-feather', 'fal fa-feather', 'far fa-feather', 'fas fa-feather',
					],
					defaultOption: 'far fa-feather',
					keywords: 'bird feather flight light plucked plumage quill write feather',
				},
				{
					className: 'far fa-feather-pointed',
					options: [
						'fat fa-feather-pointed', 'fal fa-feather-pointed', 'far fa-feather-pointed', 'fas fa-feather-pointed',
					],
					defaultOption: 'far fa-feather-pointed',
					keywords: 'bird light plucked quill write feather pointed',
				},
				{
					className: 'far fa-fire',
					options: [
						'fat fa-fire', 'fal fa-fire', 'far fa-fire', 'fas fa-fire',
					],
					defaultOption: 'far fa-fire',
					keywords: 'burn caliente fire flame heat hot popular tool fire',
				},
				{
					className: 'far fa-fire-smoke',
					options: [
						'fat fa-fire-smoke', 'fal fa-fire-smoke', 'far fa-fire-smoke', 'fas fa-fire-smoke',
					],
					defaultOption: 'far fa-fire-smoke',
					keywords: 'burn caliente flame fog heat hot fire smoke',
				},
				{
					className: 'far fa-flower',
					options: [
						'fat fa-flower', 'fal fa-flower', 'far fa-flower', 'fas fa-flower',
					],
					defaultOption: 'far fa-flower',
					keywords: 'black florette blossom daffodil flower nature spring summer flower',
				},
				{
					className: 'far fa-flower-daffodil',
					options: [
						'fat fa-flower-daffodil', 'fal fa-flower-daffodil', 'far fa-flower-daffodil', 'fas fa-flower-daffodil',
					],
					defaultOption: 'far fa-flower-daffodil',
					keywords: 'flower nature spring summer flower daffodil',
				},
				{
					className: 'far fa-flower-tulip',
					options: [
						'fat fa-flower-tulip', 'fal fa-flower-tulip', 'far fa-flower-tulip', 'fas fa-flower-tulip',
					],
					defaultOption: 'far fa-flower-tulip',
					keywords: 'flower nature spring summer tulip flower tulip',
				},
				{
					className: 'far fa-frog',
					options: [
						'fat fa-frog', 'fal fa-frog', 'far fa-frog', 'fas fa-frog',
					],
					defaultOption: 'far fa-frog',
					keywords: 'amphibian bullfrog fauna hop kermit kiss prince ribbit toad wart frog',
				},
				{
					className: 'far fa-house-tree',
					options: [
						'fat fa-house-tree', 'fal fa-house-tree', 'far fa-house-tree', 'fas fa-house-tree',
					],
					defaultOption: 'far fa-house-tree',
					keywords: 'abode city garden home house house with garden residence suburbs house tree',
				},
				{
					className: 'far fa-icicles',
					options: [
						'fat fa-icicles', 'fal fa-icicles', 'far fa-icicles', 'fas fa-icicles',
					],
					defaultOption: 'far fa-icicles',
					keywords: 'cold frozen hanging ice seasonal sharp icicles',
				},
				{
					className: 'far fa-leaf',
					options: [
						'fat fa-leaf', 'fal fa-leaf', 'far fa-leaf', 'fas fa-leaf',
					],
					defaultOption: 'far fa-leaf',
					keywords: 'eco flora nature plant vegan leaf',
				},
				{
					className: 'far fa-leaf-maple',
					options: [
						'fat fa-leaf-maple', 'fal fa-leaf-maple', 'far fa-leaf-maple', 'fas fa-leaf-maple',
					],
					defaultOption: 'far fa-leaf-maple',
					keywords: 'eco fall falling flora leaf maple maple leaf nature plant seasonal leaf maple',
				},
				{
					className: 'far fa-leaf-oak',
					options: [
						'fat fa-leaf-oak', 'fal fa-leaf-oak', 'far fa-leaf-oak', 'fas fa-leaf-oak',
					],
					defaultOption: 'far fa-leaf-oak',
					keywords: 'eco fall flora nature plant seasonal leaf oak',
				},
				{
					className: 'far fa-mountain',
					options: [
						'fat fa-mountain', 'fal fa-mountain', 'far fa-mountain', 'fas fa-mountain',
					],
					defaultOption: 'far fa-mountain',
					keywords: 'cold glacier hiking hill landscape mountain snow snow capped mountain travel view mountain',
				},
				{
					className: 'far fa-mountains',
					options: [
						'fat fa-mountains', 'fal fa-mountains', 'far fa-mountains', 'fas fa-mountains',
					],
					defaultOption: 'far fa-mountains',
					keywords: 'glacier hiking hill landscape mountai mountain travel view mountains',
				},
				{
					className: 'far fa-mushroom',
					options: [
						'fat fa-mushroom', 'fal fa-mushroom', 'far fa-mushroom', 'fas fa-mushroom',
					],
					defaultOption: 'far fa-mushroom',
					keywords: '1 up fungus toadstool mushroom',
				},
				{
					className: 'far fa-person-hiking',
					options: [
						'fat fa-person-hiking', 'fal fa-person-hiking', 'far fa-person-hiking', 'fas fa-person-hiking',
					],
					defaultOption: 'far fa-person-hiking',
					keywords: 'autumn fall hike mountain outdoors summer walk person hiking',
				},
				{
					className: 'far fa-pompebled',
					options: [
						'fat fa-pompebled', 'fal fa-pompebled', 'far fa-pompebled', 'fas fa-pompebled',
					],
					defaultOption: 'far fa-pompebled',
					keywords: 'frisian leaf lily pad netherlands seeblatt water lily pompebled',
				},
				{
					className: 'far fa-raindrops',
					options: [
						'fat fa-raindrops', 'fal fa-raindrops', 'far fa-raindrops', 'fas fa-raindrops',
					],
					defaultOption: 'far fa-raindrops',
					keywords: 'precipitation rain sprinkle storm raindrops',
				},
				{
					className: 'far fa-seedling',
					options: [
						'fat fa-seedling', 'fal fa-seedling', 'far fa-seedling', 'fas fa-seedling',
					],
					defaultOption: 'far fa-seedling',
					keywords: 'flora grow plant seedling vegan young seedling',
				},
				{
					className: 'far fa-signs-post',
					options: [
						'fat fa-signs-post', 'fal fa-signs-post', 'far fa-signs-post', 'fas fa-signs-post',
					],
					defaultOption: 'far fa-signs-post',
					keywords: 'directions directory map signage wayfinding signs post',
				},
				{
					className: 'far fa-spider',
					options: [
						'fat fa-spider', 'fal fa-spider', 'far fa-spider', 'fas fa-spider',
					],
					defaultOption: 'far fa-spider',
					keywords: 'arachnid bug charlotte crawl eight halloween insect spider spider',
				},
				{
					className: 'far fa-spider-black-widow',
					options: [
						'fat fa-spider-black-widow', 'fal fa-spider-black-widow', 'far fa-spider-black-widow', 'fas fa-spider-black-widow',
					],
					defaultOption: 'far fa-spider-black-widow',
					keywords: 'alert arachnid bug charlotte crawl danger dangerous deadly eight error halloween spider black-widow',
				},
				{
					className: 'far fa-spider-web',
					options: [
						'fat fa-spider-web', 'fal fa-spider-web', 'far fa-spider-web', 'fas fa-spider-web',
					],
					defaultOption: 'far fa-spider-web',
					keywords: 'cobweb gossamer halloween spider spider web web spider web',
				},
				{
					className: 'far fa-tree',
					options: [
						'fat fa-tree', 'fal fa-tree', 'far fa-tree', 'fas fa-tree',
					],
					defaultOption: 'far fa-tree',
					keywords: 'bark evergreen tree fall flora forest nature plant seasonal tree tree',
				},
				{
					className: 'far fa-tree-deciduous',
					options: [
						'fat fa-tree-deciduous', 'fal fa-tree-deciduous', 'far fa-tree-deciduous', 'fas fa-tree-deciduous',
					],
					defaultOption: 'far fa-tree-deciduous',
					keywords: 'bark deciduous deciduous tree fall flora forest nature plant seasonal shedding tree tree deciduous',
				},
				{
					className: 'far fa-tree-large',
					options: [
						'fat fa-tree-large', 'fal fa-tree-large', 'far fa-tree-large', 'fas fa-tree-large',
					],
					defaultOption: 'far fa-tree-large',
					keywords: 'bark fall flora forest nature plant seasonal tree large',
				},
				{
					className: 'far fa-tree-palm',
					options: [
						'fat fa-tree-palm', 'fal fa-tree-palm', 'far fa-tree-palm', 'fas fa-tree-palm',
					],
					defaultOption: 'far fa-tree-palm',
					keywords: 'coconut frond palm palm tree tree tropical tree palm',
				},
				{
					className: 'far fa-trees',
					options: [
						'fat fa-trees', 'fal fa-trees', 'far fa-trees', 'fas fa-trees',
					],
					defaultOption: 'far fa-trees',
					keywords: 'bark fall flora forest nature plant seasonal trees',
				},
				{
					className: 'far fa-volcano',
					options: [
						'fat fa-volcano', 'fal fa-volcano', 'far fa-volcano', 'fas fa-volcano',
					],
					defaultOption: 'far fa-volcano',
					keywords: 'caldera eruption lava magma mountain smoke volcano volcano',
				},
				{
					className: 'far fa-water',
					options: [
						'fat fa-water', 'fal fa-water', 'far fa-water', 'fas fa-water',
					],
					defaultOption: 'far fa-water',
					keywords: 'lake liquid ocean sea swim wet water',
				},
				{
					className: 'far fa-wind',
					options: [
						'fat fa-wind', 'fal fa-wind', 'far fa-wind', 'fas fa-wind',
					],
					defaultOption: 'far fa-wind',
					keywords: 'air blow breeze fall seasonal weather wind',
				},
			],
		},
		{
			id: 'numbers',
			name: Loc.getMessage('LANDING_ICONS_SECTION_NUMBERS'),
			items: [
				{
					className: 'far fa-0',
					options: [
						'fat fa-0', 'fal fa-0', 'far fa-0', 'fas fa-0',
					],
					defaultOption: 'far fa-0',
					keywords: 'digit zero nada none zero zilch 0',
				},
				{
					className: 'far fa-1',
					options: [
						'fat fa-1', 'fal fa-1', 'far fa-1', 'fas fa-1',
					],
					defaultOption: 'far fa-1',
					keywords: 'digit one one 1',
				},
				{
					className: 'far fa-2',
					options: [
						'fat fa-2', 'fal fa-2', 'far fa-2', 'fas fa-2',
					],
					defaultOption: 'far fa-2',
					keywords: 'digit two two 2',
				},
				{
					className: 'far fa-3',
					options: [
						'fat fa-3', 'fal fa-3', 'far fa-3', 'fas fa-3',
					],
					defaultOption: 'far fa-3',
					keywords: 'digit three three 3',
				},
				{
					className: 'far fa-4',
					options: [
						'fat fa-4', 'fal fa-4', 'far fa-4', 'fas fa-4',
					],
					defaultOption: 'far fa-4',
					keywords: 'digit four four 4',
				},
				{
					className: 'far fa-5',
					options: [
						'fat fa-5', 'fal fa-5', 'far fa-5', 'fas fa-5',
					],
					defaultOption: 'far fa-5',
					keywords: 'digit five five 5',
				},
				{
					className: 'far fa-6',
					options: [
						'fat fa-6', 'fal fa-6', 'far fa-6', 'fas fa-6',
					],
					defaultOption: 'far fa-6',
					keywords: 'digit six six 6',
				},
				{
					className: 'far fa-7',
					options: [
						'fat fa-7', 'fal fa-7', 'far fa-7', 'fas fa-7',
					],
					defaultOption: 'far fa-7',
					keywords: 'digit seven seven 7',
				},
				{
					className: 'far fa-8',
					options: [
						'fat fa-8', 'fal fa-8', 'far fa-8', 'fas fa-8',
					],
					defaultOption: 'far fa-8',
					keywords: 'digit eight eight 8',
				},
				{
					className: 'far fa-9',
					options: [
						'fat fa-9', 'fal fa-9', 'far fa-9', 'fas fa-9',
					],
					defaultOption: 'far fa-9',
					keywords: 'digit nine nine 9',
				},
				{
					className: 'far fa-circle-0',
					options: [
						'fat fa-circle-0', 'fal fa-circle-0', 'far fa-circle-0', 'fas fa-circle-0',
					],
					defaultOption: 'far fa-circle-0',
					keywords: 'circled digit zero negative circled digit zero nada none zero zilch circle 0',
				},
				{
					className: 'far fa-circle-1',
					options: [
						'fat fa-circle-1', 'fal fa-circle-1', 'far fa-circle-1', 'fas fa-circle-1',
					],
					defaultOption: 'far fa-circle-1',
					keywords: 'circled digit one dingbat circled sans serif digit one dingbat negative circled digit one dingbat negative circled sans-serif digit one one circle-1',
				},
				{
					className: 'far fa-circle-2',
					options: [
						'fat fa-circle-2', 'fal fa-circle-2', 'far fa-circle-2', 'fas fa-circle-2',
					],
					defaultOption: 'far fa-circle-2',
					keywords: 'circled digit two dingbat circled sans serif digit two dingbat negative circled digit two dingbat negative circled sans-serif digit two two circle-2',
				},
				{
					className: 'far fa-circle-3',
					options: [
						'fat fa-circle-3', 'fal fa-circle-3', 'far fa-circle-3', 'fas fa-circle-3',
					],
					defaultOption: 'far fa-circle-3',
					keywords: 'circled digit three dingbat circled sans serif digit three dingbat negative circled digit three dingbat negative circled sans-serif digit three three circle-3',
				},
				{
					className: 'far fa-circle-4',
					options: [
						'fat fa-circle-4', 'fal fa-circle-4', 'far fa-circle-4', 'fas fa-circle-4',
					],
					defaultOption: 'far fa-circle-4',
					keywords: 'circled digit four dingbat circled sans serif digit four dingbat negative circled digit four dingbat negative circled sans-serif digit four four circle-4',
				},
				{
					className: 'far fa-circle-5',
					options: [
						'fat fa-circle-5', 'fal fa-circle-5', 'far fa-circle-5', 'fas fa-circle-5',
					],
					defaultOption: 'far fa-circle-5',
					keywords: 'circled digit five dingbat circled sans serif digit five dingbat negative circled digit five dingbat negative circled sans-serif digit five five circle-5',
				},
				{
					className: 'far fa-circle-6',
					options: [
						'fat fa-circle-6', 'fal fa-circle-6', 'far fa-circle-6', 'fas fa-circle-6',
					],
					defaultOption: 'far fa-circle-6',
					keywords: 'circled digit six dingbat circled sans serif digit six dingbat negative circled digit six dingbat negative circled sans-serif digit six six circle-6',
				},
				{
					className: 'far fa-circle-7',
					options: [
						'fat fa-circle-7', 'fal fa-circle-7', 'far fa-circle-7', 'fas fa-circle-7',
					],
					defaultOption: 'far fa-circle-7',
					keywords: 'circled digit seven dingbat circled sans serif digit seven dingbat negative circled digit seven dingbat negative circled sans-serif digit seven seven circle-7',
				},
				{
					className: 'far fa-circle-8',
					options: [
						'fat fa-circle-8', 'fal fa-circle-8', 'far fa-circle-8', 'fas fa-circle-8',
					],
					defaultOption: 'far fa-circle-8',
					keywords: 'circled digit eight dingbat circled sans serif digit eight dingbat negative circled digit eight dingbat negative circled sans-serif digit eight eight circle-8',
				},
				{
					className: 'far fa-circle-9',
					options: [
						'fat fa-circle-9', 'fal fa-circle-9', 'far fa-circle-9', 'fas fa-circle-9',
					],
					defaultOption: 'far fa-circle-9',
					keywords: 'circled digit nine dingbat circled sans serif digit nine dingbat negative circled digit nine dingbat negative circled sans-serif digit nine nine circle-9',
				},
				{
					className: 'far fa-hundred-points',
					options: [
						'fat fa-hundred-points', 'fal fa-hundred-points', 'far fa-hundred-points', 'fas fa-hundred-points',
					],
					defaultOption: 'far fa-hundred-points',
					keywords: '100 agree one hundred percent perfect score win hundred points',
				},
				{
					className: 'far fa-square-0',
					options: [
						'fat fa-square-0', 'fal fa-square-0', 'far fa-square-0', 'fas fa-square-0',
					],
					defaultOption: 'far fa-square-0',
					keywords: 'nada none zero zilch square 0',
				},
				{
					className: 'far fa-square-1',
					options: [
						'fat fa-square-1', 'fal fa-square-1', 'far fa-square-1', 'fas fa-square-1',
					],
					defaultOption: 'far fa-square-1',
					keywords: 'one square 1',
				},
				{
					className: 'far fa-square-2',
					options: [
						'fat fa-square-2', 'fal fa-square-2', 'far fa-square-2', 'fas fa-square-2',
					],
					defaultOption: 'far fa-square-2',
					keywords: 'two square 2',
				},
				{
					className: 'far fa-square-3',
					options: [
						'fat fa-square-3', 'fal fa-square-3', 'far fa-square-3', 'fas fa-square-3',
					],
					defaultOption: 'far fa-square-3',
					keywords: 'three square 3',
				},
				{
					className: 'far fa-square-4',
					options: [
						'fat fa-square-4', 'fal fa-square-4', 'far fa-square-4', 'fas fa-square-4',
					],
					defaultOption: 'far fa-square-4',
					keywords: 'four square 4',
				},
				{
					className: 'far fa-square-5',
					options: [
						'fat fa-square-5', 'fal fa-square-5', 'far fa-square-5', 'fas fa-square-5',
					],
					defaultOption: 'far fa-square-5',
					keywords: 'five square 5',
				},
				{
					className: 'far fa-square-6',
					options: [
						'fat fa-square-6', 'fal fa-square-6', 'far fa-square-6', 'fas fa-square-6',
					],
					defaultOption: 'far fa-square-6',
					keywords: 'six square 6',
				},
				{
					className: 'far fa-square-7',
					options: [
						'fat fa-square-7', 'fal fa-square-7', 'far fa-square-7', 'fas fa-square-7',
					],
					defaultOption: 'far fa-square-7',
					keywords: 'seven square 7',
				},
				{
					className: 'far fa-square-8',
					options: [
						'fat fa-square-8', 'fal fa-square-8', 'far fa-square-8', 'fas fa-square-8',
					],
					defaultOption: 'far fa-square-8',
					keywords: 'eight square 8',
				},
				{
					className: 'far fa-square-9',
					options: [
						'fat fa-square-9', 'fal fa-square-9', 'far fa-square-9', 'fas fa-square-9',
					],
					defaultOption: 'far fa-square-9',
					keywords: 'nine square 9',
				},
			],
		},
		{
			id: 'photos-images',
			name: Loc.getMessage('LANDING_ICONS_SECTION_PHOTOS_IMAGES'),
			items: [
				{
					className: 'far fa-360-degrees',
					options: [
						'fat fa-360-degrees', 'fal fa-360-degrees', 'far fa-360-degrees', 'fas fa-360-degrees',
					],
					defaultOption: 'far fa-360-degrees',
					keywords: '3d panorama revolve rotate 360 degrees',
				},
				{
					className: 'far fa-aperture',
					options: [
						'fat fa-aperture', 'fal fa-aperture', 'far fa-aperture', 'fas fa-aperture',
					],
					defaultOption: 'far fa-aperture',
					keywords: 'aperture camera exposure lens photo aperture',
				},
				{
					className: 'far fa-bolt',
					options: [
						'fat fa-bolt', 'fal fa-bolt', 'far fa-bolt', 'fas fa-bolt',
					],
					defaultOption: 'far fa-bolt',
					keywords: 'charge danger electric electricity flash high voltage lightning voltage weather zap bolt',
				},
				{
					className: 'far fa-bolt-auto',
					options: [
						'fat fa-bolt-auto', 'fal fa-bolt-auto', 'far fa-bolt-auto', 'fas fa-bolt-auto',
					],
					defaultOption: 'far fa-bolt-auto',
					keywords: 'automatic flash bolt auto',
				},
				{
					className: 'far fa-bolt-lightning',
					options: [
						'fat fa-bolt-lightning', 'fal fa-bolt-lightning', 'far fa-bolt-lightning', 'fas fa-bolt-lightning',
					],
					defaultOption: 'far fa-bolt-lightning',
					keywords: 'electricity flash lightning weather zap bolt lightning',
				},
				{
					className: 'far fa-bolt-slash',
					options: [
						'fat fa-bolt-slash', 'fal fa-bolt-slash', 'far fa-bolt-slash', 'fas fa-bolt-slash',
					],
					defaultOption: 'far fa-bolt-slash',
					keywords: 'charge electricity flash lightning weather zap bolt slash',
				},
				{
					className: 'far fa-camera',
					options: [
						'fat fa-camera', 'fal fa-camera', 'far fa-camera', 'fas fa-camera',
					],
					defaultOption: 'far fa-camera',
					keywords: 'image lens photo picture record shutter video camera',
				},
				{
					className: 'far fa-camera-polaroid',
					options: [
						'fat fa-camera-polaroid', 'fal fa-camera-polaroid', 'far fa-camera-polaroid', 'fas fa-camera-polaroid',
					],
					defaultOption: 'far fa-camera-polaroid',
					keywords: 'capture film instant camera lens photo photography retro snapshot vintage camera polaroid',
				},
				{
					className: 'far fa-camera-retro',
					options: [
						'fat fa-camera-retro', 'fal fa-camera-retro', 'far fa-camera-retro', 'fas fa-camera-retro',
					],
					defaultOption: 'far fa-camera-retro',
					keywords: 'camera image lens photo picture record shutter video camera retro',
				},
				{
					className: 'far fa-camera-rotate',
					options: [
						'fat fa-camera-rotate', 'fal fa-camera-rotate', 'far fa-camera-rotate', 'fas fa-camera-rotate',
					],
					defaultOption: 'far fa-camera-rotate',
					keywords: 'flip front facing photo selfie camera-rotate',
				},
				{
					className: 'far fa-camera-slash',
					options: [
						'fat fa-camera-slash', 'fal fa-camera-slash', 'far fa-camera-slash', 'fas fa-camera-slash',
					],
					defaultOption: 'far fa-camera-slash',
					keywords: 'camera photo camera slash',
				},
				{
					className: 'far fa-camera-viewfinder',
					options: [
						'fat fa-camera-viewfinder', 'fal fa-camera-viewfinder', 'far fa-camera-viewfinder', 'fas fa-camera-viewfinder',
					],
					defaultOption: 'far fa-camera-viewfinder',
					keywords: 'camera focus screenshot video camera viewfinder',
				},
				{
					className: 'far fa-chalkboard',
					options: [
						'fat fa-chalkboard', 'fal fa-chalkboard', 'far fa-chalkboard', 'fas fa-chalkboard',
					],
					defaultOption: 'far fa-chalkboard',
					keywords: 'blackboard learning school teaching whiteboard writing chalkboard',
				},
				{
					className: 'far fa-circle-camera',
					options: [
						'fat fa-circle-camera', 'fal fa-circle-camera', 'far fa-circle-camera', 'fas fa-circle-camera',
					],
					defaultOption: 'far fa-circle-camera',
					keywords: 'photos circle camera',
				},
				{
					className: 'far fa-circle-half-stroke',
					options: [
						'fat fa-circle-half-stroke', 'fal fa-circle-half-stroke', 'far fa-circle-half-stroke', 'fas fa-circle-half-stroke',
					],
					defaultOption: 'far fa-circle-half-stroke',
					keywords: 'circle with left half black contrast dark light saturation circle half-stroke',
				},
				{
					className: 'far fa-clone',
					options: [
						'fat fa-clone', 'fal fa-clone', 'far fa-clone', 'fas fa-clone',
					],
					defaultOption: 'far fa-clone',
					keywords: 'arrange copy duplicate paste clone',
				},
				{
					className: 'far fa-comment-image',
					options: [
						'fat fa-comment-image', 'fal fa-comment-image', 'far fa-comment-image', 'fas fa-comment-image',
					],
					defaultOption: 'far fa-comment-image',
					keywords: 'chat discussion photography photos comment image',
				},
				{
					className: 'far fa-droplet',
					options: [
						'fat fa-droplet', 'fal fa-droplet', 'far fa-droplet', 'fas fa-droplet',
					],
					defaultOption: 'far fa-droplet',
					keywords: 'cold color comic drop droplet raindrop sweat waterdrop droplet',
				},
				{
					className: 'far fa-eye',
					options: [
						'fat fa-eye', 'fal fa-eye', 'far fa-eye', 'fas fa-eye',
					],
					defaultOption: 'far fa-eye',
					keywords: 'body eye look optic see seen show sight views visible eye',
				},
				{
					className: 'far fa-eye-dropper',
					options: [
						'fat fa-eye-dropper', 'fal fa-eye-dropper', 'far fa-eye-dropper', 'fas fa-eye-dropper',
					],
					defaultOption: 'far fa-eye-dropper',
					keywords: 'beaker clone color copy eyedropper pipette eye dropper',
				},
				{
					className: 'far fa-eye-slash',
					options: [
						'fat fa-eye-slash', 'fal fa-eye-slash', 'far fa-eye-slash', 'fas fa-eye-slash',
					],
					defaultOption: 'far fa-eye-slash',
					keywords: 'blind hide show toggle unseen views visible visiblity eye slash',
				},
				{
					className: 'far fa-face-viewfinder',
					options: [
						'fat fa-face-viewfinder', 'fal fa-face-viewfinder', 'far fa-face-viewfinder', 'fas fa-face-viewfinder',
					],
					defaultOption: 'far fa-face-viewfinder',
					keywords: 'face id facial identity recognition scan smile face viewfinder',
				},
				{
					className: 'far fa-file-image',
					options: [
						'fat fa-file-image', 'fal fa-file-image', 'far fa-file-image', 'fas fa-file-image',
					],
					defaultOption: 'far fa-file-image',
					keywords: 'document with picture document image jpg photo png file image',
				},
				{
					className: 'far fa-film',
					options: [
						'fat fa-film', 'fal fa-film', 'far fa-film', 'fas fa-film',
					],
					defaultOption: 'far fa-film',
					keywords: 'cinema film film frames frames movie strip video film',
				},
				{
					className: 'far fa-film-canister',
					options: [
						'fat fa-film-canister', 'fal fa-film-canister', 'far fa-film-canister', 'fas fa-film-canister',
					],
					defaultOption: 'far fa-film-canister',
					keywords: '110 35mm darkroom develop image photo photography retro vintage film canister',
				},
				{
					className: 'far fa-film-simple',
					options: [
						'fat fa-film-simple', 'fal fa-film-simple', 'far fa-film-simple', 'fas fa-film-simple',
					],
					defaultOption: 'far fa-film-simple',
					keywords: 'cinema movie strip video film simple',
				},
				{
					className: 'far fa-film-slash',
					options: [
						'fat fa-film-slash', 'fal fa-film-slash', 'far fa-film-slash', 'fas fa-film-slash',
					],
					defaultOption: 'far fa-film-slash',
					keywords: 'cinema movie strip video film slash',
				},
				{
					className: 'far fa-films',
					options: [
						'fat fa-films', 'fal fa-films', 'far fa-films', 'fas fa-films',
					],
					defaultOption: 'far fa-films',
					keywords: 'films videos films',
				},
				{
					className: 'far fa-folder-image',
					options: [
						'fat fa-folder-image', 'fal fa-folder-image', 'far fa-folder-image', 'fas fa-folder-image',
					],
					defaultOption: 'far fa-folder-image',
					keywords: 'file image photos folder image',
				},
				{
					className: 'far fa-gif',
					options: [
						'fat fa-gif', 'fal fa-gif', 'far fa-gif', 'fas fa-gif',
					],
					defaultOption: 'far fa-gif',
					keywords: 'animation gif',
				},
				{
					className: 'far fa-high-definition',
					options: [
						'fat fa-high-definition', 'fal fa-high-definition', 'far fa-high-definition', 'fas fa-high-definition',
					],
					defaultOption: 'far fa-high-definition',
					keywords: 'resolution retina video high definition',
				},
				{
					className: 'far fa-id-badge',
					options: [
						'fat fa-id-badge', 'fal fa-id-badge', 'far fa-id-badge', 'fas fa-id-badge',
					],
					defaultOption: 'far fa-id-badge',
					keywords: 'address contact identification license profile id badge',
				},
				{
					className: 'far fa-id-card',
					options: [
						'fat fa-id-card', 'fal fa-id-card', 'far fa-id-card', 'fas fa-id-card',
					],
					defaultOption: 'far fa-id-card',
					keywords: 'contact demographics document identification issued profile id card',
				},
				{
					className: 'far fa-image',
					options: [
						'fat fa-image', 'fal fa-image', 'far fa-image', 'fas fa-image',
					],
					defaultOption: 'far fa-image',
					keywords: 'album landscape photo picture image',
				},
				{
					className: 'far fa-image-landscape',
					options: [
						'fat fa-image-landscape', 'fal fa-image-landscape', 'far fa-image-landscape', 'fas fa-image-landscape',
					],
					defaultOption: 'far fa-image-landscape',
					keywords: 'image mountain photo image landscape',
				},
				{
					className: 'far fa-image-polaroid',
					options: [
						'fat fa-image-polaroid', 'fal fa-image-polaroid', 'far fa-image-polaroid', 'fas fa-image-polaroid',
					],
					defaultOption: 'far fa-image-polaroid',
					keywords: 'capture film instant camera lens photo photography retro snapshot vintage image polaroid',
				},
				{
					className: 'far fa-image-polaroid-user',
					options: [
						'fat fa-image-polaroid-user', 'fal fa-image-polaroid-user', 'far fa-image-polaroid-user', 'fas fa-image-polaroid-user',
					],
					defaultOption: 'far fa-image-polaroid-user',
					keywords: 'kodak portrait selfie image polaroid-user',
				},
				{
					className: 'far fa-image-portrait',
					options: [
						'fat fa-image-portrait', 'fal fa-image-portrait', 'far fa-image-portrait', 'fas fa-image-portrait',
					],
					defaultOption: 'far fa-image-portrait',
					keywords: 'id image photo picture selfie image portrait',
				},
				{
					className: 'far fa-image-slash',
					options: [
						'fat fa-image-slash', 'fal fa-image-slash', 'far fa-image-slash', 'fas fa-image-slash',
					],
					defaultOption: 'far fa-image-slash',
					keywords: 'album landscape photo picture image slash',
				},
				{
					className: 'far fa-image-user',
					options: [
						'fat fa-image-user', 'fal fa-image-user', 'far fa-image-user', 'fas fa-image-user',
					],
					defaultOption: 'far fa-image-user',
					keywords: 'portrait selfie image user',
				},
				{
					className: 'far fa-images',
					options: [
						'fat fa-images', 'fal fa-images', 'far fa-images', 'fas fa-images',
					],
					defaultOption: 'far fa-images',
					keywords: 'album landscape photo picture images',
				},
				{
					className: 'far fa-images-user',
					options: [
						'fat fa-images-user', 'fal fa-images-user', 'far fa-images-user', 'fas fa-images-user',
					],
					defaultOption: 'far fa-images-user',
					keywords: 'portrait selfie images user',
				},
				{
					className: 'far fa-message-image',
					options: [
						'fat fa-message-image', 'fal fa-message-image', 'far fa-message-image', 'fas fa-message-image',
					],
					defaultOption: 'far fa-message-image',
					keywords: 'chat discussion photography photos message image',
				},
				{
					className: 'far fa-minimize',
					options: [
						'fat fa-minimize', 'fal fa-minimize', 'far fa-minimize', 'fas fa-minimize',
					],
					defaultOption: 'far fa-minimize',
					keywords: 'collapse fullscreen minimize move resize shrink smaller minimize',
				},
				{
					className: 'far fa-panorama',
					options: [
						'fat fa-panorama', 'fal fa-panorama', 'far fa-panorama', 'fas fa-panorama',
					],
					defaultOption: 'far fa-panorama',
					keywords: 'image landscape photo wide panorama',
				},
				{
					className: 'far fa-photo-film',
					options: [
						'fat fa-photo-film', 'fal fa-photo-film', 'far fa-photo-film', 'fas fa-photo-film',
					],
					defaultOption: 'far fa-photo-film',
					keywords: 'av film image library media photo film',
				},
				{
					className: 'far fa-photo-film-music',
					options: [
						'fat fa-photo-film-music', 'fal fa-photo-film-music', 'far fa-photo-film-music', 'fas fa-photo-film-music',
					],
					defaultOption: 'far fa-photo-film-music',
					keywords: 'media photo film-music',
				},
				{
					className: 'far fa-rectangle-vertical-history',
					options: [
						'fat fa-rectangle-vertical-history', 'fal fa-rectangle-vertical-history', 'far fa-rectangle-vertical-history', 'fas fa-rectangle-vertical-history',
					],
					defaultOption: 'far fa-rectangle-vertical-history',
					keywords: 'collection history multiple windows rectangle vertical-history',
				},
				{
					className: 'far fa-sliders',
					options: [
						'fat fa-sliders', 'fal fa-sliders', 'far fa-sliders', 'fas fa-sliders',
					],
					defaultOption: 'far fa-sliders',
					keywords: 'adjust settings sliders toggle sliders',
				},
				{
					className: 'far fa-sliders-up',
					options: [
						'fat fa-sliders-up', 'fal fa-sliders-up', 'far fa-sliders-up', 'fas fa-sliders-up',
					],
					defaultOption: 'far fa-sliders-up',
					keywords: 'adjust settings sliders toggle sliders up',
				},
				{
					className: 'far fa-square-sliders',
					options: [
						'fat fa-square-sliders', 'fal fa-square-sliders', 'far fa-square-sliders', 'fas fa-square-sliders',
					],
					defaultOption: 'far fa-square-sliders',
					keywords: 'adjust settings sliders toggle square sliders',
				},
				{
					className: 'far fa-square-sliders-vertical',
					options: [
						'fat fa-square-sliders-vertical', 'fal fa-square-sliders-vertical', 'far fa-square-sliders-vertical', 'fas fa-square-sliders-vertical',
					],
					defaultOption: 'far fa-square-sliders-vertical',
					keywords: 'adjust settings sliders toggle square sliders-vertical',
				},
				{
					className: 'far fa-standard-definition',
					options: [
						'fat fa-standard-definition', 'fal fa-standard-definition', 'far fa-standard-definition', 'fas fa-standard-definition',
					],
					defaultOption: 'far fa-standard-definition',
					keywords: 'low resolution standard definition',
				},
			],
		},
		{
			id: 'political',
			name: Loc.getMessage('LANDING_ICONS_SECTION_POLITICAL'),
			items: [
				{
					className: 'far fa-award',
					options: [
						'fat fa-award', 'fal fa-award', 'far fa-award', 'fas fa-award',
					],
					defaultOption: 'far fa-award',
					keywords: 'honor praise prize recognition ribbon trophy award',
				},
				{
					className: 'far fa-ballot',
					options: [
						'fat fa-ballot', 'fal fa-ballot', 'far fa-ballot', 'fas fa-ballot',
					],
					defaultOption: 'far fa-ballot',
					keywords: 'checklist choice election vote voting ballot',
				},
				{
					className: 'far fa-ballot-check',
					options: [
						'fat fa-ballot-check', 'fal fa-ballot-check', 'far fa-ballot-check', 'fas fa-ballot-check',
					],
					defaultOption: 'far fa-ballot-check',
					keywords: 'checklist choice completed done election finished select success tick vote voting ballot check',
				},
				{
					className: 'far fa-booth-curtain',
					options: [
						'fat fa-booth-curtain', 'fal fa-booth-curtain', 'far fa-booth-curtain', 'fas fa-booth-curtain',
					],
					defaultOption: 'far fa-booth-curtain',
					keywords: 'changing room election vote voting voting booth booth curtain',
				},
				{
					className: 'far fa-box-ballot',
					options: [
						'fat fa-box-ballot', 'fal fa-box-ballot', 'far fa-box-ballot', 'fas fa-box-ballot',
					],
					defaultOption: 'far fa-box-ballot',
					keywords: 'ballot ballot box with ballot box election politics vote voting box ballot',
				},
				{
					className: 'far fa-bullhorn',
					options: [
						'fat fa-bullhorn', 'fal fa-bullhorn', 'far fa-bullhorn', 'fas fa-bullhorn',
					],
					defaultOption: 'far fa-bullhorn',
					keywords: 'bullhorn announcement broadcast loud louder loudspeaker megaphone public address share bullhorn',
				},
				{
					className: 'far fa-calendar-star',
					options: [
						'fat fa-calendar-star', 'fal fa-calendar-star', 'far fa-calendar-star', 'fas fa-calendar-star',
					],
					defaultOption: 'far fa-calendar-star',
					keywords: 'calendar date day event favorite important month schedule time when year calendar star',
				},
				{
					className: 'far fa-check-double',
					options: [
						'fat fa-check-double', 'fal fa-check-double', 'far fa-check-double', 'fas fa-check-double',
					],
					defaultOption: 'far fa-check-double',
					keywords: 'accept agree checkmark confirm correct done notice notification notify ok select success tick todo check double',
				},
				{
					className: 'far fa-check-to-slot',
					options: [
						'fat fa-check-to-slot', 'fal fa-check-to-slot', 'far fa-check-to-slot', 'fas fa-check-to-slot',
					],
					defaultOption: 'far fa-check-to-slot',
					keywords: 'accept cast election politics positive voting yes check to-slot',
				},
				{
					className: 'far fa-circle-dollar-to-slot',
					options: [
						'fat fa-circle-dollar-to-slot', 'fal fa-circle-dollar-to-slot', 'far fa-circle-dollar-to-slot', 'fas fa-circle-dollar-to-slot',
					],
					defaultOption: 'far fa-circle-dollar-to-slot',
					keywords: 'contribute generosity gift give circle dollar-to-slot',
				},
				{
					className: 'far fa-clipboard-list-check',
					options: [
						'fat fa-clipboard-list-check', 'fal fa-clipboard-list-check', 'far fa-clipboard-list-check', 'fas fa-clipboard-list-check',
					],
					defaultOption: 'far fa-clipboard-list-check',
					keywords: 'checklist completed done election finished intinerary ol schedule tick todo ul vote voting clipboard list-check',
				},
				{
					className: 'far fa-democrat',
					options: [
						'fat fa-democrat', 'fal fa-democrat', 'far fa-democrat', 'fas fa-democrat',
					],
					defaultOption: 'far fa-democrat',
					keywords: 'american democratic party donkey election left left wing liberal politics usa democrat',
				},
				{
					className: 'far fa-dove',
					options: [
						'fat fa-dove', 'fal fa-dove', 'far fa-dove', 'fas fa-dove',
					],
					defaultOption: 'far fa-dove',
					keywords: 'bird dove fauna fly flying peace war dove',
				},
				{
					className: 'far fa-dumpster-fire',
					options: [
						'fat fa-dumpster-fire', 'fal fa-dumpster-fire', 'far fa-dumpster-fire', 'fas fa-dumpster-fire',
					],
					defaultOption: 'far fa-dumpster-fire',
					keywords: 'alley bin commercial danger dangerous euphemism flame heat hot trash waste dumpster fire',
				},
				{
					className: 'far fa-flag-swallowtail',
					options: [
						'fat fa-flag-swallowtail', 'fal fa-flag-swallowtail', 'far fa-flag-swallowtail', 'fas fa-flag-swallowtail',
					],
					defaultOption: 'far fa-flag-swallowtail',
					keywords: 'country notice notification notify pole report symbol flag swallowtail',
				},
				{
					className: 'far fa-flag-usa',
					options: [
						'fat fa-flag-usa', 'fal fa-flag-usa', 'far fa-flag-usa', 'fas fa-flag-usa',
					],
					defaultOption: 'far fa-flag-usa',
					keywords: 'betsy ross country fla flag: united states old glory stars stripes symbol flag usa',
				},
				{
					className: 'far fa-hand-fist',
					options: [
						'fat fa-hand-fist', 'fal fa-hand-fist', 'far fa-hand-fist', 'fas fa-hand-fist',
					],
					defaultOption: 'far fa-hand-fist',
					keywords: 'dungeons & dragons clenched d&d dnd fantasy fist hand ki monk punch raised fist resist strength unarmed combat hand fist',
				},
				{
					className: 'far fa-handshake',
					options: [
						'fat fa-handshake', 'fal fa-handshake', 'far fa-handshake', 'fas fa-handshake',
					],
					defaultOption: 'far fa-handshake',
					keywords: 'agreement greeting meeting partnership handshake',
				},
				{
					className: 'far fa-landmark-dome',
					options: [
						'fat fa-landmark-dome', 'fal fa-landmark-dome', 'far fa-landmark-dome', 'fas fa-landmark-dome',
					],
					defaultOption: 'far fa-landmark-dome',
					keywords: 'building historic memorable monument politics landmark dome',
				},
				{
					className: 'far fa-person-booth',
					options: [
						'fat fa-person-booth', 'fal fa-person-booth', 'far fa-person-booth', 'fas fa-person-booth',
					],
					defaultOption: 'far fa-person-booth',
					keywords: 'changing room curtain vote voting person booth',
				},
				{
					className: 'far fa-person-sign',
					options: [
						'fat fa-person-sign', 'fal fa-person-sign', 'far fa-person-sign', 'fas fa-person-sign',
					],
					defaultOption: 'far fa-person-sign',
					keywords: 'announce protest person sign',
				},
				{
					className: 'far fa-piggy-bank',
					options: [
						'fat fa-piggy-bank', 'fal fa-piggy-bank', 'far fa-piggy-bank', 'fas fa-piggy-bank',
					],
					defaultOption: 'far fa-piggy-bank',
					keywords: 'bank save savings piggy bank',
				},
				{
					className: 'far fa-podium',
					options: [
						'fat fa-podium', 'fal fa-podium', 'far fa-podium', 'fas fa-podium',
					],
					defaultOption: 'far fa-podium',
					keywords: 'debate election keynote lecture panel politics seminar speak speaker speech talk podium',
				},
				{
					className: 'far fa-podium-star',
					options: [
						'fat fa-podium-star', 'fal fa-podium-star', 'far fa-podium-star', 'fas fa-podium-star',
					],
					defaultOption: 'far fa-podium-star',
					keywords: 'debate election keynote lecture panel politics seminar speak speaker speech talk podium star',
				},
				{
					className: 'far fa-poll-people',
					options: [
						'fat fa-poll-people', 'fal fa-poll-people', 'far fa-poll-people', 'fas fa-poll-people',
					],
					defaultOption: 'far fa-poll-people',
					keywords: 'users people poll-people',
				},
				{
					className: 'far fa-republican',
					options: [
						'fat fa-republican', 'fal fa-republican', 'far fa-republican', 'fas fa-republican',
					],
					defaultOption: 'far fa-republican',
					keywords: 'american conservative election elephant politics republican party right right wing usa republican',
				},
				{
					className: 'far fa-scale-balanced',
					options: [
						'fat fa-scale-balanced', 'fal fa-scale-balanced', 'far fa-scale-balanced', 'fas fa-scale-balanced',
					],
					defaultOption: 'far fa-scale-balanced',
					keywords: 'libra balance balance scale balanced justice legal measure scale weight zodiac scale balanced',
				},
				{
					className: 'far fa-scale-unbalanced',
					options: [
						'fat fa-scale-unbalanced', 'fal fa-scale-unbalanced', 'far fa-scale-unbalanced', 'fas fa-scale-unbalanced',
					],
					defaultOption: 'far fa-scale-unbalanced',
					keywords: 'justice legal measure unbalanced weight scale unbalanced',
				},
				{
					className: 'far fa-scale-unbalanced-flip',
					options: [
						'fat fa-scale-unbalanced-flip', 'fal fa-scale-unbalanced-flip', 'far fa-scale-unbalanced-flip', 'fas fa-scale-unbalanced-flip',
					],
					defaultOption: 'far fa-scale-unbalanced-flip',
					keywords: 'justice legal measure unbalanced weight scale unbalanced-flip',
				},
				{
					className: 'far fa-tally',
					options: [
						'fat fa-tally', 'fal fa-tally', 'far fa-tally', 'fas fa-tally',
					],
					defaultOption: 'far fa-tally',
					keywords: 'count hash numbers tally',
				},
				{
					className: 'far fa-xmark-to-slot',
					options: [
						'fat fa-xmark-to-slot', 'fal fa-xmark-to-slot', 'far fa-xmark-to-slot', 'fas fa-xmark-to-slot',
					],
					defaultOption: 'far fa-xmark-to-slot',
					keywords: 'cast election negative no politics reject voting xmark to-slot',
				},
			],
		},
		{
			id: 'punctuation-symbols',
			name: Loc.getMessage('LANDING_ICONS_SECTION_PUNCTUATION_SYMBOLS'),
			items: [
				{
					className: 'far fa-accent-grave',
					options: [
						'fat fa-accent-grave', 'fal fa-accent-grave', 'far fa-accent-grave', 'fas fa-accent-grave',
					],
					defaultOption: 'far fa-accent-grave',
					keywords: 'grave accent apostrophe tick accent grave',
				},
				{
					className: 'far fa-alt',
					options: [
						'fat fa-alt', 'fal fa-alt', 'far fa-alt', 'fas fa-alt',
					],
					defaultOption: 'far fa-alt',
					keywords: 'alternate option alt',
				},
				{
					className: 'far fa-ampersand',
					options: [
						'fat fa-ampersand', 'fal fa-ampersand', 'far fa-ampersand', 'fas fa-ampersand',
					],
					defaultOption: 'far fa-ampersand',
					keywords: 'ampersand and ampersand',
				},
				{
					className: 'far fa-apostrophe',
					options: [
						'fat fa-apostrophe', 'fal fa-apostrophe', 'far fa-apostrophe', 'fas fa-apostrophe',
					],
					defaultOption: 'far fa-apostrophe',
					keywords: 'apostrophe comma contraction quote apostrophe',
				},
				{
					className: 'far fa-asterisk',
					options: [
						'fat fa-asterisk', 'fal fa-asterisk', 'far fa-asterisk', 'fas fa-asterisk',
					],
					defaultOption: 'far fa-asterisk',
					keywords: 'asterisk heavy asterisk annotation details reference star asterisk',
				},
				{
					className: 'far fa-at',
					options: [
						'fat fa-at', 'fal fa-at', 'far fa-at', 'fas fa-at',
					],
					defaultOption: 'far fa-at',
					keywords: 'commercial at address author e mail email fluctuate handle toy yo-yo at',
				},
				{
					className: 'far fa-bracket-curly',
					options: [
						'fat fa-bracket-curly', 'fal fa-bracket-curly', 'far fa-bracket-curly', 'fas fa-bracket-curly',
					],
					defaultOption: 'far fa-bracket-curly',
					keywords: 'left curly bracket braces code bracket curly',
				},
				{
					className: 'far fa-bracket-curly-right',
					options: [
						'fat fa-bracket-curly-right', 'fal fa-bracket-curly-right', 'far fa-bracket-curly-right', 'fas fa-bracket-curly-right',
					],
					defaultOption: 'far fa-bracket-curly-right',
					keywords: 'right curly bracket braces code bracket curly-right',
				},
				{
					className: 'far fa-bracket-round',
					options: [
						'fat fa-bracket-round', 'fal fa-bracket-round', 'far fa-bracket-round', 'fas fa-bracket-round',
					],
					defaultOption: 'far fa-bracket-round',
					keywords: 'left parenthesis parentheses bracket round',
				},
				{
					className: 'far fa-bracket-round-right',
					options: [
						'fat fa-bracket-round-right', 'fal fa-bracket-round-right', 'far fa-bracket-round-right', 'fas fa-bracket-round-right',
					],
					defaultOption: 'far fa-bracket-round-right',
					keywords: 'right parenthesis parentheses bracket round-right',
				},
				{
					className: 'far fa-bracket-square',
					options: [
						'fat fa-bracket-square', 'fal fa-bracket-square', 'far fa-bracket-square', 'fas fa-bracket-square',
					],
					defaultOption: 'far fa-bracket-square',
					keywords: 'left square bracket code crotchets bracket square',
				},
				{
					className: 'far fa-bracket-square-right',
					options: [
						'fat fa-bracket-square-right', 'fal fa-bracket-square-right', 'far fa-bracket-square-right', 'fas fa-bracket-square-right',
					],
					defaultOption: 'far fa-bracket-square-right',
					keywords: 'right square bracket code crotchets bracket square-right',
				},
				{
					className: 'far fa-brackets-round',
					options: [
						'fat fa-brackets-round', 'fal fa-brackets-round', 'far fa-brackets-round', 'fas fa-brackets-round',
					],
					defaultOption: 'far fa-brackets-round',
					keywords: 'parentheses brackets round',
				},
				{
					className: 'far fa-check',
					options: [
						'fat fa-check', 'fal fa-check', 'far fa-check', 'fas fa-check',
					],
					defaultOption: 'far fa-check',
					keywords: 'check mark accept agree check check mark checkmark confirm correct done mark notice notification notify ok select success tick todo yes ? check',
				},
				{
					className: 'far fa-check-double',
					options: [
						'fat fa-check-double', 'fal fa-check-double', 'far fa-check-double', 'fas fa-check-double',
					],
					defaultOption: 'far fa-check-double',
					keywords: 'accept agree checkmark confirm correct done notice notification notify ok select success tick todo check double',
				},
				{
					className: 'far fa-circle-ampersand',
					options: [
						'fat fa-circle-ampersand', 'fal fa-circle-ampersand', 'far fa-circle-ampersand', 'fas fa-circle-ampersand',
					],
					defaultOption: 'far fa-circle-ampersand',
					keywords: 'and circle ampersand',
				},
				{
					className: 'far fa-circle-exclamation',
					options: [
						'fat fa-circle-exclamation', 'fal fa-circle-exclamation', 'far fa-circle-exclamation', 'fas fa-circle-exclamation',
					],
					defaultOption: 'far fa-circle-exclamation',
					keywords: 'alert danger error important notice notification notify problem warning circle exclamation',
				},
				{
					className: 'far fa-circle-question',
					options: [
						'fat fa-circle-question', 'fal fa-circle-question', 'far fa-circle-question', 'fas fa-circle-question',
					],
					defaultOption: 'far fa-circle-question',
					keywords: 'help information support unknown circle question',
				},
				{
					className: 'far fa-colon',
					options: [
						'fat fa-colon', 'fal fa-colon', 'far fa-colon', 'fas fa-colon',
					],
					defaultOption: 'far fa-colon',
					keywords: 'colon clause dots colon',
				},
				{
					className: 'far fa-comma',
					options: [
						'fat fa-comma', 'fal fa-comma', 'far fa-comma', 'fas fa-comma',
					],
					defaultOption: 'far fa-comma',
					keywords: 'comma interval punctuation comma',
				},
				{
					className: 'far fa-corner',
					options: [
						'fat fa-corner', 'fal fa-corner', 'far fa-corner', 'fas fa-corner',
					],
					defaultOption: 'far fa-corner',
					keywords: 'not sign angle not corner',
				},
				{
					className: 'far fa-dash',
					options: [
						'fat fa-dash', 'fal fa-dash', 'far fa-dash', 'fas fa-dash',
					],
					defaultOption: 'far fa-dash',
					keywords: 'em dash horizontal rule hyphen line minus dash',
				},
				{
					className: 'far fa-ditto',
					options: [
						'fat fa-ditto', 'fal fa-ditto', 'far fa-ditto', 'fas fa-ditto',
					],
					defaultOption: 'far fa-ditto',
					keywords: 'quotation mark inch quotation quote ditto',
				},
				{
					className: 'far fa-equals',
					options: [
						'fat fa-equals', 'fal fa-equals', 'far fa-equals', 'fas fa-equals',
					],
					defaultOption: 'far fa-equals',
					keywords: 'equals sign arithmetic even match math equals',
				},
				{
					className: 'far fa-exclamation',
					options: [
						'fat fa-exclamation', 'fal fa-exclamation', 'far fa-exclamation', 'fas fa-exclamation',
					],
					defaultOption: 'far fa-exclamation',
					keywords: '! exclamation mark alert danger error exclamation important mark notice notification notify outlined problem punctuation red exclamation mark warning white exclamation mark exclamation',
				},
				{
					className: 'far fa-greater-than',
					options: [
						'fat fa-greater-than', 'fal fa-greater-than', 'far fa-greater-than', 'fas fa-greater-than',
					],
					defaultOption: 'far fa-greater-than',
					keywords: 'greater than sign arithmetic compare math greater-than',
				},
				{
					className: 'far fa-hashtag',
					options: [
						'fat fa-hashtag', 'fal fa-hashtag', 'far fa-hashtag', 'fas fa-hashtag',
					],
					defaultOption: 'far fa-hashtag',
					keywords: 'number sign twitter instagram pound social media tag hashtag',
				},
				{
					className: 'far fa-horizontal-rule',
					options: [
						'fat fa-horizontal-rule', 'fal fa-horizontal-rule', 'far fa-horizontal-rule', 'fas fa-horizontal-rule',
					],
					defaultOption: 'far fa-horizontal-rule',
					keywords: 'horizontal bar divider hr line page break horizontal rule',
				},
				{
					className: 'far fa-hyphen',
					options: [
						'fat fa-hyphen', 'fal fa-hyphen', 'far fa-hyphen', 'fas fa-hyphen',
					],
					defaultOption: 'far fa-hyphen',
					keywords: 'hyphen minus dash horizontal rule line minus hyphen',
				},
				{
					className: 'far fa-less-than',
					options: [
						'fat fa-less-than', 'fal fa-less-than', 'far fa-less-than', 'fas fa-less-than',
					],
					defaultOption: 'far fa-less-than',
					keywords: 'less than sign arithmetic compare math less-than',
				},
				{
					className: 'far fa-minus',
					options: [
						'fat fa-minus', 'fal fa-minus', 'far fa-minus', 'fas fa-minus',
					],
					defaultOption: 'far fa-minus',
					keywords: 'en dash minus sign collapse delete hide math minify minus negative remove sign trash ? minus',
				},
				{
					className: 'far fa-option',
					options: [
						'fat fa-option', 'fal fa-option', 'far fa-option', 'fas fa-option',
					],
					defaultOption: 'far fa-option',
					keywords: 'alt alternate option',
				},
				{
					className: 'far fa-percent',
					options: [
						'fat fa-percent', 'fal fa-percent', 'far fa-percent', 'fas fa-percent',
					],
					defaultOption: 'far fa-percent',
					keywords: 'percent sign discount fraction proportion rate ratio percent',
				},
				{
					className: 'far fa-period',
					options: [
						'fat fa-period', 'fal fa-period', 'far fa-period', 'fas fa-period',
					],
					defaultOption: 'far fa-period',
					keywords: 'full stop circle dot end stop period',
				},
				{
					className: 'far fa-pipe',
					options: [
						'fat fa-pipe', 'fal fa-pipe', 'far fa-pipe', 'fas fa-pipe',
					],
					defaultOption: 'far fa-pipe',
					keywords: 'vertical line divider input line pipe',
				},
				{
					className: 'far fa-plus',
					options: [
						'fat fa-plus', 'fal fa-plus', 'far fa-plus', 'fas fa-plus',
					],
					defaultOption: 'far fa-plus',
					keywords: '0 plus sign add create expand math new plus positive shape sign plus',
				},
				{
					className: 'far fa-question',
					options: [
						'fat fa-question', 'fal fa-question', 'far fa-question', 'fas fa-question',
					],
					defaultOption: 'far fa-question',
					keywords: '? question mark help information mark outlined punctuation question red question mark support unknown white question mark question',
				},
				{
					className: 'far fa-quote-left',
					options: [
						'fat fa-quote-left', 'fal fa-quote-left', 'far fa-quote-left', 'fas fa-quote-left',
					],
					defaultOption: 'far fa-quote-left',
					keywords: 'left double quotation mark mention note phrase text type quote left',
				},
				{
					className: 'far fa-quote-right',
					options: [
						'fat fa-quote-right', 'fal fa-quote-right', 'far fa-quote-right', 'fas fa-quote-right',
					],
					defaultOption: 'far fa-quote-right',
					keywords: 'right double quotation mark mention note phrase text type quote right',
				},
				{
					className: 'far fa-quotes',
					options: [
						'fat fa-quotes', 'fal fa-quotes', 'far fa-quotes', 'fas fa-quotes',
					],
					defaultOption: 'far fa-quotes',
					keywords: 'cite quotation quote quotes',
				},
				{
					className: 'far fa-section',
					options: [
						'fat fa-section', 'fal fa-section', 'far fa-section', 'fas fa-section',
					],
					defaultOption: 'far fa-section',
					keywords: 'section sign law legal silcrow section',
				},
				{
					className: 'far fa-semicolon',
					options: [
						'fat fa-semicolon', 'fal fa-semicolon', 'far fa-semicolon', 'fas fa-semicolon',
					],
					defaultOption: 'far fa-semicolon',
					keywords: 'semicolon semicolon semicolon',
				},
				{
					className: 'far fa-slash-back',
					options: [
						'fat fa-slash-back', 'fal fa-slash-back', 'far fa-slash-back', 'fas fa-slash-back',
					],
					defaultOption: 'far fa-slash-back',
					keywords: 'reverse solidus cancel remove slash back',
				},
				{
					className: 'far fa-slash-forward',
					options: [
						'fat fa-slash-forward', 'fal fa-slash-forward', 'far fa-slash-forward', 'fas fa-slash-forward',
					],
					defaultOption: 'far fa-slash-forward',
					keywords: 'division slash solidus divide fraction slash forward',
				},
				{
					className: 'far fa-square-ampersand',
					options: [
						'fat fa-square-ampersand', 'fal fa-square-ampersand', 'far fa-square-ampersand', 'fas fa-square-ampersand',
					],
					defaultOption: 'far fa-square-ampersand',
					keywords: 'and square ampersand',
				},
				{
					className: 'far fa-square-question',
					options: [
						'fat fa-square-question', 'fal fa-square-question', 'far fa-square-question', 'fas fa-square-question',
					],
					defaultOption: 'far fa-square-question',
					keywords: 'help information support unknown square question',
				},
				{
					className: 'far fa-square-quote',
					options: [
						'fat fa-square-quote', 'fal fa-square-quote', 'far fa-square-quote', 'fas fa-square-quote',
					],
					defaultOption: 'far fa-square-quote',
					keywords: 'mention note text type square quote',
				},
				{
					className: 'far fa-tick',
					options: [
						'fat fa-tick', 'fal fa-tick', 'far fa-tick', 'fas fa-tick',
					],
					defaultOption: 'far fa-tick',
					keywords: 'apostrophe foot tick',
				},
				{
					className: 'far fa-tilde',
					options: [
						'fat fa-tilde', 'fal fa-tilde', 'far fa-tilde', 'fas fa-tilde',
					],
					defaultOption: 'far fa-tilde',
					keywords: 'tilde accent symbol text type tilde',
				},
			],
		},
		{
			id: 'religion',
			name: Loc.getMessage('LANDING_ICONS_SECTION_RELIGION'),
			items: [
				{
					className: 'far fa-ankh',
					options: [
						'fat fa-ankh', 'fal fa-ankh', 'far fa-ankh', 'fas fa-ankh',
					],
					defaultOption: 'far fa-ankh',
					keywords: 'ankh amulet copper coptic christianity copts crux ansata egypt venus ankh',
				},
				{
					className: 'far fa-atom',
					options: [
						'fat fa-atom', 'fal fa-atom', 'far fa-atom', 'fas fa-atom',
					],
					defaultOption: 'far fa-atom',
					keywords: 'atheism atheist atom atom symbol chemistry electron ion isotope neutron nuclear proton science atom',
				},
				{
					className: 'far fa-bahai',
					options: [
						'fat fa-bahai', 'fal fa-bahai', 'far fa-bahai', 'fas fa-bahai',
					],
					defaultOption: 'far fa-bahai',
					keywords: 'bahai star bahai',
				},
				{
					className: 'far fa-book-bible',
					options: [
						'fat fa-book-bible', 'fal fa-book-bible', 'far fa-book-bible', 'fas fa-book-bible',
					],
					defaultOption: 'far fa-book-bible',
					keywords: 'book catholicism christianity god holy book bible',
				},
				{
					className: 'far fa-book-journal-whills',
					options: [
						'fat fa-book-journal-whills', 'fal fa-book-journal-whills', 'far fa-book-journal-whills', 'fas fa-book-journal-whills',
					],
					defaultOption: 'far fa-book-journal-whills',
					keywords: 'book force jedi sith star wars yoda book journal-whills',
				},
				{
					className: 'far fa-book-quran',
					options: [
						'fat fa-book-quran', 'fal fa-book-quran', 'far fa-book-quran', 'fas fa-book-quran',
					],
					defaultOption: 'far fa-book-quran',
					keywords: 'book islam muslim religion book quran',
				},
				{
					className: 'far fa-book-tanakh',
					options: [
						'fat fa-book-tanakh', 'fal fa-book-tanakh', 'far fa-book-tanakh', 'fas fa-book-tanakh',
					],
					defaultOption: 'far fa-book-tanakh',
					keywords: 'book jewish judaism religion book tanakh',
				},
				{
					className: 'far fa-church',
					options: [
						'fat fa-church', 'fal fa-church', 'far fa-church', 'fas fa-church',
					],
					defaultOption: 'far fa-church',
					keywords: 'christian building cathedral chapel church community cross religion church',
				},
				{
					className: 'far fa-coffin-cross',
					options: [
						'fat fa-coffin-cross', 'fal fa-coffin-cross', 'far fa-coffin-cross', 'fas fa-coffin-cross',
					],
					defaultOption: 'far fa-coffin-cross',
					keywords: 'box burial casket catholicism cemetery christianity death eulogy funeral halloween vampire coffin cross',
				},
				{
					className: 'far fa-cross',
					options: [
						'fat fa-cross', 'fal fa-cross', 'far fa-cross', 'fas fa-cross',
					],
					defaultOption: 'far fa-cross',
					keywords: 'christian heavy latin cross catholicism christianity church cross jesus latin cross religion cross',
				},
				{
					className: 'far fa-dharmachakra',
					options: [
						'fat fa-dharmachakra', 'fal fa-dharmachakra', 'far fa-dharmachakra', 'fas fa-dharmachakra',
					],
					defaultOption: 'far fa-dharmachakra',
					keywords: 'buddhist buddhism buddhist dharma religion wheel wheel of dharma dharmachakra',
				},
				{
					className: 'far fa-dove',
					options: [
						'fat fa-dove', 'fal fa-dove', 'far fa-dove', 'fas fa-dove',
					],
					defaultOption: 'far fa-dove',
					keywords: 'bird dove fauna fly flying peace war dove',
				},
				{
					className: 'far fa-gopuram',
					options: [
						'fat fa-gopuram', 'fal fa-gopuram', 'far fa-gopuram', 'fas fa-gopuram',
					],
					defaultOption: 'far fa-gopuram',
					keywords: 'building entrance hinduism temple tower gopuram',
				},
				{
					className: 'far fa-hamsa',
					options: [
						'fat fa-hamsa', 'fal fa-hamsa', 'far fa-hamsa', 'fas fa-hamsa',
					],
					defaultOption: 'far fa-hamsa',
					keywords: 'amulet christianity islam jewish judaism muslim protection hamsa',
				},
				{
					className: 'far fa-hands-praying',
					options: [
						'fat fa-hands-praying', 'fal fa-hands-praying', 'far fa-hands-praying', 'fas fa-hands-praying',
					],
					defaultOption: 'far fa-hands-praying',
					keywords: 'kneel preach religion worship hands praying',
				},
				{
					className: 'far fa-hanukiah',
					options: [
						'fat fa-hanukiah', 'fal fa-hanukiah', 'far fa-hanukiah', 'fas fa-hanukiah',
					],
					defaultOption: 'far fa-hanukiah',
					keywords: 'candelabrum candle candlestick hanukkah jewish judaism light menorah religion hanukiah',
				},
				{
					className: 'far fa-jedi',
					options: [
						'fat fa-jedi', 'fal fa-jedi', 'far fa-jedi', 'fas fa-jedi',
					],
					defaultOption: 'far fa-jedi',
					keywords: 'crest force sith skywalker star wars yoda jedi',
				},
				{
					className: 'far fa-kaaba',
					options: [
						'fat fa-kaaba', 'fal fa-kaaba', 'far fa-kaaba', 'fas fa-kaaba',
					],
					defaultOption: 'far fa-kaaba',
					keywords: 'muslim building cube islam kaaba muslim religion kaaba',
				},
				{
					className: 'far fa-khanda',
					options: [
						'fat fa-khanda', 'fal fa-khanda', 'far fa-khanda', 'fas fa-khanda',
					],
					defaultOption: 'far fa-khanda',
					keywords: 'adi shakti chakkar sikh sikhism sword khanda',
				},
				{
					className: 'far fa-menorah',
					options: [
						'fat fa-menorah', 'fal fa-menorah', 'far fa-menorah', 'fas fa-menorah',
					],
					defaultOption: 'far fa-menorah',
					keywords: 'candle hanukkah jewish judaism light menorah',
				},
				{
					className: 'far fa-mosque',
					options: [
						'fat fa-mosque', 'fal fa-mosque', 'far fa-mosque', 'fas fa-mosque',
					],
					defaultOption: 'far fa-mosque',
					keywords: 'muslim building islam landmark mosque muslim religion mosque',
				},
				{
					className: 'far fa-om',
					options: [
						'fat fa-om', 'fal fa-om', 'far fa-om', 'fas fa-om',
					],
					defaultOption: 'far fa-om',
					keywords: 'hindu buddhism hinduism jainism mantra om religion om',
				},
				{
					className: 'far fa-peace',
					options: [
						'fat fa-peace', 'fal fa-peace', 'far fa-peace', 'fas fa-peace',
					],
					defaultOption: 'far fa-peace',
					keywords: 'peace peace symbol serenity tranquility truce war peace',
				},
				{
					className: 'far fa-person-praying',
					options: [
						'fat fa-person-praying', 'fal fa-person-praying', 'far fa-person-praying', 'fas fa-person-praying',
					],
					defaultOption: 'far fa-person-praying',
					keywords: 'kneel place of worship religion thank worship person praying',
				},
				{
					className: 'far fa-place-of-worship',
					options: [
						'fat fa-place-of-worship', 'fal fa-place-of-worship', 'far fa-place-of-worship', 'fas fa-place-of-worship',
					],
					defaultOption: 'far fa-place-of-worship',
					keywords: 'building church holy mosque synagogue place of-worship',
				},
				{
					className: 'far fa-scroll-torah',
					options: [
						'fat fa-scroll-torah', 'fal fa-scroll-torah', 'far fa-scroll-torah', 'fas fa-scroll-torah',
					],
					defaultOption: 'far fa-scroll-torah',
					keywords: 'book jewish judaism religion scroll scroll torah',
				},
				{
					className: 'far fa-spaghetti-monster-flying',
					options: [
						'fat fa-spaghetti-monster-flying', 'fal fa-spaghetti-monster-flying', 'far fa-spaghetti-monster-flying', 'fas fa-spaghetti-monster-flying',
					],
					defaultOption: 'far fa-spaghetti-monster-flying',
					keywords: 'agnosticism atheism flying spaghetti monster fsm spaghetti monster-flying',
				},
				{
					className: 'far fa-star-and-crescent',
					options: [
						'fat fa-star-and-crescent', 'fal fa-star-and-crescent', 'far fa-star-and-crescent', 'fas fa-star-and-crescent',
					],
					defaultOption: 'far fa-star-and-crescent',
					keywords: 'muslim islam muslim religion star and crescent star and-crescent',
				},
				{
					className: 'far fa-star-of-david',
					options: [
						'fat fa-star-of-david', 'fal fa-star-of-david', 'far fa-star-of-david', 'fas fa-star-of-david',
					],
					defaultOption: 'far fa-star-of-david',
					keywords: 'david jew jewish jewish judaism religion star star of david star of-david',
				},
				{
					className: 'far fa-synagogue',
					options: [
						'fat fa-synagogue', 'fal fa-synagogue', 'far fa-synagogue', 'fas fa-synagogue',
					],
					defaultOption: 'far fa-synagogue',
					keywords: 'jew jewish building jewish judaism religion star of david synagogue temple synagogue',
				},
				{
					className: 'far fa-torii-gate',
					options: [
						'fat fa-torii-gate', 'fal fa-torii-gate', 'far fa-torii-gate', 'fas fa-torii-gate',
					],
					defaultOption: 'far fa-torii-gate',
					keywords: 'building religion shinto shinto shrine shintoism shrine torii gate',
				},
				{
					className: 'far fa-vihara',
					options: [
						'fat fa-vihara', 'fal fa-vihara', 'far fa-vihara', 'fas fa-vihara',
					],
					defaultOption: 'far fa-vihara',
					keywords: 'buddhism buddhist building monastery vihara',
				},
				{
					className: 'far fa-yin-yang',
					options: [
						'fat fa-yin-yang', 'fal fa-yin-yang', 'far fa-yin-yang', 'fas fa-yin-yang',
					],
					defaultOption: 'far fa-yin-yang',
					keywords: 'daoism opposites religion tao taoism taoist yang yin yin yang yin yang',
				},
			],
		},
		{
			id: 'science',
			name: Loc.getMessage('LANDING_ICONS_SECTION_SCIENCE'),
			items: [
				{
					className: 'far fa-atom',
					options: [
						'fat fa-atom', 'fal fa-atom', 'far fa-atom', 'fas fa-atom',
					],
					defaultOption: 'far fa-atom',
					keywords: 'atheism atheist atom atom symbol chemistry electron ion isotope neutron nuclear proton science atom',
				},
				{
					className: 'far fa-atom-simple',
					options: [
						'fat fa-atom-simple', 'fal fa-atom-simple', 'far fa-atom-simple', 'fas fa-atom-simple',
					],
					defaultOption: 'far fa-atom-simple',
					keywords: 'atheism chemistry electron ion isotope neutron nuclear proton science space atom simple',
				},
				{
					className: 'far fa-biohazard',
					options: [
						'fat fa-biohazard', 'fal fa-biohazard', 'far fa-biohazard', 'fas fa-biohazard',
					],
					defaultOption: 'far fa-biohazard',
					keywords: 'biohazard covid 19 danger dangerous hazmat medical radioactive sign toxic waste zombie biohazard',
				},
				{
					className: 'far fa-book-sparkles',
					options: [
						'fat fa-book-sparkles', 'fal fa-book-sparkles', 'far fa-book-sparkles', 'fas fa-book-sparkles',
					],
					defaultOption: 'far fa-book-sparkles',
					keywords: 'dungeons & dragons d&d dark arts dnd documentation evil fantasy halloween holiday library mage magic read research sorcery voodoo witch wizard book sparkles',
				},
				{
					className: 'far fa-brain',
					options: [
						'fat fa-brain', 'fal fa-brain', 'far fa-brain', 'fas fa-brain',
					],
					defaultOption: 'far fa-brain',
					keywords: 'brain cerebellum gray matter intellect intelligent medulla oblongata mind noodle wit brain',
				},
				{
					className: 'far fa-capsules',
					options: [
						'fat fa-capsules', 'fal fa-capsules', 'far fa-capsules', 'fas fa-capsules',
					],
					defaultOption: 'far fa-capsules',
					keywords: 'drugs medicine pills prescription capsules',
				},
				{
					className: 'far fa-cauldron',
					options: [
						'fat fa-cauldron', 'fal fa-cauldron', 'far fa-cauldron', 'fas fa-cauldron',
					],
					defaultOption: 'far fa-cauldron',
					keywords: 'boil bubble cooking halloween holiday magic pot sorcery toil trouble witch wizard cauldron',
				},
				{
					className: 'far fa-chart-mixed',
					options: [
						'fat fa-chart-mixed', 'fal fa-chart-mixed', 'far fa-chart-mixed', 'fas fa-chart-mixed',
					],
					defaultOption: 'far fa-chart-mixed',
					keywords: 'chart measure roi tracking trend chart mixed',
				},
				{
					className: 'far fa-chart-network',
					options: [
						'fat fa-chart-network', 'fal fa-chart-network', 'far fa-chart-network', 'fas fa-chart-network',
					],
					defaultOption: 'far fa-chart-network',
					keywords: 'activity analytics association dashboard diagram distribution map network chart network',
				},
				{
					className: 'far fa-chart-scatter',
					options: [
						'fat fa-chart-scatter', 'fal fa-chart-scatter', 'far fa-chart-scatter', 'fas fa-chart-scatter',
					],
					defaultOption: 'far fa-chart-scatter',
					keywords: 'analytics chart diagram graph plot chart scatter',
				},
				{
					className: 'far fa-circle-radiation',
					options: [
						'fat fa-circle-radiation', 'fal fa-circle-radiation', 'far fa-circle-radiation', 'fas fa-circle-radiation',
					],
					defaultOption: 'far fa-circle-radiation',
					keywords: 'danger dangerous deadly hazard nuclear radioactive sign warning circle radiation',
				},
				{
					className: 'far fa-clipboard-check',
					options: [
						'fat fa-clipboard-check', 'fal fa-clipboard-check', 'far fa-clipboard-check', 'fas fa-clipboard-check',
					],
					defaultOption: 'far fa-clipboard-check',
					keywords: 'accept agree confirm done ok select success tick todo yes clipboard check',
				},
				{
					className: 'far fa-disease',
					options: [
						'fat fa-disease', 'fal fa-disease', 'far fa-disease', 'fas fa-disease',
					],
					defaultOption: 'far fa-disease',
					keywords: 'bacteria cancer covid 19 illness infection sickness virus disease',
				},
				{
					className: 'far fa-dna',
					options: [
						'fat fa-dna', 'fal fa-dna', 'far fa-dna', 'fas fa-dna',
					],
					defaultOption: 'far fa-dna',
					keywords: 'biologist dna double helix evolution gene genetic genetics helix life molecule protein dna',
				},
				{
					className: 'far fa-eye-dropper',
					options: [
						'fat fa-eye-dropper', 'fal fa-eye-dropper', 'far fa-eye-dropper', 'fas fa-eye-dropper',
					],
					defaultOption: 'far fa-eye-dropper',
					keywords: 'beaker clone color copy eyedropper pipette eye dropper',
				},
				{
					className: 'far fa-filter',
					options: [
						'fat fa-filter', 'fal fa-filter', 'far fa-filter', 'fas fa-filter',
					],
					defaultOption: 'far fa-filter',
					keywords: 'funnel options separate sort filter',
				},
				{
					className: 'far fa-fire',
					options: [
						'fat fa-fire', 'fal fa-fire', 'far fa-fire', 'fas fa-fire',
					],
					defaultOption: 'far fa-fire',
					keywords: 'burn caliente fire flame heat hot popular tool fire',
				},
				{
					className: 'far fa-fire-flame-curved',
					options: [
						'fat fa-fire-flame-curved', 'fal fa-fire-flame-curved', 'far fa-fire-flame-curved', 'fas fa-fire-flame-curved',
					],
					defaultOption: 'far fa-fire-flame-curved',
					keywords: 'burn caliente flame heat hot popular fire flame-curved',
				},
				{
					className: 'far fa-fire-flame-simple',
					options: [
						'fat fa-fire-flame-simple', 'fal fa-fire-flame-simple', 'far fa-fire-flame-simple', 'fas fa-fire-flame-simple',
					],
					defaultOption: 'far fa-fire-flame-simple',
					keywords: 'caliente energy fire flame gas heat hot fire flame-simple',
				},
				{
					className: 'far fa-flask',
					options: [
						'fat fa-flask', 'fal fa-flask', 'far fa-flask', 'fas fa-flask',
					],
					defaultOption: 'far fa-flask',
					keywords: 'beaker experimental labs science flask',
				},
				{
					className: 'far fa-flask-round-poison',
					options: [
						'fat fa-flask-round-poison', 'fal fa-flask-round-poison', 'far fa-flask-round-poison', 'fas fa-flask-round-poison',
					],
					defaultOption: 'far fa-flask-round-poison',
					keywords: 'beverage container drink halloween health holiday power flask round-poison',
				},
				{
					className: 'far fa-flask-round-potion',
					options: [
						'fat fa-flask-round-potion', 'fal fa-flask-round-potion', 'far fa-flask-round-potion', 'fas fa-flask-round-potion',
					],
					defaultOption: 'far fa-flask-round-potion',
					keywords: 'dungeons & dragons alert beaker beverage container d&d danger dangerous deadly death dnd drink fantasy halloween heal health holiday magic mana science flask round-potion',
				},
				{
					className: 'far fa-frog',
					options: [
						'fat fa-frog', 'fal fa-frog', 'far fa-frog', 'fas fa-frog',
					],
					defaultOption: 'far fa-frog',
					keywords: 'amphibian bullfrog fauna hop kermit kiss prince ribbit toad wart frog',
				},
				{
					className: 'far fa-head-side-brain',
					options: [
						'fat fa-head-side-brain', 'fal fa-head-side-brain', 'far fa-head-side-brain', 'fas fa-head-side-brain',
					],
					defaultOption: 'far fa-head-side-brain',
					keywords: 'diagnosis face mental health profile psychiatric psychiatry head side-brain',
				},
				{
					className: 'far fa-key-skeleton',
					options: [
						'fat fa-key-skeleton', 'fal fa-key-skeleton', 'far fa-key-skeleton', 'fas fa-key-skeleton',
					],
					defaultOption: 'far fa-key-skeleton',
					keywords: 'clue halloween key lock old old key password private secret unlock key skeleton',
				},
				{
					className: 'far fa-kite',
					options: [
						'fat fa-kite', 'fal fa-kite', 'far fa-kite', 'fas fa-kite',
					],
					defaultOption: 'far fa-kite',
					keywords: 'air benjamin fall fly flying franklin kite outdoors seasonal sky soar wind kite',
				},
				{
					className: 'far fa-magnet',
					options: [
						'fat fa-magnet', 'fal fa-magnet', 'far fa-magnet', 'fas fa-magnet',
					],
					defaultOption: 'far fa-magnet',
					keywords: 'attract attraction horseshoe lodestone magnet magnetic tool magnet',
				},
				{
					className: 'far fa-microscope',
					options: [
						'fat fa-microscope', 'fal fa-microscope', 'far fa-microscope', 'fas fa-microscope',
					],
					defaultOption: 'far fa-microscope',
					keywords: 'covid 19 electron lens microscope optics science shrink tool microscope',
				},
				{
					className: 'far fa-mortar-pestle',
					options: [
						'fat fa-mortar-pestle', 'fal fa-mortar-pestle', 'far fa-mortar-pestle', 'fas fa-mortar-pestle',
					],
					defaultOption: 'far fa-mortar-pestle',
					keywords: 'crush culinary grind medical mix pharmacy prescription spices mortar pestle',
				},
				{
					className: 'far fa-pills',
					options: [
						'fat fa-pills', 'fal fa-pills', 'far fa-pills', 'fas fa-pills',
					],
					defaultOption: 'far fa-pills',
					keywords: 'drugs medicine prescription tablets pills',
				},
				{
					className: 'far fa-prescription-bottle',
					options: [
						'fat fa-prescription-bottle', 'fal fa-prescription-bottle', 'far fa-prescription-bottle', 'fas fa-prescription-bottle',
					],
					defaultOption: 'far fa-prescription-bottle',
					keywords: 'drugs medical medicine pharmacy rx prescription bottle',
				},
				{
					className: 'far fa-radiation',
					options: [
						'fat fa-radiation', 'fal fa-radiation', 'far fa-radiation', 'fas fa-radiation',
					],
					defaultOption: 'far fa-radiation',
					keywords: 'danger dangerous deadly hazard nuclear radioactive warning radiation',
				},
				{
					className: 'far fa-seedling',
					options: [
						'fat fa-seedling', 'fal fa-seedling', 'far fa-seedling', 'fas fa-seedling',
					],
					defaultOption: 'far fa-seedling',
					keywords: 'flora grow plant seedling vegan young seedling',
				},
				{
					className: 'far fa-skull-crossbones',
					options: [
						'fat fa-skull-crossbones', 'fal fa-skull-crossbones', 'far fa-skull-crossbones', 'fas fa-skull-crossbones',
					],
					defaultOption: 'far fa-skull-crossbones',
					keywords: 'black skull and crossbones dungeons & dragons alert bones crossbones d&d danger dead deadly death dnd face fantasy halloween holiday jolly roger monster pirate poison skeleton skull skull and crossbones warning skull-crossbones',
				},
				{
					className: 'far fa-syringe',
					options: [
						'fat fa-syringe', 'fal fa-syringe', 'far fa-syringe', 'fas fa-syringe',
					],
					defaultOption: 'far fa-syringe',
					keywords: 'covid 19 doctor immunizations medical medicine needle shot sick syringe syringe',
				},
				{
					className: 'far fa-tablets',
					options: [
						'fat fa-tablets', 'fal fa-tablets', 'far fa-tablets', 'fas fa-tablets',
					],
					defaultOption: 'far fa-tablets',
					keywords: 'drugs medicine pills prescription tablets',
				},
				{
					className: 'far fa-tally',
					options: [
						'fat fa-tally', 'fal fa-tally', 'far fa-tally', 'fas fa-tally',
					],
					defaultOption: 'far fa-tally',
					keywords: 'count hash numbers tally',
				},
				{
					className: 'far fa-temperature-high',
					options: [
						'fat fa-temperature-high', 'fal fa-temperature-high', 'far fa-temperature-high', 'fas fa-temperature-high',
					],
					defaultOption: 'far fa-temperature-high',
					keywords: 'cook covid 19 mercury summer thermometer warm temperature-high',
				},
				{
					className: 'far fa-temperature-low',
					options: [
						'fat fa-temperature-low', 'fal fa-temperature-low', 'far fa-temperature-low', 'fas fa-temperature-low',
					],
					defaultOption: 'far fa-temperature-low',
					keywords: 'cold cool covid 19 mercury thermometer winter temperature-low',
				},
				{
					className: 'far fa-vial',
					options: [
						'fat fa-vial', 'fal fa-vial', 'far fa-vial', 'fas fa-vial',
					],
					defaultOption: 'far fa-vial',
					keywords: 'chemist chemistry experiment lab sample science test test tube vial',
				},
				{
					className: 'far fa-vials',
					options: [
						'fat fa-vials', 'fal fa-vials', 'far fa-vials', 'fas fa-vials',
					],
					defaultOption: 'far fa-vials',
					keywords: 'experiment lab sample science test test tube vials',
				},
			],
		},
		{
			id: 'science-fiction',
			name: Loc.getMessage('LANDING_ICONS_SECTION_SCIENCE_FICTION'),
			items: [
				{
					className: 'far fa-alien',
					options: [
						'fat fa-alien', 'fal fa-alien', 'far fa-alien', 'fas fa-alien',
					],
					defaultOption: 'far fa-alien',
					keywords: 'et alien creature extraterrestrial face fantasy humanoid monster space strange ufo alien',
				},
				{
					className: 'far fa-alien-8bit',
					options: [
						'fat fa-alien-8bit', 'fal fa-alien-8bit', 'far fa-alien-8bit', 'fas fa-alien-8bit',
					],
					defaultOption: 'far fa-alien-8bit',
					keywords: 'et alien alien monster creature extraterrestrial face humanoid monster space space invader strange ufo video game alien 8bit',
				},
				{
					className: 'far fa-atom',
					options: [
						'fat fa-atom', 'fal fa-atom', 'far fa-atom', 'fas fa-atom',
					],
					defaultOption: 'far fa-atom',
					keywords: 'atheism atheist atom atom symbol chemistry electron ion isotope neutron nuclear proton science atom',
				},
				{
					className: 'far fa-atom-simple',
					options: [
						'fat fa-atom-simple', 'fal fa-atom-simple', 'far fa-atom-simple', 'fas fa-atom-simple',
					],
					defaultOption: 'far fa-atom-simple',
					keywords: 'atheism chemistry electron ion isotope neutron nuclear proton science space atom simple',
				},
				{
					className: 'far fa-book-journal-whills',
					options: [
						'fat fa-book-journal-whills', 'fal fa-book-journal-whills', 'far fa-book-journal-whills', 'fas fa-book-journal-whills',
					],
					defaultOption: 'far fa-book-journal-whills',
					keywords: 'book force jedi sith star wars yoda book journal whills',
				},
				{
					className: 'far fa-cat-space',
					options: [
						'fat fa-cat-space', 'fal fa-cat-space', 'far fa-cat-space', 'fas fa-cat-space',
					],
					defaultOption: 'far fa-cat-space',
					keywords: 'animal astronaut cosmonaut fauna meow space cat space',
				},
				{
					className: 'far fa-drone',
					options: [
						'fat fa-drone', 'fal fa-drone', 'far fa-drone', 'fas fa-drone',
					],
					defaultOption: 'far fa-drone',
					keywords: 'aerial big brother surveillance uav unmanned vehicle drone',
				},
				{
					className: 'far fa-drone-front',
					options: [
						'fat fa-drone-front', 'fal fa-drone-front', 'far fa-drone-front', 'fas fa-drone-front',
					],
					defaultOption: 'far fa-drone-front',
					keywords: 'aerial big brother surveillance uav unmanned vehicle drone front',
				},
				{
					className: 'far fa-flux-capacitor',
					options: [
						'fat fa-flux-capacitor', 'fal fa-flux-capacitor', 'far fa-flux-capacitor', 'fas fa-flux-capacitor',
					],
					defaultOption: 'far fa-flux-capacitor',
					keywords: '1 21 gigawatts 88 mph emmett brown marty mcfly y back to the future delorean dmc time machine time travel flux capacitor',
				},
				{
					className: 'far fa-hand-spock',
					options: [
						'fat fa-hand-spock', 'fal fa-hand-spock', 'far fa-hand-spock', 'fas fa-hand-spock',
					],
					defaultOption: 'far fa-hand-spock',
					keywords: 'finger hand live long palm prosper salute spock star trek vulcan vulcan salute hand spock',
				},
				{
					className: 'far fa-jedi',
					options: [
						'fat fa-jedi', 'fal fa-jedi', 'far fa-jedi', 'fas fa-jedi',
					],
					defaultOption: 'far fa-jedi',
					keywords: 'crest force sith skywalker star wars yoda jedi',
				},
				{
					className: 'far fa-person-from-portal',
					options: [
						'fat fa-person-from-portal', 'fal fa-person-from-portal', 'far fa-person-from-portal', 'fas fa-person-from-portal',
					],
					defaultOption: 'far fa-person-from-portal',
					keywords: 'portal run transport travel person from portal',
				},
				{
					className: 'far fa-person-to-portal',
					options: [
						'fat fa-person-to-portal', 'fal fa-person-to-portal', 'far fa-person-to-portal', 'fas fa-person-to-portal',
					],
					defaultOption: 'far fa-person-to-portal',
					keywords: 'portal run transport travel person to portal',
				},
				{
					className: 'far fa-police-box',
					options: [
						'fat fa-police-box', 'fal fa-police-box', 'far fa-police-box', 'fas fa-police-box',
					],
					defaultOption: 'far fa-police-box',
					keywords: 'doctor who tardis time and relative dimension in space time machine time travel police box',
				},
				{
					className: 'far fa-raygun',
					options: [
						'fat fa-raygun', 'fal fa-raygun', 'far fa-raygun', 'fas fa-raygun',
					],
					defaultOption: 'far fa-raygun',
					keywords: 'flash gordon laser pew pew phaser space stun raygun',
				},
				{
					className: 'far fa-robot',
					options: [
						'fat fa-robot', 'fal fa-robot', 'far fa-robot', 'fas fa-robot',
					],
					defaultOption: 'far fa-robot',
					keywords: 'android automate computer cyborg face monster robot robot',
				},
				{
					className: 'far fa-robot-astromech',
					options: [
						'fat fa-robot-astromech', 'fal fa-robot-astromech', 'far fa-robot-astromech', 'fas fa-robot-astromech',
					],
					defaultOption: 'far fa-robot-astromech',
					keywords: 'artoo beep droid gps mechanic r2d2 star wars robot astromech',
				},
				{
					className: 'far fa-rocket',
					options: [
						'fat fa-rocket', 'fal fa-rocket', 'far fa-rocket', 'fas fa-rocket',
					],
					defaultOption: 'far fa-rocket',
					keywords: 'aircraft app jet launch nasa space rocket',
				},
				{
					className: 'far fa-rocket-launch',
					options: [
						'fat fa-rocket-launch', 'fal fa-rocket-launch', 'far fa-rocket-launch', 'fas fa-rocket-launch',
					],
					defaultOption: 'far fa-rocket-launch',
					keywords: 'aircraft app ignition jet launch nasa rocket space thrusters rocket launch',
				},
				{
					className: 'far fa-space-station-moon',
					options: [
						'fat fa-space-station-moon', 'fal fa-space-station-moon', 'far fa-space-station-moon', 'fas fa-space-station-moon',
					],
					defaultOption: 'far fa-space-station-moon',
					keywords: 'death star empire galen erso kyber crystal laser not a moon secret weapon star wars space station moon',
				},
				{
					className: 'far fa-space-station-moon-construction',
					options: [
						'fat fa-space-station-moon-construction', 'fal fa-space-station-moon-construction', 'far fa-space-station-moon-construction', 'fas fa-space-station-moon-construction',
					],
					defaultOption: 'far fa-space-station-moon-construction',
					keywords: 'death star empire kyber crystal laser not a moon star wars under construction space station moon construction',
				},
				{
					className: 'far fa-starfighter',
					options: [
						'fat fa-starfighter', 'fal fa-starfighter', 'far fa-starfighter', 'fas fa-starfighter',
					],
					defaultOption: 'far fa-starfighter',
					keywords: 'luke skywalker rebel spaceship star wars x wing starfighter',
				},
				{
					className: 'far fa-starfighter-twin-ion-engine',
					options: [
						'fat fa-starfighter-twin-ion-engine', 'fal fa-starfighter-twin-ion-engine', 'far fa-starfighter-twin-ion-engine', 'fas fa-starfighter-twin-ion-engine',
					],
					defaultOption: 'far fa-starfighter-twin-ion-engine',
					keywords: 'darth vader empire spaceship star wars tie fighter starfighter twin ion engine',
				},
				{
					className: 'far fa-starfighter-twin-ion-engine-advanced',
					options: [
						'fat fa-starfighter-twin-ion-engine-advanced', 'fal fa-starfighter-twin-ion-engine-advanced', 'far fa-starfighter-twin-ion-engine-advanced', 'fas fa-starfighter-twin-ion-engine-advanced',
					],
					defaultOption: 'far fa-starfighter-twin-ion-engine-advanced',
					keywords: 'empire tie fighter starfighter twin ion engine advanced',
				},
				{
					className: 'far fa-starship',
					options: [
						'fat fa-starship', 'fal fa-starship', 'far fa-starship', 'fas fa-starship',
					],
					defaultOption: 'far fa-starship',
					keywords: 'engage enterprise james t kirk jean luc picard make it so ncc 1701 spacecraft spaceship star trek starship',
				},
				{
					className: 'far fa-starship-freighter',
					options: [
						'fat fa-starship-freighter', 'fal fa-starship-freighter', 'far fa-starship-freighter', 'fas fa-starship-freighter',
					],
					defaultOption: 'far fa-starship-freighter',
					keywords: 'chewbacca han solo millenium falcon rebel spaceship star wars yt 1300 starship freighter',
				},
				{
					className: 'far fa-sword-laser',
					options: [
						'fat fa-sword-laser', 'fal fa-sword-laser', 'far fa-sword-laser', 'fas fa-sword-laser',
					],
					defaultOption: 'far fa-sword-laser',
					keywords: 'jedi lightsaber luke skywalker rebel star wars sword laser',
				},
				{
					className: 'far fa-sword-laser-alt',
					options: [
						'fat fa-sword-laser-alt', 'fal fa-sword-laser-alt', 'far fa-sword-laser-alt', 'fas fa-sword-laser-alt',
					],
					defaultOption: 'far fa-sword-laser-alt',
					keywords: 'darth vader empire lightsaber sith star wars sword laser alt',
				},
				{
					className: 'far fa-swords-laser',
					options: [
						'fat fa-swords-laser', 'fal fa-swords-laser', 'far fa-swords-laser', 'fas fa-swords-laser',
					],
					defaultOption: 'far fa-swords-laser',
					keywords: 'clash darth vader duel fight jedi lightsaber luke skywalker rebel sith star wars swords laser',
				},
				{
					className: 'far fa-transporter',
					options: [
						'fat fa-transporter', 'fal fa-transporter', 'far fa-transporter', 'fas fa-transporter',
					],
					defaultOption: 'far fa-transporter',
					keywords: 'move teleport transfer translocate travel transporter',
				},
				{
					className: 'far fa-transporter-1',
					options: [
						'fat fa-transporter-1', 'fal fa-transporter-1', 'far fa-transporter-1', 'fas fa-transporter-1',
					],
					defaultOption: 'far fa-transporter-1',
					keywords: 'move teleport transfer translocate travel transporter 1',
				},
				{
					className: 'far fa-transporter-2',
					options: [
						'fat fa-transporter-2', 'fal fa-transporter-2', 'far fa-transporter-2', 'fas fa-transporter-2',
					],
					defaultOption: 'far fa-transporter-2',
					keywords: 'move teleport transfer translocate travel transporter 2',
				},
				{
					className: 'far fa-transporter-3',
					options: [
						'fat fa-transporter-3', 'fal fa-transporter-3', 'far fa-transporter-3', 'fas fa-transporter-3',
					],
					defaultOption: 'far fa-transporter-3',
					keywords: 'move teleport transfer translocate travel transporter 3',
				},
				{
					className: 'far fa-transporter-4',
					options: [
						'fat fa-transporter-4', 'fal fa-transporter-4', 'far fa-transporter-4', 'fas fa-transporter-4',
					],
					defaultOption: 'far fa-transporter-4',
					keywords: 'move teleport transfer translocate travel transporter 4',
				},
				{
					className: 'far fa-transporter-5',
					options: [
						'fat fa-transporter-5', 'fal fa-transporter-5', 'far fa-transporter-5', 'fas fa-transporter-5',
					],
					defaultOption: 'far fa-transporter-5',
					keywords: 'move teleport transfer translocate travel transporter 5',
				},
				{
					className: 'far fa-transporter-6',
					options: [
						'fat fa-transporter-6', 'fal fa-transporter-6', 'far fa-transporter-6', 'fas fa-transporter-6',
					],
					defaultOption: 'far fa-transporter-6',
					keywords: 'move teleport transfer translocate travel transporter 6',
				},
				{
					className: 'far fa-transporter-7',
					options: [
						'fat fa-transporter-7', 'fal fa-transporter-7', 'far fa-transporter-7', 'fas fa-transporter-7',
					],
					defaultOption: 'far fa-transporter-7',
					keywords: 'move teleport transfer translocate travel transporter 7',
				},
				{
					className: 'far fa-transporter-empty',
					options: [
						'fat fa-transporter-empty', 'fal fa-transporter-empty', 'far fa-transporter-empty', 'fas fa-transporter-empty',
					],
					defaultOption: 'far fa-transporter-empty',
					keywords: 'complete move teleport transfer translocate travel transporter empty',
				},
				{
					className: 'far fa-ufo',
					options: [
						'fat fa-ufo', 'fal fa-ufo', 'far fa-ufo', 'fas fa-ufo',
					],
					defaultOption: 'far fa-ufo',
					keywords: 'ufo abduct alien extraterrestrial flying saucer space spacecraft spaceship t craft travel unidentified flying object ufo',
				},
				{
					className: 'far fa-ufo-beam',
					options: [
						'fat fa-ufo-beam', 'fal fa-ufo-beam', 'far fa-ufo-beam', 'fas fa-ufo-beam',
					],
					defaultOption: 'far fa-ufo-beam',
					keywords: 'abduct alien extraterrestrial flying saucer probe space spacecraft spaceship t craft tractor beam travel unidentified flying object ufo beam',
				},
				{
					className: 'far fa-user-alien',
					options: [
						'fat fa-user-alien', 'fal fa-user-alien', 'far fa-user-alien', 'fas fa-user-alien',
					],
					defaultOption: 'far fa-user-alien',
					keywords: 'et extraterrestrial humanoid monster space strange ufo user alien',
				},
				{
					className: 'far fa-user-astronaut',
					options: [
						'fat fa-user-astronaut', 'fal fa-user-astronaut', 'far fa-user-astronaut', 'fas fa-user-astronaut',
					],
					defaultOption: 'far fa-user-astronaut',
					keywords: 'avatar clothing cosmonaut nasa space suit user astronaut',
				},
				{
					className: 'far fa-user-bounty-hunter',
					options: [
						'fat fa-user-bounty-hunter', 'fal fa-user-bounty-hunter', 'far fa-user-bounty-hunter', 'fas fa-user-bounty-hunter',
					],
					defaultOption: 'far fa-user-bounty-hunter',
					keywords: 'beskar boba fett jango fett mando mandolorian star wars user bounty hunter',
				},
				{
					className: 'far fa-user-hair-buns',
					options: [
						'fat fa-user-hair-buns', 'fal fa-user-hair-buns', 'far fa-user-hair-buns', 'fas fa-user-hair-buns',
					],
					defaultOption: 'far fa-user-hair-buns',
					keywords: 'hairstyle leia organa princess rebel skywalker star wars user hair buns',
				},
				{
					className: 'far fa-user-robot',
					options: [
						'fat fa-user-robot', 'fal fa-user-robot', 'far fa-user-robot', 'fas fa-user-robot',
					],
					defaultOption: 'far fa-user-robot',
					keywords: 'android automate computer cyborg rosie user robot',
				},
				{
					className: 'far fa-user-visor',
					options: [
						'fat fa-user-visor', 'fal fa-user-visor', 'far fa-user-visor', 'fas fa-user-visor',
					],
					defaultOption: 'far fa-user-visor',
					keywords: 'geordi la forge star trek user visor',
				},
				{
					className: 'far fa-watch-calculator',
					options: [
						'fat fa-watch-calculator', 'fal fa-watch-calculator', 'far fa-watch-calculator', 'fas fa-watch-calculator',
					],
					defaultOption: 'far fa-watch-calculator',
					keywords: 'casio digital math time watch calculator',
				},
			],
		},
		{
			id: 'security',
			name: Loc.getMessage('LANDING_ICONS_SECTION_SECURITY'),
			items: [
				{
					className: 'far fa-badge-sheriff',
					options: [
						'fat fa-badge-sheriff', 'fal fa-badge-sheriff', 'far fa-badge-sheriff', 'fas fa-badge-sheriff',
					],
					defaultOption: 'far fa-badge-sheriff',
					keywords: 'cowboy justice law old west western badge sheriff',
				},
				{
					className: 'far fa-ban',
					options: [
						'fat fa-ban', 'fal fa-ban', 'far fa-ban', 'fas fa-ban',
					],
					defaultOption: 'far fa-ban',
					keywords: 'abort ban block cancel delete entry forbidden hide no not prohibit prohibited remove stop trash ban',
				},
				{
					className: 'far fa-ban-bug',
					options: [
						'fat fa-ban-bug', 'fal fa-ban-bug', 'far fa-ban-bug', 'fas fa-ban-bug',
					],
					defaultOption: 'far fa-ban-bug',
					keywords: 'error fix optimize warning ban bug',
				},
				{
					className: 'far fa-blanket-fire',
					options: [
						'fat fa-blanket-fire', 'fal fa-blanket-fire', 'far fa-blanket-fire', 'fas fa-blanket-fire',
					],
					defaultOption: 'far fa-blanket-fire',
					keywords: 'fire flammable safety blanket fire',
				},
				{
					className: 'far fa-block-brick-fire',
					options: [
						'fat fa-block-brick-fire', 'fal fa-block-brick-fire', 'far fa-block-brick-fire', 'fas fa-block-brick-fire',
					],
					defaultOption: 'far fa-block-brick-fire',
					keywords: 'brick fire firewall network wall block brick-fire',
				},
				{
					className: 'far fa-book-section',
					options: [
						'fat fa-book-section', 'fal fa-book-section', 'far fa-book-section', 'fas fa-book-section',
					],
					defaultOption: 'far fa-book-section',
					keywords: 'law legal library research silcrow book section',
				},
				{
					className: 'far fa-bug',
					options: [
						'fat fa-bug', 'fal fa-bug', 'far fa-bug', 'fas fa-bug',
					],
					defaultOption: 'far fa-bug',
					keywords: 'beetle error insect report bug',
				},
				{
					className: 'far fa-camera-cctv',
					options: [
						'fat fa-camera-cctv', 'fal fa-camera-cctv', 'far fa-camera-cctv', 'fas fa-camera-cctv',
					],
					defaultOption: 'far fa-camera-cctv',
					keywords: '1984 big brother george orwell camera security surveillance video camera cctv',
				},
				{
					className: 'far fa-diamond-exclamation',
					options: [
						'fat fa-diamond-exclamation', 'fal fa-diamond-exclamation', 'far fa-diamond-exclamation', 'fas fa-diamond-exclamation',
					],
					defaultOption: 'far fa-diamond-exclamation',
					keywords: 'caution danger warning diamond exclamation',
				},
				{
					className: 'far fa-do-not-enter',
					options: [
						'fat fa-do-not-enter', 'fal fa-do-not-enter', 'far fa-do-not-enter', 'fas fa-do-not-enter',
					],
					defaultOption: 'far fa-do-not-enter',
					keywords: 'closed traffic warning do not-enter',
				},
				{
					className: 'far fa-door-closed',
					options: [
						'fat fa-door-closed', 'fal fa-door-closed', 'far fa-door-closed', 'fas fa-door-closed',
					],
					defaultOption: 'far fa-door-closed',
					keywords: 'doo door enter exit locked door closed',
				},
				{
					className: 'far fa-door-open',
					options: [
						'fat fa-door-open', 'fal fa-door-open', 'far fa-door-open', 'fas fa-door-open',
					],
					defaultOption: 'far fa-door-open',
					keywords: 'enter exit welcome door open',
				},
				{
					className: 'far fa-dungeon',
					options: [
						'fat fa-dungeon', 'fal fa-dungeon', 'far fa-dungeon', 'fas fa-dungeon',
					],
					defaultOption: 'far fa-dungeon',
					keywords: 'dungeons & dragons building d&d dnd door entrance fantasy gate dungeon',
				},
				{
					className: 'far fa-eye',
					options: [
						'fat fa-eye', 'fal fa-eye', 'far fa-eye', 'fas fa-eye',
					],
					defaultOption: 'far fa-eye',
					keywords: 'body eye look optic see seen show sight views visible eye',
				},
				{
					className: 'far fa-eye-slash',
					options: [
						'fat fa-eye-slash', 'fal fa-eye-slash', 'far fa-eye-slash', 'fas fa-eye-slash',
					],
					defaultOption: 'far fa-eye-slash',
					keywords: 'blind hide show toggle unseen views visible visiblity eye slash',
				},
				{
					className: 'far fa-face-viewfinder',
					options: [
						'fat fa-face-viewfinder', 'fal fa-face-viewfinder', 'far fa-face-viewfinder', 'fas fa-face-viewfinder',
					],
					defaultOption: 'far fa-face-viewfinder',
					keywords: 'face id facial identity recognition scan smile face viewfinder',
				},
				{
					className: 'far fa-file-certificate',
					options: [
						'fat fa-file-certificate', 'fal fa-file-certificate', 'far fa-file-certificate', 'fas fa-file-certificate',
					],
					defaultOption: 'far fa-file-certificate',
					keywords: 'award diploma document license file certificate',
				},
				{
					className: 'far fa-file-contract',
					options: [
						'fat fa-file-contract', 'fal fa-file-contract', 'far fa-file-contract', 'fas fa-file-contract',
					],
					defaultOption: 'far fa-file-contract',
					keywords: 'agreement binding document legal signature file contract',
				},
				{
					className: 'far fa-file-lock',
					options: [
						'fat fa-file-lock', 'fal fa-file-lock', 'far fa-file-lock', 'fas fa-file-lock',
					],
					defaultOption: 'far fa-file-lock',
					keywords: 'contract encrypt lock private protect file lock',
				},
				{
					className: 'far fa-file-signature',
					options: [
						'fat fa-file-signature', 'fal fa-file-signature', 'far fa-file-signature', 'fas fa-file-signature',
					],
					defaultOption: 'far fa-file-signature',
					keywords: 'john hancock contract document name file signature',
				},
				{
					className: 'far fa-fingerprint',
					options: [
						'fat fa-fingerprint', 'fal fa-fingerprint', 'far fa-fingerprint', 'fas fa-fingerprint',
					],
					defaultOption: 'far fa-fingerprint',
					keywords: 'human id identification lock smudge touch unique unlock fingerprint',
				},
				{
					className: 'far fa-id-badge',
					options: [
						'fat fa-id-badge', 'fal fa-id-badge', 'far fa-id-badge', 'fas fa-id-badge',
					],
					defaultOption: 'far fa-id-badge',
					keywords: 'address contact identification license profile id badge',
				},
				{
					className: 'far fa-id-card',
					options: [
						'fat fa-id-card', 'fal fa-id-card', 'far fa-id-card', 'fas fa-id-card',
					],
					defaultOption: 'far fa-id-card',
					keywords: 'contact demographics document identification issued profile id card',
				},
				{
					className: 'far fa-id-card-clip',
					options: [
						'fat fa-id-card-clip', 'fal fa-id-card-clip', 'far fa-id-card-clip', 'fas fa-id-card-clip',
					],
					defaultOption: 'far fa-id-card-clip',
					keywords: 'contact demographics document identification issued profile id card-clip',
				},
				{
					className: 'far fa-key',
					options: [
						'fat fa-key', 'fal fa-key', 'far fa-key', 'fas fa-key',
					],
					defaultOption: 'far fa-key',
					keywords: 'key lock password private secret unlock key',
				},
				{
					className: 'far fa-key-skeleton',
					options: [
						'fat fa-key-skeleton', 'fal fa-key-skeleton', 'far fa-key-skeleton', 'fas fa-key-skeleton',
					],
					defaultOption: 'far fa-key-skeleton',
					keywords: 'clue halloween key lock old old key password private secret unlock key skeleton',
				},
				{
					className: 'far fa-light-emergency',
					options: [
						'fat fa-light-emergency', 'fal fa-light-emergency', 'far fa-light-emergency', 'fas fa-light-emergency',
					],
					defaultOption: 'far fa-light-emergency',
					keywords: 'alarm ambulance light siren warning light emergency',
				},
				{
					className: 'far fa-light-emergency-on',
					options: [
						'fat fa-light-emergency-on', 'fal fa-light-emergency-on', 'far fa-light-emergency-on', 'fas fa-light-emergency-on',
					],
					defaultOption: 'far fa-light-emergency-on',
					keywords: 'alarm ambulance light siren warning light emergency-on',
				},
				{
					className: 'far fa-lock',
					options: [
						'fat fa-lock', 'fal fa-lock', 'far fa-lock', 'fas fa-lock',
					],
					defaultOption: 'far fa-lock',
					keywords: 'admin closed lock locked open password private protect security lock',
				},
				{
					className: 'far fa-lock-keyhole',
					options: [
						'fat fa-lock-keyhole', 'fal fa-lock-keyhole', 'far fa-lock-keyhole', 'fas fa-lock-keyhole',
					],
					defaultOption: 'far fa-lock-keyhole',
					keywords: 'admin lock open password private protect security lock keyhole',
				},
				{
					className: 'far fa-lock-keyhole-open',
					options: [
						'fat fa-lock-keyhole-open', 'fal fa-lock-keyhole-open', 'far fa-lock-keyhole-open', 'fas fa-lock-keyhole-open',
					],
					defaultOption: 'far fa-lock-keyhole-open',
					keywords: 'admin lock open password private protect security unlock lock keyhole-open',
				},
				{
					className: 'far fa-lock-open',
					options: [
						'fat fa-lock-open', 'fal fa-lock-open', 'far fa-lock-open', 'fas fa-lock-open',
					],
					defaultOption: 'far fa-lock-open',
					keywords: 'admin lock open password private protect security unlock lock open',
				},
				{
					className: 'far fa-mask',
					options: [
						'fat fa-mask', 'fal fa-mask', 'far fa-mask', 'fas fa-mask',
					],
					defaultOption: 'far fa-mask',
					keywords: 'carnivale costume disguise halloween secret super hero mask',
				},
				{
					className: 'far fa-octagon-exclamation',
					options: [
						'fat fa-octagon-exclamation', 'fal fa-octagon-exclamation', 'far fa-octagon-exclamation', 'fas fa-octagon-exclamation',
					],
					defaultOption: 'far fa-octagon-exclamation',
					keywords: 'close end stop octagon exclamation',
				},
				{
					className: 'far fa-panel-ews',
					options: [
						'fat fa-panel-ews', 'fal fa-panel-ews', 'far fa-panel-ews', 'fas fa-panel-ews',
					],
					defaultOption: 'far fa-panel-ews',
					keywords: 'emergency intercom phone panel ews',
				},
				{
					className: 'far fa-panel-fire',
					options: [
						'fat fa-panel-fire', 'fal fa-panel-fire', 'far fa-panel-fire', 'fas fa-panel-fire',
					],
					defaultOption: 'far fa-panel-fire',
					keywords: 'burn emergency flame indicator intercom panel fire',
				},
				{
					className: 'far fa-passport',
					options: [
						'fat fa-passport', 'fal fa-passport', 'far fa-passport', 'fas fa-passport',
					],
					defaultOption: 'far fa-passport',
					keywords: 'document id identification issued travel passport',
				},
				{
					className: 'far fa-person-to-door',
					options: [
						'fat fa-person-to-door', 'fal fa-person-to-door', 'far fa-person-to-door', 'fas fa-person-to-door',
					],
					defaultOption: 'far fa-person-to-door',
					keywords: 'door exit leave person to-door',
				},
				{
					className: 'far fa-phone-intercom',
					options: [
						'fat fa-phone-intercom', 'fal fa-phone-intercom', 'far fa-phone-intercom', 'fas fa-phone-intercom',
					],
					defaultOption: 'far fa-phone-intercom',
					keywords: 'call phone warning phone intercom',
				},
				{
					className: 'far fa-shield',
					options: [
						'fat fa-shield', 'fal fa-shield', 'far fa-shield', 'fas fa-shield',
					],
					defaultOption: 'far fa-shield',
					keywords: 'achievement armor award block cleric defend defense holy paladin security shield weapon winner shield',
				},
				{
					className: 'far fa-shield-blank',
					options: [
						'fat fa-shield-blank', 'fal fa-shield-blank', 'far fa-shield-blank', 'fas fa-shield-blank',
					],
					defaultOption: 'far fa-shield-blank',
					keywords: 'achievement award block defend security winner shield blank',
				},
				{
					className: 'far fa-shield-check',
					options: [
						'fat fa-shield-check', 'fal fa-shield-check', 'far fa-shield-check', 'fas fa-shield-check',
					],
					defaultOption: 'far fa-shield-check',
					keywords: 'achievement award block defend security select success tick todo winner shield check',
				},
				{
					className: 'far fa-shield-exclamation',
					options: [
						'fat fa-shield-exclamation', 'fal fa-shield-exclamation', 'far fa-shield-exclamation', 'fas fa-shield-exclamation',
					],
					defaultOption: 'far fa-shield-exclamation',
					keywords: 'danger protect shield exclamation',
				},
				{
					className: 'far fa-shield-keyhole',
					options: [
						'fat fa-shield-keyhole', 'fal fa-shield-keyhole', 'far fa-shield-keyhole', 'fas fa-shield-keyhole',
					],
					defaultOption: 'far fa-shield-keyhole',
					keywords: 'lock protect shield keyhole',
				},
				{
					className: 'far fa-shield-minus',
					options: [
						'fat fa-shield-minus', 'fal fa-shield-minus', 'far fa-shield-minus', 'fas fa-shield-minus',
					],
					defaultOption: 'far fa-shield-minus',
					keywords: 'minus protect remove shield minus',
				},
				{
					className: 'far fa-shield-plus',
					options: [
						'fat fa-shield-plus', 'fal fa-shield-plus', 'far fa-shield-plus', 'fas fa-shield-plus',
					],
					defaultOption: 'far fa-shield-plus',
					keywords: 'add protect safe shield plus',
				},
				{
					className: 'far fa-shield-slash',
					options: [
						'fat fa-shield-slash', 'fal fa-shield-slash', 'far fa-shield-slash', 'fas fa-shield-slash',
					],
					defaultOption: 'far fa-shield-slash',
					keywords: 'protect remove shield slash',
				},
				{
					className: 'far fa-shield-xmark',
					options: [
						'fat fa-shield-xmark', 'fal fa-shield-xmark', 'far fa-shield-xmark', 'fas fa-shield-xmark',
					],
					defaultOption: 'far fa-shield-xmark',
					keywords: 'protect remove shield xmark',
				},
				{
					className: 'far fa-siren',
					options: [
						'fat fa-siren', 'fal fa-siren', 'far fa-siren', 'fas fa-siren',
					],
					defaultOption: 'far fa-siren',
					keywords: 'alarm alert ambulance loud police warning siren',
				},
				{
					className: 'far fa-siren-on',
					options: [
						'fat fa-siren-on', 'fal fa-siren-on', 'far fa-siren-on', 'fas fa-siren-on',
					],
					defaultOption: 'far fa-siren-on',
					keywords: 'alarm alert ambulance loud police warning siren on',
				},
				{
					className: 'far fa-sprinkler-ceiling',
					options: [
						'fat fa-sprinkler-ceiling', 'fal fa-sprinkler-ceiling', 'far fa-sprinkler-ceiling', 'fas fa-sprinkler-ceiling',
					],
					defaultOption: 'far fa-sprinkler-ceiling',
					keywords: 'emergency fire water sprinkler ceiling',
				},
				{
					className: 'far fa-unlock',
					options: [
						'fat fa-unlock', 'fal fa-unlock', 'far fa-unlock', 'fas fa-unlock',
					],
					defaultOption: 'far fa-unlock',
					keywords: 'admin lock open password private protect unlock unlocked unlock',
				},
				{
					className: 'far fa-unlock-keyhole',
					options: [
						'fat fa-unlock-keyhole', 'fal fa-unlock-keyhole', 'far fa-unlock-keyhole', 'fas fa-unlock-keyhole',
					],
					defaultOption: 'far fa-unlock-keyhole',
					keywords: 'admin lock password private protect unlock keyhole',
				},
				{
					className: 'far fa-usb-drive',
					options: [
						'fat fa-usb-drive', 'fal fa-usb-drive', 'far fa-usb-drive', 'fas fa-usb-drive',
					],
					defaultOption: 'far fa-usb-drive',
					keywords: 'access codes device flashdrive goober ssd storage thumbdrive usb drive',
				},
				{
					className: 'far fa-user-lock',
					options: [
						'fat fa-user-lock', 'fal fa-user-lock', 'far fa-user-lock', 'fas fa-user-lock',
					],
					defaultOption: 'far fa-user-lock',
					keywords: 'users people user-lock',
				},
				{
					className: 'far fa-user-police',
					options: [
						'fat fa-user-police', 'fal fa-user-police', 'far fa-user-police', 'fas fa-user-police',
					],
					defaultOption: 'far fa-user-police',
					keywords: 'cop five o law enforcement officer patrol police police officer trooper user-police',
				},
				{
					className: 'far fa-user-police-tie',
					options: [
						'fat fa-user-police-tie', 'fal fa-user-police-tie', 'far fa-user-police-tie', 'fas fa-user-police-tie',
					],
					defaultOption: 'far fa-user-police-tie',
					keywords: 'cop five o law enforcement officer patrol police trooper user-police-tie',
				},
				{
					className: 'far fa-user-secret',
					options: [
						'fat fa-user-secret', 'fal fa-user-secret', 'far fa-user-secret', 'fas fa-user-secret',
					],
					defaultOption: 'far fa-user-secret',
					keywords: 'detective sleuth spy users people user-secret',
				},
				{
					className: 'far fa-user-shield',
					options: [
						'fat fa-user-shield', 'fal fa-user-shield', 'far fa-user-shield', 'fas fa-user-shield',
					],
					defaultOption: 'far fa-user-shield',
					keywords: 'users people user-shield',
				},
				{
					className: 'far fa-user-unlock',
					options: [
						'fat fa-user-unlock', 'fal fa-user-unlock', 'far fa-user-unlock', 'fas fa-user-unlock',
					],
					defaultOption: 'far fa-user-unlock',
					keywords: 'users people user-unlock',
				},
				{
					className: 'far fa-vault',
					options: [
						'fat fa-vault', 'fal fa-vault', 'far fa-vault', 'fas fa-vault',
					],
					defaultOption: 'far fa-vault',
					keywords: 'bank important lock money safe vault',
				},
				{
					className: 'far fa-whistle',
					options: [
						'fat fa-whistle', 'fal fa-whistle', 'far fa-whistle', 'fas fa-whistle',
					],
					defaultOption: 'far fa-whistle',
					keywords: 'alert single sound toot whistle',
				},
			],
		},
		{
			id: 'shapes',
			name: Loc.getMessage('LANDING_ICONS_SECTION_SHAPES'),
			items: [
				{
					className: 'far fa-badge',
					options: [
						'fat fa-badge', 'fal fa-badge', 'far fa-badge', 'fas fa-badge',
					],
					defaultOption: 'far fa-badge',
					keywords: 'discount meatball verified verify badge',
				},
				{
					className: 'far fa-ball-pile',
					options: [
						'fat fa-ball-pile', 'fal fa-ball-pile', 'far fa-ball-pile', 'fas fa-ball-pile',
					],
					defaultOption: 'far fa-ball-pile',
					keywords: 'balance cannon group pyramid snowball ball pile',
				},
				{
					className: 'far fa-bookmark',
					options: [
						'fat fa-bookmark', 'fal fa-bookmark', 'far fa-bookmark', 'fas fa-bookmark',
					],
					defaultOption: 'far fa-bookmark',
					keywords: 'bookmark favorite library mark marker read remember research save bookmark',
				},
				{
					className: 'far fa-calendar',
					options: [
						'fat fa-calendar', 'fal fa-calendar', 'far fa-calendar', 'fas fa-calendar',
					],
					defaultOption: 'far fa-calendar',
					keywords: 'calendar calendar o date day event month schedule tear-off calendar time when year calendar',
				},
				{
					className: 'far fa-certificate',
					options: [
						'fat fa-certificate', 'fal fa-certificate', 'far fa-certificate', 'fas fa-certificate',
					],
					defaultOption: 'far fa-certificate',
					keywords: 'badge star verified certificate',
				},
				{
					className: 'far fa-circle',
					options: [
						'fat fa-circle', 'fal fa-circle', 'far fa-circle', 'fas fa-circle',
					],
					defaultOption: 'far fa-circle',
					keywords: 'black circle black large circle black circle blue blue circle brown brown circle circle circle thin diameter dot ellipse geometric green green circle notification orange orange circle purple purple circle red red circle round white circle yellow yellow circle circle',
				},
				{
					className: 'far fa-circle-bolt',
					options: [
						'fat fa-circle-bolt', 'fal fa-circle-bolt', 'far fa-circle-bolt', 'fas fa-circle-bolt',
					],
					defaultOption: 'far fa-circle-bolt',
					keywords: 'energy flash lightning circle bolt',
				},
				{
					className: 'far fa-circle-half',
					options: [
						'fat fa-circle-half', 'fal fa-circle-half', 'far fa-circle-half', 'fas fa-circle-half',
					],
					defaultOption: 'far fa-circle-half',
					keywords: 'left half black circle pie chart circle half',
				},
				{
					className: 'far fa-circle-heart',
					options: [
						'fat fa-circle-heart', 'fal fa-circle-heart', 'far fa-circle-heart', 'fas fa-circle-heart',
					],
					defaultOption: 'far fa-circle-heart',
					keywords: 'favorite like love circle heart',
				},
				{
					className: 'far fa-circle-quarter',
					options: [
						'fat fa-circle-quarter', 'fal fa-circle-quarter', 'far fa-circle-quarter', 'fas fa-circle-quarter',
					],
					defaultOption: 'far fa-circle-quarter',
					keywords: 'pie chart circle quarter',
				},
				{
					className: 'far fa-circle-quarters',
					options: [
						'fat fa-circle-quarters', 'fal fa-circle-quarters', 'far fa-circle-quarters', 'fas fa-circle-quarters',
					],
					defaultOption: 'far fa-circle-quarters',
					keywords: 'emergency light spiderman circle quarters',
				},
				{
					className: 'far fa-circle-small',
					options: [
						'fat fa-circle-small', 'fal fa-circle-small', 'far fa-circle-small', 'fas fa-circle-small',
					],
					defaultOption: 'far fa-circle-small',
					keywords: 'dot period circle small',
				},
				{
					className: 'far fa-circle-star',
					options: [
						'fat fa-circle-star', 'fal fa-circle-star', 'far fa-circle-star', 'fas fa-circle-star',
					],
					defaultOption: 'far fa-circle-star',
					keywords: 'circled white star favorite circle star',
				},
				{
					className: 'far fa-circle-three-quarters',
					options: [
						'fat fa-circle-three-quarters', 'fal fa-circle-three-quarters', 'far fa-circle-three-quarters', 'fas fa-circle-three-quarters',
					],
					defaultOption: 'far fa-circle-three-quarters',
					keywords: 'pie chart circle three-quarters',
				},
				{
					className: 'far fa-cloud',
					options: [
						'fat fa-cloud', 'fal fa-cloud', 'far fa-cloud', 'fas fa-cloud',
					],
					defaultOption: 'far fa-cloud',
					keywords: 'atmosphere cloud fog overcast save upload weather cloud',
				},
				{
					className: 'far fa-clover',
					options: [
						'fat fa-clover', 'fal fa-clover', 'far fa-clover', 'fas fa-clover',
					],
					defaultOption: 'far fa-clover',
					keywords: '4 charm clover four four leaf clover four leaf clover leaf leprechaun luck lucky clover',
				},
				{
					className: 'far fa-club',
					options: [
						'fat fa-club', 'fal fa-club', 'far fa-club', 'fas fa-club',
					],
					defaultOption: 'far fa-club',
					keywords: 'card club suit game poker suit club',
				},
				{
					className: 'far fa-comment',
					options: [
						'fat fa-comment', 'fal fa-comment', 'far fa-comment', 'fas fa-comment',
					],
					defaultOption: 'far fa-comment',
					keywords: 'right speech bubble bubble chat commenting conversation feedback message note notification sms speech texting comment',
				},
				{
					className: 'far fa-crown',
					options: [
						'fat fa-crown', 'fal fa-crown', 'far fa-crown', 'fas fa-crown',
					],
					defaultOption: 'far fa-crown',
					keywords: 'award clothing crown favorite king queen royal tiara crown',
				},
				{
					className: 'far fa-diamond',
					options: [
						'fat fa-diamond', 'fal fa-diamond', 'far fa-diamond', 'fas fa-diamond',
					],
					defaultOption: 'far fa-diamond',
					keywords: 'card cards diamond suit game gem gemstone poker suit diamond',
				},
				{
					className: 'far fa-file',
					options: [
						'fat fa-file', 'fal fa-file', 'far fa-file', 'fas fa-file',
					],
					defaultOption: 'far fa-file',
					keywords: 'empty document document new page page facing up pdf resume file',
				},
				{
					className: 'far fa-folder',
					options: [
						'fat fa-folder', 'fal fa-folder', 'far fa-folder', 'fas fa-folder',
					],
					defaultOption: 'far fa-folder',
					keywords: 'black folder archive directory document file file folder folder folder',
				},
				{
					className: 'far fa-heart',
					options: [
						'fat fa-heart', 'fal fa-heart', 'far fa-heart', 'fas fa-heart',
					],
					defaultOption: 'far fa-heart',
					keywords: 'black black heart blue blue heart brown brown heart card evil favorite game green green heart heart heart suit like love orange orange heart purple purple heart red heart relationship valentine white white heart wicked yellow yellow heart heart',
				},
				{
					className: 'far fa-heart-crack',
					options: [
						'fat fa-heart-crack', 'fal fa-heart-crack', 'far fa-heart-crack', 'fas fa-heart-crack',
					],
					defaultOption: 'far fa-heart-crack',
					keywords: 'break breakup broken broken heart crushed dislike dumped grief love lovesick relationship sad heart crack',
				},
				{
					className: 'far fa-heart-half',
					options: [
						'fat fa-heart-half', 'fal fa-heart-half', 'far fa-heart-half', 'fas fa-heart-half',
					],
					defaultOption: 'far fa-heart-half',
					keywords: 'favorite heart rating heart half',
				},
				{
					className: 'far fa-heart-half-stroke',
					options: [
						'fat fa-heart-half-stroke', 'fal fa-heart-half-stroke', 'far fa-heart-half-stroke', 'fas fa-heart-half-stroke',
					],
					defaultOption: 'far fa-heart-half-stroke',
					keywords: 'favorite heart rating heart half-stroke',
				},
				{
					className: 'far fa-hexagon',
					options: [
						'fat fa-hexagon', 'fal fa-hexagon', 'far fa-hexagon', 'fas fa-hexagon',
					],
					defaultOption: 'far fa-hexagon',
					keywords: 'horizontal black hexagon geometry honeycomb polygon shape hexagon',
				},
				{
					className: 'far fa-location-pin',
					options: [
						'fat fa-location-pin', 'fal fa-location-pin', 'far fa-location-pin', 'fas fa-location-pin',
					],
					defaultOption: 'far fa-location-pin',
					keywords: 'address coordinates destination gps localize location map navigation paper pin place point of interest position route travel location pin',
				},
				{
					className: 'far fa-octagon',
					options: [
						'fat fa-octagon', 'fal fa-octagon', 'far fa-octagon', 'fas fa-octagon',
					],
					defaultOption: 'far fa-octagon',
					keywords: 'octagonal shape sign stop stop sign octagon',
				},
				{
					className: 'far fa-play',
					options: [
						'fat fa-play', 'fal fa-play', 'far fa-play', 'fas fa-play',
					],
					defaultOption: 'far fa-play',
					keywords: 'arrow audio music play play button playing right sound start triangle video play',
				},
				{
					className: 'far fa-rectangle',
					options: [
						'fat fa-rectangle', 'fal fa-rectangle', 'far fa-rectangle', 'fas fa-rectangle',
					],
					defaultOption: 'far fa-rectangle',
					keywords: 'black rectangle geometry shape rectangle',
				},
				{
					className: 'far fa-rectangle-vertical',
					options: [
						'fat fa-rectangle-vertical', 'fal fa-rectangle-vertical', 'far fa-rectangle-vertical', 'fas fa-rectangle-vertical',
					],
					defaultOption: 'far fa-rectangle-vertical',
					keywords: 'geometry shape rectangle vertical',
				},
				{
					className: 'far fa-rectangle-wide',
					options: [
						'fat fa-rectangle-wide', 'fal fa-rectangle-wide', 'far fa-rectangle-wide', 'fas fa-rectangle-wide',
					],
					defaultOption: 'far fa-rectangle-wide',
					keywords: 'geometry landscape shape rectangle wide',
				},
				{
					className: 'far fa-rhombus',
					options: [
						'fat fa-rhombus', 'fal fa-rhombus', 'far fa-rhombus', 'fas fa-rhombus',
					],
					defaultOption: 'far fa-rhombus',
					keywords: 'diamond parallelogram rhombus',
				},
				{
					className: 'far fa-seal',
					options: [
						'fat fa-seal', 'fal fa-seal', 'far fa-seal', 'fas fa-seal',
					],
					defaultOption: 'far fa-seal',
					keywords: 'badge certificate confirm seal',
				},
				{
					className: 'far fa-shapes',
					options: [
						'fat fa-shapes', 'fal fa-shapes', 'far fa-shapes', 'fas fa-shapes',
					],
					defaultOption: 'far fa-shapes',
					keywords: 'blocks build circle square triangle shapes',
				},
				{
					className: 'far fa-shield',
					options: [
						'fat fa-shield', 'fal fa-shield', 'far fa-shield', 'fas fa-shield',
					],
					defaultOption: 'far fa-shield',
					keywords: 'achievement armor award block cleric defend defense holy paladin security shield weapon winner shield',
				},
				{
					className: 'far fa-spade',
					options: [
						'fat fa-spade', 'fal fa-spade', 'far fa-spade', 'fas fa-spade',
					],
					defaultOption: 'far fa-spade',
					keywords: 'card game poker spade suit suit spade',
				},
				{
					className: 'far fa-square',
					options: [
						'fat fa-square', 'fal fa-square', 'far fa-square', 'fas fa-square',
					],
					defaultOption: 'far fa-square',
					keywords: 'black square black medium square block box geometric shape square white medium square square',
				},
				{
					className: 'far fa-square-bolt',
					options: [
						'fat fa-square-bolt', 'fal fa-square-bolt', 'far fa-square-bolt', 'fas fa-square-bolt',
					],
					defaultOption: 'far fa-square-bolt',
					keywords: 'energy flash lightning square bolt',
				},
				{
					className: 'far fa-square-quarters',
					options: [
						'fat fa-square-quarters', 'fal fa-square-quarters', 'far fa-square-quarters', 'fas fa-square-quarters',
					],
					defaultOption: 'far fa-square-quarters',
					keywords: 'damper fire vent square quarters',
				},
				{
					className: 'far fa-square-ring',
					options: [
						'fat fa-square-ring', 'fal fa-square-ring', 'far fa-square-ring', 'fas fa-square-ring',
					],
					defaultOption: 'far fa-square-ring',
					keywords: 'pipe service square ring',
				},
				{
					className: 'far fa-square-small',
					options: [
						'fat fa-square-small', 'fal fa-square-small', 'far fa-square-small', 'fas fa-square-small',
					],
					defaultOption: 'far fa-square-small',
					keywords: 'black small square block geometric square stop white small square square small',
				},
				{
					className: 'far fa-square-star',
					options: [
						'fat fa-square-star', 'fal fa-square-star', 'far fa-square-star', 'fas fa-square-star',
					],
					defaultOption: 'far fa-square-star',
					keywords: 'favorite square star',
				},
				{
					className: 'far fa-star',
					options: [
						'fat fa-star', 'fal fa-star', 'far fa-star', 'fas fa-star',
					],
					defaultOption: 'far fa-star',
					keywords: 'achievement award favorite important night rating score star star',
				},
				{
					className: 'far fa-star-sharp',
					options: [
						'fat fa-star-sharp', 'fal fa-star-sharp', 'far fa-star-sharp', 'fas fa-star-sharp',
					],
					defaultOption: 'far fa-star-sharp',
					keywords: 'black small star critic ratings review sky star sharp',
				},
				{
					className: 'far fa-star-sharp-half',
					options: [
						'fat fa-star-sharp-half', 'fal fa-star-sharp-half', 'far fa-star-sharp-half', 'fas fa-star-sharp-half',
					],
					defaultOption: 'far fa-star-sharp-half',
					keywords: 'critic ratings review sky star sharp-half',
				},
				{
					className: 'far fa-star-sharp-half-stroke',
					options: [
						'fat fa-star-sharp-half-stroke', 'fal fa-star-sharp-half-stroke', 'far fa-star-sharp-half-stroke', 'fas fa-star-sharp-half-stroke',
					],
					defaultOption: 'far fa-star-sharp-half-stroke',
					keywords: 'critic ratings review sky star sharp-half-stroke',
				},
				{
					className: 'far fa-ticket-simple',
					options: [
						'fat fa-ticket-simple', 'fal fa-ticket-simple', 'far fa-ticket-simple', 'fas fa-ticket-simple',
					],
					defaultOption: 'far fa-ticket-simple',
					keywords: 'movie pass support ticket ticket simple',
				},
				{
					className: 'far fa-triangle',
					options: [
						'fat fa-triangle', 'fal fa-triangle', 'far fa-triangle', 'fas fa-triangle',
					],
					defaultOption: 'far fa-triangle',
					keywords: 'black up pointing triangle pyramid shape triangle',
				},
			],
		},
		{
			id: 'shopping',
			name: Loc.getMessage('LANDING_ICONS_SECTION_SHOPPING'),
			items: [
				{
					className: 'far fa-badge',
					options: [
						'fat fa-badge', 'fal fa-badge', 'far fa-badge', 'fas fa-badge',
					],
					defaultOption: 'far fa-badge',
					keywords: 'discount meatball verified verify badge',
				},
				{
					className: 'far fa-badge-check',
					options: [
						'fat fa-badge-check', 'fal fa-badge-check', 'far fa-badge-check', 'fas fa-badge-check',
					],
					defaultOption: 'far fa-badge-check',
					keywords: 'accept achievement agree award confirm correct done ok security select success verified verify winner yes badge check',
				},
				{
					className: 'far fa-badge-dollar',
					options: [
						'fat fa-badge-dollar', 'fal fa-badge-dollar', 'far fa-badge-dollar', 'fas fa-badge-dollar',
					],
					defaultOption: 'far fa-badge-dollar',
					keywords: 'deal discount money save usd badge dollar',
				},
				{
					className: 'far fa-badge-percent',
					options: [
						'fat fa-badge-percent', 'fal fa-badge-percent', 'far fa-badge-percent', 'fas fa-badge-percent',
					],
					defaultOption: 'far fa-badge-percent',
					keywords: 'deal discount money save usd badge percent',
				},
				{
					className: 'far fa-bag-shopping',
					options: [
						'fat fa-bag-shopping', 'fal fa-bag-shopping', 'far fa-bag-shopping', 'fas fa-bag-shopping',
					],
					defaultOption: 'far fa-bag-shopping',
					keywords: 'buy checkout grocery payment purchase bag shopping',
				},
				{
					className: 'far fa-bags-shopping',
					options: [
						'fat fa-bags-shopping', 'fal fa-bags-shopping', 'far fa-bags-shopping', 'fas fa-bags-shopping',
					],
					defaultOption: 'far fa-bags-shopping',
					keywords: 'bag buy checkout hotel order shopping shopping bags store bags shopping',
				},
				{
					className: 'far fa-balloon',
					options: [
						'fat fa-balloon', 'fal fa-balloon', 'far fa-balloon', 'fas fa-balloon',
					],
					defaultOption: 'far fa-balloon',
					keywords: 'balloon birthday celebrate celebration helium party pop up balloon',
				},
				{
					className: 'far fa-balloons',
					options: [
						'fat fa-balloons', 'fal fa-balloons', 'far fa-balloons', 'fas fa-balloons',
					],
					defaultOption: 'far fa-balloons',
					keywords: 'birthday celebrate celebration helium party pop up balloons',
				},
				{
					className: 'far fa-barcode',
					options: [
						'fat fa-barcode', 'fal fa-barcode', 'far fa-barcode', 'fas fa-barcode',
					],
					defaultOption: 'far fa-barcode',
					keywords: 'info laser price scan upc barcode',
				},
				{
					className: 'far fa-barcode-read',
					options: [
						'fat fa-barcode-read', 'fal fa-barcode-read', 'far fa-barcode-read', 'fas fa-barcode-read',
					],
					defaultOption: 'far fa-barcode-read',
					keywords: 'info laser price scan upc barcode read',
				},
				{
					className: 'far fa-barcode-scan',
					options: [
						'fat fa-barcode-scan', 'fal fa-barcode-scan', 'far fa-barcode-scan', 'fas fa-barcode-scan',
					],
					defaultOption: 'far fa-barcode-scan',
					keywords: 'info laser price scan upc barcode scan',
				},
				{
					className: 'far fa-basket-shopping',
					options: [
						'fat fa-basket-shopping', 'fal fa-basket-shopping', 'far fa-basket-shopping', 'fas fa-basket-shopping',
					],
					defaultOption: 'far fa-basket-shopping',
					keywords: 'buy checkout grocery payment purchase basket shopping',
				},
				{
					className: 'far fa-basket-shopping-simple',
					options: [
						'fat fa-basket-shopping-simple', 'fal fa-basket-shopping-simple', 'far fa-basket-shopping-simple', 'fas fa-basket-shopping-simple',
					],
					defaultOption: 'far fa-basket-shopping-simple',
					keywords: 'cart checkout grocery shopping basket shopping-simple',
				},
				{
					className: 'far fa-bell',
					options: [
						'fat fa-bell', 'fal fa-bell', 'far fa-bell', 'fas fa-bell',
					],
					defaultOption: 'far fa-bell',
					keywords: 'alarm alert bel bell chime notification reminder bell',
				},
				{
					className: 'far fa-bookmark',
					options: [
						'fat fa-bookmark', 'fal fa-bookmark', 'far fa-bookmark', 'fas fa-bookmark',
					],
					defaultOption: 'far fa-bookmark',
					keywords: 'bookmark favorite library mark marker read remember research save bookmark',
				},
				{
					className: 'far fa-booth-curtain',
					options: [
						'fat fa-booth-curtain', 'fal fa-booth-curtain', 'far fa-booth-curtain', 'fas fa-booth-curtain',
					],
					defaultOption: 'far fa-booth-curtain',
					keywords: 'changing room election vote voting voting booth booth curtain',
				},
				{
					className: 'far fa-box-open-full',
					options: [
						'fat fa-box-open-full', 'fal fa-box-open-full', 'far fa-box-open-full', 'fas fa-box-open-full',
					],
					defaultOption: 'far fa-box-open-full',
					keywords: 'attic package packed storage box open-full',
				},
				{
					className: 'far fa-bullhorn',
					options: [
						'fat fa-bullhorn', 'fal fa-bullhorn', 'far fa-bullhorn', 'fas fa-bullhorn',
					],
					defaultOption: 'far fa-bullhorn',
					keywords: 'bullhorn announcement broadcast loud louder loudspeaker megaphone public address share bullhorn',
				},
				{
					className: 'far fa-camera',
					options: [
						'fat fa-camera', 'fal fa-camera', 'far fa-camera', 'fas fa-camera',
					],
					defaultOption: 'far fa-camera',
					keywords: 'image lens photo picture record shutter video camera',
				},
				{
					className: 'far fa-camera-retro',
					options: [
						'fat fa-camera-retro', 'fal fa-camera-retro', 'far fa-camera-retro', 'fas fa-camera-retro',
					],
					defaultOption: 'far fa-camera-retro',
					keywords: 'camera image lens photo picture record shutter video camera retro',
				},
				{
					className: 'far fa-cart-arrow-down',
					options: [
						'fat fa-cart-arrow-down', 'fal fa-cart-arrow-down', 'far fa-cart-arrow-down', 'fas fa-cart-arrow-down',
					],
					defaultOption: 'far fa-cart-arrow-down',
					keywords: 'download save shopping cart arrow-down',
				},
				{
					className: 'far fa-cart-arrow-up',
					options: [
						'fat fa-cart-arrow-up', 'fal fa-cart-arrow-up', 'far fa-cart-arrow-up', 'fas fa-cart-arrow-up',
					],
					defaultOption: 'far fa-cart-arrow-up',
					keywords: 'cart grocery market shopping cart arrow-up',
				},
				{
					className: 'far fa-cart-circle-arrow-down',
					options: [
						'fat fa-cart-circle-arrow-down', 'fal fa-cart-circle-arrow-down', 'far fa-cart-circle-arrow-down', 'fas fa-cart-circle-arrow-down',
					],
					defaultOption: 'far fa-cart-circle-arrow-down',
					keywords: 'cart grocery market shopping cart circle-arrow-down',
				},
				{
					className: 'far fa-cart-circle-arrow-up',
					options: [
						'fat fa-cart-circle-arrow-up', 'fal fa-cart-circle-arrow-up', 'far fa-cart-circle-arrow-up', 'fas fa-cart-circle-arrow-up',
					],
					defaultOption: 'far fa-cart-circle-arrow-up',
					keywords: 'cart grocery market shopping cart circle-arrow-up',
				},
				{
					className: 'far fa-cart-circle-check',
					options: [
						'fat fa-cart-circle-check', 'fal fa-cart-circle-check', 'far fa-cart-circle-check', 'fas fa-cart-circle-check',
					],
					defaultOption: 'far fa-cart-circle-check',
					keywords: 'cart grocery market shopping cart circle-check',
				},
				{
					className: 'far fa-cart-circle-exclamation',
					options: [
						'fat fa-cart-circle-exclamation', 'fal fa-cart-circle-exclamation', 'far fa-cart-circle-exclamation', 'fas fa-cart-circle-exclamation',
					],
					defaultOption: 'far fa-cart-circle-exclamation',
					keywords: 'cart grocery market shopping cart circle-exclamation',
				},
				{
					className: 'far fa-cart-circle-plus',
					options: [
						'fat fa-cart-circle-plus', 'fal fa-cart-circle-plus', 'far fa-cart-circle-plus', 'fas fa-cart-circle-plus',
					],
					defaultOption: 'far fa-cart-circle-plus',
					keywords: 'cart grocery market shopping cart circle-plus',
				},
				{
					className: 'far fa-cart-circle-xmark',
					options: [
						'fat fa-cart-circle-xmark', 'fal fa-cart-circle-xmark', 'far fa-cart-circle-xmark', 'fas fa-cart-circle-xmark',
					],
					defaultOption: 'far fa-cart-circle-xmark',
					keywords: 'cart grocery market shopping cart circle-xmark',
				},
				{
					className: 'far fa-cart-minus',
					options: [
						'fat fa-cart-minus', 'fal fa-cart-minus', 'far fa-cart-minus', 'fas fa-cart-minus',
					],
					defaultOption: 'far fa-cart-minus',
					keywords: 'checkout food grocery cart minus',
				},
				{
					className: 'far fa-cart-plus',
					options: [
						'fat fa-cart-plus', 'fal fa-cart-plus', 'far fa-cart-plus', 'fas fa-cart-plus',
					],
					defaultOption: 'far fa-cart-plus',
					keywords: 'add create new positive shopping cart plus',
				},
				{
					className: 'far fa-cart-shopping',
					options: [
						'fat fa-cart-shopping', 'fal fa-cart-shopping', 'far fa-cart-shopping', 'fas fa-cart-shopping',
					],
					defaultOption: 'far fa-cart-shopping',
					keywords: 'buy cart checkout grocery payment purchase shopping shopping cart trolley cart shopping',
				},
				{
					className: 'far fa-cart-shopping-fast',
					options: [
						'fat fa-cart-shopping-fast', 'fal fa-cart-shopping-fast', 'far fa-cart-shopping-fast', 'fas fa-cart-shopping-fast',
					],
					defaultOption: 'far fa-cart-shopping-fast',
					keywords: 'fast food grocery market cart shopping-fast',
				},
				{
					className: 'far fa-cart-xmark',
					options: [
						'fat fa-cart-xmark', 'fal fa-cart-xmark', 'far fa-cart-xmark', 'fas fa-cart-xmark',
					],
					defaultOption: 'far fa-cart-xmark',
					keywords: 'checkout food grocery cart xmark',
				},
				{
					className: 'far fa-cash-register',
					options: [
						'fat fa-cash-register', 'fal fa-cash-register', 'far fa-cash-register', 'fas fa-cash-register',
					],
					defaultOption: 'far fa-cash-register',
					keywords: 'buy cha ching change checkout commerce leaerboard machine pay payment purchase store cash-register',
				},
				{
					className: 'far fa-certificate',
					options: [
						'fat fa-certificate', 'fal fa-certificate', 'far fa-certificate', 'fas fa-certificate',
					],
					defaultOption: 'far fa-certificate',
					keywords: 'badge star verified certificate',
				},
				{
					className: 'far fa-credit-card',
					options: [
						'fat fa-credit-card', 'fal fa-credit-card', 'far fa-credit-card', 'fas fa-credit-card',
					],
					defaultOption: 'far fa-credit-card',
					keywords: 'buy card checkout credit credit card credit card-alt debit money payment purchase credit-card',
				},
				{
					className: 'far fa-credit-card-blank',
					options: [
						'fat fa-credit-card-blank', 'fal fa-credit-card-blank', 'far fa-credit-card-blank', 'fas fa-credit-card-blank',
					],
					defaultOption: 'far fa-credit-card-blank',
					keywords: 'buy checkout debit money payment purchase credit card-blank',
				},
				{
					className: 'far fa-credit-card-front',
					options: [
						'fat fa-credit-card-front', 'fal fa-credit-card-front', 'far fa-credit-card-front', 'fas fa-credit-card-front',
					],
					defaultOption: 'far fa-credit-card-front',
					keywords: 'buy checkout chip debit money payment purchase credit card-front',
				},
				{
					className: 'far fa-gem',
					options: [
						'fat fa-gem', 'fal fa-gem', 'far fa-gem', 'fas fa-gem',
					],
					defaultOption: 'far fa-gem',
					keywords: 'diamond gem gem stone jewel jewelry sapphire stone treasure gem',
				},
				{
					className: 'far fa-gift',
					options: [
						'fat fa-gift', 'fal fa-gift', 'far fa-gift', 'fas fa-gift',
					],
					defaultOption: 'far fa-gift',
					keywords: 'box celebration christmas generosity gift giving holiday party present wrapped wrapped gift xmas gift',
				},
				{
					className: 'far fa-gift-card',
					options: [
						'fat fa-gift-card', 'fal fa-gift-card', 'far fa-gift-card', 'fas fa-gift-card',
					],
					defaultOption: 'far fa-gift-card',
					keywords: 'christmas generosity giving holiday money party present wrapped xmas gift card',
				},
				{
					className: 'far fa-gifts',
					options: [
						'fat fa-gifts', 'fal fa-gifts', 'far fa-gifts', 'fas fa-gifts',
					],
					defaultOption: 'far fa-gifts',
					keywords: 'christmas generosity giving holiday party present wrapped xmas gifts',
				},
				{
					className: 'far fa-hand-holding-box',
					options: [
						'fat fa-hand-holding-box', 'fal fa-hand-holding-box', 'far fa-hand-holding-box', 'fas fa-hand-holding-box',
					],
					defaultOption: 'far fa-hand-holding-box',
					keywords: 'carry gift handling lift package hand holding-box',
				},
				{
					className: 'far fa-handshake',
					options: [
						'fat fa-handshake', 'fal fa-handshake', 'far fa-handshake', 'fas fa-handshake',
					],
					defaultOption: 'far fa-handshake',
					keywords: 'agreement greeting meeting partnership handshake',
				},
				{
					className: 'far fa-heart',
					options: [
						'fat fa-heart', 'fal fa-heart', 'far fa-heart', 'fas fa-heart',
					],
					defaultOption: 'far fa-heart',
					keywords: 'black black heart blue blue heart brown brown heart card evil favorite game green green heart heart heart suit like love orange orange heart purple purple heart red heart relationship valentine white white heart wicked yellow yellow heart heart',
				},
				{
					className: 'far fa-key',
					options: [
						'fat fa-key', 'fal fa-key', 'far fa-key', 'fas fa-key',
					],
					defaultOption: 'far fa-key',
					keywords: 'key lock password private secret unlock key',
				},
				{
					className: 'far fa-mobile-signal',
					options: [
						'fat fa-mobile-signal', 'fal fa-mobile-signal', 'far fa-mobile-signal', 'fas fa-mobile-signal',
					],
					defaultOption: 'far fa-mobile-signal',
					keywords: 'android iphone nfc scan mobile signal',
				},
				{
					className: 'far fa-mobile-signal-out',
					options: [
						'fat fa-mobile-signal-out', 'fal fa-mobile-signal-out', 'far fa-mobile-signal-out', 'fas fa-mobile-signal-out',
					],
					defaultOption: 'far fa-mobile-signal-out',
					keywords: 'android iphone nfc scan mobile signal-out',
				},
				{
					className: 'far fa-money-check',
					options: [
						'fat fa-money-check', 'fal fa-money-check', 'far fa-money-check', 'fas fa-money-check',
					],
					defaultOption: 'far fa-money-check',
					keywords: 'bank check buy checkout cheque money payment price purchase money check',
				},
				{
					className: 'far fa-money-check-dollar',
					options: [
						'fat fa-money-check-dollar', 'fal fa-money-check-dollar', 'far fa-money-check-dollar', 'fas fa-money-check-dollar',
					],
					defaultOption: 'far fa-money-check-dollar',
					keywords: 'bank check buy checkout cheque money payment price purchase money check-dollar',
				},
				{
					className: 'far fa-money-check-dollar-pen',
					options: [
						'fat fa-money-check-dollar-pen', 'fal fa-money-check-dollar-pen', 'far fa-money-check-dollar-pen', 'fas fa-money-check-dollar-pen',
					],
					defaultOption: 'far fa-money-check-dollar-pen',
					keywords: 'bank check buy checkout cheque money payment pen price purchase money check-dollar-pen',
				},
				{
					className: 'far fa-money-check-pen',
					options: [
						'fat fa-money-check-pen', 'fal fa-money-check-pen', 'far fa-money-check-pen', 'fas fa-money-check-pen',
					],
					defaultOption: 'far fa-money-check-pen',
					keywords: 'bank check buy checkout cheque money payment pen price purchase money check-pen',
				},
				{
					className: 'far fa-moped',
					options: [
						'fat fa-moped', 'fal fa-moped', 'far fa-moped', 'fas fa-moped',
					],
					defaultOption: 'far fa-moped',
					keywords: 'delivery motorbike scooter moped',
				},
				{
					className: 'far fa-nfc',
					options: [
						'fat fa-nfc', 'fal fa-nfc', 'far fa-nfc', 'fas fa-nfc',
					],
					defaultOption: 'far fa-nfc',
					keywords: 'nfc scan nfc',
				},
				{
					className: 'far fa-nfc-lock',
					options: [
						'fat fa-nfc-lock', 'fal fa-nfc-lock', 'far fa-nfc-lock', 'fas fa-nfc-lock',
					],
					defaultOption: 'far fa-nfc-lock',
					keywords: 'nfc scan nfc lock',
				},
				{
					className: 'far fa-nfc-magnifying-glass',
					options: [
						'fat fa-nfc-magnifying-glass', 'fal fa-nfc-magnifying-glass', 'far fa-nfc-magnifying-glass', 'fas fa-nfc-magnifying-glass',
					],
					defaultOption: 'far fa-nfc-magnifying-glass',
					keywords: 'nfc scan nfc magnifying-glass',
				},
				{
					className: 'far fa-nfc-pen',
					options: [
						'fat fa-nfc-pen', 'fal fa-nfc-pen', 'far fa-nfc-pen', 'fas fa-nfc-pen',
					],
					defaultOption: 'far fa-nfc-pen',
					keywords: 'nfc scan nfc pen',
				},
				{
					className: 'far fa-nfc-signal',
					options: [
						'fat fa-nfc-signal', 'fal fa-nfc-signal', 'far fa-nfc-signal', 'fas fa-nfc-signal',
					],
					defaultOption: 'far fa-nfc-signal',
					keywords: 'nfc scan nfc signal',
				},
				{
					className: 'far fa-nfc-slash',
					options: [
						'fat fa-nfc-slash', 'fal fa-nfc-slash', 'far fa-nfc-slash', 'fas fa-nfc-slash',
					],
					defaultOption: 'far fa-nfc-slash',
					keywords: 'nfc scan nfc slash',
				},
				{
					className: 'far fa-nfc-trash',
					options: [
						'fat fa-nfc-trash', 'fal fa-nfc-trash', 'far fa-nfc-trash', 'fas fa-nfc-trash',
					],
					defaultOption: 'far fa-nfc-trash',
					keywords: 'nfc scan nfc trash',
				},
				{
					className: 'far fa-person-booth',
					options: [
						'fat fa-person-booth', 'fal fa-person-booth', 'far fa-person-booth', 'fas fa-person-booth',
					],
					defaultOption: 'far fa-person-booth',
					keywords: 'changing room curtain vote voting person booth',
				},
				{
					className: 'far fa-receipt',
					options: [
						'fat fa-receipt', 'fal fa-receipt', 'far fa-receipt', 'fas fa-receipt',
					],
					defaultOption: 'far fa-receipt',
					keywords: 'accounting bookkeeping check evidence invoice money pay proof receipt table receipt',
				},
				{
					className: 'far fa-rectangle-barcode',
					options: [
						'fat fa-rectangle-barcode', 'fal fa-rectangle-barcode', 'far fa-rectangle-barcode', 'fas fa-rectangle-barcode',
					],
					defaultOption: 'far fa-rectangle-barcode',
					keywords: 'info laser price scan upc rectangle barcode',
				},
				{
					className: 'far fa-shirt',
					options: [
						'fat fa-shirt', 'fal fa-shirt', 'far fa-shirt', 'fas fa-shirt',
					],
					defaultOption: 'far fa-shirt',
					keywords: 'clothing fashion garment shirt short sleeve t shirt tshirt shirt',
				},
				{
					className: 'far fa-shop',
					options: [
						'fat fa-shop', 'fal fa-shop', 'far fa-shop', 'fas fa-shop',
					],
					defaultOption: 'far fa-shop',
					keywords: 'building buy purchase shopping shop',
				},
				{
					className: 'far fa-shop-slash',
					options: [
						'fat fa-shop-slash', 'fal fa-shop-slash', 'far fa-shop-slash', 'fas fa-shop-slash',
					],
					defaultOption: 'far fa-shop-slash',
					keywords: 'building buy closed covid 19 purchase shopping shop-slash',
				},
				{
					className: 'far fa-star',
					options: [
						'fat fa-star', 'fal fa-star', 'far fa-star', 'fas fa-star',
					],
					defaultOption: 'far fa-star',
					keywords: 'achievement award favorite important night rating score star star',
				},
				{
					className: 'far fa-star-exclamation',
					options: [
						'fat fa-star-exclamation', 'fal fa-star-exclamation', 'far fa-star-exclamation', 'fas fa-star-exclamation',
					],
					defaultOption: 'far fa-star-exclamation',
					keywords: 'achievement alert award favorite night rating score star exclamation',
				},
				{
					className: 'far fa-store',
					options: [
						'fat fa-store', 'fal fa-store', 'far fa-store', 'fas fa-store',
					],
					defaultOption: 'far fa-store',
					keywords: 'building buy purchase shopping store',
				},
				{
					className: 'far fa-store-slash',
					options: [
						'fat fa-store-slash', 'fal fa-store-slash', 'far fa-store-slash', 'fas fa-store-slash',
					],
					defaultOption: 'far fa-store-slash',
					keywords: 'building buy closed covid 19 purchase shopping store-slash',
				},
				{
					className: 'far fa-tag',
					options: [
						'fat fa-tag', 'fal fa-tag', 'far fa-tag', 'fas fa-tag',
					],
					defaultOption: 'far fa-tag',
					keywords: 'discount labe label price shopping tag',
				},
				{
					className: 'far fa-tags',
					options: [
						'fat fa-tags', 'fal fa-tags', 'far fa-tags', 'fas fa-tags',
					],
					defaultOption: 'far fa-tags',
					keywords: 'discount label price shopping tags',
				},
				{
					className: 'far fa-thumbs-down',
					options: [
						'fat fa-thumbs-down', 'fal fa-thumbs-down', 'far fa-thumbs-down', 'fas fa-thumbs-down',
					],
					defaultOption: 'far fa-thumbs-down',
					keywords: ' 1 disagree disapprove dislike down hand social thumb thumbs down thumbs-o-down thumbs-down',
				},
				{
					className: 'far fa-thumbs-up',
					options: [
						'fat fa-thumbs-up', 'fal fa-thumbs-up', 'far fa-thumbs-up', 'fas fa-thumbs-up',
					],
					defaultOption: 'far fa-thumbs-up',
					keywords: '+1 agree approve favorite hand like ok okay social success thumb thumbs up thumbs o-up up yes you got it dude thumbs-up',
				},
				{
					className: 'far fa-trophy',
					options: [
						'fat fa-trophy', 'fal fa-trophy', 'far fa-trophy', 'fas fa-trophy',
					],
					defaultOption: 'far fa-trophy',
					keywords: 'achievement award cup game prize trophy winner trophy',
				},
				{
					className: 'far fa-trophy-star',
					options: [
						'fat fa-trophy-star', 'fal fa-trophy-star', 'far fa-trophy-star', 'fas fa-trophy-star',
					],
					defaultOption: 'far fa-trophy-star',
					keywords: 'achievement award cup game star winner trophy star',
				},
				{
					className: 'far fa-truck',
					options: [
						'fat fa-truck', 'fal fa-truck', 'far fa-truck', 'fas fa-truck',
					],
					defaultOption: 'far fa-truck',
					keywords: 'black truck cargo delivery delivery truck shipping truck vehicle truck',
				},
				{
					className: 'far fa-truck-bolt',
					options: [
						'fat fa-truck-bolt', 'fal fa-truck-bolt', 'far fa-truck-bolt', 'fas fa-truck-bolt',
					],
					defaultOption: 'far fa-truck-bolt',
					keywords: 'cargo delivery electric ev shipping vehicle truck bolt',
				},
				{
					className: 'far fa-truck-clock',
					options: [
						'fat fa-truck-clock', 'fal fa-truck-clock', 'far fa-truck-clock', 'fas fa-truck-clock',
					],
					defaultOption: 'far fa-truck-clock',
					keywords: 'express fedex mail overnight package ups truck clock',
				},
				{
					className: 'far fa-truck-container',
					options: [
						'fat fa-truck-container', 'fal fa-truck-container', 'far fa-truck-container', 'fas fa-truck-container',
					],
					defaultOption: 'far fa-truck-container',
					keywords: 'cargo delivery shipping vehicle truck container',
				},
				{
					className: 'far fa-truck-fast',
					options: [
						'fat fa-truck-fast', 'fal fa-truck-fast', 'far fa-truck-fast', 'fas fa-truck-fast',
					],
					defaultOption: 'far fa-truck-fast',
					keywords: 'express fedex mail overnight package ups truck fast',
				},
			],
		},
		{
			id: 'social',
			name: Loc.getMessage('LANDING_ICONS_SECTION_SOCIAL'),
			items: [
				{
					className: 'far fa-arrows-retweet',
					options: [
						'fat fa-arrows-retweet', 'fal fa-arrows-retweet', 'far fa-arrows-retweet', 'fas fa-arrows-retweet',
					],
					defaultOption: 'far fa-arrows-retweet',
					keywords: 'refresh reload share swap arrows retweet',
				},
				{
					className: 'far fa-bags-shopping',
					options: [
						'fat fa-bags-shopping', 'fal fa-bags-shopping', 'far fa-bags-shopping', 'fas fa-bags-shopping',
					],
					defaultOption: 'far fa-bags-shopping',
					keywords: 'bag buy checkout hotel order shopping shopping bags store bags shopping',
				},
				{
					className: 'far fa-bell',
					options: [
						'fat fa-bell', 'fal fa-bell', 'far fa-bell', 'fas fa-bell',
					],
					defaultOption: 'far fa-bell',
					keywords: 'alarm alert bel bell chime notification reminder bell',
				},
				{
					className: 'far fa-cake-candles',
					options: [
						'fat fa-cake-candles', 'fal fa-cake-candles', 'far fa-cake-candles', 'fas fa-cake-candles',
					],
					defaultOption: 'far fa-cake-candles',
					keywords: 'anniversary bakery birthday birthday cake cake candles celebration dessert frosting holiday party pastry sweet cake candles',
				},
				{
					className: 'far fa-camera',
					options: [
						'fat fa-camera', 'fal fa-camera', 'far fa-camera', 'fas fa-camera',
					],
					defaultOption: 'far fa-camera',
					keywords: 'image lens photo picture record shutter video camera',
				},
				{
					className: 'far fa-circle-envelope',
					options: [
						'fat fa-circle-envelope', 'fal fa-circle-envelope', 'far fa-circle-envelope', 'fas fa-circle-envelope',
					],
					defaultOption: 'far fa-circle-envelope',
					keywords: 'email message send circle envelope',
				},
				{
					className: 'far fa-circle-user',
					options: [
						'fat fa-circle-user', 'fal fa-circle-user', 'far fa-circle-user', 'fas fa-circle-user',
					],
					defaultOption: 'far fa-circle-user',
					keywords: 'users people circle-user',
				},
				{
					className: 'far fa-comment',
					options: [
						'fat fa-comment', 'fal fa-comment', 'far fa-comment', 'fas fa-comment',
					],
					defaultOption: 'far fa-comment',
					keywords: 'right speech bubble bubble chat commenting conversation feedback message note notification sms speech texting comment',
				},
				{
					className: 'far fa-envelope',
					options: [
						'fat fa-envelope', 'fal fa-envelope', 'far fa-envelope', 'fas fa-envelope',
					],
					defaultOption: 'far fa-envelope',
					keywords: 'back of envelope e mail email envelope letter mail message notification support envelope',
				},
				{
					className: 'far fa-hashtag',
					options: [
						'fat fa-hashtag', 'fal fa-hashtag', 'far fa-hashtag', 'fas fa-hashtag',
					],
					defaultOption: 'far fa-hashtag',
					keywords: 'number sign twitter instagram pound social media tag hashtag',
				},
				{
					className: 'far fa-heart',
					options: [
						'fat fa-heart', 'fal fa-heart', 'far fa-heart', 'fas fa-heart',
					],
					defaultOption: 'far fa-heart',
					keywords: 'black black heart blue blue heart brown brown heart card evil favorite game green green heart heart heart suit like love orange orange heart purple purple heart red heart relationship valentine white white heart wicked yellow yellow heart heart',
				},
				{
					className: 'far fa-icons',
					options: [
						'fat fa-icons', 'fal fa-icons', 'far fa-icons', 'fas fa-icons',
					],
					defaultOption: 'far fa-icons',
					keywords: 'bolt emoji heart image music photo symbols icons',
				},
				{
					className: 'far fa-image',
					options: [
						'fat fa-image', 'fal fa-image', 'far fa-image', 'fas fa-image',
					],
					defaultOption: 'far fa-image',
					keywords: 'album landscape photo picture image',
				},
				{
					className: 'far fa-images',
					options: [
						'fat fa-images', 'fal fa-images', 'far fa-images', 'fas fa-images',
					],
					defaultOption: 'far fa-images',
					keywords: 'album landscape photo picture images',
				},
				{
					className: 'far fa-location-dot',
					options: [
						'fat fa-location-dot', 'fal fa-location-dot', 'far fa-location-dot', 'fas fa-location-dot',
					],
					defaultOption: 'far fa-location-dot',
					keywords: 'address coordinates destination gps localize location map navigation paper pin place point of interest position route travel location dot',
				},
				{
					className: 'far fa-location-pin',
					options: [
						'fat fa-location-pin', 'fal fa-location-pin', 'far fa-location-pin', 'fas fa-location-pin',
					],
					defaultOption: 'far fa-location-pin',
					keywords: 'address coordinates destination gps localize location map navigation paper pin place point of interest position route travel location pin',
				},
				{
					className: 'far fa-message',
					options: [
						'fat fa-message', 'fal fa-message', 'far fa-message', 'fas fa-message',
					],
					defaultOption: 'far fa-message',
					keywords: 'bubble chat commenting conversation feedback message note notification sms speech texting message',
				},
				{
					className: 'far fa-paper-plane-top',
					options: [
						'fat fa-paper-plane-top', 'fal fa-paper-plane-top', 'far fa-paper-plane-top', 'fas fa-paper-plane-top',
					],
					defaultOption: 'far fa-paper-plane-top',
					keywords: 'email fold send paper plane-top',
				},
				{
					className: 'far fa-photo-film',
					options: [
						'fat fa-photo-film', 'fal fa-photo-film', 'far fa-photo-film', 'fas fa-photo-film',
					],
					defaultOption: 'far fa-photo-film',
					keywords: 'av film image library media photo film',
				},
				{
					className: 'far fa-photo-film-music',
					options: [
						'fat fa-photo-film-music', 'fal fa-photo-film-music', 'far fa-photo-film-music', 'fas fa-photo-film-music',
					],
					defaultOption: 'far fa-photo-film-music',
					keywords: 'media photo film-music',
				},
				{
					className: 'far fa-retweet',
					options: [
						'fat fa-retweet', 'fal fa-retweet', 'far fa-retweet', 'fas fa-retweet',
					],
					defaultOption: 'far fa-retweet',
					keywords: 'refresh reload share swap retweet',
				},
				{
					className: 'far fa-share',
					options: [
						'fat fa-share', 'fal fa-share', 'far fa-share', 'fas fa-share',
					],
					defaultOption: 'far fa-share',
					keywords: 'forward save send social share',
				},
				{
					className: 'far fa-share-from-square',
					options: [
						'fat fa-share-from-square', 'fal fa-share-from-square', 'far fa-share-from-square', 'fas fa-share-from-square',
					],
					defaultOption: 'far fa-share-from-square',
					keywords: 'forward save send social share from-square',
				},
				{
					className: 'far fa-share-nodes',
					options: [
						'fat fa-share-nodes', 'fal fa-share-nodes', 'far fa-share-nodes', 'fas fa-share-nodes',
					],
					defaultOption: 'far fa-share-nodes',
					keywords: 'forward save send social share nodes',
				},
				{
					className: 'far fa-signal-stream',
					options: [
						'fat fa-signal-stream', 'fal fa-signal-stream', 'far fa-signal-stream', 'fas fa-signal-stream',
					],
					defaultOption: 'far fa-signal-stream',
					keywords: 'podcast radio sisngal streaming wave wifi wireless signal stream',
				},
				{
					className: 'far fa-sparkles',
					options: [
						'fat fa-sparkles', 'fal fa-sparkles', 'far fa-sparkles', 'fas fa-sparkles',
					],
					defaultOption: 'far fa-sparkles',
					keywords: '* glitter magic new sparkle sparkles special star twinkle sparkles',
				},
				{
					className: 'far fa-square-poll-horizontal',
					options: [
						'fat fa-square-poll-horizontal', 'fal fa-square-poll-horizontal', 'far fa-square-poll-horizontal', 'fas fa-square-poll-horizontal',
					],
					defaultOption: 'far fa-square-poll-horizontal',
					keywords: 'chart graph results survey trend vote voting square poll-horizontal',
				},
				{
					className: 'far fa-square-poll-vertical',
					options: [
						'fat fa-square-poll-vertical', 'fal fa-square-poll-vertical', 'far fa-square-poll-vertical', 'fas fa-square-poll-vertical',
					],
					defaultOption: 'far fa-square-poll-vertical',
					keywords: 'chart graph results survey trend vote voting square poll-vertical',
				},
				{
					className: 'far fa-square-share-nodes',
					options: [
						'fat fa-square-share-nodes', 'fal fa-square-share-nodes', 'far fa-square-share-nodes', 'fas fa-square-share-nodes',
					],
					defaultOption: 'far fa-square-share-nodes',
					keywords: 'forward save send social square share-nodes',
				},
				{
					className: 'far fa-star',
					options: [
						'fat fa-star', 'fal fa-star', 'far fa-star', 'fas fa-star',
					],
					defaultOption: 'far fa-star',
					keywords: 'achievement award favorite important night rating score star star',
				},
				{
					className: 'far fa-symbols',
					options: [
						'fat fa-symbols', 'fal fa-symbols', 'far fa-symbols', 'fas fa-symbols',
					],
					defaultOption: 'far fa-symbols',
					keywords: 'bolt emoji heart image input input symbols music photo symbols ??&% symbols',
				},
				{
					className: 'far fa-thumbs-down',
					options: [
						'fat fa-thumbs-down', 'fal fa-thumbs-down', 'far fa-thumbs-down', 'fas fa-thumbs-down',
					],
					defaultOption: 'far fa-thumbs-down',
					keywords: ' 1 disagree disapprove dislike down hand social thumb thumbs down thumbs-o-down thumbs-down',
				},
				{
					className: 'far fa-thumbs-up',
					options: [
						'fat fa-thumbs-up', 'fal fa-thumbs-up', 'far fa-thumbs-up', 'fas fa-thumbs-up',
					],
					defaultOption: 'far fa-thumbs-up',
					keywords: '+1 agree approve favorite hand like ok okay social success thumb thumbs up thumbs o-up up yes you got it dude thumbs-up',
				},
				{
					className: 'far fa-thumbtack',
					options: [
						'fat fa-thumbtack', 'fal fa-thumbtack', 'far fa-thumbtack', 'fas fa-thumbtack',
					],
					defaultOption: 'far fa-thumbtack',
					keywords: 'black pushpin coordinates location marker pin pushpin thumb tack thumbtack',
				},
				{
					className: 'far fa-user',
					options: [
						'fat fa-user', 'fal fa-user', 'far fa-user', 'fas fa-user',
					],
					defaultOption: 'far fa-user',
					keywords: 'adult bust bust in silhouette gender neutral person profile silhouette unspecified gender users-people user',
				},
				{
					className: 'far fa-user-crown',
					options: [
						'fat fa-user-crown', 'fal fa-user-crown', 'far fa-user-crown', 'fas fa-user-crown',
					],
					defaultOption: 'far fa-user-crown',
					keywords: 'users people user-crown',
				},
				{
					className: 'far fa-user-group',
					options: [
						'fat fa-user-group', 'fal fa-user-group', 'far fa-user-group', 'fas fa-user-group',
					],
					defaultOption: 'far fa-user-group',
					keywords: 'bust busts in silhouette silhouette users people user-group',
				},
				{
					className: 'far fa-user-group-crown',
					options: [
						'fat fa-user-group-crown', 'fal fa-user-group-crown', 'far fa-user-group-crown', 'fas fa-user-group-crown',
					],
					defaultOption: 'far fa-user-group-crown',
					keywords: 'users people user-group-crown',
				},
				{
					className: 'far fa-user-plus',
					options: [
						'fat fa-user-plus', 'fal fa-user-plus', 'far fa-user-plus', 'fas fa-user-plus',
					],
					defaultOption: 'far fa-user-plus',
					keywords: 'add avatar positive sign up signup team user plus',
				},
				{
					className: 'far fa-users',
					options: [
						'fat fa-users', 'fal fa-users', 'far fa-users', 'fas fa-users',
					],
					defaultOption: 'far fa-users',
					keywords: 'users people users',
				},
				{
					className: 'far fa-video',
					options: [
						'fat fa-video', 'fal fa-video', 'far fa-video', 'fas fa-video',
					],
					defaultOption: 'far fa-video',
					keywords: 'camera film movie record video camera video',
				},
			],
		},
		{
			id: 'spinners',
			name: Loc.getMessage('LANDING_ICONS_SECTION_SPINNERS'),
			items: [
				{
					className: 'far fa-asterisk',
					options: [
						'fat fa-asterisk', 'fal fa-asterisk', 'far fa-asterisk', 'fas fa-asterisk',
					],
					defaultOption: 'far fa-asterisk',
					keywords: 'asterisk heavy asterisk annotation details reference star asterisk',
				},
				{
					className: 'far fa-atom',
					options: [
						'fat fa-atom', 'fal fa-atom', 'far fa-atom', 'fas fa-atom',
					],
					defaultOption: 'far fa-atom',
					keywords: 'atheism atheist atom atom symbol chemistry electron ion isotope neutron nuclear proton science atom',
				},
				{
					className: 'far fa-atom-simple',
					options: [
						'fat fa-atom-simple', 'fal fa-atom-simple', 'far fa-atom-simple', 'fas fa-atom-simple',
					],
					defaultOption: 'far fa-atom-simple',
					keywords: 'atheism chemistry electron ion isotope neutron nuclear proton science space atom simple',
				},
				{
					className: 'far fa-badge',
					options: [
						'fat fa-badge', 'fal fa-badge', 'far fa-badge', 'fas fa-badge',
					],
					defaultOption: 'far fa-badge',
					keywords: 'discount meatball verified verify badge',
				},
				{
					className: 'far fa-bahai',
					options: [
						'fat fa-bahai', 'fal fa-bahai', 'far fa-bahai', 'fas fa-bahai',
					],
					defaultOption: 'far fa-bahai',
					keywords: 'bahai star bahai',
				},
				{
					className: 'far fa-bullseye-arrow',
					options: [
						'fat fa-bullseye-arrow', 'fal fa-bullseye-arrow', 'far fa-bullseye-arrow', 'fas fa-bullseye-arrow',
					],
					defaultOption: 'far fa-bullseye-arrow',
					keywords: 'archery arrow bullseye dart direct hit game goal hit objective robin hood target bullseye arrow',
				},
				{
					className: 'far fa-certificate',
					options: [
						'fat fa-certificate', 'fal fa-certificate', 'far fa-certificate', 'fas fa-certificate',
					],
					defaultOption: 'far fa-certificate',
					keywords: 'badge star verified certificate',
				},
				{
					className: 'far fa-circle-notch',
					options: [
						'fat fa-circle-notch', 'fal fa-circle-notch', 'far fa-circle-notch', 'fas fa-circle-notch',
					],
					defaultOption: 'far fa-circle-notch',
					keywords: 'circle o-notch diameter dot ellipse round spinner circle-notch',
				},
				{
					className: 'far fa-compact-disc',
					options: [
						'fat fa-compact-disc', 'fal fa-compact-disc', 'far fa-compact-disc', 'fas fa-compact-disc',
					],
					defaultOption: 'far fa-compact-disc',
					keywords: 'optical disc icon album blu ray bluray cd computer disc disk dvd media movie music optical optical disk record video vinyl compact-disc',
				},
				{
					className: 'far fa-compass',
					options: [
						'fat fa-compass', 'fal fa-compass', 'far fa-compass', 'fas fa-compass',
					],
					defaultOption: 'far fa-compass',
					keywords: 'compass directions directory location magnetic menu navigation orienteering safari travel compass',
				},
				{
					className: 'far fa-crosshairs',
					options: [
						'fat fa-crosshairs', 'fal fa-crosshairs', 'far fa-crosshairs', 'fas fa-crosshairs',
					],
					defaultOption: 'far fa-crosshairs',
					keywords: 'aim bullseye gpd picker position crosshairs',
				},
				{
					className: 'far fa-dharmachakra',
					options: [
						'fat fa-dharmachakra', 'fal fa-dharmachakra', 'far fa-dharmachakra', 'fas fa-dharmachakra',
					],
					defaultOption: 'far fa-dharmachakra',
					keywords: 'buddhist buddhism buddhist dharma religion wheel wheel of dharma dharmachakra',
				},
				{
					className: 'far fa-fan',
					options: [
						'fat fa-fan', 'fal fa-fan', 'far fa-fan', 'fas fa-fan',
					],
					defaultOption: 'far fa-fan',
					keywords: 'ac air conditioning blade blower cool hot fan',
				},
				{
					className: 'far fa-gear',
					options: [
						'fat fa-gear', 'fal fa-gear', 'far fa-gear', 'fas fa-gear',
					],
					defaultOption: 'far fa-gear',
					keywords: 'cog cogwheel gear mechanical settings sprocket tool wheel gear',
				},
				{
					className: 'far fa-hurricane',
					options: [
						'fat fa-hurricane', 'fal fa-hurricane', 'far fa-hurricane', 'fas fa-hurricane',
					],
					defaultOption: 'far fa-hurricane',
					keywords: 'coriolis effect eye storm tropical cyclone typhoon hurricane',
				},
				{
					className: 'far fa-life-ring',
					options: [
						'fat fa-life-ring', 'fal fa-life-ring', 'far fa-life-ring', 'fas fa-life-ring',
					],
					defaultOption: 'far fa-life-ring',
					keywords: 'coast guard help overboard save support life ring',
				},
				{
					className: 'far fa-loader',
					options: [
						'fat fa-loader', 'fal fa-loader', 'far fa-loader', 'fas fa-loader',
					],
					defaultOption: 'far fa-loader',
					keywords: 'loading progress loader',
				},
				{
					className: 'far fa-moon-over-sun',
					options: [
						'fat fa-moon-over-sun', 'fal fa-moon-over-sun', 'far fa-moon-over-sun', 'fas fa-moon-over-sun',
					],
					defaultOption: 'far fa-moon-over-sun',
					keywords: 'lunar moon shadow solar sun moon over-sun',
				},
				{
					className: 'far fa-palette',
					options: [
						'fat fa-palette', 'fal fa-palette', 'far fa-palette', 'fas fa-palette',
					],
					defaultOption: 'far fa-palette',
					keywords: 'acrylic art artist palette brush color fill museum paint painting palette pigment watercolor palette',
				},
				{
					className: 'far fa-ring',
					options: [
						'fat fa-ring', 'fal fa-ring', 'far fa-ring', 'fas fa-ring',
					],
					defaultOption: 'far fa-ring',
					keywords: 'dungeons & dragons gollum band binding d&d dnd engagement fantasy gold jewelry marriage precious ring',
				},
				{
					className: 'far fa-rotate',
					options: [
						'fat fa-rotate', 'fal fa-rotate', 'far fa-rotate', 'fas fa-rotate',
					],
					defaultOption: 'far fa-rotate',
					keywords: 'anticlockwise arrow counterclockwise counterclockwise arrows button exchange refresh reload rotate swap withershins rotate',
				},
				{
					className: 'far fa-slash',
					options: [
						'fat fa-slash', 'fal fa-slash', 'far fa-slash', 'fas fa-slash',
					],
					defaultOption: 'far fa-slash',
					keywords: 'cancel close mute off stop x slash',
				},
				{
					className: 'far fa-snowflake',
					options: [
						'fat fa-snowflake', 'fal fa-snowflake', 'far fa-snowflake', 'fas fa-snowflake',
					],
					defaultOption: 'far fa-snowflake',
					keywords: 'heavy chevron snowflake cold precipitation rain snow snowflake winter snowflake',
				},
				{
					className: 'far fa-spider-web',
					options: [
						'fat fa-spider-web', 'fal fa-spider-web', 'far fa-spider-web', 'fas fa-spider-web',
					],
					defaultOption: 'far fa-spider-web',
					keywords: 'cobweb gossamer halloween spider spider web web spider web',
				},
				{
					className: 'far fa-spinner',
					options: [
						'fat fa-spinner', 'fal fa-spinner', 'far fa-spinner', 'fas fa-spinner',
					],
					defaultOption: 'far fa-spinner',
					keywords: 'circle loading progress spinner',
				},
				{
					className: 'far fa-spinner-third',
					options: [
						'fat fa-spinner-third', 'fal fa-spinner-third', 'far fa-spinner-third', 'fas fa-spinner-third',
					],
					defaultOption: 'far fa-spinner-third',
					keywords: 'circle loading progress spinner third',
				},
				{
					className: 'far fa-star-christmas',
					options: [
						'fat fa-star-christmas', 'fal fa-star-christmas', 'far fa-star-christmas', 'fas fa-star-christmas',
					],
					defaultOption: 'far fa-star-christmas',
					keywords: 'bethlehem christmas holiday north xmas star christmas',
				},
				{
					className: 'far fa-steering-wheel',
					options: [
						'fat fa-steering-wheel', 'fal fa-steering-wheel', 'far fa-steering-wheel', 'fas fa-steering-wheel',
					],
					defaultOption: 'far fa-steering-wheel',
					keywords: 'auto car direction driving navigation steering wheel',
				},
				{
					className: 'far fa-stroopwafel',
					options: [
						'fat fa-stroopwafel', 'fal fa-stroopwafel', 'far fa-stroopwafel', 'fas fa-stroopwafel',
					],
					defaultOption: 'far fa-stroopwafel',
					keywords: 'caramel cookie dessert sweets waffle stroopwafel',
				},
				{
					className: 'far fa-sun',
					options: [
						'fat fa-sun', 'fal fa-sun', 'far fa-sun', 'fas fa-sun',
					],
					defaultOption: 'far fa-sun',
					keywords: 'bright brighten contrast day lighter rays sol solar star sun sunny weather sun',
				},
				{
					className: 'far fa-tire',
					options: [
						'fat fa-tire', 'fal fa-tire', 'far fa-tire', 'fas fa-tire',
					],
					defaultOption: 'far fa-tire',
					keywords: 'auto car rim rubber wheel tire',
				},
				{
					className: 'far fa-tire-rugged',
					options: [
						'fat fa-tire-rugged', 'fal fa-tire-rugged', 'far fa-tire-rugged', 'fas fa-tire-rugged',
					],
					defaultOption: 'far fa-tire-rugged',
					keywords: 'auto car offroad rim rubber wheel tire rugged',
				},
				{
					className: 'far fa-wreath',
					options: [
						'fat fa-wreath', 'fal fa-wreath', 'far fa-wreath', 'fas fa-wreath',
					],
					defaultOption: 'far fa-wreath',
					keywords: 'christmas decoration door holiday welcome xmas wreath',
				},
				{
					className: 'far fa-yin-yang',
					options: [
						'fat fa-yin-yang', 'fal fa-yin-yang', 'far fa-yin-yang', 'fas fa-yin-yang',
					],
					defaultOption: 'far fa-yin-yang',
					keywords: 'daoism opposites religion tao taoism taoist yang yin yin yang yin yang',
				},
			],
		},
		{
			id: 'sports-fitness',
			name: Loc.getMessage('LANDING_ICONS_SECTION_SPORTS_FITNESS'),
			items: [
				{
					className: 'far fa-award-simple',
					options: [
						'fat fa-award-simple', 'fal fa-award-simple', 'far fa-award-simple', 'fas fa-award-simple',
					],
					defaultOption: 'far fa-award-simple',
					keywords: 'honor ribbon award simple',
				},
				{
					className: 'far fa-badminton',
					options: [
						'fat fa-badminton', 'fal fa-badminton', 'far fa-badminton', 'fas fa-badminton',
					],
					defaultOption: 'far fa-badminton',
					keywords: 'badminton birdie game racquet shuttlecock badminton',
				},
				{
					className: 'far fa-baseball',
					options: [
						'fat fa-baseball', 'fal fa-baseball', 'far fa-baseball', 'fas fa-baseball',
					],
					defaultOption: 'far fa-baseball',
					keywords: 'ball baseball foul glove hardball league leather mlb softball sport underarm baseball',
				},
				{
					className: 'far fa-baseball-bat-ball',
					options: [
						'fat fa-baseball-bat-ball', 'fal fa-baseball-bat-ball', 'far fa-baseball-bat-ball', 'fas fa-baseball-bat-ball',
					],
					defaultOption: 'far fa-baseball-bat-ball',
					keywords: 'bat league mlb slugger softball sport baseball bat ball',
				},
				{
					className: 'far fa-basketball',
					options: [
						'fat fa-basketball', 'fal fa-basketball', 'far fa-basketball', 'fas fa-basketball',
					],
					defaultOption: 'far fa-basketball',
					keywords: 'ball basketball dribble dunk hoop nba basketball',
				},
				{
					className: 'far fa-basketball-hoop',
					options: [
						'fat fa-basketball-hoop', 'fal fa-basketball-hoop', 'far fa-basketball-hoop', 'fas fa-basketball-hoop',
					],
					defaultOption: 'far fa-basketball-hoop',
					keywords: 'backboard dunk hoop nba basketball hoop',
				},
				{
					className: 'far fa-bicycle',
					options: [
						'fat fa-bicycle', 'fal fa-bicycle', 'far fa-bicycle', 'fas fa-bicycle',
					],
					defaultOption: 'far fa-bicycle',
					keywords: 'bicycle bike gears pedal transportation vehicle bicycle',
				},
				{
					className: 'far fa-book-heart',
					options: [
						'fat fa-book-heart', 'fal fa-book-heart', 'far fa-book-heart', 'fas fa-book-heart',
					],
					defaultOption: 'far fa-book-heart',
					keywords: 'charity diary documentation donation health history journal library read research book heart',
				},
				{
					className: 'far fa-bowling-ball',
					options: [
						'fat fa-bowling-ball', 'fal fa-bowling-ball', 'far fa-bowling-ball', 'fas fa-bowling-ball',
					],
					defaultOption: 'far fa-bowling-ball',
					keywords: 'alley candlepin gutter lane strike tenpin bowling ball',
				},
				{
					className: 'far fa-bowling-ball-pin',
					options: [
						'fat fa-bowling-ball-pin', 'fal fa-bowling-ball-pin', 'far fa-bowling-ball-pin', 'fas fa-bowling-ball-pin',
					],
					defaultOption: 'far fa-bowling-ball-pin',
					keywords: 'ball bowling game league pin strike bowling ball pin',
				},
				{
					className: 'far fa-bowling-pins',
					options: [
						'fat fa-bowling-pins', 'fal fa-bowling-pins', 'far fa-bowling-pins', 'fas fa-bowling-pins',
					],
					defaultOption: 'far fa-bowling-pins',
					keywords: 'alley candlepin gutter lane strike tenpin bowling pins',
				},
				{
					className: 'far fa-boxing-glove',
					options: [
						'fat fa-boxing-glove', 'fal fa-boxing-glove', 'far fa-boxing-glove', 'fas fa-boxing-glove',
					],
					defaultOption: 'far fa-boxing-glove',
					keywords: 'boxer boxing boxing glove fight glove heavyweight spar boxing glove',
				},
				{
					className: 'far fa-broom-ball',
					options: [
						'fat fa-broom-ball', 'fal fa-broom-ball', 'far fa-broom-ball', 'fas fa-broom-ball',
					],
					defaultOption: 'far fa-broom-ball',
					keywords: 'ball bludger broom golden snitch harry potter hogwarts quaffle sport wizard broom ball',
				},
				{
					className: 'far fa-cricket-bat-ball',
					options: [
						'fat fa-cricket-bat-ball', 'fal fa-cricket-bat-ball', 'far fa-cricket-bat-ball', 'fas fa-cricket-bat-ball',
					],
					defaultOption: 'far fa-cricket-bat-ball',
					keywords: 'ball bat bowling cricket game game wicket cricket bat ball',
				},
				{
					className: 'far fa-curling-stone',
					options: [
						'fat fa-curling-stone', 'fal fa-curling-stone', 'far fa-curling-stone', 'fas fa-curling-stone',
					],
					defaultOption: 'far fa-curling-stone',
					keywords: 'curling stone game ice olympics rock sport stone curling stone',
				},
				{
					className: 'far fa-dumbbell',
					options: [
						'fat fa-dumbbell', 'fal fa-dumbbell', 'far fa-dumbbell', 'fas fa-dumbbell',
					],
					defaultOption: 'far fa-dumbbell',
					keywords: 'exercise gym strength weight weight lifting dumbbell',
				},
				{
					className: 'far fa-field-hockey-stick-ball',
					options: [
						'fat fa-field-hockey-stick-ball', 'fal fa-field-hockey-stick-ball', 'far fa-field-hockey-stick-ball', 'fas fa-field-hockey-stick-ball',
					],
					defaultOption: 'far fa-field-hockey-stick-ball',
					keywords: 'ball field field hockey game hockey sport stick field hockey stick ball',
				},
				{
					className: 'far fa-fire-flame-curved',
					options: [
						'fat fa-fire-flame-curved', 'fal fa-fire-flame-curved', 'far fa-fire-flame-curved', 'fas fa-fire-flame-curved',
					],
					defaultOption: 'far fa-fire-flame-curved',
					keywords: 'burn caliente flame heat hot popular fire flame curved',
				},
				{
					className: 'far fa-fire-flame-simple',
					options: [
						'fat fa-fire-flame-simple', 'fal fa-fire-flame-simple', 'far fa-fire-flame-simple', 'fas fa-fire-flame-simple',
					],
					defaultOption: 'far fa-fire-flame-simple',
					keywords: 'caliente energy fire flame gas heat hot fire flame simple',
				},
				{
					className: 'far fa-fishing-rod',
					options: [
						'fat fa-fishing-rod', 'fal fa-fishing-rod', 'far fa-fishing-rod', 'fas fa-fishing-rod',
					],
					defaultOption: 'far fa-fishing-rod',
					keywords: 'bait cast fish fishing pole pole fishing rod',
				},
				{
					className: 'far fa-flag-pennant',
					options: [
						'fat fa-flag-pennant', 'fal fa-flag-pennant', 'far fa-flag-pennant', 'fas fa-flag-pennant',
					],
					defaultOption: 'far fa-flag-pennant',
					keywords: 'banner flag post sign sports triangular flag win flag pennant',
				},
				{
					className: 'far fa-flying-disc',
					options: [
						'fat fa-flying-disc', 'fal fa-flying-disc', 'far fa-flying-disc', 'fas fa-flying-disc',
					],
					defaultOption: 'far fa-flying-disc',
					keywords: 'flying disc frisbee ultimate flying disc',
				},
				{
					className: 'far fa-football',
					options: [
						'fat fa-football', 'fal fa-football', 'far fa-football', 'fas fa-football',
					],
					defaultOption: 'far fa-football',
					keywords: 'american american football ball fall football nfl pigskin seasonal football',
				},
				{
					className: 'far fa-football-helmet',
					options: [
						'fat fa-football-helmet', 'fal fa-football-helmet', 'far fa-football-helmet', 'fas fa-football-helmet',
					],
					defaultOption: 'far fa-football-helmet',
					keywords: 'ball concussion fall nfl pigskin protection seasonal football helmet',
				},
				{
					className: 'far fa-futbol',
					options: [
						'fat fa-futbol', 'fal fa-futbol', 'far fa-futbol', 'fas fa-futbol',
					],
					defaultOption: 'far fa-futbol',
					keywords: 'ball football mls soccer soccer ball futbol',
				},
				{
					className: 'far fa-goal-net',
					options: [
						'fat fa-goal-net', 'fal fa-goal-net', 'far fa-goal-net', 'fas fa-goal-net',
					],
					defaultOption: 'far fa-goal-net',
					keywords: 'goal goal net hockey lacrosse net penalty soccer goal net',
				},
				{
					className: 'far fa-golf-ball-tee',
					options: [
						'fat fa-golf-ball-tee', 'fal fa-golf-ball-tee', 'far fa-golf-ball-tee', 'fas fa-golf-ball-tee',
					],
					defaultOption: 'far fa-golf-ball-tee',
					keywords: 'caddy eagle putt tee golf ball tee',
				},
				{
					className: 'far fa-golf-club',
					options: [
						'fat fa-golf-club', 'fal fa-golf-club', 'far fa-golf-club', 'fas fa-golf-club',
					],
					defaultOption: 'far fa-golf-club',
					keywords: 'caddy eagle putt tee golf club',
				},
				{
					className: 'far fa-golf-flag-hole',
					options: [
						'fat fa-golf-flag-hole', 'fal fa-golf-flag-hole', 'far fa-golf-flag-hole', 'fas fa-golf-flag-hole',
					],
					defaultOption: 'far fa-golf-flag-hole',
					keywords: 'bogey eagle flag in hole golf hole putt golf flag hole',
				},
				{
					className: 'far fa-heart',
					options: [
						'fat fa-heart', 'fal fa-heart', 'far fa-heart', 'fas fa-heart',
					],
					defaultOption: 'far fa-heart',
					keywords: 'black black heart blue blue heart brown brown heart card evil favorite game green green heart heart heart suit like love orange orange heart purple purple heart red heart relationship valentine white white heart wicked yellow yellow heart heart',
				},
				{
					className: 'far fa-heart-pulse',
					options: [
						'fat fa-heart-pulse', 'fal fa-heart-pulse', 'far fa-heart-pulse', 'fas fa-heart-pulse',
					],
					defaultOption: 'far fa-heart-pulse',
					keywords: 'ekg electrocardiogram health lifeline vital signs heart pulse',
				},
				{
					className: 'far fa-hockey-mask',
					options: [
						'fat fa-hockey-mask', 'fal fa-hockey-mask', 'far fa-hockey-mask', 'fas fa-hockey-mask',
					],
					defaultOption: 'far fa-hockey-mask',
					keywords: 'clothing friday halloween ice jason nhl protection sport thirteenth hockey mask',
				},
				{
					className: 'far fa-hockey-puck',
					options: [
						'fat fa-hockey-puck', 'fal fa-hockey-puck', 'far fa-hockey-puck', 'fas fa-hockey-puck',
					],
					defaultOption: 'far fa-hockey-puck',
					keywords: 'ice nhl sport hockey puck',
				},
				{
					className: 'far fa-hockey-stick-puck',
					options: [
						'fat fa-hockey-stick-puck', 'fal fa-hockey-stick-puck', 'far fa-hockey-stick-puck', 'fas fa-hockey-stick-puck',
					],
					defaultOption: 'far fa-hockey-stick-puck',
					keywords: 'game hockey ice ice hockey nhl puck sport stick hockey stick puck',
				},
				{
					className: 'far fa-hockey-sticks',
					options: [
						'fat fa-hockey-sticks', 'fal fa-hockey-sticks', 'far fa-hockey-sticks', 'fas fa-hockey-sticks',
					],
					defaultOption: 'far fa-hockey-sticks',
					keywords: 'ice nhl sport hockey sticks',
				},
				{
					className: 'far fa-ice-skate',
					options: [
						'fat fa-ice-skate', 'fal fa-ice-skate', 'far fa-ice-skate', 'fas fa-ice-skate',
					],
					defaultOption: 'far fa-ice-skate',
					keywords: 'blade clothing figure skating hockey ice ice skate seasonal shoe skate ice skate',
				},
				{
					className: 'far fa-lacrosse-stick',
					options: [
						'fat fa-lacrosse-stick', 'fal fa-lacrosse-stick', 'far fa-lacrosse-stick', 'fas fa-lacrosse-stick',
					],
					defaultOption: 'far fa-lacrosse-stick',
					keywords: 'lacrosse lacrosse stick',
				},
				{
					className: 'far fa-lacrosse-stick-ball',
					options: [
						'fat fa-lacrosse-stick-ball', 'fal fa-lacrosse-stick-ball', 'far fa-lacrosse-stick-ball', 'fas fa-lacrosse-stick-ball',
					],
					defaultOption: 'far fa-lacrosse-stick-ball',
					keywords: 'ball goal lacrosse stick lacrosse stick ball',
				},
				{
					className: 'far fa-luchador-mask',
					options: [
						'fat fa-luchador-mask', 'fal fa-luchador-mask', 'far fa-luchador-mask', 'fas fa-luchador-mask',
					],
					defaultOption: 'far fa-luchador-mask',
					keywords: 'fight mexico nacho libre wrestle wrestling luchador mask',
				},
				{
					className: 'far fa-mask-snorkel',
					options: [
						'fat fa-mask-snorkel', 'fal fa-mask-snorkel', 'far fa-mask-snorkel', 'fas fa-mask-snorkel',
					],
					defaultOption: 'far fa-mask-snorkel',
					keywords: 'dive diving diving mask scuba snorkeling swimming underwater mask snorkel',
				},
				{
					className: 'far fa-medal',
					options: [
						'fat fa-medal', 'fal fa-medal', 'far fa-medal', 'fas fa-medal',
					],
					defaultOption: 'far fa-medal',
					keywords: 'award medal ribbon sports medal star trophy medal',
				},
				{
					className: 'far fa-monitor-waveform',
					options: [
						'fat fa-monitor-waveform', 'fal fa-monitor-waveform', 'far fa-monitor-waveform', 'fas fa-monitor-waveform',
					],
					defaultOption: 'far fa-monitor-waveform',
					keywords: 'ekg electrocardiogram health life vital monitor waveform',
				},
				{
					className: 'far fa-person-biking',
					options: [
						'fat fa-person-biking', 'fal fa-person-biking', 'far fa-person-biking', 'fas fa-person-biking',
					],
					defaultOption: 'far fa-person-biking',
					keywords: 'bicycle bike biking cyclist pedal person biking summer wheel person biking',
				},
				{
					className: 'far fa-person-biking-mountain',
					options: [
						'fat fa-person-biking-mountain', 'fal fa-person-biking-mountain', 'far fa-person-biking-mountain', 'fas fa-person-biking-mountain',
					],
					defaultOption: 'far fa-person-biking-mountain',
					keywords: 'bicycle bicyclist bike cyclist mountain offroad pedal person mountain biking summer wheel person biking mountain',
				},
				{
					className: 'far fa-person-hiking',
					options: [
						'fat fa-person-hiking', 'fal fa-person-hiking', 'far fa-person-hiking', 'fas fa-person-hiking',
					],
					defaultOption: 'far fa-person-hiking',
					keywords: 'autumn fall hike mountain outdoors summer walk person hiking',
				},
				{
					className: 'far fa-person-running',
					options: [
						'fat fa-person-running', 'fal fa-person-running', 'far fa-person-running', 'fas fa-person-running',
					],
					defaultOption: 'far fa-person-running',
					keywords: 'exit flee marathon person running race running person running',
				},
				{
					className: 'far fa-person-skating',
					options: [
						'fat fa-person-skating', 'fal fa-person-skating', 'far fa-person-skating', 'fas fa-person-skating',
					],
					defaultOption: 'far fa-person-skating',
					keywords: 'figure skating ice olympics rink skate winter person skating',
				},
				{
					className: 'far fa-person-ski-jumping',
					options: [
						'fat fa-person-ski-jumping', 'fal fa-person-ski-jumping', 'far fa-person-ski-jumping', 'fas fa-person-ski-jumping',
					],
					defaultOption: 'far fa-person-ski-jumping',
					keywords: 'olympics skiing winter person ski jumping',
				},
				{
					className: 'far fa-person-skiing',
					options: [
						'fat fa-person-skiing', 'fal fa-person-skiing', 'far fa-person-skiing', 'fas fa-person-skiing',
					],
					defaultOption: 'far fa-person-skiing',
					keywords: 'downhill olympics ski skier snow winter person skiing',
				},
				{
					className: 'far fa-person-skiing-nordic',
					options: [
						'fat fa-person-skiing-nordic', 'fal fa-person-skiing-nordic', 'far fa-person-skiing-nordic', 'fas fa-person-skiing-nordic',
					],
					defaultOption: 'far fa-person-skiing-nordic',
					keywords: 'cross country olympics winter person skiing nordic',
				},
				{
					className: 'far fa-person-sledding',
					options: [
						'fat fa-person-sledding', 'fal fa-person-sledding', 'far fa-person-sledding', 'fas fa-person-sledding',
					],
					defaultOption: 'far fa-person-sledding',
					keywords: 'fun slide winter person sledding',
				},
				{
					className: 'far fa-person-snowboarding',
					options: [
						'fat fa-person-snowboarding', 'fal fa-person-snowboarding', 'far fa-person-snowboarding', 'fas fa-person-snowboarding',
					],
					defaultOption: 'far fa-person-snowboarding',
					keywords: 'olympics ski snow snowboard snowboarder winter person snowboarding',
				},
				{
					className: 'far fa-person-swimming',
					options: [
						'fat fa-person-swimming', 'fal fa-person-swimming', 'far fa-person-swimming', 'fas fa-person-swimming',
					],
					defaultOption: 'far fa-person-swimming',
					keywords: 'ocean person swimming pool sea swim water person swimming',
				},
				{
					className: 'far fa-person-walking',
					options: [
						'fat fa-person-walking', 'fal fa-person-walking', 'far fa-person-walking', 'fas fa-person-walking',
					],
					defaultOption: 'far fa-person-walking',
					keywords: 'crosswalk exercise hike move person walking walk walking person walking',
				},
				{
					className: 'far fa-pickleball',
					options: [
						'fat fa-pickleball', 'fal fa-pickleball', 'far fa-pickleball', 'fas fa-pickleball',
					],
					defaultOption: 'far fa-pickleball',
					keywords: 'paddle pickleball wiffle pickleball',
				},
				{
					className: 'far fa-racquet',
					options: [
						'fat fa-racquet', 'fal fa-racquet', 'far fa-racquet', 'fas fa-racquet',
					],
					defaultOption: 'far fa-racquet',
					keywords: 'badminton racket squash tennis racquet',
				},
				{
					className: 'far fa-rugby-ball',
					options: [
						'fat fa-rugby-ball', 'fal fa-rugby-ball', 'far fa-rugby-ball', 'fas fa-rugby-ball',
					],
					defaultOption: 'far fa-rugby-ball',
					keywords: 'ball football rugby rugby football rugby ball',
				},
				{
					className: 'far fa-shirt-running',
					options: [
						'fat fa-shirt-running', 'fal fa-shirt-running', 'far fa-shirt-running', 'fas fa-shirt-running',
					],
					defaultOption: 'far fa-shirt-running',
					keywords: 'athletics running running shirt sash shirt tank top shirt running',
				},
				{
					className: 'far fa-shoe-prints',
					options: [
						'fat fa-shoe-prints', 'fal fa-shoe-prints', 'far fa-shoe-prints', 'fas fa-shoe-prints',
					],
					defaultOption: 'far fa-shoe-prints',
					keywords: 'feet footprints steps walk shoe prints',
				},
				{
					className: 'far fa-shuttlecock',
					options: [
						'fat fa-shuttlecock', 'fal fa-shuttlecock', 'far fa-shuttlecock', 'fas fa-shuttlecock',
					],
					defaultOption: 'far fa-shuttlecock',
					keywords: 'badminton birdie feather sport shuttlecock',
				},
				{
					className: 'far fa-ski-boot',
					options: [
						'fat fa-ski-boot', 'fal fa-ski-boot', 'far fa-ski-boot', 'fas fa-ski-boot',
					],
					defaultOption: 'far fa-ski-boot',
					keywords: 'boot ski snow winter ski boot',
				},
				{
					className: 'far fa-ski-boot-ski',
					options: [
						'fat fa-ski-boot-ski', 'fal fa-ski-boot-ski', 'far fa-ski-boot-ski', 'fas fa-ski-boot-ski',
					],
					defaultOption: 'far fa-ski-boot-ski',
					keywords: 'boot ski skis snow winter ski boot ski',
				},
				{
					className: 'far fa-spa',
					options: [
						'fat fa-spa', 'fal fa-spa', 'far fa-spa', 'fas fa-spa',
					],
					defaultOption: 'far fa-spa',
					keywords: 'flora massage mindfulness plant wellness spa',
				},
				{
					className: 'far fa-sportsball',
					options: [
						'fat fa-sportsball', 'fal fa-sportsball', 'far fa-sportsball', 'fas fa-sportsball',
					],
					defaultOption: 'far fa-sportsball',
					keywords: 'baseball basketball football sports sportsball sportsball',
				},
				{
					className: 'far fa-stopwatch-20',
					options: [
						'fat fa-stopwatch-20', 'fal fa-stopwatch-20', 'far fa-stopwatch-20', 'fas fa-stopwatch-20',
					],
					defaultOption: 'far fa-stopwatch-20',
					keywords: 'abcs countdown covid 19 happy birthday i will survive reminder seconds time timer stopwatch 20',
				},
				{
					className: 'far fa-table-tennis-paddle-ball',
					options: [
						'fat fa-table-tennis-paddle-ball', 'fal fa-table-tennis-paddle-ball', 'far fa-table-tennis-paddle-ball', 'fas fa-table-tennis-paddle-ball',
					],
					defaultOption: 'far fa-table-tennis-paddle-ball',
					keywords: 'ball bat game paddle ping pong table tennis table tennis paddle ball',
				},
				{
					className: 'far fa-tennis-ball',
					options: [
						'fat fa-tennis-ball', 'fal fa-tennis-ball', 'far fa-tennis-ball', 'fas fa-tennis-ball',
					],
					defaultOption: 'far fa-tennis-ball',
					keywords: 'ball racket racquet sport tennis us open tennis ball',
				},
				{
					className: 'far fa-uniform-martial-arts',
					options: [
						'fat fa-uniform-martial-arts', 'fal fa-uniform-martial-arts', 'far fa-uniform-martial-arts', 'fas fa-uniform-martial-arts',
					],
					defaultOption: 'far fa-uniform-martial-arts',
					keywords: 'aikido belt jiu jitsu judo karate martial arts martial arts uniform taekwondo uniform uniform martial arts',
				},
				{
					className: 'far fa-volleyball',
					options: [
						'fat fa-volleyball', 'fal fa-volleyball', 'far fa-volleyball', 'fas fa-volleyball',
					],
					defaultOption: 'far fa-volleyball',
					keywords: 'ball beach game olympics sport volleyball volleyball',
				},
				{
					className: 'far fa-watch-apple',
					options: [
						'fat fa-watch-apple', 'fal fa-watch-apple', 'far fa-watch-apple', 'fas fa-watch-apple',
					],
					defaultOption: 'far fa-watch-apple',
					keywords: 'apps digital fitness smartwatch watch apple',
				},
				{
					className: 'far fa-watch-fitness',
					options: [
						'fat fa-watch-fitness', 'fal fa-watch-fitness', 'far fa-watch-fitness', 'fas fa-watch-fitness',
					],
					defaultOption: 'far fa-watch-fitness',
					keywords: 'fitbit alert apple watch clock pedometer time wristwatch watch fitness',
				},
				{
					className: 'far fa-wave-pulse',
					options: [
						'fat fa-wave-pulse', 'fal fa-wave-pulse', 'far fa-wave-pulse', 'fas fa-wave-pulse',
					],
					defaultOption: 'far fa-wave-pulse',
					keywords: 'ekg activity electrocardiogram health life vital wave pulse',
				},
				{
					className: 'far fa-weight-hanging',
					options: [
						'fat fa-weight-hanging', 'fal fa-weight-hanging', 'far fa-weight-hanging', 'fas fa-weight-hanging',
					],
					defaultOption: 'far fa-weight-hanging',
					keywords: 'anvil heavy measurement weight hanging',
				},
				{
					className: 'far fa-whistle',
					options: [
						'fat fa-whistle', 'fal fa-whistle', 'far fa-whistle', 'fas fa-whistle',
					],
					defaultOption: 'far fa-whistle',
					keywords: 'alert single sound toot whistle',
				},
			],
		},
		{
			id: 'text-formatting',
			name: Loc.getMessage('LANDING_ICONS_SECTION_TEXT_FORMATTING'),
			items: [
				{
					className: 'far fa-align-center',
					options: [
						'fat fa-align-center', 'fal fa-align-center', 'far fa-align-center', 'fas fa-align-center',
					],
					defaultOption: 'far fa-align-center',
					keywords: 'format middle paragraph text align center',
				},
				{
					className: 'far fa-align-justify',
					options: [
						'fat fa-align-justify', 'fal fa-align-justify', 'far fa-align-justify', 'fas fa-align-justify',
					],
					defaultOption: 'far fa-align-justify',
					keywords: 'format paragraph text align justify',
				},
				{
					className: 'far fa-align-left',
					options: [
						'fat fa-align-left', 'fal fa-align-left', 'far fa-align-left', 'fas fa-align-left',
					],
					defaultOption: 'far fa-align-left',
					keywords: 'format paragraph text align left',
				},
				{
					className: 'far fa-align-right',
					options: [
						'fat fa-align-right', 'fal fa-align-right', 'far fa-align-right', 'fas fa-align-right',
					],
					defaultOption: 'far fa-align-right',
					keywords: 'format paragraph text align right',
				},
				{
					className: 'far fa-align-slash',
					options: [
						'fat fa-align-slash', 'fal fa-align-slash', 'far fa-align-slash', 'fas fa-align-slash',
					],
					defaultOption: 'far fa-align-slash',
					keywords: 'cancel format paragraph remove align slash',
				},
				{
					className: 'far fa-block-quote',
					options: [
						'fat fa-block-quote', 'fal fa-block-quote', 'far fa-block-quote', 'fas fa-block-quote',
					],
					defaultOption: 'far fa-block-quote',
					keywords: 'callout indent inset quote block quote',
				},
				{
					className: 'far fa-bold',
					options: [
						'fat fa-bold', 'fal fa-bold', 'far fa-bold', 'fas fa-bold',
					],
					defaultOption: 'far fa-bold',
					keywords: 'emphasis format text bold',
				},
				{
					className: 'far fa-border-all',
					options: [
						'fat fa-border-all', 'fal fa-border-all', 'far fa-border-all', 'fas fa-border-all',
					],
					defaultOption: 'far fa-border-all',
					keywords: 'cell grid outline stroke table border all',
				},
				{
					className: 'far fa-border-bottom',
					options: [
						'fat fa-border-bottom', 'fal fa-border-bottom', 'far fa-border-bottom', 'fas fa-border-bottom',
					],
					defaultOption: 'far fa-border-bottom',
					keywords: 'cell grid outline stroke table border bottom',
				},
				{
					className: 'far fa-border-bottom-right',
					options: [
						'fat fa-border-bottom-right', 'fal fa-border-bottom-right', 'far fa-border-bottom-right', 'fas fa-border-bottom-right',
					],
					defaultOption: 'far fa-border-bottom-right',
					keywords: 'cell grid outline stroke table border bottom right',
				},
				{
					className: 'far fa-border-center-h',
					options: [
						'fat fa-border-center-h', 'fal fa-border-center-h', 'far fa-border-center-h', 'fas fa-border-center-h',
					],
					defaultOption: 'far fa-border-center-h',
					keywords: 'cell grid outline stroke table border center h',
				},
				{
					className: 'far fa-border-center-v',
					options: [
						'fat fa-border-center-v', 'fal fa-border-center-v', 'far fa-border-center-v', 'fas fa-border-center-v',
					],
					defaultOption: 'far fa-border-center-v',
					keywords: 'cell grid outline stroke table border center v',
				},
				{
					className: 'far fa-border-inner',
					options: [
						'fat fa-border-inner', 'fal fa-border-inner', 'far fa-border-inner', 'fas fa-border-inner',
					],
					defaultOption: 'far fa-border-inner',
					keywords: 'cell grid outline stroke table border inner',
				},
				{
					className: 'far fa-border-left',
					options: [
						'fat fa-border-left', 'fal fa-border-left', 'far fa-border-left', 'fas fa-border-left',
					],
					defaultOption: 'far fa-border-left',
					keywords: 'cell grid outline stroke table border left',
				},
				{
					className: 'far fa-border-none',
					options: [
						'fat fa-border-none', 'fal fa-border-none', 'far fa-border-none', 'fas fa-border-none',
					],
					defaultOption: 'far fa-border-none',
					keywords: 'cell grid outline stroke table border none',
				},
				{
					className: 'far fa-border-outer',
					options: [
						'fat fa-border-outer', 'fal fa-border-outer', 'far fa-border-outer', 'fas fa-border-outer',
					],
					defaultOption: 'far fa-border-outer',
					keywords: 'cell grid outline stroke table border outer',
				},
				{
					className: 'far fa-border-right',
					options: [
						'fat fa-border-right', 'fal fa-border-right', 'far fa-border-right', 'fas fa-border-right',
					],
					defaultOption: 'far fa-border-right',
					keywords: 'cell grid outline stroke table border right',
				},
				{
					className: 'far fa-border-top',
					options: [
						'fat fa-border-top', 'fal fa-border-top', 'far fa-border-top', 'fas fa-border-top',
					],
					defaultOption: 'far fa-border-top',
					keywords: 'cell grid outline stroke table border top',
				},
				{
					className: 'far fa-border-top-left',
					options: [
						'fat fa-border-top-left', 'fal fa-border-top-left', 'far fa-border-top-left', 'fas fa-border-top-left',
					],
					defaultOption: 'far fa-border-top-left',
					keywords: 'cell outline stroke table border top left',
				},
				{
					className: 'far fa-check',
					options: [
						'fat fa-check', 'fal fa-check', 'far fa-check', 'fas fa-check',
					],
					defaultOption: 'far fa-check',
					keywords: 'check mark accept agree check check mark checkmark confirm correct done mark notice notification notify ok select success tick todo yes ? check',
				},
				{
					className: 'far fa-check-double',
					options: [
						'fat fa-check-double', 'fal fa-check-double', 'far fa-check-double', 'fas fa-check-double',
					],
					defaultOption: 'far fa-check-double',
					keywords: 'accept agree checkmark confirm correct done notice notification notify ok select success tick todo check double',
				},
				{
					className: 'far fa-circle-check',
					options: [
						'fat fa-circle-check', 'fal fa-circle-check', 'far fa-circle-check', 'fas fa-circle-check',
					],
					defaultOption: 'far fa-circle-check',
					keywords: 'accept agree confirm correct done ok select success tick todo yes circle check',
				},
				{
					className: 'far fa-columns-3',
					options: [
						'fat fa-columns-3', 'fal fa-columns-3', 'far fa-columns-3', 'fas fa-columns-3',
					],
					defaultOption: 'far fa-columns-3',
					keywords: 'divide organize panes split columns 3',
				},
				{
					className: 'far fa-command',
					options: [
						'fat fa-command', 'fal fa-command', 'far fa-command', 'fas fa-command',
					],
					defaultOption: 'far fa-command',
					keywords: 'place of interest sign apple key loop command',
				},
				{
					className: 'far fa-file-dashed-line',
					options: [
						'fat fa-file-dashed-line', 'fal fa-file-dashed-line', 'far fa-file-dashed-line', 'fas fa-file-dashed-line',
					],
					defaultOption: 'far fa-file-dashed-line',
					keywords: 'begin divide edit end format split file dashed line',
				},
				{
					className: 'far fa-filter-circle-xmark',
					options: [
						'fat fa-filter-circle-xmark', 'fal fa-filter-circle-xmark', 'far fa-filter-circle-xmark', 'fas fa-filter-circle-xmark',
					],
					defaultOption: 'far fa-filter-circle-xmark',
					keywords: 'cancel funnel options remove separate sort filter circle xmark',
				},
				{
					className: 'far fa-filter-list',
					options: [
						'fat fa-filter-list', 'fal fa-filter-list', 'far fa-filter-list', 'fas fa-filter-list',
					],
					defaultOption: 'far fa-filter-list',
					keywords: 'funnel options separate sort filter list',
				},
				{
					className: 'far fa-filter-slash',
					options: [
						'fat fa-filter-slash', 'fal fa-filter-slash', 'far fa-filter-slash', 'fas fa-filter-slash',
					],
					defaultOption: 'far fa-filter-slash',
					keywords: 'funnel options separate sort filter slash',
				},
				{
					className: 'far fa-filters',
					options: [
						'fat fa-filters', 'fal fa-filters', 'far fa-filters', 'fas fa-filters',
					],
					defaultOption: 'far fa-filters',
					keywords: 'funnel options separate sort filters',
				},
				{
					className: 'far fa-font',
					options: [
						'fat fa-font', 'fal fa-font', 'far fa-font', 'fas fa-font',
					],
					defaultOption: 'far fa-font',
					keywords: 'alphabet glyph text type typeface font',
				},
				{
					className: 'far fa-font-case',
					options: [
						'fat fa-font-case', 'fal fa-font-case', 'far fa-font-case', 'fas fa-font-case',
					],
					defaultOption: 'far fa-font-case',
					keywords: 'alphabet glyph lowercase text type typeface uppercase font case',
				},
				{
					className: 'far fa-h1',
					options: [
						'fat fa-h1', 'fal fa-h1', 'far fa-h1', 'fas fa-h1',
					],
					defaultOption: 'far fa-h1',
					keywords: 'format header text title h1',
				},
				{
					className: 'far fa-h2',
					options: [
						'fat fa-h2', 'fal fa-h2', 'far fa-h2', 'fas fa-h2',
					],
					defaultOption: 'far fa-h2',
					keywords: 'format header text title h2',
				},
				{
					className: 'far fa-h3',
					options: [
						'fat fa-h3', 'fal fa-h3', 'far fa-h3', 'fas fa-h3',
					],
					defaultOption: 'far fa-h3',
					keywords: 'format header text title h3',
				},
				{
					className: 'far fa-h4',
					options: [
						'fat fa-h4', 'fal fa-h4', 'far fa-h4', 'fas fa-h4',
					],
					defaultOption: 'far fa-h4',
					keywords: 'format header text title h4',
				},
				{
					className: 'far fa-h5',
					options: [
						'fat fa-h5', 'fal fa-h5', 'far fa-h5', 'fas fa-h5',
					],
					defaultOption: 'far fa-h5',
					keywords: 'format header text title h5',
				},
				{
					className: 'far fa-h6',
					options: [
						'fat fa-h6', 'fal fa-h6', 'far fa-h6', 'fas fa-h6',
					],
					defaultOption: 'far fa-h6',
					keywords: 'format header text title h6',
				},
				{
					className: 'far fa-hashtag-lock',
					options: [
						'fat fa-hashtag-lock', 'fal fa-hashtag-lock', 'far fa-hashtag-lock', 'fas fa-hashtag-lock',
					],
					defaultOption: 'far fa-hashtag-lock',
					keywords: 'number lock numeric lock numlock hashtag lock',
				},
				{
					className: 'far fa-heading',
					options: [
						'fat fa-heading', 'fal fa-heading', 'far fa-heading', 'fas fa-heading',
					],
					defaultOption: 'far fa-heading',
					keywords: 'format header text title heading',
				},
				{
					className: 'far fa-highlighter',
					options: [
						'fat fa-highlighter', 'fal fa-highlighter', 'far fa-highlighter', 'fas fa-highlighter',
					],
					defaultOption: 'far fa-highlighter',
					keywords: 'edit marker sharpie update write highlighter',
				},
				{
					className: 'far fa-horizontal-rule',
					options: [
						'fat fa-horizontal-rule', 'fal fa-horizontal-rule', 'far fa-horizontal-rule', 'fas fa-horizontal-rule',
					],
					defaultOption: 'far fa-horizontal-rule',
					keywords: 'horizontal bar divider hr line page break horizontal rule',
				},
				{
					className: 'far fa-i-cursor',
					options: [
						'fat fa-i-cursor', 'fal fa-i-cursor', 'far fa-i-cursor', 'fas fa-i-cursor',
					],
					defaultOption: 'far fa-i-cursor',
					keywords: 'editing i beam type writing i cursor',
				},
				{
					className: 'far fa-icons',
					options: [
						'fat fa-icons', 'fal fa-icons', 'far fa-icons', 'fas fa-icons',
					],
					defaultOption: 'far fa-icons',
					keywords: 'bolt emoji heart image music photo symbols icons',
				},
				{
					className: 'far fa-indent',
					options: [
						'fat fa-indent', 'fal fa-indent', 'far fa-indent', 'fas fa-indent',
					],
					defaultOption: 'far fa-indent',
					keywords: 'align justify paragraph tab indent',
				},
				{
					className: 'far fa-italic',
					options: [
						'fat fa-italic', 'fal fa-italic', 'far fa-italic', 'fas fa-italic',
					],
					defaultOption: 'far fa-italic',
					keywords: 'edit emphasis font format text type italic',
				},
				{
					className: 'far fa-kerning',
					options: [
						'fat fa-kerning', 'fal fa-kerning', 'far fa-kerning', 'fas fa-kerning',
					],
					defaultOption: 'far fa-kerning',
					keywords: 'adjust font spacing text tracking type typography kerning',
				},
				{
					className: 'far fa-line-columns',
					options: [
						'fat fa-line-columns', 'fal fa-line-columns', 'far fa-line-columns', 'fas fa-line-columns',
					],
					defaultOption: 'far fa-line-columns',
					keywords: 'divide organize panes split line columns',
				},
				{
					className: 'far fa-line-height',
					options: [
						'fat fa-line-height', 'fal fa-line-height', 'far fa-line-height', 'fas fa-line-height',
					],
					defaultOption: 'far fa-line-height',
					keywords: 'baseline letter spacing text line height',
				},
				{
					className: 'far fa-list',
					options: [
						'fat fa-list', 'fal fa-list', 'far fa-list', 'fas fa-list',
					],
					defaultOption: 'far fa-list',
					keywords: 'checklist completed done finished ol todo ul list',
				},
				{
					className: 'far fa-list-check',
					options: [
						'fat fa-list-check', 'fal fa-list-check', 'far fa-list-check', 'fas fa-list-check',
					],
					defaultOption: 'far fa-list-check',
					keywords: 'checklist downloading downloads loading progress project management settings to do list check',
				},
				{
					className: 'far fa-list-ol',
					options: [
						'fat fa-list-ol', 'fal fa-list-ol', 'far fa-list-ol', 'fas fa-list-ol',
					],
					defaultOption: 'far fa-list-ol',
					keywords: 'checklist completed done finished numbers ol todo ul list ol',
				},
				{
					className: 'far fa-list-ul',
					options: [
						'fat fa-list-ul', 'fal fa-list-ul', 'far fa-list-ul', 'fas fa-list-ul',
					],
					defaultOption: 'far fa-list-ul',
					keywords: 'checklist completed done finished ol todo ul list ul',
				},
				{
					className: 'far fa-lock-a',
					options: [
						'fat fa-lock-a', 'fal fa-lock-a', 'far fa-lock-a', 'fas fa-lock-a',
					],
					defaultOption: 'far fa-lock-a',
					keywords: 'capital capslock letter lock a',
				},
				{
					className: 'far fa-lock-hashtag',
					options: [
						'fat fa-lock-hashtag', 'fal fa-lock-hashtag', 'far fa-lock-hashtag', 'fas fa-lock-hashtag',
					],
					defaultOption: 'far fa-lock-hashtag',
					keywords: 'number lock numeric lock numlock lock hashtag',
				},
				{
					className: 'far fa-outdent',
					options: [
						'fat fa-outdent', 'fal fa-outdent', 'far fa-outdent', 'fas fa-outdent',
					],
					defaultOption: 'far fa-outdent',
					keywords: 'align justify paragraph tab outdent',
				},
				{
					className: 'far fa-overline',
					options: [
						'fat fa-overline', 'fal fa-overline', 'far fa-overline', 'fas fa-overline',
					],
					defaultOption: 'far fa-overline',
					keywords: 'horizontal line overbar overscore vinculum overline',
				},
				{
					className: 'far fa-paragraph',
					options: [
						'fat fa-paragraph', 'fal fa-paragraph', 'far fa-paragraph', 'fas fa-paragraph',
					],
					defaultOption: 'far fa-paragraph',
					keywords: 'pilcrow sign edit format text writing paragraph',
				},
				{
					className: 'far fa-paragraph-left',
					options: [
						'fat fa-paragraph-left', 'fal fa-paragraph-left', 'far fa-paragraph-left', 'fas fa-paragraph-left',
					],
					defaultOption: 'far fa-paragraph-left',
					keywords: 'edit format text writing paragraph left',
				},
				{
					className: 'far fa-rectangle-list',
					options: [
						'fat fa-rectangle-list', 'fal fa-rectangle-list', 'far fa-rectangle-list', 'fas fa-rectangle-list',
					],
					defaultOption: 'far fa-rectangle-list',
					keywords: 'checklist completed done finished ol todo ul rectangle list',
				},
				{
					className: 'far fa-spell-check',
					options: [
						'fat fa-spell-check', 'fal fa-spell-check', 'far fa-spell-check', 'fas fa-spell-check',
					],
					defaultOption: 'far fa-spell-check',
					keywords: 'dictionary edit editor grammar text spell check',
				},
				{
					className: 'far fa-square-a-lock',
					options: [
						'fat fa-square-a-lock', 'fal fa-square-a-lock', 'far fa-square-a-lock', 'fas fa-square-a-lock',
					],
					defaultOption: 'far fa-square-a-lock',
					keywords: 'capital capslock letter square a lock',
				},
				{
					className: 'far fa-square-check',
					options: [
						'fat fa-square-check', 'fal fa-square-check', 'far fa-square-check', 'fas fa-square-check',
					],
					defaultOption: 'far fa-square-check',
					keywords: 'accept agree box button check check box with check check mark button checkmark confirm correct done mark ok select success tick todo yes ? square check',
				},
				{
					className: 'far fa-strikethrough',
					options: [
						'fat fa-strikethrough', 'fal fa-strikethrough', 'far fa-strikethrough', 'fas fa-strikethrough',
					],
					defaultOption: 'far fa-strikethrough',
					keywords: 'cancel edit font format text type strikethrough',
				},
				{
					className: 'far fa-subscript',
					options: [
						'fat fa-subscript', 'fal fa-subscript', 'far fa-subscript', 'fas fa-subscript',
					],
					defaultOption: 'far fa-subscript',
					keywords: 'edit font format text type subscript',
				},
				{
					className: 'far fa-superscript',
					options: [
						'fat fa-superscript', 'fal fa-superscript', 'far fa-superscript', 'fas fa-superscript',
					],
					defaultOption: 'far fa-superscript',
					keywords: 'edit exponential font format text type superscript',
				},
				{
					className: 'far fa-symbols',
					options: [
						'fat fa-symbols', 'fal fa-symbols', 'far fa-symbols', 'fas fa-symbols',
					],
					defaultOption: 'far fa-symbols',
					keywords: 'bolt emoji heart image input input symbols music photo symbols ??&% symbols',
				},
				{
					className: 'far fa-table',
					options: [
						'fat fa-table', 'fal fa-table', 'far fa-table', 'fas fa-table',
					],
					defaultOption: 'far fa-table',
					keywords: 'data excel spreadsheet table',
				},
				{
					className: 'far fa-table-cells',
					options: [
						'fat fa-table-cells', 'fal fa-table-cells', 'far fa-table-cells', 'fas fa-table-cells',
					],
					defaultOption: 'far fa-table-cells',
					keywords: 'blocks boxes grid squares table cells',
				},
				{
					className: 'far fa-table-cells-large',
					options: [
						'fat fa-table-cells-large', 'fal fa-table-cells-large', 'far fa-table-cells-large', 'fas fa-table-cells-large',
					],
					defaultOption: 'far fa-table-cells-large',
					keywords: 'blocks boxes grid squares table cells large',
				},
				{
					className: 'far fa-table-columns',
					options: [
						'fat fa-table-columns', 'fal fa-table-columns', 'far fa-table-columns', 'fas fa-table-columns',
					],
					defaultOption: 'far fa-table-columns',
					keywords: 'browser dashboard organize panes split table columns',
				},
				{
					className: 'far fa-table-layout',
					options: [
						'fat fa-table-layout', 'fal fa-table-layout', 'far fa-table-layout', 'fas fa-table-layout',
					],
					defaultOption: 'far fa-table-layout',
					keywords: 'cell column layout row spreadsheet table layout',
				},
				{
					className: 'far fa-table-list',
					options: [
						'fat fa-table-list', 'fal fa-table-list', 'far fa-table-list', 'fas fa-table-list',
					],
					defaultOption: 'far fa-table-list',
					keywords: 'checklist completed done finished ol todo ul table list',
				},
				{
					className: 'far fa-table-pivot',
					options: [
						'fat fa-table-pivot', 'fal fa-table-pivot', 'far fa-table-pivot', 'fas fa-table-pivot',
					],
					defaultOption: 'far fa-table-pivot',
					keywords: 'cell flip layout rotate row table table pivot',
				},
				{
					className: 'far fa-table-rows',
					options: [
						'fat fa-table-rows', 'fal fa-table-rows', 'far fa-table-rows', 'fas fa-table-rows',
					],
					defaultOption: 'far fa-table-rows',
					keywords: 'cell spreadsheet table table rows',
				},
				{
					className: 'far fa-text',
					options: [
						'fat fa-text', 'fal fa-text', 'far fa-text', 'fas fa-text',
					],
					defaultOption: 'far fa-text',
					keywords: 'font format letter style typography text',
				},
				{
					className: 'far fa-text-height',
					options: [
						'fat fa-text-height', 'fal fa-text-height', 'far fa-text-height', 'fas fa-text-height',
					],
					defaultOption: 'far fa-text-height',
					keywords: 'edit font format text type text height',
				},
				{
					className: 'far fa-text-size',
					options: [
						'fat fa-text-size', 'fal fa-text-size', 'far fa-text-size', 'fas fa-text-size',
					],
					defaultOption: 'far fa-text-size',
					keywords: 'decrease edit font format increase text type text size',
				},
				{
					className: 'far fa-text-slash',
					options: [
						'fat fa-text-slash', 'fal fa-text-slash', 'far fa-text-slash', 'fas fa-text-slash',
					],
					defaultOption: 'far fa-text-slash',
					keywords: 'cancel font format remove style text text slash',
				},
				{
					className: 'far fa-text-width',
					options: [
						'fat fa-text-width', 'fal fa-text-width', 'far fa-text-width', 'fas fa-text-width',
					],
					defaultOption: 'far fa-text-width',
					keywords: 'edit font format text type text width',
				},
				{
					className: 'far fa-underline',
					options: [
						'fat fa-underline', 'fal fa-underline', 'far fa-underline', 'fas fa-underline',
					],
					defaultOption: 'far fa-underline',
					keywords: 'edit emphasis format text writing underline',
				},
			],
		},
		{
			id: 'time',
			name: Loc.getMessage('LANDING_ICONS_SECTION_TIME'),
			items: [
				{
					className: 'far fa-alarm-clock',
					options: [
						'fat fa-alarm-clock', 'fal fa-alarm-clock', 'far fa-alarm-clock', 'fas fa-alarm-clock',
					],
					defaultOption: 'far fa-alarm-clock',
					keywords: 'alarm alarm clock clock date late reminder sleep snooze timer timestamp watch alarm clock',
				},
				{
					className: 'far fa-alarm-exclamation',
					options: [
						'fat fa-alarm-exclamation', 'fal fa-alarm-exclamation', 'far fa-alarm-exclamation', 'fas fa-alarm-exclamation',
					],
					defaultOption: 'far fa-alarm-exclamation',
					keywords: 'alert date late reminder sleep snooze timer timestamp watch alarm exclamation',
				},
				{
					className: 'far fa-alarm-plus',
					options: [
						'fat fa-alarm-plus', 'fal fa-alarm-plus', 'far fa-alarm-plus', 'fas fa-alarm-plus',
					],
					defaultOption: 'far fa-alarm-plus',
					keywords: 'alert date late reminder sleep snooze timer timestamp watch alarm plus',
				},
				{
					className: 'far fa-alarm-snooze',
					options: [
						'fat fa-alarm-snooze', 'fal fa-alarm-snooze', 'far fa-alarm-snooze', 'fas fa-alarm-snooze',
					],
					defaultOption: 'far fa-alarm-snooze',
					keywords: 'alert date late reminder sleep snooze timer timestamp watch alarm snooze',
				},
				{
					className: 'far fa-bell',
					options: [
						'fat fa-bell', 'fal fa-bell', 'far fa-bell', 'fas fa-bell',
					],
					defaultOption: 'far fa-bell',
					keywords: 'alarm alert bel bell chime notification reminder bell',
				},
				{
					className: 'far fa-bell-exclamation',
					options: [
						'fat fa-bell-exclamation', 'fal fa-bell-exclamation', 'far fa-bell-exclamation', 'fas fa-bell-exclamation',
					],
					defaultOption: 'far fa-bell-exclamation',
					keywords: 'alarm alert chime notification reminder bell exclamation',
				},
				{
					className: 'far fa-bell-plus',
					options: [
						'fat fa-bell-plus', 'fal fa-bell-plus', 'far fa-bell-plus', 'fas fa-bell-plus',
					],
					defaultOption: 'far fa-bell-plus',
					keywords: 'alarm alert chime notification reminder bell plus',
				},
				{
					className: 'far fa-bell-slash',
					options: [
						'fat fa-bell-slash', 'fal fa-bell-slash', 'far fa-bell-slash', 'fas fa-bell-slash',
					],
					defaultOption: 'far fa-bell-slash',
					keywords: 'alert bell bell with slash cancel disabled forbidden mute notification off quiet reminder silent bell slash',
				},
				{
					className: 'far fa-calendar',
					options: [
						'fat fa-calendar', 'fal fa-calendar', 'far fa-calendar', 'fas fa-calendar',
					],
					defaultOption: 'far fa-calendar',
					keywords: 'calendar calendar o date day event month schedule tear off calendar time when year calendar',
				},
				{
					className: 'far fa-calendar-arrow-down',
					options: [
						'fat fa-calendar-arrow-down', 'fal fa-calendar-arrow-down', 'far fa-calendar-arrow-down', 'fas fa-calendar-arrow-down',
					],
					defaultOption: 'far fa-calendar-arrow-down',
					keywords: 'date day download month reminder year calendar arrow down',
				},
				{
					className: 'far fa-calendar-arrow-up',
					options: [
						'fat fa-calendar-arrow-up', 'fal fa-calendar-arrow-up', 'far fa-calendar-arrow-up', 'fas fa-calendar-arrow-up',
					],
					defaultOption: 'far fa-calendar-arrow-up',
					keywords: 'date day month reminder upload year calendar arrow up',
				},
				{
					className: 'far fa-calendar-check',
					options: [
						'fat fa-calendar-check', 'fal fa-calendar-check', 'far fa-calendar-check', 'fas fa-calendar-check',
					],
					defaultOption: 'far fa-calendar-check',
					keywords: 'accept agree appointment confirm correct date day done event month ok schedule select success tick time todo when year calendar check',
				},
				{
					className: 'far fa-calendar-clock',
					options: [
						'fat fa-calendar-clock', 'fal fa-calendar-clock', 'far fa-calendar-clock', 'fas fa-calendar-clock',
					],
					defaultOption: 'far fa-calendar-clock',
					keywords: 'date day delay month remind year calendar clock',
				},
				{
					className: 'far fa-calendar-day',
					options: [
						'fat fa-calendar-day', 'fal fa-calendar-day', 'far fa-calendar-day', 'fas fa-calendar-day',
					],
					defaultOption: 'far fa-calendar-day',
					keywords: 'date day detail event focus month schedule single day time today when year calendar day',
				},
				{
					className: 'far fa-calendar-days',
					options: [
						'fat fa-calendar-days', 'fal fa-calendar-days', 'far fa-calendar-days', 'fas fa-calendar-days',
					],
					defaultOption: 'far fa-calendar-days',
					keywords: 'calendar date day event month schedule time when year calendar days',
				},
				{
					className: 'far fa-calendar-exclamation',
					options: [
						'fat fa-calendar-exclamation', 'fal fa-calendar-exclamation', 'far fa-calendar-exclamation', 'fas fa-calendar-exclamation',
					],
					defaultOption: 'far fa-calendar-exclamation',
					keywords: 'alert calendar date day error event important month schedule time when year calendar exclamation',
				},
				{
					className: 'far fa-calendar-heart',
					options: [
						'fat fa-calendar-heart', 'fal fa-calendar-heart', 'far fa-calendar-heart', 'fas fa-calendar-heart',
					],
					defaultOption: 'far fa-calendar-heart',
					keywords: 'date day favorite month rsvp valentine year calendar heart',
				},
				{
					className: 'far fa-calendar-image',
					options: [
						'fat fa-calendar-image', 'fal fa-calendar-image', 'far fa-calendar-image', 'fas fa-calendar-image',
					],
					defaultOption: 'far fa-calendar-image',
					keywords: 'date day month reminder year calendar image',
				},
				{
					className: 'far fa-calendar-lines',
					options: [
						'fat fa-calendar-lines', 'fal fa-calendar-lines', 'far fa-calendar-lines', 'fas fa-calendar-lines',
					],
					defaultOption: 'far fa-calendar-lines',
					keywords: 'date day month reminder year calendar lines',
				},
				{
					className: 'far fa-calendar-minus',
					options: [
						'fat fa-calendar-minus', 'fal fa-calendar-minus', 'far fa-calendar-minus', 'fas fa-calendar-minus',
					],
					defaultOption: 'far fa-calendar-minus',
					keywords: 'calendar date day delete event month negative remove schedule time when year calendar minus',
				},
				{
					className: 'far fa-calendar-pen',
					options: [
						'fat fa-calendar-pen', 'fal fa-calendar-pen', 'far fa-calendar-pen', 'fas fa-calendar-pen',
					],
					defaultOption: 'far fa-calendar-pen',
					keywords: 'date day edit event month pen pencil schedule time update when write year calendar pen',
				},
				{
					className: 'far fa-calendar-plus',
					options: [
						'fat fa-calendar-plus', 'fal fa-calendar-plus', 'far fa-calendar-plus', 'fas fa-calendar-plus',
					],
					defaultOption: 'far fa-calendar-plus',
					keywords: 'add calendar create date day event month new positive schedule time when year calendar plus',
				},
				{
					className: 'far fa-calendar-range',
					options: [
						'fat fa-calendar-range', 'fal fa-calendar-range', 'far fa-calendar-range', 'fas fa-calendar-range',
					],
					defaultOption: 'far fa-calendar-range',
					keywords: 'date day month reminder year calendar range',
				},
				{
					className: 'far fa-calendar-week',
					options: [
						'fat fa-calendar-week', 'fal fa-calendar-week', 'far fa-calendar-week', 'fas fa-calendar-week',
					],
					defaultOption: 'far fa-calendar-week',
					keywords: 'date day detail event focus month schedule single week time today when year calendar week',
				},
				{
					className: 'far fa-calendar-xmark',
					options: [
						'fat fa-calendar-xmark', 'fal fa-calendar-xmark', 'far fa-calendar-xmark', 'fas fa-calendar-xmark',
					],
					defaultOption: 'far fa-calendar-xmark',
					keywords: 'archive calendar date day delete event month remove schedule time when x year calendar xmark',
				},
				{
					className: 'far fa-calendars',
					options: [
						'fat fa-calendars', 'fal fa-calendars', 'far fa-calendars', 'fas fa-calendars',
					],
					defaultOption: 'far fa-calendars',
					keywords: 'date day month reminder year calendars',
				},
				{
					className: 'far fa-circle-calendar',
					options: [
						'fat fa-circle-calendar', 'fal fa-circle-calendar', 'far fa-circle-calendar', 'fas fa-circle-calendar',
					],
					defaultOption: 'far fa-circle-calendar',
					keywords: 'date day month reminder year circle calendar',
				},
				{
					className: 'far fa-clock',
					options: [
						'fat fa-clock', 'fal fa-clock', 'far fa-clock', 'fas fa-clock',
					],
					defaultOption: 'far fa-clock',
					keywords: '00 4 4:00 clock date four four o clock hour late minute o clock o clock schedule ticking time timer timestamp watch clock',
				},
				{
					className: 'far fa-clock-desk',
					options: [
						'fat fa-clock-desk', 'fal fa-clock-desk', 'far fa-clock-desk', 'fas fa-clock-desk',
					],
					defaultOption: 'far fa-clock-desk',
					keywords: 'alarm clock mantelpiece clock timer clock desk',
				},
				{
					className: 'far fa-clock-eight',
					options: [
						'fat fa-clock-eight', 'fal fa-clock-eight', 'far fa-clock-eight', 'fas fa-clock-eight',
					],
					defaultOption: 'far fa-clock-eight',
					keywords: '00 8 8:00 clock eight eight o clock hour minute o clock o clock ticking time clock eight',
				},
				{
					className: 'far fa-clock-eight-thirty',
					options: [
						'fat fa-clock-eight-thirty', 'fal fa-clock-eight-thirty', 'far fa-clock-eight-thirty', 'fas fa-clock-eight-thirty',
					],
					defaultOption: 'far fa-clock-eight-thirty',
					keywords: '8 8:30 clock eight eight thirty hour minute o clock thirty ticking time clock eight thirty',
				},
				{
					className: 'far fa-clock-eleven',
					options: [
						'fat fa-clock-eleven', 'fal fa-clock-eleven', 'far fa-clock-eleven', 'fas fa-clock-eleven',
					],
					defaultOption: 'far fa-clock-eleven',
					keywords: '00 11 11:00 clock eleven eleven o clock hour minute o clock o clock ticking time clock eleven',
				},
				{
					className: 'far fa-clock-eleven-thirty',
					options: [
						'fat fa-clock-eleven-thirty', 'fal fa-clock-eleven-thirty', 'far fa-clock-eleven-thirty', 'fas fa-clock-eleven-thirty',
					],
					defaultOption: 'far fa-clock-eleven-thirty',
					keywords: '11 11:30 clock eleven eleven thirty hour minute o clock thirty ticking time clock eleven thirty',
				},
				{
					className: 'far fa-clock-five',
					options: [
						'fat fa-clock-five', 'fal fa-clock-five', 'far fa-clock-five', 'fas fa-clock-five',
					],
					defaultOption: 'far fa-clock-five',
					keywords: '00 5 5:00 clock five five o clock hour minute o clock o clock ticking time clock five',
				},
				{
					className: 'far fa-clock-five-thirty',
					options: [
						'fat fa-clock-five-thirty', 'fal fa-clock-five-thirty', 'far fa-clock-five-thirty', 'fas fa-clock-five-thirty',
					],
					defaultOption: 'far fa-clock-five-thirty',
					keywords: '5 5:30 clock five five thirty hour minute o clock thirty ticking time clock five thirty',
				},
				{
					className: 'far fa-clock-four-thirty',
					options: [
						'fat fa-clock-four-thirty', 'fal fa-clock-four-thirty', 'far fa-clock-four-thirty', 'fas fa-clock-four-thirty',
					],
					defaultOption: 'far fa-clock-four-thirty',
					keywords: '4 4:30 clock four four thirty hour minute o clock thirty ticking time clock four thirty',
				},
				{
					className: 'far fa-clock-nine',
					options: [
						'fat fa-clock-nine', 'fal fa-clock-nine', 'far fa-clock-nine', 'fas fa-clock-nine',
					],
					defaultOption: 'far fa-clock-nine',
					keywords: '00 9 9:00 clock hour minute nine nine o clock o clock o clock ticking time clock nine',
				},
				{
					className: 'far fa-clock-nine-thirty',
					options: [
						'fat fa-clock-nine-thirty', 'fal fa-clock-nine-thirty', 'far fa-clock-nine-thirty', 'fas fa-clock-nine-thirty',
					],
					defaultOption: 'far fa-clock-nine-thirty',
					keywords: '9 9:30 clock hour minute nine nine thirty o clock thirty ticking time clock nine thirty',
				},
				{
					className: 'far fa-clock-one',
					options: [
						'fat fa-clock-one', 'fal fa-clock-one', 'far fa-clock-one', 'fas fa-clock-one',
					],
					defaultOption: 'far fa-clock-one',
					keywords: '00 1 1:00 clock hour minute o clock ticking time clock one',
				},
				{
					className: 'far fa-clock-one-thirty',
					options: [
						'fat fa-clock-one-thirty', 'fal fa-clock-one-thirty', 'far fa-clock-one-thirty', 'fas fa-clock-one-thirty',
					],
					defaultOption: 'far fa-clock-one-thirty',
					keywords: '1 1:30 clock hour minute o clock thirty ticking time clock one thirty',
				},
				{
					className: 'far fa-clock-seven',
					options: [
						'fat fa-clock-seven', 'fal fa-clock-seven', 'far fa-clock-seven', 'fas fa-clock-seven',
					],
					defaultOption: 'far fa-clock-seven',
					keywords: '00 7 7:00 clock hour minute o clock o clock seven seven o clock ticking time clock seven',
				},
				{
					className: 'far fa-clock-seven-thirty',
					options: [
						'fat fa-clock-seven-thirty', 'fal fa-clock-seven-thirty', 'far fa-clock-seven-thirty', 'fas fa-clock-seven-thirty',
					],
					defaultOption: 'far fa-clock-seven-thirty',
					keywords: '7 7:30 clock hour minute o clock seven seven thirty thirty ticking time clock seven thirty',
				},
				{
					className: 'far fa-clock-six',
					options: [
						'fat fa-clock-six', 'fal fa-clock-six', 'far fa-clock-six', 'fas fa-clock-six',
					],
					defaultOption: 'far fa-clock-six',
					keywords: '00 6 6:00 clock hour minute o clock o clock six six o clock ticking time clock six',
				},
				{
					className: 'far fa-clock-six-thirty',
					options: [
						'fat fa-clock-six-thirty', 'fal fa-clock-six-thirty', 'far fa-clock-six-thirty', 'fas fa-clock-six-thirty',
					],
					defaultOption: 'far fa-clock-six-thirty',
					keywords: '6 6:30 clock hour minute o clock six six thirty thirty ticking time clock six thirty',
				},
				{
					className: 'far fa-clock-ten',
					options: [
						'fat fa-clock-ten', 'fal fa-clock-ten', 'far fa-clock-ten', 'fas fa-clock-ten',
					],
					defaultOption: 'far fa-clock-ten',
					keywords: '00 10 10:00 clock hour minute o clock o clock ten ten o clock ticking time clock ten',
				},
				{
					className: 'far fa-clock-ten-thirty',
					options: [
						'fat fa-clock-ten-thirty', 'fal fa-clock-ten-thirty', 'far fa-clock-ten-thirty', 'fas fa-clock-ten-thirty',
					],
					defaultOption: 'far fa-clock-ten-thirty',
					keywords: '10 10:30 clock hour minute o clock ten ten thirty thirty ticking time clock ten thirty',
				},
				{
					className: 'far fa-clock-three',
					options: [
						'fat fa-clock-three', 'fal fa-clock-three', 'far fa-clock-three', 'fas fa-clock-three',
					],
					defaultOption: 'far fa-clock-three',
					keywords: '00 3 3:00 clock hour minute o clock o clock three three o clock ticking time witching hour clock three',
				},
				{
					className: 'far fa-clock-three-thirty',
					options: [
						'fat fa-clock-three-thirty', 'fal fa-clock-three-thirty', 'far fa-clock-three-thirty', 'fas fa-clock-three-thirty',
					],
					defaultOption: 'far fa-clock-three-thirty',
					keywords: '3 3:30 clock hour minute o clock thirty three three thirty ticking time clock three thirty',
				},
				{
					className: 'far fa-clock-twelve',
					options: [
						'fat fa-clock-twelve', 'fal fa-clock-twelve', 'far fa-clock-twelve', 'fas fa-clock-twelve',
					],
					defaultOption: 'far fa-clock-twelve',
					keywords: '00 12 12:00 clock hour midnight minute noon o clock o clock ticking time twelve twelve o clock clock twelve',
				},
				{
					className: 'far fa-clock-twelve-thirty',
					options: [
						'fat fa-clock-twelve-thirty', 'fal fa-clock-twelve-thirty', 'far fa-clock-twelve-thirty', 'fas fa-clock-twelve-thirty',
					],
					defaultOption: 'far fa-clock-twelve-thirty',
					keywords: '12 12:30 clock hour minute o clock thirty ticking time twelve twelve thirty clock twelve thirty',
				},
				{
					className: 'far fa-clock-two',
					options: [
						'fat fa-clock-two', 'fal fa-clock-two', 'far fa-clock-two', 'fas fa-clock-two',
					],
					defaultOption: 'far fa-clock-two',
					keywords: '00 1 1:00 2 2:00 clock hour minute o clock one one o clock o clock ticking time two two o clock clock two',
				},
				{
					className: 'far fa-clock-two-thirty',
					options: [
						'fat fa-clock-two-thirty', 'fal fa-clock-two-thirty', 'far fa-clock-two-thirty', 'fas fa-clock-two-thirty',
					],
					defaultOption: 'far fa-clock-two-thirty',
					keywords: '1 1:30 2 2:30 clock hour minute o clock one one thirty thirty ticking time two two thirty clock two thirty',
				},
				{
					className: 'far fa-flux-capacitor',
					options: [
						'fat fa-flux-capacitor', 'fal fa-flux-capacitor', 'far fa-flux-capacitor', 'fas fa-flux-capacitor',
					],
					defaultOption: 'far fa-flux-capacitor',
					keywords: '1 21 gigawatts 88 mph emmett brown marty mcfly y back to the future delorean dmc time machine time travel flux capacitor',
				},
				{
					className: 'far fa-hourglass',
					options: [
						'fat fa-hourglass', 'fal fa-hourglass', 'far fa-hourglass', 'fas fa-hourglass',
					],
					defaultOption: 'far fa-hourglass',
					keywords: 'hour hourglass hourglass not done minute sand stopwatch time timer hourglass',
				},
				{
					className: 'far fa-hourglass-clock',
					options: [
						'fat fa-hourglass-clock', 'fal fa-hourglass-clock', 'far fa-hourglass-clock', 'fas fa-hourglass-clock',
					],
					defaultOption: 'far fa-hourglass-clock',
					keywords: 'countdown hour hourglass hourglass not done minute sand stopwatch time timer hourglass clock',
				},
				{
					className: 'far fa-hourglass-empty',
					options: [
						'fat fa-hourglass-empty', 'fal fa-hourglass-empty', 'far fa-hourglass-empty', 'fas fa-hourglass-empty',
					],
					defaultOption: 'far fa-hourglass-empty',
					keywords: 'hour minute sand stopwatch time hourglass empty',
				},
				{
					className: 'far fa-hourglass-end',
					options: [
						'fat fa-hourglass-end', 'fal fa-hourglass-end', 'far fa-hourglass-end', 'fas fa-hourglass-end',
					],
					defaultOption: 'far fa-hourglass-end',
					keywords: 'hour hourglass done minute sand stopwatch time timer hourglass end',
				},
				{
					className: 'far fa-hourglass-start',
					options: [
						'fat fa-hourglass-start', 'fal fa-hourglass-start', 'far fa-hourglass-start', 'fas fa-hourglass-start',
					],
					defaultOption: 'far fa-hourglass-start',
					keywords: 'hour minute sand stopwatch time hourglass start',
				},
				{
					className: 'far fa-house-day',
					options: [
						'fat fa-house-day', 'fal fa-house-day', 'far fa-house-day', 'fas fa-house-day',
					],
					defaultOption: 'far fa-house-day',
					keywords: 'abode building family home residence solar sun house day',
				},
				{
					className: 'far fa-house-night',
					options: [
						'fat fa-house-night', 'fal fa-house-night', 'far fa-house-night', 'fas fa-house-night',
					],
					defaultOption: 'far fa-house-night',
					keywords: 'abode building family home moon residence stars house night',
				},
				{
					className: 'far fa-reply-clock',
					options: [
						'fat fa-reply-clock', 'fal fa-reply-clock', 'far fa-reply-clock', 'fas fa-reply-clock',
					],
					defaultOption: 'far fa-reply-clock',
					keywords: 'email remind reply send reply clock',
				},
				{
					className: 'far fa-snooze',
					options: [
						'fat fa-snooze', 'fal fa-snooze', 'far fa-snooze', 'fas fa-snooze',
					],
					defaultOption: 'far fa-snooze',
					keywords: 'alarm comic nap rest siesta sleep zzz snooze',
				},
				{
					className: 'far fa-stopwatch',
					options: [
						'fat fa-stopwatch', 'fal fa-stopwatch', 'far fa-stopwatch', 'fas fa-stopwatch',
					],
					defaultOption: 'far fa-stopwatch',
					keywords: 'clock reminder stopwatch time stopwatch',
				},
				{
					className: 'far fa-stopwatch-20',
					options: [
						'fat fa-stopwatch-20', 'fal fa-stopwatch-20', 'far fa-stopwatch-20', 'fas fa-stopwatch-20',
					],
					defaultOption: 'far fa-stopwatch-20',
					keywords: 'abcs countdown covid 19 happy birthday i will survive reminder seconds time timer stopwatch 20',
				},
				{
					className: 'far fa-timer',
					options: [
						'fat fa-timer', 'fal fa-timer', 'far fa-timer', 'fas fa-timer',
					],
					defaultOption: 'far fa-timer',
					keywords: 'clock countdown stopwatch timer timer clock timer',
				},
				{
					className: 'far fa-trash-can-clock',
					options: [
						'fat fa-trash-can-clock', 'fal fa-trash-can-clock', 'far fa-trash-can-clock', 'fas fa-trash-can-clock',
					],
					defaultOption: 'far fa-trash-can-clock',
					keywords: 'delay delete garbage hide remove trash can clock',
				},
				{
					className: 'far fa-trash-clock',
					options: [
						'fat fa-trash-clock', 'fal fa-trash-clock', 'far fa-trash-clock', 'fas fa-trash-clock',
					],
					defaultOption: 'far fa-trash-clock',
					keywords: 'delay delete garbage hide remove trash clock',
				},
				{
					className: 'far fa-watch',
					options: [
						'fat fa-watch', 'fal fa-watch', 'far fa-watch', 'fas fa-watch',
					],
					defaultOption: 'far fa-watch',
					keywords: 'alert clock time watch wristwatch watch',
				},
				{
					className: 'far fa-watch-apple',
					options: [
						'fat fa-watch-apple', 'fal fa-watch-apple', 'far fa-watch-apple', 'fas fa-watch-apple',
					],
					defaultOption: 'far fa-watch-apple',
					keywords: 'apps digital fitness smartwatch watch apple',
				},
				{
					className: 'far fa-watch-calculator',
					options: [
						'fat fa-watch-calculator', 'fal fa-watch-calculator', 'far fa-watch-calculator', 'fas fa-watch-calculator',
					],
					defaultOption: 'far fa-watch-calculator',
					keywords: 'casio digital math time watch calculator',
				},
				{
					className: 'far fa-watch-smart',
					options: [
						'fat fa-watch-smart', 'fal fa-watch-smart', 'far fa-watch-smart', 'fas fa-watch-smart',
					],
					defaultOption: 'far fa-watch-smart',
					keywords: 'apps fitness time watch smart',
				},
			],
		},
		{
			id: 'toggle',
			name: Loc.getMessage('LANDING_ICONS_SECTION_TOGGLE'),
			items: [
				{
					className: 'far fa-brightness',
					options: [
						'fat fa-brightness', 'fal fa-brightness', 'far fa-brightness', 'fas fa-brightness',
					],
					defaultOption: 'far fa-brightness',
					keywords: 'bright bright button brightness display light sun brightness',
				},
				{
					className: 'far fa-brightness-low',
					options: [
						'fat fa-brightness-low', 'fal fa-brightness-low', 'far fa-brightness-low', 'fas fa-brightness-low',
					],
					defaultOption: 'far fa-brightness-low',
					keywords: 'bright brightness dim dim button display light low sun brightness low',
				},
				{
					className: 'far fa-bullseye',
					options: [
						'fat fa-bullseye', 'fal fa-bullseye', 'far fa-bullseye', 'fas fa-bullseye',
					],
					defaultOption: 'far fa-bullseye',
					keywords: 'archery goal objective target bullseye',
				},
				{
					className: 'far fa-bullseye-arrow',
					options: [
						'fat fa-bullseye-arrow', 'fal fa-bullseye-arrow', 'far fa-bullseye-arrow', 'fas fa-bullseye-arrow',
					],
					defaultOption: 'far fa-bullseye-arrow',
					keywords: 'archery arrow bullseye dart direct hit game goal hit objective robin hood target bullseye arrow',
				},
				{
					className: 'far fa-circle',
					options: [
						'fat fa-circle', 'fal fa-circle', 'far fa-circle', 'fas fa-circle',
					],
					defaultOption: 'far fa-circle',
					keywords: 'black circle black large circle black circle blue blue circle brown brown circle circle circle thin diameter dot ellipse geometric green green circle notification orange orange circle purple purple circle red red circle round white circle yellow yellow circle circle',
				},
				{
					className: 'far fa-circle-check',
					options: [
						'fat fa-circle-check', 'fal fa-circle-check', 'far fa-circle-check', 'fas fa-circle-check',
					],
					defaultOption: 'far fa-circle-check',
					keywords: 'accept agree confirm correct done ok select success tick todo yes circle check',
				},
				{
					className: 'far fa-circle-dot',
					options: [
						'fat fa-circle-dot', 'fal fa-circle-dot', 'far fa-circle-dot', 'fas fa-circle-dot',
					],
					defaultOption: 'far fa-circle-dot',
					keywords: 'bullseye button geometric notification radio radio button target circle dot',
				},
				{
					className: 'far fa-dial',
					options: [
						'fat fa-dial', 'fal fa-dial', 'far fa-dial', 'fas fa-dial',
					],
					defaultOption: 'far fa-dial',
					keywords: 'dial level dial',
				},
				{
					className: 'far fa-dial-high',
					options: [
						'fat fa-dial-high', 'fal fa-dial-high', 'far fa-dial-high', 'fas fa-dial-high',
					],
					defaultOption: 'far fa-dial-high',
					keywords: 'dial level dial high',
				},
				{
					className: 'far fa-dial-low',
					options: [
						'fat fa-dial-low', 'fal fa-dial-low', 'far fa-dial-low', 'fas fa-dial-low',
					],
					defaultOption: 'far fa-dial-low',
					keywords: 'dial level dial low',
				},
				{
					className: 'far fa-dial-max',
					options: [
						'fat fa-dial-max', 'fal fa-dial-max', 'far fa-dial-max', 'fas fa-dial-max',
					],
					defaultOption: 'far fa-dial-max',
					keywords: 'dial level dial max',
				},
				{
					className: 'far fa-dial-med',
					options: [
						'fat fa-dial-med', 'fal fa-dial-med', 'far fa-dial-med', 'fas fa-dial-med',
					],
					defaultOption: 'far fa-dial-med',
					keywords: 'dial level dial med',
				},
				{
					className: 'far fa-dial-med-low',
					options: [
						'fat fa-dial-med-low', 'fal fa-dial-med-low', 'far fa-dial-med-low', 'fas fa-dial-med-low',
					],
					defaultOption: 'far fa-dial-med-low',
					keywords: 'dial level dial med low',
				},
				{
					className: 'far fa-dial-min',
					options: [
						'fat fa-dial-min', 'fal fa-dial-min', 'far fa-dial-min', 'fas fa-dial-min',
					],
					defaultOption: 'far fa-dial-min',
					keywords: 'dial level dial min',
				},
				{
					className: 'far fa-dial-off',
					options: [
						'fat fa-dial-off', 'fal fa-dial-off', 'far fa-dial-off', 'fas fa-dial-off',
					],
					defaultOption: 'far fa-dial-off',
					keywords: 'dial level dial off',
				},
				{
					className: 'far fa-keyboard-brightness',
					options: [
						'fat fa-keyboard-brightness', 'fal fa-keyboard-brightness', 'far fa-keyboard-brightness', 'fas fa-keyboard-brightness',
					],
					defaultOption: 'far fa-keyboard-brightness',
					keywords: 'glow keyboard keycap light keyboard brightness',
				},
				{
					className: 'far fa-keyboard-brightness-low',
					options: [
						'fat fa-keyboard-brightness-low', 'fal fa-keyboard-brightness-low', 'far fa-keyboard-brightness-low', 'fas fa-keyboard-brightness-low',
					],
					defaultOption: 'far fa-keyboard-brightness-low',
					keywords: 'glow keyboard keycap light keyboard brightness low',
				},
				{
					className: 'far fa-location-crosshairs',
					options: [
						'fat fa-location-crosshairs', 'fal fa-location-crosshairs', 'far fa-location-crosshairs', 'fas fa-location-crosshairs',
					],
					defaultOption: 'far fa-location-crosshairs',
					keywords: 'address coordinate direction gps location map navigation place where location crosshairs',
				},
				{
					className: 'far fa-location-crosshairs-slash',
					options: [
						'fat fa-location-crosshairs-slash', 'fal fa-location-crosshairs-slash', 'far fa-location-crosshairs-slash', 'fas fa-location-crosshairs-slash',
					],
					defaultOption: 'far fa-location-crosshairs-slash',
					keywords: 'address coordinate direction gps map navigation place where location crosshairs slash',
				},
				{
					className: 'far fa-microphone',
					options: [
						'fat fa-microphone', 'fal fa-microphone', 'far fa-microphone', 'fas fa-microphone',
					],
					defaultOption: 'far fa-microphone',
					keywords: 'audio podcast record sing sound voice microphone',
				},
				{
					className: 'far fa-microphone-slash',
					options: [
						'fat fa-microphone-slash', 'fal fa-microphone-slash', 'far fa-microphone-slash', 'fas fa-microphone-slash',
					],
					defaultOption: 'far fa-microphone-slash',
					keywords: 'audio disable mute podcast record sing sound voice microphone slash',
				},
				{
					className: 'far fa-plane-up',
					options: [
						'fat fa-plane-up', 'fal fa-plane-up', 'far fa-plane-up', 'fas fa-plane-up',
					],
					defaultOption: 'far fa-plane-up',
					keywords: 'airplane airport internet signal sky wifi wireless plane up',
				},
				{
					className: 'far fa-plane-up-slash',
					options: [
						'fat fa-plane-up-slash', 'fal fa-plane-up-slash', 'far fa-plane-up-slash', 'fas fa-plane-up-slash',
					],
					defaultOption: 'far fa-plane-up-slash',
					keywords: 'airplane airport internet signal sky wifi wireless plane up slash',
				},
				{
					className: 'far fa-signal',
					options: [
						'fat fa-signal', 'fal fa-signal', 'far fa-signal', 'fas fa-signal',
					],
					defaultOption: 'far fa-signal',
					keywords: 'antenna antenna bars bar bars cell graph mobile online phone reception status signal',
				},
				{
					className: 'far fa-signal-bars',
					options: [
						'fat fa-signal-bars', 'fal fa-signal-bars', 'far fa-signal-bars', 'fas fa-signal-bars',
					],
					defaultOption: 'far fa-signal-bars',
					keywords: 'bars graph online reception status signal bars',
				},
				{
					className: 'far fa-signal-bars-fair',
					options: [
						'fat fa-signal-bars-fair', 'fal fa-signal-bars-fair', 'far fa-signal-bars-fair', 'fas fa-signal-bars-fair',
					],
					defaultOption: 'far fa-signal-bars-fair',
					keywords: 'bars graph online reception status signal bars fair',
				},
				{
					className: 'far fa-signal-bars-good',
					options: [
						'fat fa-signal-bars-good', 'fal fa-signal-bars-good', 'far fa-signal-bars-good', 'fas fa-signal-bars-good',
					],
					defaultOption: 'far fa-signal-bars-good',
					keywords: 'bars graph online reception status signal bars good',
				},
				{
					className: 'far fa-signal-bars-slash',
					options: [
						'fat fa-signal-bars-slash', 'fal fa-signal-bars-slash', 'far fa-signal-bars-slash', 'fas fa-signal-bars-slash',
					],
					defaultOption: 'far fa-signal-bars-slash',
					keywords: 'bars graph online reception status signal bars slash',
				},
				{
					className: 'far fa-signal-bars-weak',
					options: [
						'fat fa-signal-bars-weak', 'fal fa-signal-bars-weak', 'far fa-signal-bars-weak', 'fas fa-signal-bars-weak',
					],
					defaultOption: 'far fa-signal-bars-weak',
					keywords: 'bars graph online reception status signal bars weak',
				},
				{
					className: 'far fa-signal-fair',
					options: [
						'fat fa-signal-fair', 'fal fa-signal-fair', 'far fa-signal-fair', 'fas fa-signal-fair',
					],
					defaultOption: 'far fa-signal-fair',
					keywords: 'bars graph online reception status signal fair',
				},
				{
					className: 'far fa-signal-good',
					options: [
						'fat fa-signal-good', 'fal fa-signal-good', 'far fa-signal-good', 'fas fa-signal-good',
					],
					defaultOption: 'far fa-signal-good',
					keywords: 'bars graph online reception status signal good',
				},
				{
					className: 'far fa-signal-slash',
					options: [
						'fat fa-signal-slash', 'fal fa-signal-slash', 'far fa-signal-slash', 'fas fa-signal-slash',
					],
					defaultOption: 'far fa-signal-slash',
					keywords: 'bars graph online reception status signal slash',
				},
				{
					className: 'far fa-signal-strong',
					options: [
						'fat fa-signal-strong', 'fal fa-signal-strong', 'far fa-signal-strong', 'fas fa-signal-strong',
					],
					defaultOption: 'far fa-signal-strong',
					keywords: 'bars graph online reception status signal strong',
				},
				{
					className: 'far fa-signal-weak',
					options: [
						'fat fa-signal-weak', 'fal fa-signal-weak', 'far fa-signal-weak', 'fas fa-signal-weak',
					],
					defaultOption: 'far fa-signal-weak',
					keywords: 'bars graph online reception status signal weak',
				},
				{
					className: 'far fa-slider',
					options: [
						'fat fa-slider', 'fal fa-slider', 'far fa-slider', 'fas fa-slider',
					],
					defaultOption: 'far fa-slider',
					keywords: 'adjust settings toggle slider',
				},
				{
					className: 'far fa-sliders-simple',
					options: [
						'fat fa-sliders-simple', 'fal fa-sliders-simple', 'far fa-sliders-simple', 'fas fa-sliders-simple',
					],
					defaultOption: 'far fa-sliders-simple',
					keywords: 'adjust off on settings toggles sliders simple',
				},
				{
					className: 'far fa-star',
					options: [
						'fat fa-star', 'fal fa-star', 'far fa-star', 'fas fa-star',
					],
					defaultOption: 'far fa-star',
					keywords: 'achievement award favorite important night rating score star star',
				},
				{
					className: 'far fa-star-half',
					options: [
						'fat fa-star-half', 'fal fa-star-half', 'far fa-star-half', 'fas fa-star-half',
					],
					defaultOption: 'far fa-star-half',
					keywords: 'achievement award rating score star half empty star half full star half',
				},
				{
					className: 'far fa-star-half-stroke',
					options: [
						'fat fa-star-half-stroke', 'fal fa-star-half-stroke', 'far fa-star-half-stroke', 'fas fa-star-half-stroke',
					],
					defaultOption: 'far fa-star-half-stroke',
					keywords: 'achievement award rating score star half empty star half full star half stroke',
				},
				{
					className: 'far fa-toggle-off',
					options: [
						'fat fa-toggle-off', 'fal fa-toggle-off', 'far fa-toggle-off', 'fas fa-toggle-off',
					],
					defaultOption: 'far fa-toggle-off',
					keywords: 'switch toggle off',
				},
				{
					className: 'far fa-toggle-on',
					options: [
						'fat fa-toggle-on', 'fal fa-toggle-on', 'far fa-toggle-on', 'fas fa-toggle-on',
					],
					defaultOption: 'far fa-toggle-on',
					keywords: 'switch toggle on',
				},
				{
					className: 'far fa-wifi',
					options: [
						'fat fa-wifi', 'fal fa-wifi', 'far fa-wifi', 'fas fa-wifi',
					],
					defaultOption: 'far fa-wifi',
					keywords: 'connection hotspot internet network wireless wifi',
				},
				{
					className: 'far fa-wifi-exclamation',
					options: [
						'fat fa-wifi-exclamation', 'fal fa-wifi-exclamation', 'far fa-wifi-exclamation', 'fas fa-wifi-exclamation',
					],
					defaultOption: 'far fa-wifi-exclamation',
					keywords: 'connection fail internet wireless wifi exclamation',
				},
				{
					className: 'far fa-wifi-fair',
					options: [
						'fat fa-wifi-fair', 'fal fa-wifi-fair', 'far fa-wifi-fair', 'fas fa-wifi-fair',
					],
					defaultOption: 'far fa-wifi-fair',
					keywords: 'average connection hotspot internet network wireless wifi fair',
				},
				{
					className: 'far fa-wifi-slash',
					options: [
						'fat fa-wifi-slash', 'fal fa-wifi-slash', 'far fa-wifi-slash', 'fas fa-wifi-slash',
					],
					defaultOption: 'far fa-wifi-slash',
					keywords: 'ban broken connection disabled hotspot internet network unavailable wireless wifi slash',
				},
				{
					className: 'far fa-wifi-weak',
					options: [
						'fat fa-wifi-weak', 'fal fa-wifi-weak', 'far fa-wifi-weak', 'fas fa-wifi-weak',
					],
					defaultOption: 'far fa-wifi-weak',
					keywords: 'connection hotspot internet network weak wireless wifi weak',
				},
			],
		},
		{
			id: 'transportation',
			name: Loc.getMessage('LANDING_ICONS_SECTION_TRANSPORTATION'),
			items: [
				{
					className: 'far fa-baby-carriage',
					options: [
						'fat fa-baby-carriage', 'fal fa-baby-carriage', 'far fa-baby-carriage', 'fas fa-baby-carriage',
					],
					defaultOption: 'far fa-baby-carriage',
					keywords: 'buggy carrier infant push stroller transportation walk wheels baby carriage',
				},
				{
					className: 'far fa-bicycle',
					options: [
						'fat fa-bicycle', 'fal fa-bicycle', 'far fa-bicycle', 'fas fa-bicycle',
					],
					defaultOption: 'far fa-bicycle',
					keywords: 'bicycle bike gears pedal transportation vehicle bicycle',
				},
				{
					className: 'far fa-bus',
					options: [
						'fat fa-bus', 'fal fa-bus', 'far fa-bus', 'fas fa-bus',
					],
					defaultOption: 'far fa-bus',
					keywords: 'bus oncoming oncoming bus public transportation transportation travel vehicle bus',
				},
				{
					className: 'far fa-bus-simple',
					options: [
						'fat fa-bus-simple', 'fal fa-bus-simple', 'far fa-bus-simple', 'fas fa-bus-simple',
					],
					defaultOption: 'far fa-bus-simple',
					keywords: 'mta public transportation transportation travel vehicle bus simple',
				},
				{
					className: 'far fa-cable-car',
					options: [
						'fat fa-cable-car', 'fal fa-cable-car', 'far fa-cable-car', 'fas fa-cable-car',
					],
					defaultOption: 'far fa-cable-car',
					keywords: 'aerial tramway cable gondola lift mountain mountain cableway tram tramway trolley cable car',
				},
				{
					className: 'far fa-car',
					options: [
						'fat fa-car', 'fal fa-car', 'far fa-car', 'fas fa-car',
					],
					defaultOption: 'far fa-car',
					keywords: 'auto automobile car oncoming oncoming automobile sedan transportation travel vehicle car',
				},
				{
					className: 'far fa-car-bolt',
					options: [
						'fat fa-car-bolt', 'fal fa-car-bolt', 'far fa-car-bolt', 'fas fa-car-bolt',
					],
					defaultOption: 'far fa-car-bolt',
					keywords: 'auto automobile electric ev sedan tesla transportation travel vehicle car bolt',
				},
				{
					className: 'far fa-car-building',
					options: [
						'fat fa-car-building', 'fal fa-car-building', 'far fa-car-building', 'fas fa-car-building',
					],
					defaultOption: 'far fa-car-building',
					keywords: 'city office transportation travel work car building',
				},
				{
					className: 'far fa-car-bump',
					options: [
						'fat fa-car-bump', 'fal fa-car-bump', 'far fa-car-bump', 'fas fa-car-bump',
					],
					defaultOption: 'far fa-car-bump',
					keywords: 'auto automobile off road sedan transportation vehicle car bump',
				},
				{
					className: 'far fa-car-bus',
					options: [
						'fat fa-car-bus', 'fal fa-car-bus', 'far fa-car-bus', 'fas fa-car-bus',
					],
					defaultOption: 'far fa-car-bus',
					keywords: 'directions ground transportation map transportation travel car bus',
				},
				{
					className: 'far fa-car-circle-bolt',
					options: [
						'fat fa-car-circle-bolt', 'fal fa-car-circle-bolt', 'far fa-car-circle-bolt', 'fas fa-car-circle-bolt',
					],
					defaultOption: 'far fa-car-circle-bolt',
					keywords: 'auto automobile electric ev sedan tesla transportation travel vehicle car circle bolt',
				},
				{
					className: 'far fa-car-crash',
					options: [
						'fat fa-car-crash', 'fal fa-car-crash', 'far fa-car-crash', 'fas fa-car-crash',
					],
					defaultOption: 'far fa-car-crash',
					keywords: 'accident auto automobile insurance sedan transportation vehicle wreck car crash',
				},
				{
					className: 'far fa-car-rear',
					options: [
						'fat fa-car-rear', 'fal fa-car-rear', 'far fa-car-rear', 'fas fa-car-rear',
					],
					defaultOption: 'far fa-car-rear',
					keywords: 'auto automobile sedan transportation travel vehicle car rear',
				},
				{
					className: 'far fa-car-side',
					options: [
						'fat fa-car-side', 'fal fa-car-side', 'far fa-car-side', 'fas fa-car-side',
					],
					defaultOption: 'far fa-car-side',
					keywords: 'auto automobile car sedan transportation travel vehicle car side',
				},
				{
					className: 'far fa-car-side-bolt',
					options: [
						'fat fa-car-side-bolt', 'fal fa-car-side-bolt', 'far fa-car-side-bolt', 'fas fa-car-side-bolt',
					],
					defaultOption: 'far fa-car-side-bolt',
					keywords: 'auto automobile electric ev sedan tesla transportation travel vehicle car side bolt',
				},
				{
					className: 'far fa-car-tilt',
					options: [
						'fat fa-car-tilt', 'fal fa-car-tilt', 'far fa-car-tilt', 'fas fa-car-tilt',
					],
					defaultOption: 'far fa-car-tilt',
					keywords: 'accident auto automobile insurance sedan transportation vehicle wreck car tilt',
				},
				{
					className: 'far fa-cars',
					options: [
						'fat fa-cars', 'fal fa-cars', 'far fa-cars', 'fas fa-cars',
					],
					defaultOption: 'far fa-cars',
					keywords: 'automobiles autos transportation travel cars',
				},
				{
					className: 'far fa-cart-shopping',
					options: [
						'fat fa-cart-shopping', 'fal fa-cart-shopping', 'far fa-cart-shopping', 'fas fa-cart-shopping',
					],
					defaultOption: 'far fa-cart-shopping',
					keywords: 'buy cart checkout grocery payment purchase shopping shopping cart trolley cart shopping',
				},
				{
					className: 'far fa-drone',
					options: [
						'fat fa-drone', 'fal fa-drone', 'far fa-drone', 'fas fa-drone',
					],
					defaultOption: 'far fa-drone',
					keywords: 'aerial big brother surveillance uav unmanned vehicle drone',
				},
				{
					className: 'far fa-drone-front',
					options: [
						'fat fa-drone-front', 'fal fa-drone-front', 'far fa-drone-front', 'fas fa-drone-front',
					],
					defaultOption: 'far fa-drone-front',
					keywords: 'aerial big brother surveillance uav unmanned vehicle drone front',
				},
				{
					className: 'far fa-flux-capacitor',
					options: [
						'fat fa-flux-capacitor', 'fal fa-flux-capacitor', 'far fa-flux-capacitor', 'fas fa-flux-capacitor',
					],
					defaultOption: 'far fa-flux-capacitor',
					keywords: '1 21 gigawatts 88 mph emmett brown marty mcfly y back to the future delorean dmc time machine time travel flux capacitor',
				},
				{
					className: 'far fa-helicopter',
					options: [
						'fat fa-helicopter', 'fal fa-helicopter', 'far fa-helicopter', 'fas fa-helicopter',
					],
					defaultOption: 'far fa-helicopter',
					keywords: 'airwolf apache chopper flight fly helicopter travel vehicle helicopter',
				},
				{
					className: 'far fa-horse',
					options: [
						'fat fa-horse', 'fal fa-horse', 'far fa-horse', 'fas fa-horse',
					],
					defaultOption: 'far fa-horse',
					keywords: 'equestrian equus fauna horse mammmal mare neigh pony racehorse racing horse',
				},
				{
					className: 'far fa-horse-saddle',
					options: [
						'fat fa-horse-saddle', 'fal fa-horse-saddle', 'far fa-horse-saddle', 'fas fa-horse-saddle',
					],
					defaultOption: 'far fa-horse-saddle',
					keywords: 'cowboy equus fauna mammmal mare neigh pony rodeo western horse saddle',
				},
				{
					className: 'far fa-jet-fighter',
					options: [
						'fat fa-jet-fighter', 'fal fa-jet-fighter', 'far fa-jet-fighter', 'fas fa-jet-fighter',
					],
					defaultOption: 'far fa-jet-fighter',
					keywords: 'airplane fast fly goose maverick plane quick top gun transportation travel jet fighter',
				},
				{
					className: 'far fa-moped',
					options: [
						'fat fa-moped', 'fal fa-moped', 'far fa-moped', 'fas fa-moped',
					],
					defaultOption: 'far fa-moped',
					keywords: 'delivery motorbike scooter moped',
				},
				{
					className: 'far fa-motorcycle',
					options: [
						'fat fa-motorcycle', 'fal fa-motorcycle', 'far fa-motorcycle', 'fas fa-motorcycle',
					],
					defaultOption: 'far fa-motorcycle',
					keywords: 'bike machine motorcycle racing transportation vehicle motorcycle',
				},
				{
					className: 'far fa-paper-plane',
					options: [
						'fat fa-paper-plane', 'fal fa-paper-plane', 'far fa-paper-plane', 'fas fa-paper-plane',
					],
					defaultOption: 'far fa-paper-plane',
					keywords: 'air float fold mail paper send paper plane',
				},
				{
					className: 'far fa-pegasus',
					options: [
						'fat fa-pegasus', 'fal fa-pegasus', 'far fa-pegasus', 'fas fa-pegasus',
					],
					defaultOption: 'far fa-pegasus',
					keywords: 'fantasy horse unicorn wings pegasus',
				},
				{
					className: 'far fa-person-ski-lift',
					options: [
						'fat fa-person-ski-lift', 'fal fa-person-ski-lift', 'far fa-person-ski-lift', 'fas fa-person-ski-lift',
					],
					defaultOption: 'far fa-person-ski-lift',
					keywords: 'mountain skiing winter person ski lift',
				},
				{
					className: 'far fa-person-snowmobiling',
					options: [
						'fat fa-person-snowmobiling', 'fal fa-person-snowmobiling', 'far fa-person-snowmobiling', 'fas fa-person-snowmobiling',
					],
					defaultOption: 'far fa-person-snowmobiling',
					keywords: 'snowmobile winter person snowmobiling',
				},
				{
					className: 'far fa-plane',
					options: [
						'fat fa-plane', 'fal fa-plane', 'far fa-plane', 'fas fa-plane',
					],
					defaultOption: 'far fa-plane',
					keywords: 'airplane airport destination fly location mode travel trip plane',
				},
				{
					className: 'far fa-plane-engines',
					options: [
						'fat fa-plane-engines', 'fal fa-plane-engines', 'far fa-plane-engines', 'fas fa-plane-engines',
					],
					defaultOption: 'far fa-plane-engines',
					keywords: 'aeroplane airplane airport destination fly location mode travel trip plane engines',
				},
				{
					className: 'far fa-plane-prop',
					options: [
						'fat fa-plane-prop', 'fal fa-plane-prop', 'far fa-plane-prop', 'fas fa-plane-prop',
					],
					defaultOption: 'far fa-plane-prop',
					keywords: 'aeroplane airplane airport fly sky small airplane plane prop',
				},
				{
					className: 'far fa-plane-slash',
					options: [
						'fat fa-plane-slash', 'fal fa-plane-slash', 'far fa-plane-slash', 'fas fa-plane-slash',
					],
					defaultOption: 'far fa-plane-slash',
					keywords: 'airplane mode airport canceled covid 19 delayed grounded travel plane slash',
				},
				{
					className: 'far fa-plane-tail',
					options: [
						'fat fa-plane-tail', 'fal fa-plane-tail', 'far fa-plane-tail', 'fas fa-plane-tail',
					],
					defaultOption: 'far fa-plane-tail',
					keywords: 'airplane airport fly sky plane tail',
				},
				{
					className: 'far fa-plane-up',
					options: [
						'fat fa-plane-up', 'fal fa-plane-up', 'far fa-plane-up', 'fas fa-plane-up',
					],
					defaultOption: 'far fa-plane-up',
					keywords: 'airplane airport internet signal sky wifi wireless plane up',
				},
				{
					className: 'far fa-robot-astromech',
					options: [
						'fat fa-robot-astromech', 'fal fa-robot-astromech', 'far fa-robot-astromech', 'fas fa-robot-astromech',
					],
					defaultOption: 'far fa-robot-astromech',
					keywords: 'artoo beep droid gps mechanic r2d2 star wars robot astromech',
				},
				{
					className: 'far fa-rocket',
					options: [
						'fat fa-rocket', 'fal fa-rocket', 'far fa-rocket', 'fas fa-rocket',
					],
					defaultOption: 'far fa-rocket',
					keywords: 'aircraft app jet launch nasa space rocket',
				},
				{
					className: 'far fa-rocket-launch',
					options: [
						'fat fa-rocket-launch', 'fal fa-rocket-launch', 'far fa-rocket-launch', 'fas fa-rocket-launch',
					],
					defaultOption: 'far fa-rocket-launch',
					keywords: 'aircraft app ignition jet launch nasa rocket space thrusters rocket launch',
				},
				{
					className: 'far fa-rv',
					options: [
						'fat fa-rv', 'fal fa-rv', 'far fa-rv', 'fas fa-rv',
					],
					defaultOption: 'far fa-rv',
					keywords: 'camping cousin eddie recreational travel vehicle rv',
				},
				{
					className: 'far fa-sailboat',
					options: [
						'fat fa-sailboat', 'fal fa-sailboat', 'far fa-sailboat', 'fas fa-sailboat',
					],
					defaultOption: 'far fa-sailboat',
					keywords: 'dinghy mast sailboat sailing yacht sailboat',
				},
				{
					className: 'far fa-seat-airline',
					options: [
						'fat fa-seat-airline', 'fal fa-seat-airline', 'far fa-seat-airline', 'fas fa-seat-airline',
					],
					defaultOption: 'far fa-seat-airline',
					keywords: 'airplane chair recline seat seat airline',
				},
				{
					className: 'far fa-ship',
					options: [
						'fat fa-ship', 'fal fa-ship', 'far fa-ship', 'fas fa-ship',
					],
					defaultOption: 'far fa-ship',
					keywords: 'boat passenger sea ship water ship',
				},
				{
					className: 'far fa-shuttle-space',
					options: [
						'fat fa-shuttle-space', 'fal fa-shuttle-space', 'far fa-shuttle-space', 'fas fa-shuttle-space',
					],
					defaultOption: 'far fa-shuttle-space',
					keywords: 'astronaut machine nasa rocket space transportation shuttle space',
				},
				{
					className: 'far fa-sleigh',
					options: [
						'fat fa-sleigh', 'fal fa-sleigh', 'far fa-sleigh', 'fas fa-sleigh',
					],
					defaultOption: 'far fa-sleigh',
					keywords: 'christmas claus fly holiday santa sled snow xmas sleigh',
				},
				{
					className: 'far fa-snowplow',
					options: [
						'fat fa-snowplow', 'fal fa-snowplow', 'far fa-snowplow', 'fas fa-snowplow',
					],
					defaultOption: 'far fa-snowplow',
					keywords: 'clean up cold road storm winter snowplow',
				},
				{
					className: 'far fa-starfighter',
					options: [
						'fat fa-starfighter', 'fal fa-starfighter', 'far fa-starfighter', 'fas fa-starfighter',
					],
					defaultOption: 'far fa-starfighter',
					keywords: 'luke skywalker rebel spaceship star wars x wing starfighter',
				},
				{
					className: 'far fa-starfighter-twin-ion-engine',
					options: [
						'fat fa-starfighter-twin-ion-engine', 'fal fa-starfighter-twin-ion-engine', 'far fa-starfighter-twin-ion-engine', 'fas fa-starfighter-twin-ion-engine',
					],
					defaultOption: 'far fa-starfighter-twin-ion-engine',
					keywords: 'darth vader empire spaceship star wars tie fighter starfighter twin ion engine',
				},
				{
					className: 'far fa-starfighter-twin-ion-engine-advanced',
					options: [
						'fat fa-starfighter-twin-ion-engine-advanced', 'fal fa-starfighter-twin-ion-engine-advanced', 'far fa-starfighter-twin-ion-engine-advanced', 'fas fa-starfighter-twin-ion-engine-advanced',
					],
					defaultOption: 'far fa-starfighter-twin-ion-engine-advanced',
					keywords: 'empire tie fighter starfighter twin ion engine advanced',
				},
				{
					className: 'far fa-starship',
					options: [
						'fat fa-starship', 'fal fa-starship', 'far fa-starship', 'fas fa-starship',
					],
					defaultOption: 'far fa-starship',
					keywords: 'engage enterprise james t kirk jean luc picard make it so ncc 1701 spacecraft spaceship star trek starship',
				},
				{
					className: 'far fa-starship-freighter',
					options: [
						'fat fa-starship-freighter', 'fal fa-starship-freighter', 'far fa-starship-freighter', 'fas fa-starship-freighter',
					],
					defaultOption: 'far fa-starship-freighter',
					keywords: 'chewbacca han solo millenium falcon rebel spaceship star wars yt 1300 starship freighter',
				},
				{
					className: 'far fa-taxi',
					options: [
						'fat fa-taxi', 'fal fa-taxi', 'far fa-taxi', 'fas fa-taxi',
					],
					defaultOption: 'far fa-taxi',
					keywords: 'cab cabbie car car service lyft machine oncoming oncoming taxi taxi transportation travel uber vehicle taxi',
				},
				{
					className: 'far fa-taxi-bus',
					options: [
						'fat fa-taxi-bus', 'fal fa-taxi-bus', 'far fa-taxi-bus', 'fas fa-taxi-bus',
					],
					defaultOption: 'far fa-taxi-bus',
					keywords: 'bus cab coach hack motorbus public transportation taxicab taxi bus',
				},
				{
					className: 'far fa-tower-control',
					options: [
						'fat fa-tower-control', 'fal fa-tower-control', 'far fa-tower-control', 'fas fa-tower-control',
					],
					defaultOption: 'far fa-tower-control',
					keywords: 'air traffic control airplane airport tower control',
				},
				{
					className: 'far fa-tractor',
					options: [
						'fat fa-tractor', 'fal fa-tractor', 'far fa-tractor', 'fas fa-tractor',
					],
					defaultOption: 'far fa-tractor',
					keywords: 'agriculture farm tractor vehicle tractor',
				},
				{
					className: 'far fa-train',
					options: [
						'fat fa-train', 'fal fa-train', 'far fa-train', 'fas fa-train',
					],
					defaultOption: 'far fa-train',
					keywords: 'bullet commute locomotive railway subway train train',
				},
				{
					className: 'far fa-train-subway',
					options: [
						'fat fa-train-subway', 'fal fa-train-subway', 'far fa-train-subway', 'fas fa-train-subway',
					],
					defaultOption: 'far fa-train-subway',
					keywords: 'machine railway train transportation vehicle train subway',
				},
				{
					className: 'far fa-train-subway-tunnel',
					options: [
						'fat fa-train-subway-tunnel', 'fal fa-train-subway-tunnel', 'far fa-train-subway-tunnel', 'fas fa-train-subway-tunnel',
					],
					defaultOption: 'far fa-train-subway-tunnel',
					keywords: 'metro rail railroad railway subway train tunnel train subway tunnel',
				},
				{
					className: 'far fa-train-track',
					options: [
						'fat fa-train-track', 'fal fa-train-track', 'far fa-train-track', 'fas fa-train-track',
					],
					defaultOption: 'far fa-train-track',
					keywords: 'rail railroad tracks train train track',
				},
				{
					className: 'far fa-train-tram',
					options: [
						'fat fa-train-tram', 'fal fa-train-tram', 'far fa-train-tram', 'fas fa-train-tram',
					],
					defaultOption: 'far fa-train-tram',
					keywords: 'crossing machine mountains seasonal tram transportation trolleybus train tram',
				},
				{
					className: 'far fa-train-tunnel',
					options: [
						'fat fa-train-tunnel', 'fal fa-train-tunnel', 'far fa-train-tunnel', 'fas fa-train-tunnel',
					],
					defaultOption: 'far fa-train-tunnel',
					keywords: 'rail subway tracks train tunnel train tunnel',
				},
				{
					className: 'far fa-truck',
					options: [
						'fat fa-truck', 'fal fa-truck', 'far fa-truck', 'fas fa-truck',
					],
					defaultOption: 'far fa-truck',
					keywords: 'black truck cargo delivery delivery truck shipping truck vehicle truck',
				},
				{
					className: 'far fa-truck-bolt',
					options: [
						'fat fa-truck-bolt', 'fal fa-truck-bolt', 'far fa-truck-bolt', 'fas fa-truck-bolt',
					],
					defaultOption: 'far fa-truck-bolt',
					keywords: 'cargo delivery electric ev shipping vehicle truck bolt',
				},
				{
					className: 'far fa-truck-container-empty',
					options: [
						'fat fa-truck-container-empty', 'fal fa-truck-container-empty', 'far fa-truck-container-empty', 'fas fa-truck-container-empty',
					],
					defaultOption: 'far fa-truck-container-empty',
					keywords: 'container flatbed shipping truck container empty',
				},
				{
					className: 'far fa-truck-flatbed',
					options: [
						'fat fa-truck-flatbed', 'fal fa-truck-flatbed', 'far fa-truck-flatbed', 'fas fa-truck-flatbed',
					],
					defaultOption: 'far fa-truck-flatbed',
					keywords: 'container flatbed shipping truck flatbed',
				},
				{
					className: 'far fa-truck-front',
					options: [
						'fat fa-truck-front', 'fal fa-truck-front', 'far fa-truck-front', 'fas fa-truck-front',
					],
					defaultOption: 'far fa-truck-front',
					keywords: 'shuttle truck van truck front',
				},
				{
					className: 'far fa-truck-medical',
					options: [
						'fat fa-truck-medical', 'fal fa-truck-medical', 'far fa-truck-medical', 'fas fa-truck-medical',
					],
					defaultOption: 'far fa-truck-medical',
					keywords: 'ambulance covid 19 emergency emt er help hospital support vehicle truck medical',
				},
				{
					className: 'far fa-truck-monster',
					options: [
						'fat fa-truck-monster', 'fal fa-truck-monster', 'far fa-truck-monster', 'fas fa-truck-monster',
					],
					defaultOption: 'far fa-truck-monster',
					keywords: 'offroad vehicle wheel truck monster',
				},
				{
					className: 'far fa-truck-pickup',
					options: [
						'fat fa-truck-pickup', 'fal fa-truck-pickup', 'far fa-truck-pickup', 'fas fa-truck-pickup',
					],
					defaultOption: 'far fa-truck-pickup',
					keywords: 'cargo pick up pickup pickup truck truck vehicle truck pickup',
				},
				{
					className: 'far fa-truck-plow',
					options: [
						'fat fa-truck-plow', 'fal fa-truck-plow', 'far fa-truck-plow', 'fas fa-truck-plow',
					],
					defaultOption: 'far fa-truck-plow',
					keywords: 'clean up cold seasonal snow winter truck plow',
				},
				{
					className: 'far fa-truck-tow',
					options: [
						'fat fa-truck-tow', 'fal fa-truck-tow', 'far fa-truck-tow', 'fas fa-truck-tow',
					],
					defaultOption: 'far fa-truck-tow',
					keywords: 'accident assistance help tow truck tow',
				},
				{
					className: 'far fa-ufo',
					options: [
						'fat fa-ufo', 'fal fa-ufo', 'far fa-ufo', 'fas fa-ufo',
					],
					defaultOption: 'far fa-ufo',
					keywords: 'ufo abduct alien extraterrestrial flying saucer space spacecraft spaceship t craft travel unidentified flying object ufo',
				},
				{
					className: 'far fa-ufo-beam',
					options: [
						'fat fa-ufo-beam', 'fal fa-ufo-beam', 'far fa-ufo-beam', 'fas fa-ufo-beam',
					],
					defaultOption: 'far fa-ufo-beam',
					keywords: 'abduct alien extraterrestrial flying saucer probe space spacecraft spaceship t craft tractor beam travel unidentified flying object ufo beam',
				},
				{
					className: 'far fa-van-shuttle',
					options: [
						'fat fa-van-shuttle', 'fal fa-van-shuttle', 'far fa-van-shuttle', 'fas fa-van-shuttle',
					],
					defaultOption: 'far fa-van-shuttle',
					keywords: 'airport bus machine minibus public transportation transportation travel vehicle van shuttle',
				},
				{
					className: 'far fa-wheelchair',
					options: [
						'fat fa-wheelchair', 'fal fa-wheelchair', 'far fa-wheelchair', 'fas fa-wheelchair',
					],
					defaultOption: 'far fa-wheelchair',
					keywords: 'users people wheelchair',
				},
				{
					className: 'far fa-wheelchair-move',
					options: [
						'fat fa-wheelchair-move', 'fal fa-wheelchair-move', 'far fa-wheelchair-move', 'fas fa-wheelchair-move',
					],
					defaultOption: 'far fa-wheelchair-move',
					keywords: 'access users people wheelchair symbol wheelchair move',
				},
			],
		},
		{
			id: 'travel-hotel',
			name: Loc.getMessage('LANDING_ICONS_SECTION_TRAVEL_HOTEL'),
			items: [
				{
					className: 'far fa-air-conditioner',
					options: [
						'fat fa-air-conditioner', 'fal fa-air-conditioner', 'far fa-air-conditioner', 'fas fa-air-conditioner',
					],
					defaultOption: 'far fa-air-conditioner',
					keywords: 'ac cool heat heat pump hvac mini split temperature unit air conditioner',
				},
				{
					className: 'far fa-alarm-clock',
					options: [
						'fat fa-alarm-clock', 'fal fa-alarm-clock', 'far fa-alarm-clock', 'fas fa-alarm-clock',
					],
					defaultOption: 'far fa-alarm-clock',
					keywords: 'alarm alarm clock clock date late reminder sleep snooze timer timestamp watch alarm clock',
				},
				{
					className: 'far fa-alarm-snooze',
					options: [
						'fat fa-alarm-snooze', 'fal fa-alarm-snooze', 'far fa-alarm-snooze', 'fas fa-alarm-snooze',
					],
					defaultOption: 'far fa-alarm-snooze',
					keywords: 'alert date late reminder sleep snooze timer timestamp watch alarm snooze',
				},
				{
					className: 'far fa-archway',
					options: [
						'fat fa-archway', 'fal fa-archway', 'far fa-archway', 'fas fa-archway',
					],
					defaultOption: 'far fa-archway',
					keywords: 'arc monument road street tunnel archway',
				},
				{
					className: 'far fa-baby-carriage',
					options: [
						'fat fa-baby-carriage', 'fal fa-baby-carriage', 'far fa-baby-carriage', 'fas fa-baby-carriage',
					],
					defaultOption: 'far fa-baby-carriage',
					keywords: 'buggy carrier infant push stroller transportation walk wheels baby carriage',
				},
				{
					className: 'far fa-ban-smoking',
					options: [
						'fat fa-ban-smoking', 'fal fa-ban-smoking', 'far fa-ban-smoking', 'fas fa-ban-smoking',
					],
					defaultOption: 'far fa-ban-smoking',
					keywords: 'ban cancel forbidden no no smoking non smoking not prohibited smoking ban smoking',
				},
				{
					className: 'far fa-bath',
					options: [
						'fat fa-bath', 'fal fa-bath', 'far fa-bath', 'fas fa-bath',
					],
					defaultOption: 'far fa-bath',
					keywords: 'bath bathtub clean shower tub wash bath',
				},
				{
					className: 'far fa-bed',
					options: [
						'fat fa-bed', 'fal fa-bed', 'far fa-bed', 'fas fa-bed',
					],
					defaultOption: 'far fa-bed',
					keywords: 'hotel lodging mattress person in bed rest sleep travel bed',
				},
				{
					className: 'far fa-bed-bunk',
					options: [
						'fat fa-bed-bunk', 'fal fa-bed-bunk', 'far fa-bed-bunk', 'fas fa-bed-bunk',
					],
					defaultOption: 'far fa-bed-bunk',
					keywords: 'lodging mattress rest siblings sleep sleepover travel bed bunk',
				},
				{
					className: 'far fa-bed-empty',
					options: [
						'fat fa-bed-empty', 'fal fa-bed-empty', 'far fa-bed-empty', 'fas fa-bed-empty',
					],
					defaultOption: 'far fa-bed-empty',
					keywords: 'bed hotel lodging mattress rest sleep travel bed empty',
				},
				{
					className: 'far fa-bell-concierge',
					options: [
						'fat fa-bell-concierge', 'fal fa-bell-concierge', 'far fa-bell-concierge', 'fas fa-bell-concierge',
					],
					defaultOption: 'far fa-bell-concierge',
					keywords: 'attention bell bellhop bellhop bell hotel receptionist service support bell concierge',
				},
				{
					className: 'far fa-book-atlas',
					options: [
						'fat fa-book-atlas', 'fal fa-book-atlas', 'far fa-book-atlas', 'fas fa-book-atlas',
					],
					defaultOption: 'far fa-book-atlas',
					keywords: 'book directions geography globe library map research travel wayfinding book atlas',
				},
				{
					className: 'far fa-briefcase',
					options: [
						'fat fa-briefcase', 'fal fa-briefcase', 'far fa-briefcase', 'fas fa-briefcase',
					],
					defaultOption: 'far fa-briefcase',
					keywords: 'bag briefcas briefcase business luggage office work briefcase',
				},
				{
					className: 'far fa-bus',
					options: [
						'fat fa-bus', 'fal fa-bus', 'far fa-bus', 'fas fa-bus',
					],
					defaultOption: 'far fa-bus',
					keywords: 'bus oncoming oncoming bus public transportation transportation travel vehicle bus',
				},
				{
					className: 'far fa-bus-simple',
					options: [
						'fat fa-bus-simple', 'fal fa-bus-simple', 'far fa-bus-simple', 'fas fa-bus-simple',
					],
					defaultOption: 'far fa-bus-simple',
					keywords: 'mta public transportation transportation travel vehicle bus simple',
				},
				{
					className: 'far fa-cable-car',
					options: [
						'fat fa-cable-car', 'fal fa-cable-car', 'far fa-cable-car', 'fas fa-cable-car',
					],
					defaultOption: 'far fa-cable-car',
					keywords: 'aerial tramway cable gondola lift mountain mountain cableway tram tramway trolley cable car',
				},
				{
					className: 'far fa-cactus',
					options: [
						'fat fa-cactus', 'fal fa-cactus', 'far fa-cactus', 'fas fa-cactus',
					],
					defaultOption: 'far fa-cactus',
					keywords: 'cactus cowboy desert flora old west plant succulent western cactus',
				},
				{
					className: 'far fa-car',
					options: [
						'fat fa-car', 'fal fa-car', 'far fa-car', 'fas fa-car',
					],
					defaultOption: 'far fa-car',
					keywords: 'auto automobile car oncoming oncoming automobile sedan transportation travel vehicle car',
				},
				{
					className: 'far fa-car-building',
					options: [
						'fat fa-car-building', 'fal fa-car-building', 'far fa-car-building', 'fas fa-car-building',
					],
					defaultOption: 'far fa-car-building',
					keywords: 'city office transportation travel work car building',
				},
				{
					className: 'far fa-car-bus',
					options: [
						'fat fa-car-bus', 'fal fa-car-bus', 'far fa-car-bus', 'fas fa-car-bus',
					],
					defaultOption: 'far fa-car-bus',
					keywords: 'directions ground transportation map transportation travel car bus',
				},
				{
					className: 'far fa-car-garage',
					options: [
						'fat fa-car-garage', 'fal fa-car-garage', 'far fa-car-garage', 'fas fa-car-garage',
					],
					defaultOption: 'far fa-car-garage',
					keywords: 'auto automobile mechanic sedan transportation vehicle car garage',
				},
				{
					className: 'far fa-caravan',
					options: [
						'fat fa-caravan', 'fal fa-caravan', 'far fa-caravan', 'fas fa-caravan',
					],
					defaultOption: 'far fa-caravan',
					keywords: 'camper motor home rv trailer travel caravan',
				},
				{
					className: 'far fa-caravan-simple',
					options: [
						'fat fa-caravan-simple', 'fal fa-caravan-simple', 'far fa-caravan-simple', 'fas fa-caravan-simple',
					],
					defaultOption: 'far fa-caravan-simple',
					keywords: 'camper motor home rv trailer travel caravan simple',
				},
				{
					className: 'far fa-cars',
					options: [
						'fat fa-cars', 'fal fa-cars', 'far fa-cars', 'fas fa-cars',
					],
					defaultOption: 'far fa-cars',
					keywords: 'automobiles autos transportation travel cars',
				},
				{
					className: 'far fa-cart-flatbed-suitcase',
					options: [
						'fat fa-cart-flatbed-suitcase', 'fal fa-cart-flatbed-suitcase', 'far fa-cart-flatbed-suitcase', 'fas fa-cart-flatbed-suitcase',
					],
					defaultOption: 'far fa-cart-flatbed-suitcase',
					keywords: 'airport bag baggage suitcase travel cart flatbed suitcase',
				},
				{
					className: 'far fa-dice',
					options: [
						'fat fa-dice', 'fal fa-dice', 'far fa-dice', 'fas fa-dice',
					],
					defaultOption: 'far fa-dice',
					keywords: 'chance dice die gambling game game die roll dice',
				},
				{
					className: 'far fa-dice-five',
					options: [
						'fat fa-dice-five', 'fal fa-dice-five', 'far fa-dice-five', 'fas fa-dice-five',
					],
					defaultOption: 'far fa-dice-five',
					keywords: 'die face 5 chance gambling game roll dice five',
				},
				{
					className: 'far fa-door-closed',
					options: [
						'fat fa-door-closed', 'fal fa-door-closed', 'far fa-door-closed', 'fas fa-door-closed',
					],
					defaultOption: 'far fa-door-closed',
					keywords: 'doo door enter exit locked door closed',
				},
				{
					className: 'far fa-door-open',
					options: [
						'fat fa-door-open', 'fal fa-door-open', 'far fa-door-open', 'fas fa-door-open',
					],
					defaultOption: 'far fa-door-open',
					keywords: 'enter exit welcome door open',
				},
				{
					className: 'far fa-dryer',
					options: [
						'fat fa-dryer', 'fal fa-dryer', 'far fa-dryer', 'fas fa-dryer',
					],
					defaultOption: 'far fa-dryer',
					keywords: 'clean clothes laundromat laundry washing machine dryer',
				},
				{
					className: 'far fa-dryer-heat',
					options: [
						'fat fa-dryer-heat', 'fal fa-dryer-heat', 'far fa-dryer-heat', 'fas fa-dryer-heat',
					],
					defaultOption: 'far fa-dryer-heat',
					keywords: 'clean clothes laundromat laundry washing machine dryer heat',
				},
				{
					className: 'far fa-dumbbell',
					options: [
						'fat fa-dumbbell', 'fal fa-dumbbell', 'far fa-dumbbell', 'fas fa-dumbbell',
					],
					defaultOption: 'far fa-dumbbell',
					keywords: 'exercise gym strength weight weight lifting dumbbell',
				},
				{
					className: 'far fa-earth-africa',
					options: [
						'fat fa-earth-africa', 'fal fa-earth-africa', 'far fa-earth-africa', 'fas fa-earth-africa',
					],
					defaultOption: 'far fa-earth-africa',
					keywords: 'africa all country earth europe global globe gps language localize location map online place planet translate travel world earth africa',
				},
				{
					className: 'far fa-earth-americas',
					options: [
						'fat fa-earth-americas', 'fal fa-earth-americas', 'far fa-earth-americas', 'fas fa-earth-americas',
					],
					defaultOption: 'far fa-earth-americas',
					keywords: 'all america country earth global globe gps language localize location map online place planet translate travel world earth americas',
				},
				{
					className: 'far fa-earth-asia',
					options: [
						'fat fa-earth-asia', 'fal fa-earth-asia', 'far fa-earth-asia', 'fas fa-earth-asia',
					],
					defaultOption: 'far fa-earth-asia',
					keywords: 'all asia australia country earth global globe gps language localize location map online place planet translate travel world earth asia',
				},
				{
					className: 'far fa-elevator',
					options: [
						'fat fa-elevator', 'fal fa-elevator', 'far fa-elevator', 'fas fa-elevator',
					],
					defaultOption: 'far fa-elevator',
					keywords: 'accessibility elevator hoist lift users people elevator',
				},
				{
					className: 'far fa-escalator',
					options: [
						'fat fa-escalator', 'fal fa-escalator', 'far fa-escalator', 'fas fa-escalator',
					],
					defaultOption: 'far fa-escalator',
					keywords: 'elevator rise stairs escalator',
				},
				{
					className: 'far fa-fan-table',
					options: [
						'fat fa-fan-table', 'fal fa-fan-table', 'far fa-fan-table', 'fas fa-fan-table',
					],
					defaultOption: 'far fa-fan-table',
					keywords: 'ac air conditioning blade blower cool hot oscillate fan table',
				},
				{
					className: 'far fa-fireplace',
					options: [
						'fat fa-fireplace', 'fal fa-fireplace', 'far fa-fireplace', 'fas fa-fireplace',
					],
					defaultOption: 'far fa-fireplace',
					keywords: 'caliente flame hearth heat holiday mantle toasty warmth fireplace',
				},
				{
					className: 'far fa-flux-capacitor',
					options: [
						'fat fa-flux-capacitor', 'fal fa-flux-capacitor', 'far fa-flux-capacitor', 'fas fa-flux-capacitor',
					],
					defaultOption: 'far fa-flux-capacitor',
					keywords: '1 21 gigawatts 88 mph emmett brown marty mcfly y back to the future delorean dmc time machine time travel flux capacitor',
				},
				{
					className: 'far fa-fork-knife',
					options: [
						'fat fa-fork-knife', 'fal fa-fork-knife', 'far fa-fork-knife', 'fas fa-fork-knife',
					],
					defaultOption: 'far fa-fork-knife',
					keywords: 'cutlery dining dinner eat food fork knife restaurant fork knife',
				},
				{
					className: 'far fa-heat',
					options: [
						'fat fa-heat', 'fal fa-heat', 'far fa-heat', 'fas fa-heat',
					],
					defaultOption: 'far fa-heat',
					keywords: 'ac air conditioner boiler heating hot sauna spa summer temperature heat',
				},
				{
					className: 'far fa-horse-saddle',
					options: [
						'fat fa-horse-saddle', 'fal fa-horse-saddle', 'far fa-horse-saddle', 'fas fa-horse-saddle',
					],
					defaultOption: 'far fa-horse-saddle',
					keywords: 'cowboy equus fauna mammmal mare neigh pony rodeo western horse saddle',
				},
				{
					className: 'far fa-hot-tub-person',
					options: [
						'fat fa-hot-tub-person', 'fal fa-hot-tub-person', 'far fa-hot-tub-person', 'fas fa-hot-tub-person',
					],
					defaultOption: 'far fa-hot-tub-person',
					keywords: 'jacuzzi spa hot tub person',
				},
				{
					className: 'far fa-hotel',
					options: [
						'fat fa-hotel', 'fal fa-hotel', 'far fa-hotel', 'fas fa-hotel',
					],
					defaultOption: 'far fa-hotel',
					keywords: 'building hotel inn lodging motel resort travel hotel',
				},
				{
					className: 'far fa-infinity',
					options: [
						'fat fa-infinity', 'fal fa-infinity', 'far fa-infinity', 'fas fa-infinity',
					],
					defaultOption: 'far fa-infinity',
					keywords: 'infinity eternity forever infinity math unbounded universal infinity',
				},
				{
					className: 'far fa-island-tropical',
					options: [
						'fat fa-island-tropical', 'fal fa-island-tropical', 'far fa-island-tropical', 'fas fa-island-tropical',
					],
					defaultOption: 'far fa-island-tropical',
					keywords: 'castaway desert desert island island palm tree sand stranded summer vacation island tropical',
				},
				{
					className: 'far fa-key',
					options: [
						'fat fa-key', 'fal fa-key', 'far fa-key', 'fas fa-key',
					],
					defaultOption: 'far fa-key',
					keywords: 'key lock password private secret unlock key',
				},
				{
					className: 'far fa-lamp-desk',
					options: [
						'fat fa-lamp-desk', 'fal fa-lamp-desk', 'far fa-lamp-desk', 'fas fa-lamp-desk',
					],
					defaultOption: 'far fa-lamp-desk',
					keywords: 'bright furniture light lamp desk',
				},
				{
					className: 'far fa-map',
					options: [
						'fat fa-map', 'fal fa-map', 'far fa-map', 'fas fa-map',
					],
					defaultOption: 'far fa-map',
					keywords: 'address coordinates destination gps localize location map navigation paper pin place point of interest position route travel world world map map',
				},
				{
					className: 'far fa-map-location',
					options: [
						'fat fa-map-location', 'fal fa-map-location', 'far fa-map-location', 'fas fa-map-location',
					],
					defaultOption: 'far fa-map-location',
					keywords: 'address coordinates destination gps localize location map navigation paper pin place point of interest position route travel map location',
				},
				{
					className: 'far fa-map-location-dot',
					options: [
						'fat fa-map-location-dot', 'fal fa-map-location-dot', 'far fa-map-location-dot', 'fas fa-map-location-dot',
					],
					defaultOption: 'far fa-map-location-dot',
					keywords: 'address coordinates destination gps localize location map navigation paper pin place point of interest position route travel map location dot',
				},
				{
					className: 'far fa-martini-glass',
					options: [
						'fat fa-martini-glass', 'fal fa-martini-glass', 'far fa-martini-glass', 'fas fa-martini-glass',
					],
					defaultOption: 'far fa-martini-glass',
					keywords: 'alcohol bar beverage cocktail cocktail glass drink glass liquor martini glass',
				},
				{
					className: 'far fa-martini-glass-citrus',
					options: [
						'fat fa-martini-glass-citrus', 'fal fa-martini-glass-citrus', 'far fa-martini-glass-citrus', 'fas fa-martini-glass-citrus',
					],
					defaultOption: 'far fa-martini-glass-citrus',
					keywords: 'alcohol beverage drink gin glass margarita martini vodka martini glass citrus',
				},
				{
					className: 'far fa-martini-glass-empty',
					options: [
						'fat fa-martini-glass-empty', 'fal fa-martini-glass-empty', 'far fa-martini-glass-empty', 'fas fa-martini-glass-empty',
					],
					defaultOption: 'far fa-martini-glass-empty',
					keywords: 'alcohol bar beverage drink liquor martini glass empty',
				},
				{
					className: 'far fa-microwave',
					options: [
						'fat fa-microwave', 'fal fa-microwave', 'far fa-microwave', 'fas fa-microwave',
					],
					defaultOption: 'far fa-microwave',
					keywords: 'chef cook kitchen nuke microwave',
				},
				{
					className: 'far fa-monument',
					options: [
						'fat fa-monument', 'fal fa-monument', 'far fa-monument', 'fas fa-monument',
					],
					defaultOption: 'far fa-monument',
					keywords: 'building historic landmark memorable monument',
				},
				{
					className: 'far fa-moped',
					options: [
						'fat fa-moped', 'fal fa-moped', 'far fa-moped', 'fas fa-moped',
					],
					defaultOption: 'far fa-moped',
					keywords: 'delivery motorbike scooter moped',
				},
				{
					className: 'far fa-mug-saucer',
					options: [
						'fat fa-mug-saucer', 'fal fa-mug-saucer', 'far fa-mug-saucer', 'fas fa-mug-saucer',
					],
					defaultOption: 'far fa-mug-saucer',
					keywords: 'beverage breakfast cafe drink fall morning mug seasonal tea mug saucer',
				},
				{
					className: 'far fa-outlet',
					options: [
						'fat fa-outlet', 'fal fa-outlet', 'far fa-outlet', 'fas fa-outlet',
					],
					defaultOption: 'far fa-outlet',
					keywords: 'electricity energy plug outlet',
				},
				{
					className: 'far fa-oven',
					options: [
						'fat fa-oven', 'fal fa-oven', 'far fa-oven', 'fas fa-oven',
					],
					defaultOption: 'far fa-oven',
					keywords: 'bake broiler convection cook kitchen stove oven',
				},
				{
					className: 'far fa-passport',
					options: [
						'fat fa-passport', 'fal fa-passport', 'far fa-passport', 'fas fa-passport',
					],
					defaultOption: 'far fa-passport',
					keywords: 'document id identification issued travel passport',
				},
				{
					className: 'far fa-paw-simple',
					options: [
						'fat fa-paw-simple', 'fal fa-paw-simple', 'far fa-paw-simple', 'fas fa-paw-simple',
					],
					defaultOption: 'far fa-paw-simple',
					keywords: 'animal cat dog pet print paw simple',
				},
				{
					className: 'far fa-person-seat',
					options: [
						'fat fa-person-seat', 'fal fa-person-seat', 'far fa-person-seat', 'fas fa-person-seat',
					],
					defaultOption: 'far fa-person-seat',
					keywords: 'airplane chair recline seat travel person seat',
				},
				{
					className: 'far fa-person-seat-reclined',
					options: [
						'fat fa-person-seat-reclined', 'fal fa-person-seat-reclined', 'far fa-person-seat-reclined', 'fas fa-person-seat-reclined',
					],
					defaultOption: 'far fa-person-seat-reclined',
					keywords: 'airplane chair recline seat travel person seat reclined',
				},
				{
					className: 'far fa-person-swimming',
					options: [
						'fat fa-person-swimming', 'fal fa-person-swimming', 'far fa-person-swimming', 'fas fa-person-swimming',
					],
					defaultOption: 'far fa-person-swimming',
					keywords: 'ocean person swimming pool sea swim water person swimming',
				},
				{
					className: 'far fa-phone-rotary',
					options: [
						'fat fa-phone-rotary', 'fal fa-phone-rotary', 'far fa-phone-rotary', 'fas fa-phone-rotary',
					],
					defaultOption: 'far fa-phone-rotary',
					keywords: 'call earphone number phone retro support telephone vintage voice phone rotary',
				},
				{
					className: 'far fa-pineapple',
					options: [
						'fat fa-pineapple', 'fal fa-pineapple', 'far fa-pineapple', 'fas fa-pineapple',
					],
					defaultOption: 'far fa-pineapple',
					keywords: 'ananas fruit pineapple tropical pineapple',
				},
				{
					className: 'far fa-plane',
					options: [
						'fat fa-plane', 'fal fa-plane', 'far fa-plane', 'fas fa-plane',
					],
					defaultOption: 'far fa-plane',
					keywords: 'airplane airport destination fly location mode travel trip plane',
				},
				{
					className: 'far fa-plane-arrival',
					options: [
						'fat fa-plane-arrival', 'fal fa-plane-arrival', 'far fa-plane-arrival', 'fas fa-plane-arrival',
					],
					defaultOption: 'far fa-plane-arrival',
					keywords: 'aeroplane airplane airplane arrival airport arrivals arriving destination fly land landing location mode travel trip plane arrival',
				},
				{
					className: 'far fa-plane-departure',
					options: [
						'fat fa-plane-departure', 'fal fa-plane-departure', 'far fa-plane-departure', 'fas fa-plane-departure',
					],
					defaultOption: 'far fa-plane-departure',
					keywords: 'aeroplane airplane airplane departure airport check in departing departure departures destination fly location mode take off taking off travel trip plane departure',
				},
				{
					className: 'far fa-plane-prop',
					options: [
						'fat fa-plane-prop', 'fal fa-plane-prop', 'far fa-plane-prop', 'fas fa-plane-prop',
					],
					defaultOption: 'far fa-plane-prop',
					keywords: 'aeroplane airplane airport fly sky small airplane plane prop',
				},
				{
					className: 'far fa-plane-slash',
					options: [
						'fat fa-plane-slash', 'fal fa-plane-slash', 'far fa-plane-slash', 'fas fa-plane-slash',
					],
					defaultOption: 'far fa-plane-slash',
					keywords: 'airplane mode airport canceled covid 19 delayed grounded travel plane slash',
				},
				{
					className: 'far fa-plane-tail',
					options: [
						'fat fa-plane-tail', 'fal fa-plane-tail', 'far fa-plane-tail', 'fas fa-plane-tail',
					],
					defaultOption: 'far fa-plane-tail',
					keywords: 'airplane airport fly sky plane tail',
				},
				{
					className: 'far fa-plane-up',
					options: [
						'fat fa-plane-up', 'fal fa-plane-up', 'far fa-plane-up', 'fas fa-plane-up',
					],
					defaultOption: 'far fa-plane-up',
					keywords: 'airplane airport internet signal sky wifi wireless plane up',
				},
				{
					className: 'far fa-plane-up-slash',
					options: [
						'fat fa-plane-up-slash', 'fal fa-plane-up-slash', 'far fa-plane-up-slash', 'fas fa-plane-up-slash',
					],
					defaultOption: 'far fa-plane-up-slash',
					keywords: 'airplane airport internet signal sky wifi wireless plane up slash',
				},
				{
					className: 'far fa-plate-utensils',
					options: [
						'fat fa-plate-utensils', 'fal fa-plate-utensils', 'far fa-plate-utensils', 'fas fa-plate-utensils',
					],
					defaultOption: 'far fa-plate-utensils',
					keywords: 'dinner food fork knife plate plate utensils',
				},
				{
					className: 'far fa-refrigerator',
					options: [
						'fat fa-refrigerator', 'fal fa-refrigerator', 'far fa-refrigerator', 'fas fa-refrigerator',
					],
					defaultOption: 'far fa-refrigerator',
					keywords: 'cold cool freezer fridge icebox kitchen refrigerator',
				},
				{
					className: 'far fa-restroom-simple',
					options: [
						'fat fa-restroom-simple', 'fal fa-restroom-simple', 'far fa-restroom-simple', 'fas fa-restroom-simple',
					],
					defaultOption: 'far fa-restroom-simple',
					keywords: 'wc bathroom lavatory restroom toilet water closet wc restroom simple',
				},
				{
					className: 'far fa-rings-wedding',
					options: [
						'fat fa-rings-wedding', 'fal fa-rings-wedding', 'far fa-rings-wedding', 'fas fa-rings-wedding',
					],
					defaultOption: 'far fa-rings-wedding',
					keywords: 'diamond engagement gold marriage matrimony platinum proposal rings wedding',
				},
				{
					className: 'far fa-rv',
					options: [
						'fat fa-rv', 'fal fa-rv', 'far fa-rv', 'fas fa-rv',
					],
					defaultOption: 'far fa-rv',
					keywords: 'camping cousin eddie recreational travel vehicle rv',
				},
				{
					className: 'far fa-seat-airline',
					options: [
						'fat fa-seat-airline', 'fal fa-seat-airline', 'far fa-seat-airline', 'fas fa-seat-airline',
					],
					defaultOption: 'far fa-seat-airline',
					keywords: 'airplane chair recline seat seat airline',
				},
				{
					className: 'far fa-shower',
					options: [
						'fat fa-shower', 'fal fa-shower', 'far fa-shower', 'fas fa-shower',
					],
					defaultOption: 'far fa-shower',
					keywords: 'bath clean faucet shower water shower',
				},
				{
					className: 'far fa-slot-machine',
					options: [
						'fat fa-slot-machine', 'fal fa-slot-machine', 'far fa-slot-machine', 'fas fa-slot-machine',
					],
					defaultOption: 'far fa-slot-machine',
					keywords: 'gamble gambling game lucky slot slot machine vegas slot machine',
				},
				{
					className: 'far fa-smoking',
					options: [
						'fat fa-smoking', 'fal fa-smoking', 'far fa-smoking', 'fas fa-smoking',
					],
					defaultOption: 'far fa-smoking',
					keywords: 'cancer cigarette nicotine smoking smoking status tobacco smoking',
				},
				{
					className: 'far fa-snooze',
					options: [
						'fat fa-snooze', 'fal fa-snooze', 'far fa-snooze', 'fas fa-snooze',
					],
					defaultOption: 'far fa-snooze',
					keywords: 'alarm comic nap rest siesta sleep zzz snooze',
				},
				{
					className: 'far fa-snowflake',
					options: [
						'fat fa-snowflake', 'fal fa-snowflake', 'far fa-snowflake', 'fas fa-snowflake',
					],
					defaultOption: 'far fa-snowflake',
					keywords: 'heavy chevron snowflake cold precipitation rain snow snowflake winter snowflake',
				},
				{
					className: 'far fa-spa',
					options: [
						'fat fa-spa', 'fal fa-spa', 'far fa-spa', 'fas fa-spa',
					],
					defaultOption: 'far fa-spa',
					keywords: 'flora massage mindfulness plant wellness spa',
				},
				{
					className: 'far fa-stairs',
					options: [
						'fat fa-stairs', 'fal fa-stairs', 'far fa-stairs', 'fas fa-stairs',
					],
					defaultOption: 'far fa-stairs',
					keywords: 'exit steps up stairs',
				},
				{
					className: 'far fa-suitcase',
					options: [
						'fat fa-suitcase', 'fal fa-suitcase', 'far fa-suitcase', 'fas fa-suitcase',
					],
					defaultOption: 'far fa-suitcase',
					keywords: 'baggage luggage move packing suitcase travel trip suitcase',
				},
				{
					className: 'far fa-suitcase-rolling',
					options: [
						'fat fa-suitcase-rolling', 'fal fa-suitcase-rolling', 'far fa-suitcase-rolling', 'fas fa-suitcase-rolling',
					],
					defaultOption: 'far fa-suitcase-rolling',
					keywords: 'baggage luggage move suitcase travel trip suitcase rolling',
				},
				{
					className: 'far fa-taxi',
					options: [
						'fat fa-taxi', 'fal fa-taxi', 'far fa-taxi', 'fas fa-taxi',
					],
					defaultOption: 'far fa-taxi',
					keywords: 'cab cabbie car car service lyft machine oncoming oncoming taxi taxi transportation travel uber vehicle taxi',
				},
				{
					className: 'far fa-taxi-bus',
					options: [
						'fat fa-taxi-bus', 'fal fa-taxi-bus', 'far fa-taxi-bus', 'fas fa-taxi-bus',
					],
					defaultOption: 'far fa-taxi-bus',
					keywords: 'bus cab coach hack motorbus public transportation taxicab taxi bus',
				},
				{
					className: 'far fa-ticket-airline',
					options: [
						'fat fa-ticket-airline', 'fal fa-ticket-airline', 'far fa-ticket-airline', 'fas fa-ticket-airline',
					],
					defaultOption: 'far fa-ticket-airline',
					keywords: 'airplane arrival boarding pass departure ticket travel ticket airline',
				},
				{
					className: 'far fa-tickets-airline',
					options: [
						'fat fa-tickets-airline', 'fal fa-tickets-airline', 'far fa-tickets-airline', 'fas fa-tickets-airline',
					],
					defaultOption: 'far fa-tickets-airline',
					keywords: 'airplane arrival boarding pass departure ticket travel tickets airline',
				},
				{
					className: 'far fa-toilet',
					options: [
						'fat fa-toilet', 'fal fa-toilet', 'far fa-toilet', 'fas fa-toilet',
					],
					defaultOption: 'far fa-toilet',
					keywords: 'bathroom flush john loo pee plumbing poop porcelain potty restroom throne toile toilet washroom waste wc toilet',
				},
				{
					className: 'far fa-toilet-paper-blank-under',
					options: [
						'fat fa-toilet-paper-blank-under', 'fal fa-toilet-paper-blank-under', 'far fa-toilet-paper-blank-under', 'fas fa-toilet-paper-blank-under',
					],
					defaultOption: 'far fa-toilet-paper-blank-under',
					keywords: 'bathroom lavatory privy restroom roll toilet wipe toilet paper blank under',
				},
				{
					className: 'far fa-toilet-paper-under',
					options: [
						'fat fa-toilet-paper-under', 'fal fa-toilet-paper-under', 'far fa-toilet-paper-under', 'fas fa-toilet-paper-under',
					],
					defaultOption: 'far fa-toilet-paper-under',
					keywords: 'bathroom lavatory privy restroom roll toilet wipe toilet paper under',
				},
				{
					className: 'far fa-toilet-paper-under-slash',
					options: [
						'fat fa-toilet-paper-under-slash', 'fal fa-toilet-paper-under-slash', 'far fa-toilet-paper-under-slash', 'fas fa-toilet-paper-under-slash',
					],
					defaultOption: 'far fa-toilet-paper-under-slash',
					keywords: 'bathroom lavatory privy restroom roll toilet wipe toilet paper under slash',
				},
				{
					className: 'far fa-tower-control',
					options: [
						'fat fa-tower-control', 'fal fa-tower-control', 'far fa-tower-control', 'fas fa-tower-control',
					],
					defaultOption: 'far fa-tower-control',
					keywords: 'air traffic control airplane airport tower control',
				},
				{
					className: 'far fa-train-subway-tunnel',
					options: [
						'fat fa-train-subway-tunnel', 'fal fa-train-subway-tunnel', 'far fa-train-subway-tunnel', 'fas fa-train-subway-tunnel',
					],
					defaultOption: 'far fa-train-subway-tunnel',
					keywords: 'metro rail railroad railway subway train tunnel train subway tunnel',
				},
				{
					className: 'far fa-train-tram',
					options: [
						'fat fa-train-tram', 'fal fa-train-tram', 'far fa-train-tram', 'fas fa-train-tram',
					],
					defaultOption: 'far fa-train-tram',
					keywords: 'crossing machine mountains seasonal tram transportation trolleybus train tram',
				},
				{
					className: 'far fa-tree-palm',
					options: [
						'fat fa-tree-palm', 'fal fa-tree-palm', 'far fa-tree-palm', 'fas fa-tree-palm',
					],
					defaultOption: 'far fa-tree-palm',
					keywords: 'coconut frond palm palm tree tree tropical tree palm',
				},
				{
					className: 'far fa-tv',
					options: [
						'fat fa-tv', 'fal fa-tv', 'far fa-tv', 'fas fa-tv',
					],
					defaultOption: 'far fa-tv',
					keywords: 'computer display monitor television tv',
				},
				{
					className: 'far fa-tv-retro',
					options: [
						'fat fa-tv-retro', 'fal fa-tv-retro', 'far fa-tv-retro', 'fas fa-tv-retro',
					],
					defaultOption: 'far fa-tv-retro',
					keywords: 'computer display monitor television tv video tv retro',
				},
				{
					className: 'far fa-umbrella-beach',
					options: [
						'fat fa-umbrella-beach', 'fal fa-umbrella-beach', 'far fa-umbrella-beach', 'fas fa-umbrella-beach',
					],
					defaultOption: 'far fa-umbrella-beach',
					keywords: 'beach beach with umbrella protection recreation sand shade summer sun umbrella umbrella beach',
				},
				{
					className: 'far fa-user-chef',
					options: [
						'fat fa-user-chef', 'fal fa-user-chef', 'far fa-user-chef', 'fas fa-user-chef',
					],
					defaultOption: 'far fa-user-chef',
					keywords: 'chef cook dining food kitchen restaurant user chef',
				},
				{
					className: 'far fa-user-pilot',
					options: [
						'fat fa-user-pilot', 'fal fa-user-pilot', 'far fa-user-pilot', 'fas fa-user-pilot',
					],
					defaultOption: 'far fa-user-pilot',
					keywords: 'airplane airport flight fly navigate pilot user pilot',
				},
				{
					className: 'far fa-user-pilot-tie',
					options: [
						'fat fa-user-pilot-tie', 'fal fa-user-pilot-tie', 'far fa-user-pilot-tie', 'fas fa-user-pilot-tie',
					],
					defaultOption: 'far fa-user-pilot-tie',
					keywords: 'airplane airport flight fly navigate pilot user pilot tie',
				},
				{
					className: 'far fa-utensils',
					options: [
						'fat fa-utensils', 'fal fa-utensils', 'far fa-utensils', 'fas fa-utensils',
					],
					defaultOption: 'far fa-utensils',
					keywords: 'cooking cutlery dining dinner eat food fork fork and knife knife restaurant utensils',
				},
				{
					className: 'far fa-vacuum',
					options: [
						'fat fa-vacuum', 'fal fa-vacuum', 'far fa-vacuum', 'fas fa-vacuum',
					],
					defaultOption: 'far fa-vacuum',
					keywords: 'cleaning dyson floor suck suction vacuum',
				},
				{
					className: 'far fa-van-shuttle',
					options: [
						'fat fa-van-shuttle', 'fal fa-van-shuttle', 'far fa-van-shuttle', 'fas fa-van-shuttle',
					],
					defaultOption: 'far fa-van-shuttle',
					keywords: 'airport bus machine minibus public transportation transportation travel vehicle van shuttle',
				},
				{
					className: 'far fa-wagon-covered',
					options: [
						'fat fa-wagon-covered', 'fal fa-wagon-covered', 'far fa-wagon-covered', 'fas fa-wagon-covered',
					],
					defaultOption: 'far fa-wagon-covered',
					keywords: 'contestoga dysentery oregon trail stagecoach vehicle western wheel wagon covered',
				},
				{
					className: 'far fa-washing-machine',
					options: [
						'fat fa-washing-machine', 'fal fa-washing-machine', 'far fa-washing-machine', 'fas fa-washing-machine',
					],
					defaultOption: 'far fa-washing-machine',
					keywords: 'clean clothes laundromat laundry washing machine washing machine',
				},
				{
					className: 'far fa-water-ladder',
					options: [
						'fat fa-water-ladder', 'fal fa-water-ladder', 'far fa-water-ladder', 'fas fa-water-ladder',
					],
					defaultOption: 'far fa-water-ladder',
					keywords: 'ladder recreation swim water water ladder',
				},
				{
					className: 'far fa-wheelchair',
					options: [
						'fat fa-wheelchair', 'fal fa-wheelchair', 'far fa-wheelchair', 'fas fa-wheelchair',
					],
					defaultOption: 'far fa-wheelchair',
					keywords: 'users people wheelchair',
				},
				{
					className: 'far fa-wheelchair-move',
					options: [
						'fat fa-wheelchair-move', 'fal fa-wheelchair-move', 'far fa-wheelchair-move', 'fas fa-wheelchair-move',
					],
					defaultOption: 'far fa-wheelchair-move',
					keywords: 'access users people wheelchair symbol wheelchair move',
				},
				{
					className: 'far fa-wifi',
					options: [
						'fat fa-wifi', 'fal fa-wifi', 'far fa-wifi', 'fas fa-wifi',
					],
					defaultOption: 'far fa-wifi',
					keywords: 'connection hotspot internet network wireless wifi',
				},
				{
					className: 'far fa-wifi-slash',
					options: [
						'fat fa-wifi-slash', 'fal fa-wifi-slash', 'far fa-wifi-slash', 'fas fa-wifi-slash',
					],
					defaultOption: 'far fa-wifi-slash',
					keywords: 'ban broken connection disabled hotspot internet network unavailable wireless wifi slash',
				},
				{
					className: 'far fa-wine-glass',
					options: [
						'fat fa-wine-glass', 'fal fa-wine-glass', 'far fa-wine-glass', 'fas fa-wine-glass',
					],
					defaultOption: 'far fa-wine-glass',
					keywords: 'alcohol bar beverage cabernet drink glass grapes merlot sauvignon wine wine glass wine glass',
				},
				{
					className: 'far fa-wine-glass-empty',
					options: [
						'fat fa-wine-glass-empty', 'fal fa-wine-glass-empty', 'far fa-wine-glass-empty', 'fas fa-wine-glass-empty',
					],
					defaultOption: 'far fa-wine-glass-empty',
					keywords: 'alcohol beverage cabernet drink grapes merlot sauvignon wine glass empty',
				},
			],
		},
		{
			id: 'users-people',
			name: Loc.getMessage('LANDING_ICONS_SECTION_USERS_PEOPLE'),
			items: [
				{
					className: 'far fa-address-book',
					options: [
						'fat fa-address-book', 'fal fa-address-book', 'far fa-address-book', 'fas fa-address-book',
					],
					defaultOption: 'far fa-address-book',
					keywords: 'contact directory index little black book rolodex address book',
				},
				{
					className: 'far fa-address-card',
					options: [
						'fat fa-address-card', 'fal fa-address-card', 'far fa-address-card', 'fas fa-address-card',
					],
					defaultOption: 'far fa-address-card',
					keywords: 'about contact id identification postcard profile address card',
				},
				{
					className: 'far fa-angel',
					options: [
						'fat fa-angel', 'fal fa-angel', 'far fa-angel', 'fas fa-angel',
					],
					defaultOption: 'far fa-angel',
					keywords: 'christmas decoration halo holiday holy michael landon wings xmas angel',
				},
				{
					className: 'far fa-baby',
					options: [
						'fat fa-baby', 'fal fa-baby', 'far fa-baby', 'fas fa-baby',
					],
					defaultOption: 'far fa-baby',
					keywords: 'users people baby',
				},
				{
					className: 'far fa-bed',
					options: [
						'fat fa-bed', 'fal fa-bed', 'far fa-bed', 'fas fa-bed',
					],
					defaultOption: 'far fa-bed',
					keywords: 'hotel lodging mattress person in bed rest sleep travel bed',
				},
				{
					className: 'far fa-book-user',
					options: [
						'fat fa-book-user', 'fal fa-book-user', 'far fa-book-user', 'fas fa-book-user',
					],
					defaultOption: 'far fa-book-user',
					keywords: 'address biography diary documentation journal library read research book user',
				},
				{
					className: 'far fa-chalkboard-user',
					options: [
						'fat fa-chalkboard-user', 'fal fa-chalkboard-user', 'far fa-chalkboard-user', 'fas fa-chalkboard-user',
					],
					defaultOption: 'far fa-chalkboard-user',
					keywords: 'blackboard instructor learning professor school whiteboard writing chalkboard user',
				},
				{
					className: 'far fa-chart-user',
					options: [
						'fat fa-chart-user', 'fal fa-chart-user', 'far fa-chart-user', 'fas fa-chart-user',
					],
					defaultOption: 'far fa-chart-user',
					keywords: 'users people chart user',
				},
				{
					className: 'far fa-child',
					options: [
						'fat fa-child', 'fal fa-child', 'far fa-child', 'fas fa-child',
					],
					defaultOption: 'far fa-child',
					keywords: 'boy girl kid toddler young child',
				},
				{
					className: 'far fa-circle-user',
					options: [
						'fat fa-circle-user', 'fal fa-circle-user', 'far fa-circle-user', 'fas fa-circle-user',
					],
					defaultOption: 'far fa-circle-user',
					keywords: 'users people circle user',
				},
				{
					className: 'far fa-clipboard-user',
					options: [
						'fat fa-clipboard-user', 'fal fa-clipboard-user', 'far fa-clipboard-user', 'fas fa-clipboard-user',
					],
					defaultOption: 'far fa-clipboard-user',
					keywords: 'attendance record roster staff clipboard user',
				},
				{
					className: 'far fa-elevator',
					options: [
						'fat fa-elevator', 'fal fa-elevator', 'far fa-elevator', 'fas fa-elevator',
					],
					defaultOption: 'far fa-elevator',
					keywords: 'accessibility elevator hoist lift users people elevator',
				},
				{
					className: 'far fa-face-frown',
					options: [
						'fat fa-face-frown', 'fal fa-face-frown', 'far fa-face-frown', 'fas fa-face-frown',
					],
					defaultOption: 'far fa-face-frown',
					keywords: 'disapprove emoticon face frown frowning face rating sad face frown',
				},
				{
					className: 'far fa-face-meh',
					options: [
						'fat fa-face-meh', 'fal fa-face-meh', 'far fa-face-meh', 'fas fa-face-meh',
					],
					defaultOption: 'far fa-face-meh',
					keywords: 'deadpan emoticon face meh neutral neutral face rating face meh',
				},
				{
					className: 'far fa-face-smile',
					options: [
						'fat fa-face-smile', 'fal fa-face-smile', 'far fa-face-smile', 'fas fa-face-smile',
					],
					defaultOption: 'far fa-face-smile',
					keywords: 'approve emoticon face happy rating satisfied slightly smiling face smile face smile',
				},
				{
					className: 'far fa-family',
					options: [
						'fat fa-family', 'fal fa-family', 'far fa-family', 'fas fa-family',
					],
					defaultOption: 'far fa-family',
					keywords: 'adults child famil family folk kid family',
				},
				{
					className: 'far fa-family-dress',
					options: [
						'fat fa-family-dress', 'fal fa-family-dress', 'far fa-family-dress', 'fas fa-family-dress',
					],
					defaultOption: 'far fa-family-dress',
					keywords: 'adults child family folk kid family dress',
				},
				{
					className: 'far fa-family-pants',
					options: [
						'fat fa-family-pants', 'fal fa-family-pants', 'far fa-family-pants', 'fas fa-family-pants',
					],
					defaultOption: 'far fa-family-pants',
					keywords: 'adults child family folk kid family pants',
				},
				{
					className: 'far fa-file-user',
					options: [
						'fat fa-file-user', 'fal fa-file-user', 'far fa-file-user', 'fas fa-file-user',
					],
					defaultOption: 'far fa-file-user',
					keywords: 'account document page personnel profile resume file user',
				},
				{
					className: 'far fa-folder-user',
					options: [
						'fat fa-folder-user', 'fal fa-folder-user', 'far fa-folder-user', 'fas fa-folder-user',
					],
					defaultOption: 'far fa-folder-user',
					keywords: 'contacts file resume folder user',
				},
				{
					className: 'far fa-head-side',
					options: [
						'fat fa-head-side', 'fal fa-head-side', 'far fa-head-side', 'fas fa-head-side',
					],
					defaultOption: 'far fa-head-side',
					keywords: 'bald face profile user head side',
				},
				{
					className: 'far fa-head-side-brain',
					options: [
						'fat fa-head-side-brain', 'fal fa-head-side-brain', 'far fa-head-side-brain', 'fas fa-head-side-brain',
					],
					defaultOption: 'far fa-head-side-brain',
					keywords: 'diagnosis face mental health profile psychiatric psychiatry head side brain',
				},
				{
					className: 'far fa-head-side-cough',
					options: [
						'fat fa-head-side-cough', 'fal fa-head-side-cough', 'far fa-head-side-cough', 'fas fa-head-side-cough',
					],
					defaultOption: 'far fa-head-side-cough',
					keywords: 'cough covid 19 germs lungs respiratory sick head side cough',
				},
				{
					className: 'far fa-head-side-cough-slash',
					options: [
						'fat fa-head-side-cough-slash', 'fal fa-head-side-cough-slash', 'far fa-head-side-cough-slash', 'fas fa-head-side-cough-slash',
					],
					defaultOption: 'far fa-head-side-cough-slash',
					keywords: 'cough covid 19 germs lungs respiratory sick head side cough slash',
				},
				{
					className: 'far fa-head-side-goggles',
					options: [
						'fat fa-head-side-goggles', 'fal fa-head-side-goggles', 'far fa-head-side-goggles', 'fas fa-head-side-goggles',
					],
					defaultOption: 'far fa-head-side-goggles',
					keywords: '3d augmented face occulus profile reality virtual head side goggles',
				},
				{
					className: 'far fa-head-side-headphones',
					options: [
						'fat fa-head-side-headphones', 'fal fa-head-side-headphones', 'far fa-head-side-headphones', 'fas fa-head-side-headphones',
					],
					defaultOption: 'far fa-head-side-headphones',
					keywords: 'amplifier bluetooth earphone headset listen microphone music head side headphones',
				},
				{
					className: 'far fa-head-side-heart',
					options: [
						'fat fa-head-side-heart', 'fal fa-head-side-heart', 'far fa-head-side-heart', 'fas fa-head-side-heart',
					],
					defaultOption: 'far fa-head-side-heart',
					keywords: 'care love thought head side heart',
				},
				{
					className: 'far fa-head-side-mask',
					options: [
						'fat fa-head-side-mask', 'fal fa-head-side-mask', 'far fa-head-side-mask', 'fas fa-head-side-mask',
					],
					defaultOption: 'far fa-head-side-mask',
					keywords: 'breath covid 19 filter respirator virus head side mask',
				},
				{
					className: 'far fa-head-side-medical',
					options: [
						'fat fa-head-side-medical', 'fal fa-head-side-medical', 'far fa-head-side-medical', 'fas fa-head-side-medical',
					],
					defaultOption: 'far fa-head-side-medical',
					keywords: 'diagnosis face mental health profile psychiatric psychiatry head side medical',
				},
				{
					className: 'far fa-head-side-virus',
					options: [
						'fat fa-head-side-virus', 'fal fa-head-side-virus', 'far fa-head-side-virus', 'fas fa-head-side-virus',
					],
					defaultOption: 'far fa-head-side-virus',
					keywords: 'cold covid 19 flu sick head side virus',
				},
				{
					className: 'far fa-hospital-user',
					options: [
						'fat fa-hospital-user', 'fal fa-hospital-user', 'far fa-hospital-user', 'fas fa-hospital-user',
					],
					defaultOption: 'far fa-hospital-user',
					keywords: 'covid 19 doctor network patient primary care hospital user',
				},
				{
					className: 'far fa-hot-tub-person',
					options: [
						'fat fa-hot-tub-person', 'fal fa-hot-tub-person', 'far fa-hot-tub-person', 'fas fa-hot-tub-person',
					],
					defaultOption: 'far fa-hot-tub-person',
					keywords: 'jacuzzi spa hot tub person',
				},
				{
					className: 'far fa-house-chimney-user',
					options: [
						'fat fa-house-chimney-user', 'fal fa-house-chimney-user', 'far fa-house-chimney-user', 'fas fa-house-chimney-user',
					],
					defaultOption: 'far fa-house-chimney-user',
					keywords: 'covid 19 home isolation quarantine house chimney user',
				},
				{
					className: 'far fa-house-person-leave',
					options: [
						'fat fa-house-person-leave', 'fal fa-house-person-leave', 'far fa-house-person-leave', 'fas fa-house-person-leave',
					],
					defaultOption: 'far fa-house-person-leave',
					keywords: 'away home house person leave',
				},
				{
					className: 'far fa-house-person-return',
					options: [
						'fat fa-house-person-return', 'fal fa-house-person-return', 'far fa-house-person-return', 'fas fa-house-person-return',
					],
					defaultOption: 'far fa-house-person-return',
					keywords: 'home remote house person return',
				},
				{
					className: 'far fa-house-user',
					options: [
						'fat fa-house-user', 'fal fa-house-user', 'far fa-house-user', 'fas fa-house-user',
					],
					defaultOption: 'far fa-house-user',
					keywords: 'house house user',
				},
				{
					className: 'far fa-id-badge',
					options: [
						'fat fa-id-badge', 'fal fa-id-badge', 'far fa-id-badge', 'fas fa-id-badge',
					],
					defaultOption: 'far fa-id-badge',
					keywords: 'address contact identification license profile id badge',
				},
				{
					className: 'far fa-id-card',
					options: [
						'fat fa-id-card', 'fal fa-id-card', 'far fa-id-card', 'fas fa-id-card',
					],
					defaultOption: 'far fa-id-card',
					keywords: 'contact demographics document identification issued profile id card',
				},
				{
					className: 'far fa-id-card-clip',
					options: [
						'fat fa-id-card-clip', 'fal fa-id-card-clip', 'far fa-id-card-clip', 'fas fa-id-card-clip',
					],
					defaultOption: 'far fa-id-card-clip',
					keywords: 'contact demographics document identification issued profile id card clip',
				},
				{
					className: 'far fa-image-polaroid-user',
					options: [
						'fat fa-image-polaroid-user', 'fal fa-image-polaroid-user', 'far fa-image-polaroid-user', 'fas fa-image-polaroid-user',
					],
					defaultOption: 'far fa-image-polaroid-user',
					keywords: 'kodak portrait selfie image polaroid user',
				},
				{
					className: 'far fa-image-portrait',
					options: [
						'fat fa-image-portrait', 'fal fa-image-portrait', 'far fa-image-portrait', 'fas fa-image-portrait',
					],
					defaultOption: 'far fa-image-portrait',
					keywords: 'id image photo picture selfie image portrait',
				},
				{
					className: 'far fa-image-user',
					options: [
						'fat fa-image-user', 'fal fa-image-user', 'far fa-image-user', 'fas fa-image-user',
					],
					defaultOption: 'far fa-image-user',
					keywords: 'portrait selfie image user',
				},
				{
					className: 'far fa-images-user',
					options: [
						'fat fa-images-user', 'fal fa-images-user', 'far fa-images-user', 'fas fa-images-user',
					],
					defaultOption: 'far fa-images-user',
					keywords: 'portrait selfie images user',
				},
				{
					className: 'far fa-people',
					options: [
						'fat fa-people', 'fal fa-people', 'far fa-people', 'fas fa-people',
					],
					defaultOption: 'far fa-people',
					keywords: 'couple hand hold holding hands man users people woman woman and man holding hands people',
				},
				{
					className: 'far fa-people-arrows-left-right',
					options: [
						'fat fa-people-arrows-left-right', 'fal fa-people-arrows-left-right', 'far fa-people-arrows-left-right', 'fas fa-people-arrows-left-right',
					],
					defaultOption: 'far fa-people-arrows-left-right',
					keywords: 'users people people arrows left right',
				},
				{
					className: 'far fa-people-carry-box',
					options: [
						'fat fa-people-carry-box', 'fal fa-people-carry-box', 'far fa-people-carry-box', 'fas fa-people-carry-box',
					],
					defaultOption: 'far fa-people-carry-box',
					keywords: 'users people people carry box',
				},
				{
					className: 'far fa-people-dress',
					options: [
						'fat fa-people-dress', 'fal fa-people-dress', 'far fa-people-dress', 'fas fa-people-dress',
					],
					defaultOption: 'far fa-people-dress',
					keywords: 'couple hand holding hands users people women women holding hands people dress',
				},
				{
					className: 'far fa-people-dress-simple',
					options: [
						'fat fa-people-dress-simple', 'fal fa-people-dress-simple', 'far fa-people-dress-simple', 'fas fa-people-dress-simple',
					],
					defaultOption: 'far fa-people-dress-simple',
					keywords: 'users people people dress simple',
				},
				{
					className: 'far fa-people-pants',
					options: [
						'fat fa-people-pants', 'fal fa-people-pants', 'far fa-people-pants', 'fas fa-people-pants',
					],
					defaultOption: 'far fa-people-pants',
					keywords: 'gemini couple holding hands man men men holding hands twins users people zodiac people pants',
				},
				{
					className: 'far fa-people-pants-simple',
					options: [
						'fat fa-people-pants-simple', 'fal fa-people-pants-simple', 'far fa-people-pants-simple', 'fas fa-people-pants-simple',
					],
					defaultOption: 'far fa-people-pants-simple',
					keywords: 'users people people pants simple',
				},
				{
					className: 'far fa-people-simple',
					options: [
						'fat fa-people-simple', 'fal fa-people-simple', 'far fa-people-simple', 'fas fa-people-simple',
					],
					defaultOption: 'far fa-people-simple',
					keywords: 'users people people simple',
				},
				{
					className: 'far fa-person',
					options: [
						'fat fa-person', 'fal fa-person', 'far fa-person', 'fas fa-person',
					],
					defaultOption: 'far fa-person',
					keywords: 'man person standing stand standing woman person',
				},
				{
					className: 'far fa-person-biking',
					options: [
						'fat fa-person-biking', 'fal fa-person-biking', 'far fa-person-biking', 'fas fa-person-biking',
					],
					defaultOption: 'far fa-person-biking',
					keywords: 'bicycle bike biking cyclist pedal person biking summer wheel person biking',
				},
				{
					className: 'far fa-person-biking-mountain',
					options: [
						'fat fa-person-biking-mountain', 'fal fa-person-biking-mountain', 'far fa-person-biking-mountain', 'fas fa-person-biking-mountain',
					],
					defaultOption: 'far fa-person-biking-mountain',
					keywords: 'bicycle bicyclist bike cyclist mountain offroad pedal person mountain biking summer wheel person biking mountain',
				},
				{
					className: 'far fa-person-booth',
					options: [
						'fat fa-person-booth', 'fal fa-person-booth', 'far fa-person-booth', 'fas fa-person-booth',
					],
					defaultOption: 'far fa-person-booth',
					keywords: 'changing room curtain vote voting person booth',
				},
				{
					className: 'far fa-person-carry-box',
					options: [
						'fat fa-person-carry-box', 'fal fa-person-carry-box', 'far fa-person-carry-box', 'fas fa-person-carry-box',
					],
					defaultOption: 'far fa-person-carry-box',
					keywords: 'deliver lift person carry box',
				},
				{
					className: 'far fa-person-digging',
					options: [
						'fat fa-person-digging', 'fal fa-person-digging', 'far fa-person-digging', 'fas fa-person-digging',
					],
					defaultOption: 'far fa-person-digging',
					keywords: 'bury dig men at work person digging',
				},
				{
					className: 'far fa-person-dolly',
					options: [
						'fat fa-person-dolly', 'fal fa-person-dolly', 'far fa-person-dolly', 'fas fa-person-dolly',
					],
					defaultOption: 'far fa-person-dolly',
					keywords: 'carry deliver transport person dolly',
				},
				{
					className: 'far fa-person-dolly-empty',
					options: [
						'fat fa-person-dolly-empty', 'fal fa-person-dolly-empty', 'far fa-person-dolly-empty', 'fas fa-person-dolly-empty',
					],
					defaultOption: 'far fa-person-dolly-empty',
					keywords: 'carry deliver transport person dolly empty',
				},
				{
					className: 'far fa-person-dots-from-line',
					options: [
						'fat fa-person-dots-from-line', 'fal fa-person-dots-from-line', 'far fa-person-dots-from-line', 'fas fa-person-dots-from-line',
					],
					defaultOption: 'far fa-person-dots-from-line',
					keywords: 'allergy diagnosis person dots from line',
				},
				{
					className: 'far fa-person-dress',
					options: [
						'fat fa-person-dress', 'fal fa-person-dress', 'far fa-person-dress', 'fas fa-person-dress',
					],
					defaultOption: 'far fa-person-dress',
					keywords: 'man skirt woman person dress',
				},
				{
					className: 'far fa-person-dress-simple',
					options: [
						'fat fa-person-dress-simple', 'fal fa-person-dress-simple', 'far fa-person-dress-simple', 'fas fa-person-dress-simple',
					],
					defaultOption: 'far fa-person-dress-simple',
					keywords: 'lavatory man restroom skirt wc woman women s room person dress simple',
				},
				{
					className: 'far fa-person-from-portal',
					options: [
						'fat fa-person-from-portal', 'fal fa-person-from-portal', 'far fa-person-from-portal', 'fas fa-person-from-portal',
					],
					defaultOption: 'far fa-person-from-portal',
					keywords: 'portal run transport travel person from portal',
				},
				{
					className: 'far fa-person-hiking',
					options: [
						'fat fa-person-hiking', 'fal fa-person-hiking', 'far fa-person-hiking', 'fas fa-person-hiking',
					],
					defaultOption: 'far fa-person-hiking',
					keywords: 'autumn fall hike mountain outdoors summer walk person hiking',
				},
				{
					className: 'far fa-person-pinball',
					options: [
						'fat fa-person-pinball', 'fal fa-person-pinball', 'far fa-person-pinball', 'fas fa-person-pinball',
					],
					defaultOption: 'far fa-person-pinball',
					keywords: 'arcade fun game pinball person pinball',
				},
				{
					className: 'far fa-person-praying',
					options: [
						'fat fa-person-praying', 'fal fa-person-praying', 'far fa-person-praying', 'fas fa-person-praying',
					],
					defaultOption: 'far fa-person-praying',
					keywords: 'kneel place of worship religion thank worship person praying',
				},
				{
					className: 'far fa-person-pregnant',
					options: [
						'fat fa-person-pregnant', 'fal fa-person-pregnant', 'far fa-person-pregnant', 'fas fa-person-pregnant',
					],
					defaultOption: 'far fa-person-pregnant',
					keywords: 'baby birth child pregnant pregnant woman woman person pregnant',
				},
				{
					className: 'far fa-person-running',
					options: [
						'fat fa-person-running', 'fal fa-person-running', 'far fa-person-running', 'fas fa-person-running',
					],
					defaultOption: 'far fa-person-running',
					keywords: 'exit flee marathon person running race running person running',
				},
				{
					className: 'far fa-person-seat',
					options: [
						'fat fa-person-seat', 'fal fa-person-seat', 'far fa-person-seat', 'fas fa-person-seat',
					],
					defaultOption: 'far fa-person-seat',
					keywords: 'airplane chair recline seat travel person seat',
				},
				{
					className: 'far fa-person-seat-reclined',
					options: [
						'fat fa-person-seat-reclined', 'fal fa-person-seat-reclined', 'far fa-person-seat-reclined', 'fas fa-person-seat-reclined',
					],
					defaultOption: 'far fa-person-seat-reclined',
					keywords: 'airplane chair recline seat travel person seat reclined',
				},
				{
					className: 'far fa-person-sign',
					options: [
						'fat fa-person-sign', 'fal fa-person-sign', 'far fa-person-sign', 'fas fa-person-sign',
					],
					defaultOption: 'far fa-person-sign',
					keywords: 'announce protest person sign',
				},
				{
					className: 'far fa-person-simple',
					options: [
						'fat fa-person-simple', 'fal fa-person-simple', 'far fa-person-simple', 'fas fa-person-simple',
					],
					defaultOption: 'far fa-person-simple',
					keywords: 'lavatory man men s room restroom wc woman person simple',
				},
				{
					className: 'far fa-person-skating',
					options: [
						'fat fa-person-skating', 'fal fa-person-skating', 'far fa-person-skating', 'fas fa-person-skating',
					],
					defaultOption: 'far fa-person-skating',
					keywords: 'figure skating ice olympics rink skate winter person skating',
				},
				{
					className: 'far fa-person-ski-jumping',
					options: [
						'fat fa-person-ski-jumping', 'fal fa-person-ski-jumping', 'far fa-person-ski-jumping', 'fas fa-person-ski-jumping',
					],
					defaultOption: 'far fa-person-ski-jumping',
					keywords: 'olympics skiing winter person ski jumping',
				},
				{
					className: 'far fa-person-ski-lift',
					options: [
						'fat fa-person-ski-lift', 'fal fa-person-ski-lift', 'far fa-person-ski-lift', 'fas fa-person-ski-lift',
					],
					defaultOption: 'far fa-person-ski-lift',
					keywords: 'mountain skiing winter person ski lift',
				},
				{
					className: 'far fa-person-skiing',
					options: [
						'fat fa-person-skiing', 'fal fa-person-skiing', 'far fa-person-skiing', 'fas fa-person-skiing',
					],
					defaultOption: 'far fa-person-skiing',
					keywords: 'downhill olympics ski skier snow winter person skiing',
				},
				{
					className: 'far fa-person-skiing-nordic',
					options: [
						'fat fa-person-skiing-nordic', 'fal fa-person-skiing-nordic', 'far fa-person-skiing-nordic', 'fas fa-person-skiing-nordic',
					],
					defaultOption: 'far fa-person-skiing-nordic',
					keywords: 'cross country olympics winter person skiing nordic',
				},
				{
					className: 'far fa-person-sledding',
					options: [
						'fat fa-person-sledding', 'fal fa-person-sledding', 'far fa-person-sledding', 'fas fa-person-sledding',
					],
					defaultOption: 'far fa-person-sledding',
					keywords: 'fun slide winter person sledding',
				},
				{
					className: 'far fa-person-snowboarding',
					options: [
						'fat fa-person-snowboarding', 'fal fa-person-snowboarding', 'far fa-person-snowboarding', 'fas fa-person-snowboarding',
					],
					defaultOption: 'far fa-person-snowboarding',
					keywords: 'olympics ski snow snowboard snowboarder winter person snowboarding',
				},
				{
					className: 'far fa-person-snowmobiling',
					options: [
						'fat fa-person-snowmobiling', 'fal fa-person-snowmobiling', 'far fa-person-snowmobiling', 'fas fa-person-snowmobiling',
					],
					defaultOption: 'far fa-person-snowmobiling',
					keywords: 'snowmobile winter person snowmobiling',
				},
				{
					className: 'far fa-person-swimming',
					options: [
						'fat fa-person-swimming', 'fal fa-person-swimming', 'far fa-person-swimming', 'fas fa-person-swimming',
					],
					defaultOption: 'far fa-person-swimming',
					keywords: 'ocean person swimming pool sea swim water person swimming',
				},
				{
					className: 'far fa-person-to-door',
					options: [
						'fat fa-person-to-door', 'fal fa-person-to-door', 'far fa-person-to-door', 'fas fa-person-to-door',
					],
					defaultOption: 'far fa-person-to-door',
					keywords: 'door exit leave person to door',
				},
				{
					className: 'far fa-person-to-portal',
					options: [
						'fat fa-person-to-portal', 'fal fa-person-to-portal', 'far fa-person-to-portal', 'fas fa-person-to-portal',
					],
					defaultOption: 'far fa-person-to-portal',
					keywords: 'portal run transport travel person to portal',
				},
				{
					className: 'far fa-person-walking',
					options: [
						'fat fa-person-walking', 'fal fa-person-walking', 'far fa-person-walking', 'fas fa-person-walking',
					],
					defaultOption: 'far fa-person-walking',
					keywords: 'crosswalk exercise hike move person walking walk walking person walking',
				},
				{
					className: 'far fa-person-walking-with-cane',
					options: [
						'fat fa-person-walking-with-cane', 'fal fa-person-walking-with-cane', 'far fa-person-walking-with-cane', 'fas fa-person-walking-with-cane',
					],
					defaultOption: 'far fa-person-walking-with-cane',
					keywords: 'blind cane person walking with cane',
				},
				{
					className: 'far fa-poll-people',
					options: [
						'fat fa-poll-people', 'fal fa-poll-people', 'far fa-poll-people', 'fas fa-poll-people',
					],
					defaultOption: 'far fa-poll-people',
					keywords: 'users people poll people',
				},
				{
					className: 'far fa-poo',
					options: [
						'fat fa-poo', 'fal fa-poo', 'far fa-poo', 'fas fa-poo',
					],
					defaultOption: 'far fa-poo',
					keywords: 'crap dung face monster pile of poo poo poop shit smile turd poo',
				},
				{
					className: 'far fa-restroom',
					options: [
						'fat fa-restroom', 'fal fa-restroom', 'far fa-restroom', 'fas fa-restroom',
					],
					defaultOption: 'far fa-restroom',
					keywords: 'bathroom toilet water closet wc restroom',
				},
				{
					className: 'far fa-restroom-simple',
					options: [
						'fat fa-restroom-simple', 'fal fa-restroom-simple', 'far fa-restroom-simple', 'fas fa-restroom-simple',
					],
					defaultOption: 'far fa-restroom-simple',
					keywords: 'wc bathroom lavatory restroom toilet water closet wc restroom simple',
				},
				{
					className: 'far fa-screen-users',
					options: [
						'fat fa-screen-users', 'fal fa-screen-users', 'far fa-screen-users', 'fas fa-screen-users',
					],
					defaultOption: 'far fa-screen-users',
					keywords: 'chalkboard group presentation students teachers team screen users',
				},
				{
					className: 'far fa-skull',
					options: [
						'fat fa-skull', 'fal fa-skull', 'far fa-skull', 'fas fa-skull',
					],
					defaultOption: 'far fa-skull',
					keywords: 'bones death face fairy tale monster skeleton skull x ray yorick skull',
				},
				{
					className: 'far fa-square-user',
					options: [
						'fat fa-square-user', 'fal fa-square-user', 'far fa-square-user', 'fas fa-square-user',
					],
					defaultOption: 'far fa-square-user',
					keywords: 'person profile square user',
				},
				{
					className: 'far fa-street-view',
					options: [
						'fat fa-street-view', 'fal fa-street-view', 'far fa-street-view', 'fas fa-street-view',
					],
					defaultOption: 'far fa-street-view',
					keywords: 'directions location map navigation street view',
				},
				{
					className: 'far fa-user',
					options: [
						'fat fa-user', 'fal fa-user', 'far fa-user', 'fas fa-user',
					],
					defaultOption: 'far fa-user',
					keywords: 'adult bust bust in silhouette gender neutral person profile silhouette unspecified gender users people user',
				},
				{
					className: 'far fa-user-alien',
					options: [
						'fat fa-user-alien', 'fal fa-user-alien', 'far fa-user-alien', 'fas fa-user-alien',
					],
					defaultOption: 'far fa-user-alien',
					keywords: 'et extraterrestrial humanoid monster space strange ufo user alien',
				},
				{
					className: 'far fa-user-astronaut',
					options: [
						'fat fa-user-astronaut', 'fal fa-user-astronaut', 'far fa-user-astronaut', 'fas fa-user-astronaut',
					],
					defaultOption: 'far fa-user-astronaut',
					keywords: 'avatar clothing cosmonaut nasa space suit user astronaut',
				},
				{
					className: 'far fa-user-bounty-hunter',
					options: [
						'fat fa-user-bounty-hunter', 'fal fa-user-bounty-hunter', 'far fa-user-bounty-hunter', 'fas fa-user-bounty-hunter',
					],
					defaultOption: 'far fa-user-bounty-hunter',
					keywords: 'beskar boba fett jango fett mando mandolorian star wars user bounty hunter',
				},
				{
					className: 'far fa-user-check',
					options: [
						'fat fa-user-check', 'fal fa-user-check', 'far fa-user-check', 'fas fa-user-check',
					],
					defaultOption: 'far fa-user-check',
					keywords: 'users people user check',
				},
				{
					className: 'far fa-user-chef',
					options: [
						'fat fa-user-chef', 'fal fa-user-chef', 'far fa-user-chef', 'fas fa-user-chef',
					],
					defaultOption: 'far fa-user-chef',
					keywords: 'chef cook dining food kitchen restaurant user chef',
				},
				{
					className: 'far fa-user-clock',
					options: [
						'fat fa-user-clock', 'fal fa-user-clock', 'far fa-user-clock', 'fas fa-user-clock',
					],
					defaultOption: 'far fa-user-clock',
					keywords: 'users people user clock',
				},
				{
					className: 'far fa-user-cowboy',
					options: [
						'fat fa-user-cowboy', 'fal fa-user-cowboy', 'far fa-user-cowboy', 'fas fa-user-cowboy',
					],
					defaultOption: 'far fa-user-cowboy',
					keywords: 'buckaroo cowgirl horse jackeroo jessie old west pardner ranch rancher rodeo the lone ranger western woody wrangler user cowboy',
				},
				{
					className: 'far fa-user-crown',
					options: [
						'fat fa-user-crown', 'fal fa-user-crown', 'far fa-user-crown', 'fas fa-user-crown',
					],
					defaultOption: 'far fa-user-crown',
					keywords: 'users people user crown',
				},
				{
					className: 'far fa-user-doctor',
					options: [
						'fat fa-user-doctor', 'fal fa-user-doctor', 'far fa-user-doctor', 'fas fa-user-doctor',
					],
					defaultOption: 'far fa-user-doctor',
					keywords: 'covid 19 job medical nurse occupation physician profile surgeon user doctor',
				},
				{
					className: 'far fa-user-doctor-hair',
					options: [
						'fat fa-user-doctor-hair', 'fal fa-user-doctor-hair', 'far fa-user-doctor-hair', 'fas fa-user-doctor-hair',
					],
					defaultOption: 'far fa-user-doctor-hair',
					keywords: 'covid 19 job medical nurse occupation physician profile surgeon user doctor hair',
				},
				{
					className: 'far fa-user-doctor-hair-long',
					options: [
						'fat fa-user-doctor-hair-long', 'fal fa-user-doctor-hair-long', 'far fa-user-doctor-hair-long', 'fas fa-user-doctor-hair-long',
					],
					defaultOption: 'far fa-user-doctor-hair-long',
					keywords: 'covid 19 job medical nurse occupation physician profile surgeon user doctor hair long',
				},
				{
					className: 'far fa-user-doctor-message',
					options: [
						'fat fa-user-doctor-message', 'fal fa-user-doctor-message', 'far fa-user-doctor-message', 'fas fa-user-doctor-message',
					],
					defaultOption: 'far fa-user-doctor-message',
					keywords: 'advice comment diagnosis opinion prescription user doctor message',
				},
				{
					className: 'far fa-user-gear',
					options: [
						'fat fa-user-gear', 'fal fa-user-gear', 'far fa-user-gear', 'fas fa-user-gear',
					],
					defaultOption: 'far fa-user-gear',
					keywords: 'users people user gear',
				},
				{
					className: 'far fa-user-graduate',
					options: [
						'fat fa-user-graduate', 'fal fa-user-graduate', 'far fa-user-graduate', 'fas fa-user-graduate',
					],
					defaultOption: 'far fa-user-graduate',
					keywords: 'users people user graduate',
				},
				{
					className: 'far fa-user-group',
					options: [
						'fat fa-user-group', 'fal fa-user-group', 'far fa-user-group', 'fas fa-user-group',
					],
					defaultOption: 'far fa-user-group',
					keywords: 'bust busts in silhouette silhouette users people user group',
				},
				{
					className: 'far fa-user-group-crown',
					options: [
						'fat fa-user-group-crown', 'fal fa-user-group-crown', 'far fa-user-group-crown', 'fas fa-user-group-crown',
					],
					defaultOption: 'far fa-user-group-crown',
					keywords: 'users people user group crown',
				},
				{
					className: 'far fa-user-hair',
					options: [
						'fat fa-user-hair', 'fal fa-user-hair', 'far fa-user-hair', 'fas fa-user-hair',
					],
					defaultOption: 'far fa-user-hair',
					keywords: 'bust bust in silhouette person profile silhouette user hair',
				},
				{
					className: 'far fa-user-hair-buns',
					options: [
						'fat fa-user-hair-buns', 'fal fa-user-hair-buns', 'far fa-user-hair-buns', 'fas fa-user-hair-buns',
					],
					defaultOption: 'far fa-user-hair-buns',
					keywords: 'hairstyle leia organa princess rebel skywalker star wars user hair buns',
				},
				{
					className: 'far fa-user-hair-long',
					options: [
						'fat fa-user-hair-long', 'fal fa-user-hair-long', 'far fa-user-hair-long', 'fas fa-user-hair-long',
					],
					defaultOption: 'far fa-user-hair-long',
					keywords: 'bust bust in silhouette person profile silhouette user hair long',
				},
				{
					className: 'far fa-user-hair-mullet',
					options: [
						'fat fa-user-hair-mullet', 'fal fa-user-hair-mullet', 'far fa-user-hair-mullet', 'fas fa-user-hair-mullet',
					],
					defaultOption: 'far fa-user-hair-mullet',
					keywords: 'business mullet party user hair mullet',
				},
				{
					className: 'far fa-user-headset',
					options: [
						'fat fa-user-headset', 'fal fa-user-headset', 'far fa-user-headset', 'fas fa-user-headset',
					],
					defaultOption: 'far fa-user-headset',
					keywords: 'users people user headset',
				},
				{
					className: 'far fa-user-helmet-safety',
					options: [
						'fat fa-user-helmet-safety', 'fal fa-user-helmet-safety', 'far fa-user-helmet-safety', 'fas fa-user-helmet-safety',
					],
					defaultOption: 'far fa-user-helmet-safety',
					keywords: 'construction construction worker hardhat hat helmet safety worker user helmet safety',
				},
				{
					className: 'far fa-user-injured',
					options: [
						'fat fa-user-injured', 'fal fa-user-injured', 'far fa-user-injured', 'fas fa-user-injured',
					],
					defaultOption: 'far fa-user-injured',
					keywords: 'users people user injured',
				},
				{
					className: 'far fa-user-large',
					options: [
						'fat fa-user-large', 'fal fa-user-large', 'far fa-user-large', 'fas fa-user-large',
					],
					defaultOption: 'far fa-user-large',
					keywords: 'users people user large',
				},
				{
					className: 'far fa-user-large-slash',
					options: [
						'fat fa-user-large-slash', 'fal fa-user-large-slash', 'far fa-user-large-slash', 'fas fa-user-large-slash',
					],
					defaultOption: 'far fa-user-large-slash',
					keywords: 'users people user large slash',
				},
				{
					className: 'far fa-user-lock',
					options: [
						'fat fa-user-lock', 'fal fa-user-lock', 'far fa-user-lock', 'fas fa-user-lock',
					],
					defaultOption: 'far fa-user-lock',
					keywords: 'users people user lock',
				},
				{
					className: 'far fa-user-minus',
					options: [
						'fat fa-user-minus', 'fal fa-user-minus', 'far fa-user-minus', 'fas fa-user-minus',
					],
					defaultOption: 'far fa-user-minus',
					keywords: 'delete negative remove user minus',
				},
				{
					className: 'far fa-user-music',
					options: [
						'fat fa-user-music', 'fal fa-user-music', 'far fa-user-music', 'fas fa-user-music',
					],
					defaultOption: 'far fa-user-music',
					keywords: 'artist music musician singer user music',
				},
				{
					className: 'far fa-user-ninja',
					options: [
						'fat fa-user-ninja', 'fal fa-user-ninja', 'far fa-user-ninja', 'fas fa-user-ninja',
					],
					defaultOption: 'far fa-user-ninja',
					keywords: 'assassin avatar dangerous deadly fighter hidden ninja sneaky stealth user ninja',
				},
				{
					className: 'far fa-user-nurse',
					options: [
						'fat fa-user-nurse', 'fal fa-user-nurse', 'far fa-user-nurse', 'fas fa-user-nurse',
					],
					defaultOption: 'far fa-user-nurse',
					keywords: 'covid 19 doctor md medico midwife physician practitioner surgeon user nurse',
				},
				{
					className: 'far fa-user-nurse-hair',
					options: [
						'fat fa-user-nurse-hair', 'fal fa-user-nurse-hair', 'far fa-user-nurse-hair', 'fas fa-user-nurse-hair',
					],
					defaultOption: 'far fa-user-nurse-hair',
					keywords: 'doctor md midwife physician practitioner surgeon user nurse hair',
				},
				{
					className: 'far fa-user-nurse-hair-long',
					options: [
						'fat fa-user-nurse-hair-long', 'fal fa-user-nurse-hair-long', 'far fa-user-nurse-hair-long', 'fas fa-user-nurse-hair-long',
					],
					defaultOption: 'far fa-user-nurse-hair-long',
					keywords: 'doctor md midwife physician practitioner surgeon user nurse hair long',
				},
				{
					className: 'far fa-user-pen',
					options: [
						'fat fa-user-pen', 'fal fa-user-pen', 'far fa-user-pen', 'fas fa-user-pen',
					],
					defaultOption: 'far fa-user-pen',
					keywords: 'users people user pen',
				},
				{
					className: 'far fa-user-pilot',
					options: [
						'fat fa-user-pilot', 'fal fa-user-pilot', 'far fa-user-pilot', 'fas fa-user-pilot',
					],
					defaultOption: 'far fa-user-pilot',
					keywords: 'airplane airport flight fly navigate pilot user pilot',
				},
				{
					className: 'far fa-user-pilot-tie',
					options: [
						'fat fa-user-pilot-tie', 'fal fa-user-pilot-tie', 'far fa-user-pilot-tie', 'fas fa-user-pilot-tie',
					],
					defaultOption: 'far fa-user-pilot-tie',
					keywords: 'airplane airport flight fly navigate pilot user pilot tie',
				},
				{
					className: 'far fa-user-plus',
					options: [
						'fat fa-user-plus', 'fal fa-user-plus', 'far fa-user-plus', 'fas fa-user-plus',
					],
					defaultOption: 'far fa-user-plus',
					keywords: 'add avatar positive sign up signup team user plus',
				},
				{
					className: 'far fa-user-police',
					options: [
						'fat fa-user-police', 'fal fa-user-police', 'far fa-user-police', 'fas fa-user-police',
					],
					defaultOption: 'far fa-user-police',
					keywords: 'cop five o law enforcement officer patrol police police officer trooper user police',
				},
				{
					className: 'far fa-user-police-tie',
					options: [
						'fat fa-user-police-tie', 'fal fa-user-police-tie', 'far fa-user-police-tie', 'fas fa-user-police-tie',
					],
					defaultOption: 'far fa-user-police-tie',
					keywords: 'cop five o law enforcement officer patrol police trooper user police tie',
				},
				{
					className: 'far fa-user-robot',
					options: [
						'fat fa-user-robot', 'fal fa-user-robot', 'far fa-user-robot', 'fas fa-user-robot',
					],
					defaultOption: 'far fa-user-robot',
					keywords: 'android automate computer cyborg rosie user robot',
				},
				{
					className: 'far fa-user-secret',
					options: [
						'fat fa-user-secret', 'fal fa-user-secret', 'far fa-user-secret', 'fas fa-user-secret',
					],
					defaultOption: 'far fa-user-secret',
					keywords: 'detective sleuth spy users people user secret',
				},
				{
					className: 'far fa-user-shakespeare',
					options: [
						'fat fa-user-shakespeare', 'fal fa-user-shakespeare', 'far fa-user-shakespeare', 'fas fa-user-shakespeare',
					],
					defaultOption: 'far fa-user-shakespeare',
					keywords: 'bard playwright theater theatre user shakespeare',
				},
				{
					className: 'far fa-user-shield',
					options: [
						'fat fa-user-shield', 'fal fa-user-shield', 'far fa-user-shield', 'fas fa-user-shield',
					],
					defaultOption: 'far fa-user-shield',
					keywords: 'users people user shield',
				},
				{
					className: 'far fa-user-slash',
					options: [
						'fat fa-user-slash', 'fal fa-user-slash', 'far fa-user-slash', 'fas fa-user-slash',
					],
					defaultOption: 'far fa-user-slash',
					keywords: 'ban delete remove user slash',
				},
				{
					className: 'far fa-user-tag',
					options: [
						'fat fa-user-tag', 'fal fa-user-tag', 'far fa-user-tag', 'fas fa-user-tag',
					],
					defaultOption: 'far fa-user-tag',
					keywords: 'users people user tag',
				},
				{
					className: 'far fa-user-tie',
					options: [
						'fat fa-user-tie', 'fal fa-user-tie', 'far fa-user-tie', 'fas fa-user-tie',
					],
					defaultOption: 'far fa-user-tie',
					keywords: 'avatar business clothing formal professional suit user tie',
				},
				{
					className: 'far fa-user-tie-hair',
					options: [
						'fat fa-user-tie-hair', 'fal fa-user-tie-hair', 'far fa-user-tie-hair', 'fas fa-user-tie-hair',
					],
					defaultOption: 'far fa-user-tie-hair',
					keywords: 'avatar business clothing formal professional suit user tie hair',
				},
				{
					className: 'far fa-user-tie-hair-long',
					options: [
						'fat fa-user-tie-hair-long', 'fal fa-user-tie-hair-long', 'far fa-user-tie-hair-long', 'fas fa-user-tie-hair-long',
					],
					defaultOption: 'far fa-user-tie-hair-long',
					keywords: 'avatar business clothing formal professional suit user tie hair long',
				},
				{
					className: 'far fa-user-unlock',
					options: [
						'fat fa-user-unlock', 'fal fa-user-unlock', 'far fa-user-unlock', 'fas fa-user-unlock',
					],
					defaultOption: 'far fa-user-unlock',
					keywords: 'users people user unlock',
				},
				{
					className: 'far fa-user-visor',
					options: [
						'fat fa-user-visor', 'fal fa-user-visor', 'far fa-user-visor', 'fas fa-user-visor',
					],
					defaultOption: 'far fa-user-visor',
					keywords: 'geordi la forge star trek user visor',
				},
				{
					className: 'far fa-user-vneck',
					options: [
						'fat fa-user-vneck', 'fal fa-user-vneck', 'far fa-user-vneck', 'fas fa-user-vneck',
					],
					defaultOption: 'far fa-user-vneck',
					keywords: 'bust bust in silhouette person profile silhouette user vneck',
				},
				{
					className: 'far fa-user-vneck-hair',
					options: [
						'fat fa-user-vneck-hair', 'fal fa-user-vneck-hair', 'far fa-user-vneck-hair', 'fas fa-user-vneck-hair',
					],
					defaultOption: 'far fa-user-vneck-hair',
					keywords: 'bust bust in silhouette person profile silhouette user vneck hair',
				},
				{
					className: 'far fa-user-vneck-hair-long',
					options: [
						'fat fa-user-vneck-hair-long', 'fal fa-user-vneck-hair-long', 'far fa-user-vneck-hair-long', 'fas fa-user-vneck-hair-long',
					],
					defaultOption: 'far fa-user-vneck-hair-long',
					keywords: 'bust bust in silhouette person profile silhouette user vneck hair long',
				},
				{
					className: 'far fa-user-xmark',
					options: [
						'fat fa-user-xmark', 'fal fa-user-xmark', 'far fa-user-xmark', 'fas fa-user-xmark',
					],
					defaultOption: 'far fa-user-xmark',
					keywords: 'archive delete remove x user xmark',
				},
				{
					className: 'far fa-users',
					options: [
						'fat fa-users', 'fal fa-users', 'far fa-users', 'fas fa-users',
					],
					defaultOption: 'far fa-users',
					keywords: 'users people users',
				},
				{
					className: 'far fa-users-gear',
					options: [
						'fat fa-users-gear', 'fal fa-users-gear', 'far fa-users-gear', 'fas fa-users-gear',
					],
					defaultOption: 'far fa-users-gear',
					keywords: 'users people users gear',
				},
				{
					className: 'far fa-users-medical',
					options: [
						'fat fa-users-medical', 'fal fa-users-medical', 'far fa-users-medical', 'fas fa-users-medical',
					],
					defaultOption: 'far fa-users-medical',
					keywords: 'group patients physician team users medical',
				},
				{
					className: 'far fa-users-slash',
					options: [
						'fat fa-users-slash', 'fal fa-users-slash', 'far fa-users-slash', 'fas fa-users-slash',
					],
					defaultOption: 'far fa-users-slash',
					keywords: 'users people users slash',
				},
				{
					className: 'far fa-wheelchair',
					options: [
						'fat fa-wheelchair', 'fal fa-wheelchair', 'far fa-wheelchair', 'fas fa-wheelchair',
					],
					defaultOption: 'far fa-wheelchair',
					keywords: 'users people wheelchair',
				},
				{
					className: 'far fa-wheelchair-move',
					options: [
						'fat fa-wheelchair-move', 'fal fa-wheelchair-move', 'far fa-wheelchair-move', 'fas fa-wheelchair-move',
					],
					defaultOption: 'far fa-wheelchair-move',
					keywords: 'access users people wheelchair symbol wheelchair move',
				},
			],
		},
		{
			id: 'weather',
			name: Loc.getMessage('LANDING_ICONS_SECTION_WEATHER'),
			items: [
				{
					className: 'far fa-bolt',
					options: [
						'fat fa-bolt', 'fal fa-bolt', 'far fa-bolt', 'fas fa-bolt',
					],
					defaultOption: 'far fa-bolt',
					keywords: 'charge danger electric electricity flash high voltage lightning voltage weather zap bolt',
				},
				{
					className: 'far fa-bolt-lightning',
					options: [
						'fat fa-bolt-lightning', 'fal fa-bolt-lightning', 'far fa-bolt-lightning', 'fas fa-bolt-lightning',
					],
					defaultOption: 'far fa-bolt-lightning',
					keywords: 'electricity flash lightning weather zap bolt lightning',
				},
				{
					className: 'far fa-cloud',
					options: [
						'fat fa-cloud', 'fal fa-cloud', 'far fa-cloud', 'fas fa-cloud',
					],
					defaultOption: 'far fa-cloud',
					keywords: 'atmosphere cloud fog overcast save upload weather cloud',
				},
				{
					className: 'far fa-cloud-bolt',
					options: [
						'fat fa-cloud-bolt', 'fal fa-cloud-bolt', 'far fa-cloud-bolt', 'fas fa-cloud-bolt',
					],
					defaultOption: 'far fa-cloud-bolt',
					keywords: 'bolt cloud cloud with lightning lightning precipitation rain storm weather cloud bolt',
				},
				{
					className: 'far fa-cloud-bolt-moon',
					options: [
						'fat fa-cloud-bolt-moon', 'fal fa-cloud-bolt-moon', 'far fa-cloud-bolt-moon', 'fas fa-cloud-bolt-moon',
					],
					defaultOption: 'far fa-cloud-bolt-moon',
					keywords: 'bolt lightning lunar moon precipitation rain storm weather cloud bolt moon',
				},
				{
					className: 'far fa-cloud-bolt-sun',
					options: [
						'fat fa-cloud-bolt-sun', 'fal fa-cloud-bolt-sun', 'far fa-cloud-bolt-sun', 'fas fa-cloud-bolt-sun',
					],
					defaultOption: 'far fa-cloud-bolt-sun',
					keywords: 'bolt lightning precipitation rain solar storm sun weather cloud bolt sun',
				},
				{
					className: 'far fa-cloud-drizzle',
					options: [
						'fat fa-cloud-drizzle', 'fal fa-cloud-drizzle', 'far fa-cloud-drizzle', 'fas fa-cloud-drizzle',
					],
					defaultOption: 'far fa-cloud-drizzle',
					keywords: 'precipitation rain sprinkle cloud drizzle',
				},
				{
					className: 'far fa-cloud-fog',
					options: [
						'fat fa-cloud-fog', 'fal fa-cloud-fog', 'far fa-cloud-fog', 'fas fa-cloud-fog',
					],
					defaultOption: 'far fa-cloud-fog',
					keywords: 'cloud fog haze karl mist opaque san francisco visibility weather cloud fog',
				},
				{
					className: 'far fa-cloud-hail',
					options: [
						'fat fa-cloud-hail', 'fal fa-cloud-hail', 'far fa-cloud-hail', 'fas fa-cloud-hail',
					],
					defaultOption: 'far fa-cloud-hail',
					keywords: 'golf balls ice precipitation sleet snow storm cloud hail',
				},
				{
					className: 'far fa-cloud-hail-mixed',
					options: [
						'fat fa-cloud-hail-mixed', 'fal fa-cloud-hail-mixed', 'far fa-cloud-hail-mixed', 'fas fa-cloud-hail-mixed',
					],
					defaultOption: 'far fa-cloud-hail-mixed',
					keywords: 'freezing ice precipitation rain sleet snow storm cloud hail mixed',
				},
				{
					className: 'far fa-cloud-meatball',
					options: [
						'fat fa-cloud-meatball', 'fal fa-cloud-meatball', 'far fa-cloud-meatball', 'fas fa-cloud-meatball',
					],
					defaultOption: 'far fa-cloud-meatball',
					keywords: 'fldsmdfr food spaghetti storm cloud meatball',
				},
				{
					className: 'far fa-cloud-moon',
					options: [
						'fat fa-cloud-moon', 'fal fa-cloud-moon', 'far fa-cloud-moon', 'fas fa-cloud-moon',
					],
					defaultOption: 'far fa-cloud-moon',
					keywords: 'crescent evening lunar night partly cloudy sky cloud moon',
				},
				{
					className: 'far fa-cloud-moon-rain',
					options: [
						'fat fa-cloud-moon-rain', 'fal fa-cloud-moon-rain', 'far fa-cloud-moon-rain', 'fas fa-cloud-moon-rain',
					],
					defaultOption: 'far fa-cloud-moon-rain',
					keywords: 'crescent evening lunar night partly cloudy precipitation rain sky storm cloud moon rain',
				},
				{
					className: 'far fa-cloud-rain',
					options: [
						'fat fa-cloud-rain', 'fal fa-cloud-rain', 'far fa-cloud-rain', 'fas fa-cloud-rain',
					],
					defaultOption: 'far fa-cloud-rain',
					keywords: 'rain cloud cloud with rain precipitation rain sky storm cloud rain',
				},
				{
					className: 'far fa-cloud-rainbow',
					options: [
						'fat fa-cloud-rainbow', 'fal fa-cloud-rainbow', 'far fa-cloud-rainbow', 'fas fa-cloud-rainbow',
					],
					defaultOption: 'far fa-cloud-rainbow',
					keywords: 'gold leprechaun prism rain sky cloud rainbow',
				},
				{
					className: 'far fa-cloud-showers',
					options: [
						'fat fa-cloud-showers', 'fal fa-cloud-showers', 'far fa-cloud-showers', 'fas fa-cloud-showers',
					],
					defaultOption: 'far fa-cloud-showers',
					keywords: 'precipitation rain sky storm cloud showers',
				},
				{
					className: 'far fa-cloud-showers-heavy',
					options: [
						'fat fa-cloud-showers-heavy', 'fal fa-cloud-showers-heavy', 'far fa-cloud-showers-heavy', 'fas fa-cloud-showers-heavy',
					],
					defaultOption: 'far fa-cloud-showers-heavy',
					keywords: 'precipitation rain sky storm cloud showers heavy',
				},
				{
					className: 'far fa-cloud-sleet',
					options: [
						'fat fa-cloud-sleet', 'fal fa-cloud-sleet', 'far fa-cloud-sleet', 'fas fa-cloud-sleet',
					],
					defaultOption: 'far fa-cloud-sleet',
					keywords: 'freezing hail precipitation rain winter wintry mix cloud sleet',
				},
				{
					className: 'far fa-cloud-snow',
					options: [
						'fat fa-cloud-snow', 'fal fa-cloud-snow', 'far fa-cloud-snow', 'fas fa-cloud-snow',
					],
					defaultOption: 'far fa-cloud-snow',
					keywords: 'blizzard cloud cloud with snow cold noreaster precipitation snow winter cloud snow',
				},
				{
					className: 'far fa-cloud-sun',
					options: [
						'fat fa-cloud-sun', 'fal fa-cloud-sun', 'far fa-cloud-sun', 'fas fa-cloud-sun',
					],
					defaultOption: 'far fa-cloud-sun',
					keywords: 'clear cloud day daytime fall outdoors overcast partly cloudy sun sun behind cloud cloud sun',
				},
				{
					className: 'far fa-cloud-sun-rain',
					options: [
						'fat fa-cloud-sun-rain', 'fal fa-cloud-sun-rain', 'far fa-cloud-sun-rain', 'fas fa-cloud-sun-rain',
					],
					defaultOption: 'far fa-cloud-sun-rain',
					keywords: 'cloud day overcast precipitation rain storm summer sun sun behind rain cloud sunshower cloud sun rain',
				},
				{
					className: 'far fa-clouds',
					options: [
						'fat fa-clouds', 'fal fa-clouds', 'far fa-clouds', 'fas fa-clouds',
					],
					defaultOption: 'far fa-clouds',
					keywords: 'cloudy fog haze overcast smoke storm weather clouds',
				},
				{
					className: 'far fa-clouds-moon',
					options: [
						'fat fa-clouds-moon', 'fal fa-clouds-moon', 'far fa-clouds-moon', 'fas fa-clouds-moon',
					],
					defaultOption: 'far fa-clouds-moon',
					keywords: 'cloudy moonlight night overcast sky clouds moon',
				},
				{
					className: 'far fa-clouds-sun',
					options: [
						'fat fa-clouds-sun', 'fal fa-clouds-sun', 'far fa-clouds-sun', 'fas fa-clouds-sun',
					],
					defaultOption: 'far fa-clouds-sun',
					keywords: 'cloudy day moonlight overcast sky summer clouds sun',
				},
				{
					className: 'far fa-droplet-degree',
					options: [
						'fat fa-droplet-degree', 'fal fa-droplet-degree', 'far fa-droplet-degree', 'fas fa-droplet-degree',
					],
					defaultOption: 'far fa-droplet-degree',
					keywords: 'air fog humidity temperature water droplet degree',
				},
				{
					className: 'far fa-droplet-percent',
					options: [
						'fat fa-droplet-percent', 'fal fa-droplet-percent', 'far fa-droplet-percent', 'fas fa-droplet-percent',
					],
					defaultOption: 'far fa-droplet-percent',
					keywords: 'evaporation fog precipitation rain droplet percent',
				},
				{
					className: 'far fa-eclipse',
					options: [
						'fat fa-eclipse', 'fal fa-eclipse', 'far fa-eclipse', 'fas fa-eclipse',
					],
					defaultOption: 'far fa-eclipse',
					keywords: 'lunar moon shadow solar sun eclipse',
				},
				{
					className: 'far fa-fire-smoke',
					options: [
						'fat fa-fire-smoke', 'fal fa-fire-smoke', 'far fa-fire-smoke', 'fas fa-fire-smoke',
					],
					defaultOption: 'far fa-fire-smoke',
					keywords: 'burn caliente flame fog heat hot fire smoke',
				},
				{
					className: 'far fa-heat',
					options: [
						'fat fa-heat', 'fal fa-heat', 'far fa-heat', 'fas fa-heat',
					],
					defaultOption: 'far fa-heat',
					keywords: 'ac air conditioner boiler heating hot sauna spa summer temperature heat',
				},
				{
					className: 'far fa-house-flood',
					options: [
						'fat fa-house-flood', 'fal fa-house-flood', 'far fa-house-flood', 'fas fa-house-flood',
					],
					defaultOption: 'far fa-house-flood',
					keywords: 'building devastation disaster home insurance water house flood',
				},
				{
					className: 'far fa-hurricane',
					options: [
						'fat fa-hurricane', 'fal fa-hurricane', 'far fa-hurricane', 'fas fa-hurricane',
					],
					defaultOption: 'far fa-hurricane',
					keywords: 'coriolis effect eye storm tropical cyclone typhoon hurricane',
				},
				{
					className: 'far fa-icicles',
					options: [
						'fat fa-icicles', 'fal fa-icicles', 'far fa-icicles', 'fas fa-icicles',
					],
					defaultOption: 'far fa-icicles',
					keywords: 'cold frozen hanging ice seasonal sharp icicles',
				},
				{
					className: 'far fa-meteor',
					options: [
						'fat fa-meteor', 'fal fa-meteor', 'far fa-meteor', 'fas fa-meteor',
					],
					defaultOption: 'far fa-meteor',
					keywords: 'armageddon asteroid comet shooting star space meteor',
				},
				{
					className: 'far fa-moon',
					options: [
						'fat fa-moon', 'fal fa-moon', 'far fa-moon', 'fas fa-moon',
					],
					defaultOption: 'far fa-moon',
					keywords: 'power sleep symbol contrast crescent crescent moon dark lunar moon night moon',
				},
				{
					className: 'far fa-moon-cloud',
					options: [
						'fat fa-moon-cloud', 'fal fa-moon-cloud', 'far fa-moon-cloud', 'fas fa-moon-cloud',
					],
					defaultOption: 'far fa-moon-cloud',
					keywords: 'crescent dark lunar night overcast moon cloud',
				},
				{
					className: 'far fa-moon-over-sun',
					options: [
						'fat fa-moon-over-sun', 'fal fa-moon-over-sun', 'far fa-moon-over-sun', 'fas fa-moon-over-sun',
					],
					defaultOption: 'far fa-moon-over-sun',
					keywords: 'lunar moon shadow solar sun moon over sun',
				},
				{
					className: 'far fa-moon-stars',
					options: [
						'fat fa-moon-stars', 'fal fa-moon-stars', 'far fa-moon-stars', 'fas fa-moon-stars',
					],
					defaultOption: 'far fa-moon-stars',
					keywords: 'clear crescent lunar space star moon stars',
				},
				{
					className: 'far fa-poo-storm',
					options: [
						'fat fa-poo-storm', 'fal fa-poo-storm', 'far fa-poo-storm', 'fas fa-poo-storm',
					],
					defaultOption: 'far fa-poo-storm',
					keywords: 'bolt cloud euphemism lightning mess poop shit turd poo storm',
				},
				{
					className: 'far fa-rainbow',
					options: [
						'fat fa-rainbow', 'fal fa-rainbow', 'far fa-rainbow', 'fas fa-rainbow',
					],
					defaultOption: 'far fa-rainbow',
					keywords: 'gold leprechaun prism rain rainbow sky rainbow',
				},
				{
					className: 'far fa-raindrops',
					options: [
						'fat fa-raindrops', 'fal fa-raindrops', 'far fa-raindrops', 'fas fa-raindrops',
					],
					defaultOption: 'far fa-raindrops',
					keywords: 'precipitation rain sprinkle storm raindrops',
				},
				{
					className: 'far fa-smog',
					options: [
						'fat fa-smog', 'fal fa-smog', 'far fa-smog', 'fas fa-smog',
					],
					defaultOption: 'far fa-smog',
					keywords: 'dragon fog haze pollution smoke weather smog',
				},
				{
					className: 'far fa-smoke',
					options: [
						'fat fa-smoke', 'fal fa-smoke', 'far fa-smoke', 'fas fa-smoke',
					],
					defaultOption: 'far fa-smoke',
					keywords: 'cloud fire fog haze smoke',
				},
				{
					className: 'far fa-snow-blowing',
					options: [
						'fat fa-snow-blowing', 'fal fa-snow-blowing', 'far fa-snow-blowing', 'fas fa-snow-blowing',
					],
					defaultOption: 'far fa-snow-blowing',
					keywords: 'blizzard precipitation storm winter snow blowing',
				},
				{
					className: 'far fa-snowflake',
					options: [
						'fat fa-snowflake', 'fal fa-snowflake', 'far fa-snowflake', 'fas fa-snowflake',
					],
					defaultOption: 'far fa-snowflake',
					keywords: 'heavy chevron snowflake cold precipitation rain snow snowflake winter snowflake',
				},
				{
					className: 'far fa-snowflakes',
					options: [
						'fat fa-snowflakes', 'fal fa-snowflakes', 'far fa-snowflakes', 'fas fa-snowflakes',
					],
					defaultOption: 'far fa-snowflakes',
					keywords: 'precipitation rain winter snowflakes',
				},
				{
					className: 'far fa-sparkles',
					options: [
						'fat fa-sparkles', 'fal fa-sparkles', 'far fa-sparkles', 'fas fa-sparkles',
					],
					defaultOption: 'far fa-sparkles',
					keywords: '* glitter magic new sparkle sparkles special star twinkle sparkles',
				},
				{
					className: 'far fa-stars',
					options: [
						'fat fa-stars', 'fal fa-stars', 'far fa-stars', 'fas fa-stars',
					],
					defaultOption: 'far fa-stars',
					keywords: 'favorite galaxy magic night space stars',
				},
				{
					className: 'far fa-sun',
					options: [
						'fat fa-sun', 'fal fa-sun', 'far fa-sun', 'fas fa-sun',
					],
					defaultOption: 'far fa-sun',
					keywords: 'bright brighten contrast day lighter rays sol solar star sun sunny weather sun',
				},
				{
					className: 'far fa-sun-bright',
					options: [
						'fat fa-sun-bright', 'fal fa-sun-bright', 'far fa-sun-bright', 'fas fa-sun-bright',
					],
					defaultOption: 'far fa-sun-bright',
					keywords: 'brightness sky summer sun bright',
				},
				{
					className: 'far fa-sun-cloud',
					options: [
						'fat fa-sun-cloud', 'fal fa-sun-cloud', 'far fa-sun-cloud', 'fas fa-sun-cloud',
					],
					defaultOption: 'far fa-sun-cloud',
					keywords: 'cloud day lighter sol solar star sun sun behind small cloud weather sun cloud',
				},
				{
					className: 'far fa-sun-dust',
					options: [
						'fat fa-sun-dust', 'fal fa-sun-dust', 'far fa-sun-dust', 'fas fa-sun-dust',
					],
					defaultOption: 'far fa-sun-dust',
					keywords: 'day dry haze heat sun dust',
				},
				{
					className: 'far fa-sun-haze',
					options: [
						'fat fa-sun-haze', 'fal fa-sun-haze', 'far fa-sun-haze', 'fas fa-sun-haze',
					],
					defaultOption: 'far fa-sun-haze',
					keywords: 'fog heat hot sweltering sun haze',
				},
				{
					className: 'far fa-sunrise',
					options: [
						'fat fa-sunrise', 'fal fa-sunrise', 'far fa-sunrise', 'fas fa-sunrise',
					],
					defaultOption: 'far fa-sunrise',
					keywords: 'dawn day daybreak daylight daytime morning sun sun up sunrise sunrise',
				},
				{
					className: 'far fa-sunset',
					options: [
						'fat fa-sunset', 'fal fa-sunset', 'far fa-sunset', 'fas fa-sunset',
					],
					defaultOption: 'far fa-sunset',
					keywords: 'dusk night nighttime sun sun down sunset sunset',
				},
				{
					className: 'far fa-temperature-arrow-down',
					options: [
						'fat fa-temperature-arrow-down', 'fal fa-temperature-arrow-down', 'far fa-temperature-arrow-down', 'fas fa-temperature-arrow-down',
					],
					defaultOption: 'far fa-temperature-arrow-down',
					keywords: 'air conditioner cold heater mercury thermometer winter temperature arrow down',
				},
				{
					className: 'far fa-temperature-arrow-up',
					options: [
						'fat fa-temperature-arrow-up', 'fal fa-temperature-arrow-up', 'far fa-temperature-arrow-up', 'fas fa-temperature-arrow-up',
					],
					defaultOption: 'far fa-temperature-arrow-up',
					keywords: 'air conditioner cold heater mercury thermometer winter temperature arrow up',
				},
				{
					className: 'far fa-temperature-empty',
					options: [
						'fat fa-temperature-empty', 'fal fa-temperature-empty', 'far fa-temperature-empty', 'fas fa-temperature-empty',
					],
					defaultOption: 'far fa-temperature-empty',
					keywords: 'cold mercury status temperature temperature empty',
				},
				{
					className: 'far fa-temperature-full',
					options: [
						'fat fa-temperature-full', 'fal fa-temperature-full', 'far fa-temperature-full', 'fas fa-temperature-full',
					],
					defaultOption: 'far fa-temperature-full',
					keywords: 'fever hot mercury status temperature temperature full',
				},
				{
					className: 'far fa-temperature-half',
					options: [
						'fat fa-temperature-half', 'fal fa-temperature-half', 'far fa-temperature-half', 'fas fa-temperature-half',
					],
					defaultOption: 'far fa-temperature-half',
					keywords: 'mercury status temperature thermometer weather temperature half',
				},
				{
					className: 'far fa-temperature-high',
					options: [
						'fat fa-temperature-high', 'fal fa-temperature-high', 'far fa-temperature-high', 'fas fa-temperature-high',
					],
					defaultOption: 'far fa-temperature-high',
					keywords: 'cook covid 19 mercury summer thermometer warm temperature high',
				},
				{
					className: 'far fa-temperature-list',
					options: [
						'fat fa-temperature-list', 'fal fa-temperature-list', 'far fa-temperature-list', 'fas fa-temperature-list',
					],
					defaultOption: 'far fa-temperature-list',
					keywords: 'gauge heat thermometer temperature list',
				},
				{
					className: 'far fa-temperature-low',
					options: [
						'fat fa-temperature-low', 'fal fa-temperature-low', 'far fa-temperature-low', 'fas fa-temperature-low',
					],
					defaultOption: 'far fa-temperature-low',
					keywords: 'cold cool covid 19 mercury thermometer winter temperature low',
				},
				{
					className: 'far fa-temperature-quarter',
					options: [
						'fat fa-temperature-quarter', 'fal fa-temperature-quarter', 'far fa-temperature-quarter', 'fas fa-temperature-quarter',
					],
					defaultOption: 'far fa-temperature-quarter',
					keywords: 'mercury status temperature temperature quarter',
				},
				{
					className: 'far fa-temperature-snow',
					options: [
						'fat fa-temperature-snow', 'fal fa-temperature-snow', 'far fa-temperature-snow', 'fas fa-temperature-snow',
					],
					defaultOption: 'far fa-temperature-snow',
					keywords: 'cold mercury thermometer winter temperature snow',
				},
				{
					className: 'far fa-temperature-sun',
					options: [
						'fat fa-temperature-sun', 'fal fa-temperature-sun', 'far fa-temperature-sun', 'fas fa-temperature-sun',
					],
					defaultOption: 'far fa-temperature-sun',
					keywords: 'heat mercury summer thermometer temperature sun',
				},
				{
					className: 'far fa-temperature-three-quarters',
					options: [
						'fat fa-temperature-three-quarters', 'fal fa-temperature-three-quarters', 'far fa-temperature-three-quarters', 'fas fa-temperature-three-quarters',
					],
					defaultOption: 'far fa-temperature-three-quarters',
					keywords: 'mercury status temperature temperature three quarters',
				},
				{
					className: 'far fa-tornado',
					options: [
						'fat fa-tornado', 'fal fa-tornado', 'far fa-tornado', 'fas fa-tornado',
					],
					defaultOption: 'far fa-tornado',
					keywords: 'cloud cyclone dorothy landspout tornado toto twister vortext waterspout weather whirlwind tornado',
				},
				{
					className: 'far fa-umbrella',
					options: [
						'fat fa-umbrella', 'fal fa-umbrella', 'far fa-umbrella', 'fas fa-umbrella',
					],
					defaultOption: 'far fa-umbrella',
					keywords: 'protection rain storm wet umbrella',
				},
				{
					className: 'far fa-umbrella-simple',
					options: [
						'fat fa-umbrella-simple', 'fal fa-umbrella-simple', 'far fa-umbrella-simple', 'fas fa-umbrella-simple',
					],
					defaultOption: 'far fa-umbrella-simple',
					keywords: 'clothing rain spring umbrella umbrella simple',
				},
				{
					className: 'far fa-volcano',
					options: [
						'fat fa-volcano', 'fal fa-volcano', 'far fa-volcano', 'fas fa-volcano',
					],
					defaultOption: 'far fa-volcano',
					keywords: 'caldera eruption lava magma mountain smoke volcano volcano',
				},
				{
					className: 'far fa-water',
					options: [
						'fat fa-water', 'fal fa-water', 'far fa-water', 'fas fa-water',
					],
					defaultOption: 'far fa-water',
					keywords: 'lake liquid ocean sea swim wet water',
				},
				{
					className: 'far fa-water-arrow-down',
					options: [
						'fat fa-water-arrow-down', 'fal fa-water-arrow-down', 'far fa-water-arrow-down', 'fas fa-water-arrow-down',
					],
					defaultOption: 'far fa-water-arrow-down',
					keywords: 'flood lake liquid ocean recede sea swim wet water arrow down',
				},
				{
					className: 'far fa-water-arrow-up',
					options: [
						'fat fa-water-arrow-up', 'fal fa-water-arrow-up', 'far fa-water-arrow-up', 'fas fa-water-arrow-up',
					],
					defaultOption: 'far fa-water-arrow-up',
					keywords: 'flood lake liquid ocean sea swim wet water arrow up',
				},
				{
					className: 'far fa-wind',
					options: [
						'fat fa-wind', 'fal fa-wind', 'far fa-wind', 'fas fa-wind',
					],
					defaultOption: 'far fa-wind',
					keywords: 'air blow breeze fall seasonal weather wind',
				},
				{
					className: 'far fa-wind-warning',
					options: [
						'fat fa-wind-warning', 'fal fa-wind-warning', 'far fa-wind-warning', 'fas fa-wind-warning',
					],
					defaultOption: 'far fa-wind-warning',
					keywords: 'air alert blow breeze fall hurricane seasonal tornado weather wind warning',
				},
				{
					className: 'far fa-windsock',
					options: [
						'fat fa-windsock', 'fal fa-windsock', 'far fa-windsock', 'fas fa-windsock',
					],
					defaultOption: 'far fa-windsock',
					keywords: 'air blow breeze fall seasonal weather windsock',
				},
			],
		},
		{
			id: 'writing',
			name: Loc.getMessage('LANDING_ICONS_SECTION_WRITING'),
			items: [
				{
					className: 'far fa-blog',
					options: [
						'fat fa-blog', 'fal fa-blog', 'far fa-blog', 'fas fa-blog',
					],
					defaultOption: 'far fa-blog',
					keywords: 'journal log online personal post web 2 0 wordpress writing blog',
				},
				{
					className: 'far fa-book',
					options: [
						'fat fa-book', 'fal fa-book', 'far fa-book', 'fas fa-book',
					],
					defaultOption: 'far fa-book',
					keywords: 'book cover decorated diary documentation journal library notebook notebook with decorative cover read research book',
				},
				{
					className: 'far fa-book-arrow-right',
					options: [
						'fat fa-book-arrow-right', 'fal fa-book-arrow-right', 'far fa-book-arrow-right', 'fas fa-book-arrow-right',
					],
					defaultOption: 'far fa-book-arrow-right',
					keywords: 'library research book arrow right',
				},
				{
					className: 'far fa-book-arrow-up',
					options: [
						'fat fa-book-arrow-up', 'fal fa-book-arrow-up', 'far fa-book-arrow-up', 'fas fa-book-arrow-up',
					],
					defaultOption: 'far fa-book-arrow-up',
					keywords: 'library research book arrow up',
				},
				{
					className: 'far fa-book-bookmark',
					options: [
						'fat fa-book-bookmark', 'fal fa-book-bookmark', 'far fa-book-bookmark', 'fas fa-book-bookmark',
					],
					defaultOption: 'far fa-book-bookmark',
					keywords: 'library research book bookmark',
				},
				{
					className: 'far fa-book-circle-arrow-right',
					options: [
						'fat fa-book-circle-arrow-right', 'fal fa-book-circle-arrow-right', 'far fa-book-circle-arrow-right', 'fas fa-book-circle-arrow-right',
					],
					defaultOption: 'far fa-book-circle-arrow-right',
					keywords: 'library research book circle arrow right',
				},
				{
					className: 'far fa-book-circle-arrow-up',
					options: [
						'fat fa-book-circle-arrow-up', 'fal fa-book-circle-arrow-up', 'far fa-book-circle-arrow-up', 'fas fa-book-circle-arrow-up',
					],
					defaultOption: 'far fa-book-circle-arrow-up',
					keywords: 'library research book circle arrow up',
				},
				{
					className: 'far fa-book-copy',
					options: [
						'fat fa-book-copy', 'fal fa-book-copy', 'far fa-book-copy', 'fas fa-book-copy',
					],
					defaultOption: 'far fa-book-copy',
					keywords: 'library research book copy',
				},
				{
					className: 'far fa-book-font',
					options: [
						'fat fa-book-font', 'fal fa-book-font', 'far fa-book-font', 'fas fa-book-font',
					],
					defaultOption: 'far fa-book-font',
					keywords: 'library research book font',
				},
				{
					className: 'far fa-book-open-cover',
					options: [
						'fat fa-book-open-cover', 'fal fa-book-open-cover', 'far fa-book-open-cover', 'fas fa-book-open-cover',
					],
					defaultOption: 'far fa-book-open-cover',
					keywords: 'library research book open cover',
				},
				{
					className: 'far fa-bookmark',
					options: [
						'fat fa-bookmark', 'fal fa-bookmark', 'far fa-bookmark', 'fas fa-bookmark',
					],
					defaultOption: 'far fa-bookmark',
					keywords: 'bookmark favorite library mark marker read remember research save bookmark',
				},
				{
					className: 'far fa-bookmark-slash',
					options: [
						'fat fa-bookmark-slash', 'fal fa-bookmark-slash', 'far fa-bookmark-slash', 'fas fa-bookmark-slash',
					],
					defaultOption: 'far fa-bookmark-slash',
					keywords: 'library research bookmark slash',
				},
				{
					className: 'far fa-box-archive',
					options: [
						'fat fa-box-archive', 'fal fa-box-archive', 'far fa-box-archive', 'fas fa-box-archive',
					],
					defaultOption: 'far fa-box-archive',
					keywords: 'box package save storage box archive',
				},
				{
					className: 'far fa-circle-book-open',
					options: [
						'fat fa-circle-book-open', 'fal fa-circle-book-open', 'far fa-circle-book-open', 'fas fa-circle-book-open',
					],
					defaultOption: 'far fa-circle-book-open',
					keywords: 'library research circle book open',
				},
				{
					className: 'far fa-circle-bookmark',
					options: [
						'fat fa-circle-bookmark', 'fal fa-circle-bookmark', 'far fa-circle-bookmark', 'fas fa-circle-bookmark',
					],
					defaultOption: 'far fa-circle-bookmark',
					keywords: 'library research circle bookmark',
				},
				{
					className: 'far fa-envelope',
					options: [
						'fat fa-envelope', 'fal fa-envelope', 'far fa-envelope', 'fas fa-envelope',
					],
					defaultOption: 'far fa-envelope',
					keywords: 'back of envelope e mail email envelope letter mail message notification support envelope',
				},
				{
					className: 'far fa-envelope-open',
					options: [
						'fat fa-envelope-open', 'fal fa-envelope-open', 'far fa-envelope-open', 'fas fa-envelope-open',
					],
					defaultOption: 'far fa-envelope-open',
					keywords: 'e mail email letter mail message notification support envelope open',
				},
				{
					className: 'far fa-eraser',
					options: [
						'fat fa-eraser', 'fal fa-eraser', 'far fa-eraser', 'fas fa-eraser',
					],
					defaultOption: 'far fa-eraser',
					keywords: 'art delete remove rubber eraser',
				},
				{
					className: 'far fa-file',
					options: [
						'fat fa-file', 'fal fa-file', 'far fa-file', 'fas fa-file',
					],
					defaultOption: 'far fa-file',
					keywords: 'empty document document new page page facing up pdf resume file',
				},
				{
					className: 'far fa-file-lines',
					options: [
						'fat fa-file-lines', 'fal fa-file-lines', 'far fa-file-lines', 'fas fa-file-lines',
					],
					defaultOption: 'far fa-file-lines',
					keywords: 'document document with text document file text invoice new page pdf file lines',
				},
				{
					className: 'far fa-folder',
					options: [
						'fat fa-folder', 'fal fa-folder', 'far fa-folder', 'fas fa-folder',
					],
					defaultOption: 'far fa-folder',
					keywords: 'black folder archive directory document file file folder folder folder',
				},
				{
					className: 'far fa-folder-open',
					options: [
						'fat fa-folder-open', 'fal fa-folder-open', 'far fa-folder-open', 'fas fa-folder-open',
					],
					defaultOption: 'far fa-folder-open',
					keywords: 'open folder archive directory document empty file folder new open open file folder folder open',
				},
				{
					className: 'far fa-highlighter-line',
					options: [
						'fat fa-highlighter-line', 'fal fa-highlighter-line', 'far fa-highlighter-line', 'fas fa-highlighter-line',
					],
					defaultOption: 'far fa-highlighter-line',
					keywords: 'highlight marker select highlighter line',
				},
				{
					className: 'far fa-input-numeric',
					options: [
						'fat fa-input-numeric', 'fal fa-input-numeric', 'far fa-input-numeric', 'fas fa-input-numeric',
					],
					defaultOption: 'far fa-input-numeric',
					keywords: 'age date field input numeric',
				},
				{
					className: 'far fa-input-pipe',
					options: [
						'fat fa-input-pipe', 'fal fa-input-pipe', 'far fa-input-pipe', 'fas fa-input-pipe',
					],
					defaultOption: 'far fa-input-pipe',
					keywords: 'field input input pipe',
				},
				{
					className: 'far fa-input-text',
					options: [
						'fat fa-input-text', 'fal fa-input-text', 'far fa-input-text', 'fas fa-input-text',
					],
					defaultOption: 'far fa-input-text',
					keywords: 'field input name input text',
				},
				{
					className: 'far fa-keyboard',
					options: [
						'fat fa-keyboard', 'fal fa-keyboard', 'far fa-keyboard', 'fas fa-keyboard',
					],
					defaultOption: 'far fa-keyboard',
					keywords: 'accessory computer edit input keyboard text type write keyboard',
				},
				{
					className: 'far fa-memo',
					options: [
						'fat fa-memo', 'fal fa-memo', 'far fa-memo', 'fas fa-memo',
					],
					defaultOption: 'far fa-memo',
					keywords: 'note page file idea note paper memo',
				},
				{
					className: 'far fa-memo-circle-check',
					options: [
						'fat fa-memo-circle-check', 'fal fa-memo-circle-check', 'far fa-memo-circle-check', 'fas fa-memo-circle-check',
					],
					defaultOption: 'far fa-memo-circle-check',
					keywords: 'file idea note paper memo circle check',
				},
				{
					className: 'far fa-memo-pad',
					options: [
						'fat fa-memo-pad', 'fal fa-memo-pad', 'far fa-memo-pad', 'fas fa-memo-pad',
					],
					defaultOption: 'far fa-memo-pad',
					keywords: 'file idea note paper memo pad',
				},
				{
					className: 'far fa-newspaper',
					options: [
						'fat fa-newspaper', 'fal fa-newspaper', 'far fa-newspaper', 'fas fa-newspaper',
					],
					defaultOption: 'far fa-newspaper',
					keywords: 'article editorial headline journal journalism news newspaper paper press newspaper',
				},
				{
					className: 'far fa-notdef',
					options: [
						'fat fa-notdef', 'fal fa-notdef', 'far fa-notdef', 'fas fa-notdef',
					],
					defaultOption: 'far fa-notdef',
					keywords: 'close missing notdef',
				},
				{
					className: 'far fa-note',
					options: [
						'fat fa-note', 'fal fa-note', 'far fa-note', 'fas fa-note',
					],
					defaultOption: 'far fa-note',
					keywords: 'empty note memo sticky note note',
				},
				{
					className: 'far fa-note-sticky',
					options: [
						'fat fa-note-sticky', 'fal fa-note-sticky', 'far fa-note-sticky', 'fas fa-note-sticky',
					],
					defaultOption: 'far fa-note-sticky',
					keywords: 'message note paper reminder sticker note sticky',
				},
				{
					className: 'far fa-notebook',
					options: [
						'fat fa-notebook', 'fal fa-notebook', 'far fa-notebook', 'fas fa-notebook',
					],
					defaultOption: 'far fa-notebook',
					keywords: 'daybook diary journal noteboo notebook sketch notebook',
				},
				{
					className: 'far fa-notes',
					options: [
						'fat fa-notes', 'fal fa-notes', 'far fa-notes', 'fas fa-notes',
					],
					defaultOption: 'far fa-notes',
					keywords: 'memo sticky note notes',
				},
				{
					className: 'far fa-paper-plane',
					options: [
						'fat fa-paper-plane', 'fal fa-paper-plane', 'far fa-paper-plane', 'fas fa-paper-plane',
					],
					defaultOption: 'far fa-paper-plane',
					keywords: 'air float fold mail paper send paper plane',
				},
				{
					className: 'far fa-paperclip',
					options: [
						'fat fa-paperclip', 'fal fa-paperclip', 'far fa-paperclip', 'fas fa-paperclip',
					],
					defaultOption: 'far fa-paperclip',
					keywords: 'attach attachment connect link papercli paperclip paperclip',
				},
				{
					className: 'far fa-paperclip-vertical',
					options: [
						'fat fa-paperclip-vertical', 'fal fa-paperclip-vertical', 'far fa-paperclip-vertical', 'fas fa-paperclip-vertical',
					],
					defaultOption: 'far fa-paperclip-vertical',
					keywords: 'attach attachment connect link paperclip vertical',
				},
				{
					className: 'far fa-paragraph',
					options: [
						'fat fa-paragraph', 'fal fa-paragraph', 'far fa-paragraph', 'fas fa-paragraph',
					],
					defaultOption: 'far fa-paragraph',
					keywords: 'pilcrow sign edit format text writing paragraph',
				},
				{
					className: 'far fa-pen',
					options: [
						'fat fa-pen', 'fal fa-pen', 'far fa-pen', 'fas fa-pen',
					],
					defaultOption: 'far fa-pen',
					keywords: 'ballpoint design edit pen update write pen',
				},
				{
					className: 'far fa-pen-circle',
					options: [
						'fat fa-pen-circle', 'fal fa-pen-circle', 'far fa-pen-circle', 'fas fa-pen-circle',
					],
					defaultOption: 'far fa-pen-circle',
					keywords: 'draw edit pencil write pen circle',
				},
				{
					className: 'far fa-pen-clip',
					options: [
						'fat fa-pen-clip', 'fal fa-pen-clip', 'far fa-pen-clip', 'fas fa-pen-clip',
					],
					defaultOption: 'far fa-pen-clip',
					keywords: 'design edit update write pen clip',
				},
				{
					className: 'far fa-pen-clip-slash',
					options: [
						'fat fa-pen-clip-slash', 'fal fa-pen-clip-slash', 'far fa-pen-clip-slash', 'fas fa-pen-clip-slash',
					],
					defaultOption: 'far fa-pen-clip-slash',
					keywords: 'remove style pen clip slash',
				},
				{
					className: 'far fa-pen-fancy-slash',
					options: [
						'fat fa-pen-fancy-slash', 'fal fa-pen-fancy-slash', 'far fa-pen-fancy-slash', 'fas fa-pen-fancy-slash',
					],
					defaultOption: 'far fa-pen-fancy-slash',
					keywords: 'remove style pen fancy slash',
				},
				{
					className: 'far fa-pen-field',
					options: [
						'fat fa-pen-field', 'fal fa-pen-field', 'far fa-pen-field', 'fas fa-pen-field',
					],
					defaultOption: 'far fa-pen-field',
					keywords: 'imput signature pen field',
				},
				{
					className: 'far fa-pen-line',
					options: [
						'fat fa-pen-line', 'fal fa-pen-line', 'far fa-pen-line', 'fas fa-pen-line',
					],
					defaultOption: 'far fa-pen-line',
					keywords: 'draw write pen line',
				},
				{
					className: 'far fa-pen-slash',
					options: [
						'fat fa-pen-slash', 'fal fa-pen-slash', 'far fa-pen-slash', 'fas fa-pen-slash',
					],
					defaultOption: 'far fa-pen-slash',
					keywords: 'remove style pen slash',
				},
				{
					className: 'far fa-pen-swirl',
					options: [
						'fat fa-pen-swirl', 'fal fa-pen-swirl', 'far fa-pen-swirl', 'fas fa-pen-swirl',
					],
					defaultOption: 'far fa-pen-swirl',
					keywords: 'draw scribble stylus pen swirl',
				},
				{
					className: 'far fa-pen-to-square',
					options: [
						'fat fa-pen-to-square', 'fal fa-pen-to-square', 'far fa-pen-to-square', 'fas fa-pen-to-square',
					],
					defaultOption: 'far fa-pen-to-square',
					keywords: 'edit pen pencil update write pen to square',
				},
				{
					className: 'far fa-pencil',
					options: [
						'fat fa-pencil', 'fal fa-pencil', 'far fa-pencil', 'fas fa-pencil',
					],
					defaultOption: 'far fa-pencil',
					keywords: 'lower left pencil design edit penci pencil update write pencil',
				},
				{
					className: 'far fa-pencil-slash',
					options: [
						'fat fa-pencil-slash', 'fal fa-pencil-slash', 'far fa-pencil-slash', 'fas fa-pencil-slash',
					],
					defaultOption: 'far fa-pencil-slash',
					keywords: 'remove style pencil slash',
				},
				{
					className: 'far fa-quote-left',
					options: [
						'fat fa-quote-left', 'fal fa-quote-left', 'far fa-quote-left', 'fas fa-quote-left',
					],
					defaultOption: 'far fa-quote-left',
					keywords: 'left double quotation mark mention note phrase text type quote left',
				},
				{
					className: 'far fa-quote-right',
					options: [
						'fat fa-quote-right', 'fal fa-quote-right', 'far fa-quote-right', 'fas fa-quote-right',
					],
					defaultOption: 'far fa-quote-right',
					keywords: 'right double quotation mark mention note phrase text type quote right',
				},
				{
					className: 'far fa-quotes',
					options: [
						'fat fa-quotes', 'fal fa-quotes', 'far fa-quotes', 'fas fa-quotes',
					],
					defaultOption: 'far fa-quotes',
					keywords: 'cite quotation quote quotes',
				},
				{
					className: 'far fa-signature',
					options: [
						'fat fa-signature', 'fal fa-signature', 'far fa-signature', 'fas fa-signature',
					],
					defaultOption: 'far fa-signature',
					keywords: 'john hancock cursive name writing signature',
				},
				{
					className: 'far fa-square-pen',
					options: [
						'fat fa-square-pen', 'fal fa-square-pen', 'far fa-square-pen', 'fas fa-square-pen',
					],
					defaultOption: 'far fa-square-pen',
					keywords: 'edit pencil square update write square pen',
				},
				{
					className: 'far fa-square-quote',
					options: [
						'fat fa-square-quote', 'fal fa-square-quote', 'far fa-square-quote', 'fas fa-square-quote',
					],
					defaultOption: 'far fa-square-quote',
					keywords: 'mention note text type square quote',
				},
				{
					className: 'far fa-thumbtack',
					options: [
						'fat fa-thumbtack', 'fal fa-thumbtack', 'far fa-thumbtack', 'fas fa-thumbtack',
					],
					defaultOption: 'far fa-thumbtack',
					keywords: 'black pushpin coordinates location marker pin pushpin thumb tack thumbtack',
				},
				{
					className: 'far fa-typewriter',
					options: [
						'fat fa-typewriter', 'fal fa-typewriter', 'far fa-typewriter', 'fas fa-typewriter',
					],
					defaultOption: 'far fa-typewriter',
					keywords: 'keyboard letterpress movable type newspaper novel retro typing vintage writing typewriter',
				},
			],
		},
	],
};
